// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'https://api.ros.carvia.dev' | (string & {});
};

export type AsmOptions = {
    groupId: number;
    groupsToDisplay?: Array<number>;
};

export enum AcquisitionSource {
    RENTED_BEFORE = 'RENTED_BEFORE',
    COLD_ACQUISITION = 'COLD_ACQUISITION',
    PERSONAL_NETWORK = 'PERSONAL_NETWORK',
    REFERRAL = 'REFERRAL',
    OTHER = 'OTHER'
}

export type ActorMeta = {
    email?: string;
    type: 'actor';
    userId?: string;
};

export type AdditionalCostsDto = {
    /**
     * The km added by a extra in the booking.
     */
    additionalBookedKmExtraValue: number;
    /**
     * The cost per kwh in €.
     */
    costPerKwh: number;
    /**
     * The cost per liter in €.
     */
    costPerLiter: number;
    /**
     * The extra costs in € for exceeding the rental duration.
     */
    costsOfExtraDuration: number;
    /**
     * The extra costs in € for exceeding the mileage limit.
     */
    costsOfExtraKm: number;
    /**
     * The costs in € for recharging the battery.
     */
    costsOfRecharging: number | null;
    /**
     * The costs in € for refueling the car.
     */
    costsOfRefueling: number | null;
    /**
     * The amount of exceeded
     */
    extraDuration: number;
    /**
     * The amount of exceeded km.
     */
    extraKm: number;
    /**
     * The km included in the booking.
     */
    includedKms: number;
    /**
     * The amount of missing battery capacity in kwh
     */
    missingBattery: number | null;
    /**
     * The amount of missing fuel in liters.
     */
    missingFuel: number | null;
    /**
     * The total additional costs in €.
     */
    totalAdditionalCosts: number;
};

export type AdditionalCostsLedgerDescription = {
    /**
     * The km added by a extra in the booking.
     */
    additionalBookedKmExtraValue?: number;
    /**
     * The cost per kwh in €.
     */
    costPerKwh?: number;
    /**
     * The cost per liter in €.
     */
    costPerLiter?: number;
    /**
     * The extra costs in € for exceeding the rental duration.
     */
    costsOfExtraDuration?: number;
    /**
     * The extra costs in € for exceeding the mileage limit.
     */
    costsOfExtraKm?: number;
    /**
     * The costs in € for recharging the battery.
     */
    costsOfRecharging?: number | null;
    /**
     * The costs in € for refueling the car.
     */
    costsOfRefueling?: number | null;
    /**
     * The amount of exceeded
     */
    extraDuration?: number;
    /**
     * The amount of exceeded km.
     */
    extraKm?: number;
    /**
     * The km included in the booking.
     */
    includedKms?: number;
    /**
     * The amount of missing battery capacity in kwh
     */
    missingBattery?: number | null;
    /**
     * The amount of missing fuel in liters.
     */
    missingFuel?: number | null;
    /**
     * The total additional costs in €.
     */
    totalAdditionalCosts?: number;
    type: 'additional_costs';
};

export type AdditionalDriver = {
    dateOfBirth?: Date | null;
    firstName?: string;
    lastName?: string;
    licenseAuthority?: string;
    licenseDate?: Date | null;
    licenseNumber?: string;
};

export type AdditionalDriverDto = {
    dateOfBirth?: Date | null;
    firstName: string;
    lastName: string;
    licenseAuthority: string;
    licenseDate?: Date | null;
    licenseNumber: string;
};

export type AdditionalTrackingData = {
    bookingOrigin?: BookingOriginDto;
    cookies?: RecordStringAny;
    device?: TrackingDeviceData;
    firstOrigin?: BookingOriginDto;
    gclid?: string;
    page?: TrackingPageData;
    trackingAttribution?: TrackingAttributionDto;
    wasTrackedByGoogleAds?: boolean;
};

export type AdminCreateUserDto = {
    agencySettings?: AgencySettings | null;
    callerId?: string | null;
    city?: string | null;
    comment?: string | null;
    company?: string | null;
    country?: string | null;
    dateOfBirth?: Date | null;
    did?: string | null;
    email: string;
    firstName: string;
    functions?: Array<UserFunction>;
    gender?: Gender | null;
    idCardAuthority?: string | null;
    idCardDate?: Date | null;
    idCardNumber?: string | null;
    lastName: string;
    leadId?: string | null;
    licenseAuthority?: string | null;
    licenseDate?: Date | null;
    licenseNumber?: string | null;
    partnerSubTypeId?: string | null;
    password?: string;
    paymentTermDayType?: PaymentTermDayType | null;
    paymentTermDays?: number | null;
    phone?: string | null;
    preferredLocal: Local;
    preferredPaymentTerminalId?: string | null;
    refreshToken?: string | null;
    role?: UserRole;
    sipId?: string | null;
    staffomaticUserId?: string | null;
    stationIds?: Array<string> | null;
    street?: string | null;
    vatId?: string | null;
    zip?: string | null;
};

export type AdminUpdateUserDto = {
    agencySettings?: AgencySettings | null;
    callerId?: string | null;
    city?: string | null;
    comment?: string | null;
    company?: string | null;
    country?: string | null;
    dateOfBirth?: Date | null;
    did?: string | null;
    email?: string;
    firstName?: string;
    functions?: Array<UserFunction>;
    gender?: Gender | null;
    idCardAuthority?: string | null;
    idCardDate?: Date | null;
    idCardNumber?: string | null;
    lastName?: string;
    leadId?: string | null;
    licenseAuthority?: string | null;
    licenseDate?: Date | null;
    licenseNumber?: string | null;
    partnerSubTypeId?: string | null;
    password?: string;
    paymentTermDayType?: PaymentTermDayType | null;
    paymentTermDays?: number | null;
    phone?: string | null;
    preferredLocal?: Local;
    preferredPaymentTerminalId?: string | null;
    refreshToken?: string | null;
    role?: UserRole;
    sipId?: string | null;
    staffomaticUserId?: string | null;
    stationIds?: Array<string> | null;
    street?: string | null;
    vatId?: string | null;
    zip?: string | null;
};

export type AdyenPaymentDataDto = {
    ccDetails?: CreditCardDetailsDto;
    originalReference?: string;
    paymentMethodVariant?: string;
    reference: string;
    refundedAmount?: number;
    service: 'adyen';
};

export type AdyenSettlementBatch = {
    batchNumber: number;
    createdDate: Date;
    details: Array<AdyenSettlementDetail>;
    id: string;
    legalEntity: LegalEntity;
    merchantAccount: string;
    reportUrl: string;
    status: SettlementBatchStatus;
    updatedDate: Date;
};

export type AdyenSettlementDetail = {
    batch: AdyenSettlementBatch;
    commission: number;
    creationDate: Date | null;
    grossCredit: number;
    grossCurrency: string | null;
    grossDebit: number;
    id: string;
    interchange: number;
    markup: number;
    matchStatus: SettlementDetailMatchStatus | null;
    merchantReference: string | null;
    modificationMerchantReference: string | null;
    modificationPspReference: string | null;
    netCredit: number;
    netCurrency: string | null;
    netDebit: number;
    payment: Payment | null;
    paymentMethod: string | null;
    paymentMethodVariant: string | null;
    pspReference: string | null;
    schemeFees: number;
    shopperReference: string | null;
    type: string;
};

export type AgencySettings = {
    acquisitionSource?: AcquisitionSource;
    allowedEmployeeDomains?: Array<string>;
    commissionPercent?: number;
    companyInvoicingType?: CompanyInvoicingType;
    contactPerson?: string;
    discountPercent?: number;
    intendedRentalFrequency?: IntendedRentalFrequency;
    invoiceEmail?: string;
    isAgency?: boolean;
    noDeposit?: boolean;
    requiredVehicleClasses?: Array<VehicleClassPreference>;
};

export enum AgencyType {
    AGENCY_FOR_OWN_ACCOUNT = 'AGENCY_FOR_OWN_ACCOUNT',
    AGENCY_ON_COMMISSION_BASIS = 'AGENCY_ON_COMMISSION_BASIS',
    BROKER = 'BROKER'
}

export type AgentProvisionSummaryDto = {
    averageReviewRating: number | null;
    detailings: number;
    endDate: Date;
    extrasProvisions: number;
    handovers: number;
    ratingProvisions: number;
    returns: number;
    reviewAnsweredCount: number;
    reviewTotalCount: number;
    startDate: Date;
};

export enum AiAssistant {
    CHATGPT = 'CHATGPT',
    GEMINI = 'GEMINI',
    CLAUDE = 'CLAUDE',
    PERPLEXITY = 'PERPLEXITY',
    MICROSOFT_COPILOT = 'MICROSOFT_COPILOT',
    OTHER = 'OTHER'
}

export type AllocateInvoiceToLedgerEntriesDto = {
    /**
     * ID of the invoice to allocate
     */
    invoiceId: string;
    scope: ({
        type: 'booking';
    } & BookingScopeDto) | ({
        type: 'ledgerEntries';
    } & LedgerEntriesScopeDto);
};

export type AllocatePaymentToLedgerEntriesDto = {
    /**
     * ID of the payment to allocate
     */
    paymentId: string;
    scope: ({
        type: 'booking';
    } & BookingScopeDto) | ({
        type: 'invoice';
    } & InvoiceScopeDto) | ({
        type: 'ledgerEntries';
    } & LedgerEntriesScopeDto);
};

export type Allocation = {
    booking: Booking | null;
    bufferMinutes: number;
    calculatedTransferMinutes?: number;
    car: Car;
    carSwapReason: CarSwapReason | null;
    comment: string | null;
    createdDate: Date;
    customTransferMinutes: number | null;
    distanceInKm: number | null;
    driver?: User | null;
    dropoffLocation: Point | null;
    dropoffLocationGeocodedAddress: LocationGeocodedName | null;
    dropoffLocationType: BookingLocationType;
    dropoffResponsibleStation?: Station | null;
    endDate: Date;
    externalDriverEmail: string | null;
    fuelLevelEnd: number | null;
    fuelLevelStart: number | null;
    handingOverAgent?: User | null;
    handoverDate: Date | null;
    id: string;
    isActive: boolean;
    isBlocking: boolean;
    milageEnd: number | null;
    milageStart: number | null;
    pickupLocation: Point | null;
    pickupLocationGeocodedAddress: LocationGeocodedName | null;
    pickupLocationType: BookingLocationType;
    pickupResponsibleStation?: Station | null;
    rentalPartner: 'PORSCHE_DRIVE' | null;
    returnDate: Date | null;
    returningAgent?: User | null;
    startDate: Date;
    status: AllocationStatus;
    transferOf: Allocation | null;
    transfers: Array<Allocation> | null;
    type: AllocationType;
    updatedDate: Date;
    workshopAppointment?: WorkshopAppointment | null;
};

export enum AllocationStatus {
    NOT_CONFIRMED = 'NOT_CONFIRMED',
    CONFIRMED = 'CONFIRMED',
    HANDED_OVER = 'HANDED_OVER',
    RETURNED = 'RETURNED'
}

export type AllocationTransactionDto = {
    bookingComment: string | null;
    bookingId: string;
    bookingNumber: string;
    carCurrentLocationType: CarLocationType;
    carId: string;
    carMake: string;
    carModel: string;
    carReadyToHandover: boolean;
    carStatus: CarStatus;
    comment: string | null;
    customerName: string;
    driverName: string;
    endDate: Date;
    hasTransfer: boolean;
    id: string;
    isFirstBookingAllocation: boolean;
    isLastBookingAllocation: boolean;
    isReadyForPickup?: boolean | null;
    licencePlate: string | null;
    /**
     * Booked extras that have to be prepared before the handover (see `preHandoverExtraTypes`).
     */
    preHandoverExtras: Array<AllocationTransactionPreHandoverExtraDto>;
    rentalPartner: string | null;
    startDate: Date;
    stationId: string;
    stationInfo: LocalizedFieldDto;
    status: AllocationStatus;
    swapFromId: string | null;
    transferOfId: string | null;
    transfers?: Array<AllocationTransactionTransferDto>;
    type: AllocationType;
    workshopAppointmentComment?: string | null;
    workshopAppointmentId?: string | null;
    workshopAppointmentTypes?: Array<WorkshopAppointmentType> | null;
};

export type AllocationTransactionPreHandoverExtraDto = {
    count: number;
    type: VehicleExtraType;
};

export type AllocationTransactionTransferDto = {
    comment: string | null;
    driverName: string;
    endDate: string;
    externalDriverEmail: string | null;
    id: string;
    startDate: string;
    type: AllocationType;
};

export enum AllocationTransactionType {
    HANDOVER = 'HANDOVER',
    RETURN = 'RETURN'
}

export enum AllocationType {
    BOOKING = 'BOOKING',
    TRANSFER_DELIVERY = 'TRANSFER_DELIVERY',
    TRANSFER_RETURN = 'TRANSFER_RETURN',
    PARTNER_BOOKING = 'PARTNER_BOOKING',
    BLOCKER = 'BLOCKER',
    WORKSHOP_APPOINTMENT = 'WORKSHOP_APPOINTMENT'
}

export type AlternativeOpeningHours = {
    date: Date;
    openingHours?: LegacyOpeningTimes;
    ranges: Array<TimeRange>;
};

export type AlternativeOpeningHoursDto = {
    ranges: Array<TimeRange>;
};

export type Amount = {
    currency: string;
    value: number;
};

export type AnyClassAny = {
    [key: string]: unknown;
};

export type ApiKey = {
    createdDate: Date;
    id: string;
    keyHash: string;
    keyPrefix: string;
    lastUsedAt: Date | null;
    name: string;
    rules?: Array<ApiKeyRuleDto> | null;
    updatedDate: Date;
    user?: User | null;
};

export type ApiKeyRuleDto = {
    /**
     * The action(s) this rule applies to
     */
    action: string | Array<string>;
    /**
     * Optional MongoDB-style conditions for the rule
     */
    conditions?: {
        [key: string]: unknown;
    };
    /**
     * Optional fields this rule is limited to
     */
    fields?: Array<string>;
    /**
     * If true, this is a "cannot" rule (denial)
     */
    inverted?: boolean;
    /**
     * Optional reason for denial (shown in error messages)
     */
    reason?: string;
    /**
     * The subject(s) this rule applies to
     */
    subject: string | Array<string>;
};

export type ApiKeyRulesDto = {
    /**
     * Array of CASL rules defining API key permissions
     */
    rules: Array<ApiKeyRuleDto>;
};

export type ApplePayMerchantValidationDto = {
    domainName: string;
    legalEntityId?: string | null;
};

export type ApplePayPaymentMethodDto = {
    applePaymentToken: string;
    type: 'applepay';
};

export type ApplyCouponDto = {
    /**
     * The booking id the coupon should be applied to
     */
    bookingId: string;
    /**
     * The coupon code to validate
     */
    couponCode: string;
    /**
     * If true, only validate and calculate deduction (no deduction is persisted).
     */
    dryRun?: boolean;
};

export type ApprovalRequest = {
    approver?: User;
    createdDate: Date;
    id: string;
    jobData: RecordStringAny;
    jobName: string;
    rejectionReason?: string;
    requester: User;
    requiredPermissions?: Array<string>;
    result?: RecordStringAny;
    status: ApprovalRequestStatus;
    tags?: Array<string>;
    updatedDate: Date;
};

export enum ApprovalRequestFilter {
    ALL = 'ALL',
    ASSIGNED_TO_ME = 'ASSIGNED_TO_ME',
    CREATED_BY_ME = 'CREATED_BY_ME'
}

export type ApprovalRequestResponseDto = {
    /**
     * The approver user information (if approved/rejected)
     */
    approver?: User;
    /**
     * When the approval request was created
     */
    createdDate: Date;
    /**
     * The unique identifier of the approval request
     */
    id: string;
    /**
     * The job data associated with the approval request
     */
    jobData: RecordStringAny;
    /**
     * The job name/type of the approval request
     */
    jobName: string;
    /**
     * The rejection reason (if the request was rejected)
     */
    rejectionReason?: string;
    /**
     * The requester user information
     */
    requester: User;
    /**
     * The required permissions for approval
     */
    requiredPermissions: Array<string>;
    /**
     * The result data after the approval request was processed
     */
    result?: RecordStringAny;
    /**
     * The status of the approval request
     */
    status: ApprovalRequestStatus;
    /**
     * Tags for categorizing and filtering approval requests
     */
    tags: Array<string>;
    /**
     * The human-readable title of the approval request
     */
    title: string;
    /**
     * When the approval request was last updated
     */
    updatedDate: Date;
};

export enum ApprovalRequestSort {
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate',
    STATUS = 'status'
}

export enum ApprovalRequestStatus {
    REQUESTED = 'REQUESTED',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    WITHDRAWN = 'WITHDRAWN'
}

export type AreaCharge = {
    customPrice: number | null;
    geometry: AreaChargeGeometryDto;
    id: string;
    name: string;
    priceId: string | null;
};

export type AreaChargeGeometryDto = {
    /**
     * Polygon rings. The first ring is the exterior, following rings are holes.
     */
    coordinates: Array<Array<Array<Array<number>>>>;
    type: 'MultiPolygon';
};

export type AreaChargePriceDto = {
    /**
     * Surcharge in EUR. Changing it updates every fence that uses this price.
     */
    amount: number;
    id: string;
    name: string;
};

export type AssignSettlementPaymentDto = {
    paymentId: string;
};

export type AttachDamageEvidenceDto = {
    imageFileKey?: string;
    videoFileKey?: string;
};

export type AttachShotImageDto = {
    captureId: string;
    imageFileKey: string;
};

export type AttributedBooking = {
    attributedAmount: number;
    bookingNumber: number | null;
    id: string;
};

export type AttributedInvoice = {
    attributedAmount: number;
    completeInvoiceNumber: string | null;
    id: string;
};

export type AuditLog = {
    approvalRequest?: ApprovalRequest;
    changedFields: ChangedFields;
    createdAt: Date;
    entityId: string;
    entityType: AuditLogEntityType;
    id: string;
    meta: Array<AuditLogMeta> | null;
    modelName?: string;
    operation: AuditLogOperation;
    user: User | null;
};

export enum AuditLogEntityType {
    ALLOCATION = 'Allocation',
    BOOKING = 'Booking',
    CAR = 'Car',
    COUPON = 'Coupon',
    INFRINGEMENT = 'Infringement',
    INSURANCE_CASE = 'InsuranceCase',
    INVOICE = 'Invoice',
    LEAD = 'Lead',
    MAKE = 'Make',
    USER = 'User',
    VEHICLE_TYPE = 'VehicleType',
    WORKSHOP_APPOINTMENT = 'WorkshopAppointment'
}

export type AuditLogMeta = ({
    type: 'actor';
} & ActorMeta) | ({
    type: 'milage-expectation';
} & ChangedMilageExpectationMeta) | ({
    type: 'origin';
} & OriginMeta) | ({
    type: 'customer-mail';
} & SentCustomerMailMeta);

export enum AuditLogOperation {
    CREATE = 'create',
    UPDATE = 'update',
    DELETE = 'delete',
    MAIL_SENT = 'mail_sent'
}

export enum AutoAssignValueType {
    NET_PURCHASE_PRICE = 'NET_PURCHASE_PRICE',
    EXTRA_KM_PRICE = 'EXTRA_KM_PRICE'
}

export enum AutoChargeType {
    PAYMENT_LINK = 'PAYMENT_LINK',
    PSEUDO_NUMBER = 'PSEUDO_NUMBER',
    DEPOSIT = 'DEPOSIT'
}

export type AvailableHolidayRuleDto = {
    name: LocalizedFieldDto;
    rule: string;
};

export type AxaInsuranceData = {
    axaCategory?: AxaVehicleCategory;
    initialDays: number;
    licencePlate?: string;
    maxDayPrice?: number;
    porscheCenter?: PorscheCenter;
    referenceNumber: string;
};

export type AxaInsuranceDataDto = {
    axaCategory?: AxaVehicleCategory;
    initialDays: number;
    licencePlate?: string;
    maxDayPrice?: number;
    porscheCenter?: PorscheCenterDto;
    referenceNumber: string;
};

export enum AxaVehicleCategory {
    ECONOMY = 'ECONOMY',
    COMPACT = 'COMPACT',
    INTERMEDIATE = 'INTERMEDIATE',
    STANDARD = 'STANDARD',
    FULL_SIZE = 'FULL_SIZE',
    PREMIUM = 'PREMIUM',
    LUXURY = 'LUXURY',
    SPECIAL = 'SPECIAL',
    SEVEN_SEATER = 'SEVEN_SEATER',
    PORSCHE_A = 'PORSCHE_A',
    PORSCHE_B = 'PORSCHE_B',
    PORSCHE_C = 'PORSCHE_C'
}

export type BadRequestErrorDto = {
    error: 'Bad Request';
    message: Array<BadRequestErrorMessageDto>;
    statusCode: 400;
};

export type BadRequestErrorMessageDto = {
    error: string;
    field: string;
};

export enum BankStatementAction {
    CREATE_PAYMENT = 'CREATE_PAYMENT',
    LINK_PAYMENT = 'LINK_PAYMENT',
    LINK_SETTLEMENT = 'LINK_SETTLEMENT',
    IGNORE = 'IGNORE'
}

export type BankStatementEntryDto = {
    accountIban: string;
    action: BankStatementAction | null;
    amount: number;
    bankEntryReference: string;
    bankTransactionId: string | null;
    bookedDate: Date;
    /**
     * Instant an agent confirmed the Bank statement action (create payment, link payment, link settlement, or ignore). Unrelated to booking CONFIRMED.
     */
    confirmedAt: Date | null;
    counterpartyIban: string | null;
    counterpartyName: string | null;
    creditDebit: string | null;
    endToEndId: string | null;
    id: string;
    /**
     * The linked Payment has neither booking nor invoice and is distributed separately.
     */
    isCollectivePayment: boolean;
    /**
     * Legal entity that owns the account IBAN.
     */
    legalEntity: LegalEntitySummaryDto;
    paymentId: string | null;
    remittance: string | null;
    remittanceLines: Array<string>;
    settlementDetailId: string | null;
    suggestion: BankStatementSuggestionDto | null;
    unconfirmedTarget: boolean;
    valueDate: Date | null;
};

export type BankStatementEntryPageDto = {
    items: Array<BankStatementEntryDto>;
    /**
     * Cursor for the next page, null on the last page.
     */
    nextCursor: string | null;
};

export type BankStatementIngestResultDto = {
    conflicts: number;
    ingested: number;
    skipped: number;
    updated: number;
};

export enum BankStatementListStatus {
    UNMATCHED = 'UNMATCHED',
    CONFIRMED = 'CONFIRMED',
    IGNORED = 'IGNORED',
    ALL = 'ALL'
}

export enum BankStatementMatchCertainty {
    HIGH = 'high',
    LOW = 'low',
    MEDIUM = 'medium'
}

export type BankStatementMatchHighlights = {
    amount: boolean;
    bookingNumber: boolean;
    invoiceNumber: boolean;
    knownIban: boolean;
    name: boolean;
};

export type BankStatementOpenAmountDto = {
    amount: number;
    /**
     * The booking it belongs to; only id, number, status and start date are set.
     */
    booking: Booking | null;
    counterpartyName: string | null;
    counterpartyType: CounterpartyType | null;
    /**
     * Key of the booking remaining to pay that already includes this invoice
     * remainder; the two are never chosen together.
     */
    coveredByKey: string | null;
    dueSince: Date | null;
    /**
     * Unlinked PAID transfer payments of this invoice or booking (target picker only).
     */
    existingPayments?: Array<Payment>;
    highlights?: BankStatementMatchHighlights;
    id: string;
    /**
     * The invoice it belongs to; only id, number and invoice date are set.
     */
    invoice: Invoice | null;
    key: string;
    /**
     * User owing this open amount (booking customer or agency); null for guests.
     */
    payerUserId: string | null;
    /**
     * The unlinked Payment; only id, reference and dates are set.
     */
    payment: Payment | null;
    /**
     * The Merchant payout; only its id and the batch number are set.
     */
    settlementDetail: AdyenSettlementDetail | null;
    type: BankStatementOpenAmountType;
};

export enum BankStatementOpenAmountType {
    SETTLEMENT = 'SETTLEMENT',
    PAYMENT = 'PAYMENT',
    INVOICE = 'INVOICE',
    BOOKING = 'BOOKING'
}

export type BankStatementPaymentTargetDto = {
    bookingId?: string;
    counterpartyType?: CounterpartyType;
    invoiceId?: string;
};

export type BankStatementSuggestionDto = {
    action: BankStatementAction;
    certainty: BankStatementMatchCertainty;
    needsCounterparty: boolean;
    source: BankStatementSuggestionSource;
    /**
     * The first of `targets`.
     */
    target: BankStatementOpenAmountDto;
    /**
     * One target, or several open amounts of one payer for a collective payment,
     * oldest due first.
     */
    targets: Array<BankStatementOpenAmountDto>;
    unconfirmedTarget: boolean;
};

export enum BankStatementSuggestionSource {
    AMOUNT = 'amount',
    AUTO_MATCH = 'auto-match',
    KNOWN_IBAN = 'known-iban'
}

export type BankStatementWebhookCounterpartyDto = {
    bic?: string | null;
    iban?: string | null;
    name?: string | null;
};

export type BankStatementWebhookPayloadDto = {
    accountIban?: string | null;
    fetchedAt?: string;
    source?: string;
    transactions: Array<BankStatementWebhookTransactionDto>;
};

export type BankStatementWebhookTransactionDto = {
    accountIban?: string | null;
    amount: number;
    counterparty?: BankStatementWebhookCounterpartyDto;
    creditDebit?: string | null;
    currency?: string | null;
    date?: string | null;
    endToEndId?: string | null;
    entryRef?: string | null;
    id?: string | null;
    reference?: string | null;
    referenceLines?: Array<string>;
    txId?: string | null;
    valueDate?: string | null;
};

export type BasePaymentData = {
    ccDetails?: CreditCardDetails;
    refundedAmount?: number;
    service?: 'adyen' | 'bank-statement' | 'coupon';
};

export type BaseStoredPaymentMethod = {
    ccDetails?: CreditCardDetails;
    createdAt: Date;
    id: string;
    /**
     * Payment type (VISA, MASTERCARD, etc.) - may be null for deposit-only entries
     */
    paymentType?: PaymentType | null;
    /**
     * What this payment method was used/stored for (can have multiple purposes)
     */
    purposes: Array<CreditCard>;
    service?: 'adyen' | 'computop';
    readonly userId?: string;
    /**
     * Wallet provider if this is a wallet payment (Apple Pay, Google Pay)
     */
    walletProvider?: WalletProvider | null;
};

export type BlockAmountDto = {
    /**
     * Amount to be blocked. Must be positive
     */
    amount: number;
    /**
     * ID of the booking, whose customers card is to be blocked.
     */
    bookingId: string;
    paymentLinkReceiver?: PaymentLinkReceiver;
};

export type BookedExtra = {
    calculatedPrice: number | null;
    createdDate?: Date;
    id?: string;
    readonly isDefaultOptionSelected: boolean;
    updatedDate?: Date;
    vehicleExtraOptionSnapshot: VehicleExtraOption;
    vehicleExtraSnapshot: VehicleExtra;
};

export type BookedExtraDto = {
    extraType?: VehicleExtraType;
    optionValue?: string;
    vehicleExtraId?: string;
    vehicleExtraOptionId?: string;
};

export type Booking = {
    additionalDrivers: Array<AdditionalDriver>;
    agency: User | null;
    allocations: Array<Allocation>;
    readonly allowedInvoicingTypes: Array<InvoicingType>;
    blockedCreditCardAmount: number | null;
    blockedCreditCardDate: Date | null;
    readonly blockedCreditCardDetails?: CreditCardDetails | null;
    blockedCreditCardIncludesOpenFee: boolean | null;
    blockedCreditCardLastRefreshDate: Date | null;
    blockedCreditCardRefNr: string | null;
    bookedCar?: Car;
    bookingIpInfo: unknown;
    bookingNumber: number;
    calculatedAdditionalCosts: AdditionalCostsDto | null;
    calculatedInclusiveKm: number | null;
    carSwaps: Array<CarSwapDto>;
    /**
     * Derived from ledger; not stored on the booking row.
     */
    collectDeposit?: boolean;
    confirmationFileKey: string | null;
    confirmationReply: string | null;
    contractFileKey: string | null;
    coupons?: Array<Coupon>;
    createdBy?: User | null;
    createdDate: Date;
    creationSource: BookingCreationSource | null;
    readonly currentAllocatedCar?: Car | null;
    customInclusiveKm: number | null;
    customer?: User | null;
    customerComment: string | null;
    customerData: CustomerData;
    damages?: Array<Damage> | null;
    debitCardPaymentAtHandover: boolean;
    readonly defaultInvoicingType: InvoicingType;
    deferredPayment: boolean;
    deposit: number | null;
    depositPaymentLinkUrl: string | null;
    dropoffLocation: Point | null;
    dropoffLocationGeocodedAddress: LocationGeocodedName | null;
    dropoffLocationType: BookingLocationType;
    dropoffStation?: Station | null;
    endDate: Date;
    externalReference: string | null;
    flags: BookingFlags;
    readonly fraudDetectionInfo?: FraudDetectionInfo | null;
    handoverDate: Date | null;
    readonly hasBlockedCreditCard: boolean;
    readonly hasOnlineCreditCardPayment: boolean;
    hasPeriodicInvoicing: boolean;
    hasUnhandledDamages: boolean;
    id: string;
    inclusiveKm: Array<InclusiveKmPerDay>;
    infringements?: Array<Infringement> | null;
    insuranceCase?: InsuranceCase | null;
    internalComment: string | null;
    invoicingType: InvoicingType;
    ledgerEntries?: Array<LedgerEntry>;
    legalEntity: LegalEntity;
    npsSurveys: Array<NpsSurvey>;
    readonly onlineCreditCardDetails?: CreditCardDetails | null;
    onlinePaymentTransferId: string | null;
    pickupLocation: Point | null;
    pickupLocationGeocodedAddress: LocationGeocodedName | null;
    pickupLocationType: BookingLocationType;
    pickupStation?: Station | null;
    priceCalculation?: ({
        type: 'LONG_TERM';
    } & LongTermPricing) | ({
        type: 'SHORT_TERM';
    } & ShortTermPricing) | null;
    pricePerExtraKm: number | null;
    returnDate: Date | null;
    reviews: Array<Review>;
    salesChannel: SalesChannel | null;
    signatureFileKey: string | null;
    startDate: Date;
    status: BookingStatus;
    surveysConducted?: Array<SurveyConducted>;
    taxCountry: TaxCountry;
    taxProcedure: TaxProcedure;
    readonly totalDurationDays: number;
    readonly totalDurationExceeded: number;
    readonly totalRentalDays: number;
    trackingData: AdditionalTrackingData | null;
    /**
     * Unpaid customer deposit-lane amount in euros. Derived from ledger.
     */
    unpaidDeposit?: number;
    updatedDate: Date;
};

export type BookingAllocationDto = {
    carId: string;
    carSwapReason?: CarSwapReason;
    comment?: string | null;
    dropoffLocation?: LocationDto | null;
    dropoffLocationGeocodedAddress?: LocationGeocodedNameDto | null;
    dropoffLocationType?: BookingLocationType | null;
    dropoffResponsibleStationId?: string | null;
    endDate?: Date | null;
    id?: string;
    pickupLocation?: LocationDto | null;
    pickupLocationGeocodedAddress?: LocationGeocodedNameDto | null;
    pickupLocationType: BookingLocationType | null;
    pickupResponsibleStationId?: string | null;
    startDate: Date | null;
};

export type BookingBalanceDto = {
    AGENCY: number;
    CUSTOMER: number;
    OTHER: number;
};

export type BookingConfirmationNotificationEvent = {
    bookingId: string;
    bookingNumber: number;
    bookingOverview: BookingOverviewDto;
    carImageUrl: string | null;
    confirmationSentDate: string;
    durationDays: number | null;
    totalAmount: number | null;
};

export enum BookingCreationSource {
    ROS = 'ROS',
    WEBSITE = 'WEBSITE',
    EXTERNAL_API = 'EXTERNAL_API'
}

export type BookingDto = {
    additionalDrivers: Array<AdditionalDriver>;
    agency: User | null;
    allocations: Array<Allocation>;
    readonly allowedInvoicingTypes: Array<InvoicingType>;
    blockedCreditCardAmount: number | null;
    blockedCreditCardDate: Date | null;
    readonly blockedCreditCardDetails?: CreditCardDetails | null;
    blockedCreditCardIncludesOpenFee: boolean | null;
    blockedCreditCardLastRefreshDate: Date | null;
    blockedCreditCardRefNr: string | null;
    bookedCar?: Car;
    bookingIpInfo: unknown;
    bookingNumber: number;
    calculatedAdditionalCosts: AdditionalCostsDto | null;
    calculatedInclusiveKm: number | null;
    carSwaps: Array<CarSwapDto>;
    /**
     * Derived from ledger; not stored on the booking row.
     */
    collectDeposit?: boolean;
    confirmationFileKey: string | null;
    confirmationFileUrl?: string | null;
    confirmationReply: string | null;
    contractFileKey: string | null;
    contractFileUrl?: string | null;
    coupons?: Array<Coupon>;
    createdBy?: User | null;
    createdDate: Date;
    creationSource: BookingCreationSource | null;
    readonly currentAllocatedCar?: Car | null;
    currentBalance?: BookingBalanceDto;
    customInclusiveKm: number | null;
    customer?: User | null;
    customerComment: string | null;
    customerData: CustomerData;
    damages?: Array<Damage> | null;
    debitCardPaymentAtHandover: boolean;
    readonly defaultInvoicingType: InvoicingType;
    deferredPayment: boolean;
    deposit: number | null;
    depositPaymentLinkUrl: string | null;
    displayLocale: Local;
    dropoffLocation: Point | null;
    dropoffLocationGeocodedAddress: LocationGeocodedName | null;
    dropoffLocationType: BookingLocationType;
    dropoffStation?: Station | null;
    endDate: Date;
    externalReference: string | null;
    flags: BookingFlags;
    readonly fraudDetectionInfo?: FraudDetectionInfo | null;
    handoverDate: Date | null;
    readonly hasBlockedCreditCard: boolean;
    readonly hasOnlineCreditCardPayment: boolean;
    hasPeriodicInvoicing: boolean;
    hasUnhandledDamages: boolean;
    id: string;
    inclusiveKm: Array<InclusiveKmPerDay>;
    infringements?: Array<Infringement> | null;
    insuranceCase?: InsuranceCase | null;
    internalComment: string | null;
    invoicingType: InvoicingType;
    isReadyToFinalize?: boolean;
    ledgerCostBreakdown?: BookingLedgerCostBreakdownDto;
    ledgerEntries?: Array<LedgerEntry>;
    legalEntity: LegalEntity;
    npsSurveys: Array<NpsSurvey>;
    readonly onlineCreditCardDetails?: CreditCardDetails | null;
    onlinePaymentTransferId: string | null;
    pickupLocation: Point | null;
    pickupLocationGeocodedAddress: LocationGeocodedName | null;
    pickupLocationType: BookingLocationType;
    pickupStation?: Station | null;
    priceCalculation?: ({
        type: 'LONG_TERM';
    } & LongTermPricing) | ({
        type: 'SHORT_TERM';
    } & ShortTermPricing) | null;
    pricePerExtraKm: number | null;
    returnDate: Date | null;
    reviews: Array<Review>;
    salesChannel: SalesChannel | null;
    signatureFileKey: string | null;
    startDate: Date;
    status: BookingStatus;
    surveysConducted?: Array<SurveyConducted>;
    taxCountry: TaxCountry;
    taxProcedure: TaxProcedure;
    readonly totalDurationDays: number;
    readonly totalDurationExceeded: number;
    readonly totalRentalDays: number;
    trackingData: AdditionalTrackingData | null;
    /**
     * Unpaid customer deposit-lane amount in euros. Derived from ledger.
     */
    unpaidDeposit?: number;
    updatedDate: Date;
};

export type BookingFlags = {
    agencyInvoiceSentDate?: string | null;
    agencyUpcomingInvoiceInternalReminderSentDate?: string | null;
    agencyUpcomingInvoiceMailSentDate?: string | null;
    agentInvoiceSentDate?: string | null;
    agentUpcomingInvoiceInternalReminderSentDate?: string | null;
    agentUpcomingInvoiceMailSentDate?: string | null;
    confirmationSentDate?: string | null;
    createdDepositPaymentLinkDate?: string | null;
    createdPaymentLinkDate?: string | null;
    insuranceCustomerInfoMailSentDate?: string | null;
    upcomingAgentBookingMailSentDate?: string | null;
    upcomingBookingMailSentDate?: string | null;
};

export enum BookingJobDelayReason {
    INVOICE_PDF_NOT_GENERATED = 'invoice-pdf-not-generated',
    PAYMENTS_NOT_SETTLED = 'payments-not-settled',
    CONTRACT_PDF_NOT_GENERATED = 'contract-pdf-not-generated',
    CAR_SWAP_PROTOCOL_PDF_NOT_GENERATED = 'car-swap-protocol-pdf-not-generated',
    SEARCH_VECTOR_BACKFILL_IN_PROGRESS = 'search-vector-backfill-in-progress'
}

export type BookingJobDto = {
    delayReason?: BookingJobDelayReason;
    id: string;
    name: string;
    progress: number | {
        delayReason?: BookingJobDelayReason;
        step: BookingJobStep;
        value?: number;
    };
    runAt?: string;
    status: QueueJobStatus;
    step?: BookingJobStep;
};

export type BookingJobEvent = {
    bookingId: string;
    error?: unknown;
    event: BookingJobEventType;
    name: BookingJobType;
    progress?: {
        delayReason?: BookingJobDelayReason;
        step?: BookingJobStep;
        value: number;
    };
};

export enum BookingJobEventType {
    ACTIVE = 'active',
    COMPLETED = 'completed',
    FAILED = 'failed',
    WAITING = 'waiting',
    DELAYED = 'delayed'
}

export enum BookingJobStep {
    GENERATE_PDF = 'generate-pdf',
    UPLOAD_PDF = 'upload-pdf',
    RUN_INVOICING = 'run-invoicing',
    CHARGE_DUE_AMOUNT = 'charge-due-amount',
    CHARGE_AGENCY_DUE_AMOUNT = 'charge-agency-due-amount',
    WAIT_FOR_PAYMENTS = 'wait-for-payments',
    SEND_MAIL = 'send-mail',
    SEND_AGENCY_INVOICE_MAIL = 'send-agency-invoice-mail',
    SEND_INTERNAL_MAIL = 'send-internal-mail'
}

export enum BookingJobType {
    GENERATE_CONTRACT = 'generate-contract',
    GENERATE_CAR_SWAP_PROTOCOL = 'generate-car-swap-protocol',
    RUN_FRAUD_DETECTION = 'run-fraud-detection',
    RUN_SCHUFA_EVALUATION = 'run-schufa-evaluation',
    SEND_HANDOVER_MAIL = 'send-handover-mail',
    SEND_CAR_SWAP_MAIL = 'send-car-swap-mail',
    SEND_CONFIRMATION = 'send-confirmation',
    SEND_CREATED_MAIL = 'send-created-mail',
    PROCESS_CANCELLATION = 'process-cancellation',
    SEND_CANCELLATION_MAILS = 'send-cancellation-mails',
    PROCESS_RETURNED = 'process-returned',
    SEND_DEPOSIT_RECEIPT_MAIL = 'send-deposit-receipt-mail',
    GENERATE_INSURANCE_CASE_INVOICES = 'generate-insurance-case-invoices',
    BACKFILL_SEARCH_VECTOR = 'backfill-search-vector',
    PERIODIC_LEDGER = 'periodic-ledger',
    PERIODIC_INVOICE = 'periodic-invoice',
    PERIODIC_CHARGE = 'periodic-charge'
}

export type BookingLedgerCostBreakdownDto = {
    AGENCY: CounterpartyLedgerCostBreakdownDto;
    CUSTOMER: CounterpartyLedgerCostBreakdownDto;
    OTHER: CounterpartyLedgerCostBreakdownDto;
};

export enum BookingLinkStep {
    CAR = 'car',
    BOOK = 'book'
}

export enum BookingLocationType {
    STATION = 'STATION',
    STREET = 'STREET'
}

export type BookingOriginDto = {
    category?: string;
    makeId?: string;
    type: string;
    vehicleTypeIds?: Array<string>;
};

export type BookingOverviewDto = {
    /**
     * Number of bookings confirmed today
     */
    confirmedBookingsCount: number;
    /**
     * Combined total price of bookings confirmed today
     */
    confirmedBookingsTotalCost: number;
    /**
     * Daily target in EUR for confirmed bookings total cost
     */
    dailyTargetEur: number;
};

export type BookingPricingDto = {
    acceptedPrice?: number;
    applyToFollowing?: boolean;
    bookedExtras?: Array<BookedExtraDto> | null;
    customBookedExtras?: Array<UpdateCustomBookedExtraDto> | null;
    customDeposit?: number | null;
    customInclusiveKm?: number | null;
    customPricePerExtraKm?: number | null;
    customTotalBasePrice?: number | null;
    periodIndex?: number;
    priceDifferenceCounterparty?: CounterpartyType;
    priceRecalculationMode?: PriceRecalculationMode;
    type?: PricingType;
};

export type BookingScopeDto = {
    /**
     * ID of the booking to allocate to
     */
    bookingId: string;
    counterpartyType?: CounterpartyType;
    invoiceId?: unknown;
    ledgerEntries?: unknown;
    type: 'booking';
};

export enum BookingStatus {
    DRAFT = 'DRAFT',
    FLOATING = 'FLOATING',
    OPEN = 'OPEN',
    CONFIRMED = 'CONFIRMED',
    HANDED_OVER = 'HANDED_OVER',
    CAR_RETURNED = 'CAR_RETURNED',
    CANCELED = 'CANCELED',
    FINALIZED = 'FINALIZED'
}

export type BookingsActionNeededCountsDto = {
    forReviewCount: number;
    noCarCount: number;
    transfersWithoutDriverCount: number;
};

export type BuyCouponRequestDto = {
    amount: number;
    customerData: PublicCustomerDataDto;
    email: string;
    paymentMethod: PaymentMethodDto;
    returnUrl: string;
};

export type CalculateExampleDto = {
    endDate: Date;
    modifiers: Array<PricingModifierDto>;
    startDate: Date;
    stationId: string;
    stationLoad?: number | null;
    vehicleTypeId: string;
};

export type CalculatePricePerExtraKmResponseDto = {
    pricePerExtraKm: number;
};

export type CallDto = {
    callId: string;
    endedAt?: Date;
    number: string;
    relevantBookings?: Array<Booking>;
    relevantUsers?: Array<User>;
    sipId: string;
    startedAt: Date;
    type: 'in' | 'out';
};

export enum CancellationFee {
    NO_FEE = 'NO_FEE',
    WITHIN_SEVEN_DAYS = 'WITHIN_SEVEN_DAYS',
    AFTER_BOOKING_START_DATE = 'AFTER_BOOKING_START_DATE'
}

export type CancellationFeeLedgerDescription = {
    cancellationDate: Date;
    overrideCancellationFee?: CancellationFee;
    overrideCancellationFeeComment?: string;
    reason?: CancellationReason;
    type: 'cancellation_fee';
};

export type CancellationLedgerDescription = {
    reason: CancellationReason;
    type: 'cancellation';
};

export enum CancellationReason {
    BOOKING_CANCELLATION = 'booking_cancellation',
    BOOKING_ADJUSTMENT = 'booking_adjustment',
    INVOICING_CHANGES = 'invoicing_changes'
}

export enum CancelledBy {
    US = 'US',
    CUSTOMER = 'CUSTOMER'
}

export type CaptureLeadDto = {
    company: string;
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
    plannedBookingsPerMonth: string;
};

export type CaptureSignatureDto = {
    signatureFileKey: string;
};

export type Car = {
    accelaration: number | null;
    acquisitionType: CarAcquisitionType;
    additionalSeats: number | null;
    allocations?: Array<Allocation> | null;
    availableFrom: Date;
    availableRange?: CarAvailability;
    availableUntil: Date | null;
    batteryCapacityInKwh: number | null;
    bookings?: Array<Booking> | null;
    brakedTowingCapacityInKg: number | null;
    color: CarColor | null;
    createdDate: Date;
    currentLocationType: CarLocationType;
    damages: Array<Damage>;
    documents: Array<CarDocument>;
    drive: DriveType | null;
    fin: string | null;
    firstRegistration: Date | null;
    fleetNumber: number;
    fuelLevel: number;
    fuelType: FuelType | null;
    hasDistanceControl: boolean | null;
    hasNavigation: boolean | null;
    hasRearViewCamera: boolean | null;
    hasTowHitch: boolean;
    hiddenFromPublic: boolean;
    id: string;
    imageFileKey: string | null;
    readonly imageUrl?: string | null;
    initialMilage: number | null;
    insuranceCompany: string | null;
    isBlocked?: boolean;
    isGhostCar: boolean;
    lastTuvDate: Date | null;
    lastTyreConditionCheck: LastTyreConditionCheckDto | null;
    leasingRate: number | null;
    legalEntities?: Array<CarLegalEntity>;
    licencePlate: string | null;
    listPrice: number;
    merchantConsultedDate: Date | null;
    milage: number;
    needsTyreCheck?: boolean;
    newCarAnnouncenmentMailSentDate: Date | null;
    nextAllocationStartDate?: Date | null;
    nextAvailableStartDate?: Date | null;
    notAtTheHub: boolean;
    possibleUpgradeFrom: Array<PossibleUpgrade>;
    possibleUpgradesTo: Array<PossibleUpgrade>;
    power: number | null;
    promotionalVideo?: Media | null;
    purchasePrice: number | null;
    purchaseReminderMailSentDate: Date | null;
    rangeInKm: number | null;
    readyToHandover?: boolean;
    registrationAndOrganizationDoneDate: Date | null;
    rentalDuration?: number | null;
    saleDate: Date | null;
    salePrice: number | null;
    seats: number | null;
    stations: Array<CarStations>;
    status: CarStatus;
    tankVolumeInLiter: number | null;
    totalBasePrice?: number | null;
    totalPrice?: number | null;
    transferDeliveryPrice?: number;
    transferReturnPrice?: number;
    transmission: TransmissionType | null;
    tyreConditionFront: TyreCondition;
    tyreConditionRear: TyreCondition;
    tyres: CarTyres;
    unbrakedTowingCapacityInKg: number | null;
    undiscountedTotalPrice?: number | null;
    updatedDate: Date;
    vehicleType?: VehicleType;
    workshopAppointments?: Array<WorkshopAppointment> | null;
};

export enum CarAcquisitionType {
    PURCHASED_NEW = 'PURCHASED_NEW',
    PURCHASED_USED = 'PURCHASED_USED',
    LEASED = 'LEASED'
}

export type CarAvailability = {
    hasBeenAdjusted: boolean;
    possibleEndDate: Date | null;
    possibleStartDate: Date | null;
    unavailableReason: UnavailableReason | null;
};

export enum CarColor {
    WHITE = 'WHITE',
    BLACK = 'BLACK',
    GREY = 'GREY',
    SILVER = 'SILVER',
    BLUE = 'BLUE',
    GREEN = 'GREEN',
    YELLOW = 'YELLOW',
    RED = 'RED',
    ORANGE = 'ORANGE',
    TURQUOISE = 'TURQUOISE',
    CHALK = 'CHALK',
    BEIGE = 'BEIGE',
    NATO_OLIVE = 'NATO_OLIVE',
    GOLD = 'GOLD',
    BROWN = 'BROWN'
}

export type CarDocument = {
    car: Car;
    comment: string | null;
    createdDate: Date;
    documentFileKey: string;
    id: string;
    name: string;
    type: CarDocumentType | null;
    updatedDate: Date;
};

export type CarDocumentDto = {
    car: Car;
    comment: string | null;
    createdDate: Date;
    documentFileKey: string;
    documentFileUrl: string;
    id: string;
    name: string;
    type: CarDocumentType | null;
    updatedDate: Date;
};

export enum CarDocumentType {
    CAR_IMAGE = 'CAR_IMAGE',
    ORDER_CONFIRMATION = 'ORDER_CONFIRMATION',
    REGISTRATION_CERTIFICATE = 'REGISTRATION_CERTIFICATE',
    FINANCING_CONTRACT = 'FINANCING_CONTRACT',
    PURCHASE_CONTRACT = 'PURCHASE_CONTRACT',
    COC = 'COC',
    OTHER = 'OTHER'
}

export type CarLegalEntity = {
    car: Car;
    fromDate: Date | null;
    id: string;
    legalEntity: LegalEntity;
    untilDate: Date | null;
};

export type CarLegalEntityDto = {
    fromDate: Date | null;
    legalEntityId: string;
};

export enum CarLocationType {
    STATION = 'STATION',
    STREET = 'STREET',
    IN_USE = 'IN_USE'
}

export type CarStationDto = {
    fromDate: Date | null;
    id: string;
    primary: boolean;
    untilDate?: Date | null;
};

export type CarStations = {
    car: Car;
    fromDate: Date | null;
    id: string;
    primary: boolean;
    station: Station;
    stationId: string;
    untilDate: Date | null;
};

export enum CarStatus {
    ORDERED = 'ORDERED',
    FLOAT_IN = 'FLOAT_IN',
    FLOAT_OUT = 'FLOAT_OUT'
}

export type CarSwapDto = {
    date: string | Date;
    handedOverAllocationId?: string;
    protocolFileKey?: string;
    protocolFileUrl?: string;
    returnedAllocationId?: string;
    signatureFileKey: string;
};

export enum CarSwapReason {
    FLAT_TYRE = 'FLAT_TYRE',
    TECHNICAL_DEFECT = 'TECHNICAL_DEFECT',
    ACCIDENT = 'ACCIDENT',
    OTHER = 'OTHER'
}

export enum CarTyres {
    WINTER = 'WINTER',
    SUMMER = 'SUMMER',
    ALL_SEASON = 'ALL_SEASON'
}

export type CardHolderDataDto = {
    city: string;
    country: string;
    email: string;
    firstName: string;
    lastName: string;
    street: string;
    zip: string;
};

export type CardPaymentMethodDto = {
    browserInfo?: unknown;
    encryptedCardData: EncryptedCardDataDto;
    riskData?: unknown;
    type: 'card';
};

export type ChangeDeleted = {
    identifier: string;
    type: 'deleted';
    value: unknown;
};

export type ChangedCreated = {
    identifier: string;
    type: 'created';
    value: unknown;
};

export type ChangedField = ChangeDeleted | ChangedCreated | Array<ChangeDeleted | ChangedCreated | ChangedRelated> | ChangedRelated | ChangedRelationId | ChangedValue;

export type ChangedFields = {
    [key: string]: ChangedField;
};

export type ChangedMilageExpectationMeta = {
    delta: number;
    deviationComment?: string;
    deviationReason?: MilageDeviationReason;
    expectedMaxDelta: number | null;
    expectedMinDelta: number | null;
    includesTransfer: boolean;
    milageAfter: number;
    milageBefore: number;
    mode: MilageExpectationMode;
    needsConfirmation: boolean;
    stationId: string;
    type: 'milage-expectation';
};

export type ChangedRelated = {
    changedFields: ChangedFields;
    entityId?: string;
    entityType?: string;
    identifier: string;
    type: 'related';
};

export type ChangedRelationId = {
    entityType: string;
    newIdentifier?: string;
    newValue?: string | null;
    oldIdentifier?: string;
    oldValue?: string | null;
    type: 'relation';
};

export type ChangedValue = {
    newValue: string | null;
    oldValue: string | null;
    type: 'field';
};

export type ChargeAmountDto = {
    /**
     * Amount to be charged (only positive)
     */
    amount: number;
    /**
     * When true, auto-allocate the resulting payment to open ledger entries
     * (e.g. handover open-fee charge when deposit is already blocked).
     */
    autoAllocateLedger?: boolean;
    /**
     * ID of the booking, whose customer is to be charged from or credited to.
     */
    bookingId: string;
    counterpartyType?: CounterpartyType;
    /**
     * ID of the invoice the payments should be linked to.
     */
    invoiceId?: string | null;
    /**
     * Key of the stored payment method to be used.
     */
    key?: string;
    ledgerEntries?: Array<LedgerEntryScope>;
    paymentLinkReceiver?: PaymentLinkReceiver;
    types?: Array<AutoChargeType> | null;
};

export type ChargeAmountResponseDto = {
    charged: boolean;
    paymentLink?: PaymentLinkDto;
    payments: Array<Payment>;
};

export type ChargeCreditCardDto = {
    amount: number;
    bookingId: string;
    paymentTerminalId: string;
    type: TerminalTransactionType;
};

export type ChargeCreditCardResponseDto = {
    refNr: string;
};

export type CheckoutOrderResponse = {
    amount?: Amount | null;
    expiresAt?: string;
    orderData?: string;
    pspReference: string;
    reference?: string;
    remainingAmount?: Amount | null;
};

export type CheckoutResponseDto = {
    action?: unknown;
    donationToken?: string;
    order?: unknown;
    redirectUrl: string;
    result: 'error' | 'pending' | 'success';
    resultCode?: string;
};

export type CleaningFeeDto = {
    /**
     * Localized guidelines for how to assess the damage
     */
    guidelines?: LocalizedFieldDto;
    /**
     * Unique identifier for the cleaning fee
     */
    id: string;
    /**
     * Localized name of the cleaning fee
     */
    name: LocalizedFieldDto;
    /**
     * Whether a photo is required for this cleaning fee
     */
    photoRequired: boolean;
    /**
     * Price of the cleaning fee
     */
    price: number;
};

export type CleaningFeeSelectionDto = {
    /**
     * ID of the cleaning fee to add
     */
    cleaningFeeId: string;
    /**
     * Locale for the cleaning fee name
     */
    locale: Local;
    /**
     * Photo file keys for the cleaning fee
     */
    photoFileKeys?: Array<string>;
};

export type ClockInDto = {
    /**
     * Optional at a station and during the max shift duration; required when clocking in or out outside the allowed station area or after a too long shift (e.g. booking number and reason).
     */
    comment?: string;
    latitude?: number;
    longitude?: number;
};

export type ClockOutDto = {
    /**
     * Optional at a station and during the max shift duration; required when clocking in or out outside the allowed station area or after a too long shift (e.g. booking number and reason).
     */
    comment?: string;
    latitude?: number;
    longitude?: number;
    /**
     * If true, clock out using the configured maximum shift duration instead of the current time (no comment required for long shifts).
     */
    useMaxDuration?: boolean;
};

export type ClockTime = {
    hour: number;
    minute: number;
};

export type CommentAuthorDto = {
    firstName: string;
    id: string;
    lastName: string;
};

export type CommentDto = {
    author: CommentAuthorDto;
    body: TipTapNode;
    createdDate: Date;
    id: string;
    mentionedUserIds: Array<string>;
    parentId: string | null;
    reactions: Array<CommentReactionDto>;
    replies: Array<CommentDto>;
    resolvedAt: Date | null;
    resolvedBy: CommentAuthorDto | null;
    updatedDate: Date;
};

export type CommentMentionCandidateDto = {
    firstName: string;
    id: string;
    lastName: string;
};

export type CommentMentionCandidatesDto = {
    items: Array<CommentMentionCandidateDto>;
};

export type CommentReactionDto = {
    emoji: string;
    users: Array<CommentAuthorDto>;
};

export type CommentSocketClientMessage = ({
    event: 'subscribe';
} & CommentSocketSubscribeMessage) | ({
    event: 'unsubscribe';
} & CommentSocketUnsubscribeMessage);

export type CommentSocketCountItem = {
    count: number;
    entityId: string;
    entityType: CommentableEntityType;
};

export type CommentSocketCountsMessage = {
    data: CommentSocketCountsPayload;
    event: 'counts';
};

export type CommentSocketCountsPayload = {
    items: Array<CommentSocketCountItem>;
};

export type CommentSocketErrorMessage = {
    data: CommentSocketErrorPayload;
    event: 'error';
};

export type CommentSocketErrorPayload = {
    entityId?: string;
    entityType?: CommentableEntityType;
    message: string;
};

export type CommentSocketListMessage = {
    data: CommentSocketListPayload;
    event: 'list';
};

export type CommentSocketListPayload = {
    comments: Array<CommentDto>;
    entityId: string;
    entityType: CommentableEntityType;
};

export type CommentSocketServerMessage = ({
    event: 'counts';
} & CommentSocketCountsMessage) | ({
    event: 'error';
} & CommentSocketErrorMessage) | ({
    event: 'list';
} & CommentSocketListMessage);

export type CommentSocketSubscribeMessage = {
    data: CommentSocketWatch;
    event: 'subscribe';
};

export type CommentSocketTarget = {
    entityId: string;
    entityType: CommentableEntityType;
};

export type CommentSocketUnsubscribeMessage = {
    data: CommentSocketWatch;
    event: 'unsubscribe';
};

export type CommentSocketWatch = ({
    kind: 'count';
} & CommentSocketWatchCount) | ({
    kind: 'list';
} & CommentSocketWatchList);

export type CommentSocketWatchCount = {
    items: Array<CommentSocketTarget>;
    kind: 'count';
};

export type CommentSocketWatchList = {
    entityId: string;
    entityType: CommentableEntityType;
    kind: 'list';
};

export enum CommentableEntityType {
    INVOICE = 'Invoice',
    LEAD = 'Lead',
    BANK_STATEMENT_ENTRY = 'BankStatementEntry'
}

export type CompactCar = {
    accelaration: number | null;
    acquisitionType: CarAcquisitionType;
    additionalSeats: number | null;
    allocations?: Array<Allocation> | null;
    availableFrom: Date;
    availableRange?: CarAvailability;
    availableUntil: Date | null;
    batteryCapacityInKwh: number | null;
    bookings?: Array<Booking> | null;
    brakedTowingCapacityInKg: number | null;
    color: CarColor | null;
    createdDate: Date;
    currentLocationType: CarLocationType;
    damages: Array<Damage>;
    documents: Array<CarDocument>;
    drive: DriveType | null;
    fin: string | null;
    firstRegistration: Date | null;
    fleetNumber: number;
    fuelLevel: number;
    fuelType: FuelType | null;
    hasDistanceControl: boolean | null;
    hasNavigation: boolean | null;
    hasRearViewCamera: boolean | null;
    hasTowHitch: boolean;
    hiddenFromPublic: boolean;
    id: string;
    imageFileKey: string | null;
    readonly imageUrl?: string | null;
    initialMilage: number | null;
    insuranceCompany: string | null;
    isBlocked?: boolean;
    isGhostCar: boolean;
    lastTuvDate: Date | null;
    lastTyreConditionCheck: LastTyreConditionCheckDto | null;
    leasingRate: number | null;
    legalEntities?: Array<CarLegalEntity>;
    licencePlate: string | null;
    listPrice: number;
    merchantConsultedDate: Date | null;
    milage: number;
    needsTyreCheck?: boolean;
    newCarAnnouncenmentMailSentDate: Date | null;
    nextAllocationStartDate?: Date | null;
    nextAvailableStartDate?: Date | null;
    notAtTheHub: boolean;
    possibleUpgradeFrom: Array<PossibleUpgrade>;
    possibleUpgradesTo: Array<CompactPossibleUpgradesTo>;
    power: number | null;
    promotionalVideo?: Media | null;
    purchasePrice: number | null;
    purchaseReminderMailSentDate: Date | null;
    rangeInKm: number | null;
    readyToHandover?: boolean;
    registrationAndOrganizationDoneDate: Date | null;
    rentalDuration?: number | null;
    saleDate: Date | null;
    salePrice: number | null;
    seats: number | null;
    stations: Array<CarStations>;
    status: CarStatus;
    tankVolumeInLiter: number | null;
    totalBasePrice?: number | null;
    totalPrice?: number | null;
    transferDeliveryPrice?: number;
    transferReturnPrice?: number;
    transmission: TransmissionType | null;
    tyreConditionFront: TyreCondition;
    tyreConditionRear: TyreCondition;
    tyres: CarTyres;
    unbrakedTowingCapacityInKg: number | null;
    undiscountedTotalPrice?: number | null;
    updatedDate: Date;
    vehicleType: CompactVehicleType;
    workshopAppointments?: Array<WorkshopAppointment> | null;
};

export type CompactPossibleUpgradesTo = {
    from: Car;
    id: string;
    order: number;
    to: {
        id: string;
    };
};

export type CompactVehicleType = {
    accelaration: number | null;
    acrissCode?: string | null;
    additionalSeats: number;
    axaCategory: AxaVehicleCategory | null;
    basePrice: number;
    batteryCapacityInKwh: number | null;
    canBeBookedWithDebitCard?: boolean;
    cars?: Array<Car>;
    categories: Array<VehicleCategory>;
    createdDate: Date;
    customContractCheckboxes: Array<CustomContractCheckbox>;
    customDeposit: number | null;
    customMinAge: number | null;
    customPricePerExtraKm: number | null;
    deposit: number;
    discountFactor?: number | null;
    discountFrom: Date | null;
    discountUntil: Date | null;
    drive: DriveType;
    europCategory: EuropVehicleCategory | null;
    fuelType: FuelType;
    grossPurchasePrice: number;
    hasDistanceControl: boolean | null;
    hasNavigation: boolean | null;
    hasRearViewCamera: boolean | null;
    id: string;
    imageFileKey: string | null;
    readonly imageUrl?: string | null;
    inspectionIntervalInKm: number;
    isAlwaysOnWinterTyres: boolean;
    isBlocked?: boolean;
    isMysteryCar: boolean;
    jlrCategory: JlrVehicleCategory | null;
    readonly licenceNeededForXYears?: number | null;
    mainCategory: VehicleCategory;
    make: Make;
    minAge: number;
    minPricePerDay?: number | null;
    model: string;
    readonly netPurchasePrice: number;
    nextAvailableStartDate?: Date | null;
    numCars?: number;
    power: number | null;
    pricePerExtraKm: number;
    promotionalVideo?: Media | null;
    rangeInKm: number | null;
    rentalDuration?: number | null;
    rolandCategory: RolandVehicleCategory | null;
    seats: number;
    tankVolumeInLiter: number | null;
    totalBasePrice?: number | null;
    totalPrice?: number | null;
    transmission: TransmissionType;
    undiscountedTotalPrice?: number | null;
    updatedDate: Date;
    volvoCategory: VolvoVehicleCategory | null;
};

export enum CompanyInvoicingType {
    COMPANY_BULK_INVOICE = 'COMPANY_BULK_INVOICE',
    COMPANY_INVOICE = 'COMPANY_INVOICE',
    REGULAR = 'REGULAR'
}

export type CompleteHandoverDto = {
    createCarSwapProtocol?: boolean;
    handedOverAllocationId?: string;
    returnedAllocationId?: string;
    signatureFileKey: string;
};

export type CompleteNpsSurveyDto = {
    comment?: string | null;
    score: number;
    wishedCar?: string | null;
};

export type CompleteReviewDto = {
    comment?: string | null;
    rating?: number | null;
};

export type ComputopNotifyDto = {
    Data: string;
    Len: string;
    MerchantID?: string;
};

export type ComputopPaymentDataDto = {
    ccBrand?: string;
    ccDetails?: CreditCardDetailsDto;
    ccExpiry?: string;
    merchantId: string;
    payId: string;
    refundedAmount?: number;
};

export type ConfirmBankStatementActionDto = {
    action: BankStatementAction | null;
    bookingId?: string;
    counterpartyType?: CounterpartyType;
    /**
     * The action the client last saw on the entry (null while unmatched). When set
     * and the entry has changed since, the confirm is rejected instead of applied twice.
     */
    expectedAction?: BankStatementAction | null;
    invoiceId?: string;
    paymentId?: string;
    settlementDetailId?: string;
    /**
     * With CREATE_PAYMENT: several open amounts of one payer (collective payment).
     * One Payment is created and allocated oldest due first, each up to its open amount;
     * money left over stays unallocated. Replaces invoiceId / bookingId / counterpartyType.
     */
    targets?: Array<BankStatementPaymentTargetDto>;
};

export type ConfirmContactDto = {
    email: string;
    phone: string;
};

export type ConfirmEmailDto = {
    token: string;
};

export type ContractPenaltyResponseDto = {
    damage?: Damage | null;
    invoice?: Invoice | null;
};

export enum ContractPenaltyType {
    ABROAD_WITHOUT_EXTRA = 'ABROAD_WITHOUT_EXTRA',
    ABROAD_OUTSIDE_AREA = 'ABROAD_OUTSIDE_AREA',
    UNREGISTERED_DRIVER = 'UNREGISTERED_DRIVER',
    RACETRACK = 'RACETRACK'
}

export type ConvertToLongTermDto = {
    bookedExtras: Array<BookedExtraDto>;
    customBookedExtras?: Array<UpdateCustomBookedExtraDto> | null;
    customTotalBasePrice: number;
    invoiceDropoffTransfer?: boolean;
    invoicePickupTransfer?: boolean;
    quoteStartDate: Date;
};

export type CountBookingsOfUserDto = {
    cancelledBookingsCount: number;
    completedBookingsCount: number;
};

export type CounterVideoWallHandoverEventDto = {
    /**
     * Handover session id. Empty for heartbeats.
     */
    sessionId: string;
    type: 'handover.heartbeat' | 'handover.started';
    /**
     * Resolved car (or vehicle type fallback) promotional video, if any.
     */
    video: CounterVideoWallHandoverVideoDto | null;
};

export type CounterVideoWallHandoverVideoDto = {
    fileUrl: string;
    mediaId: string;
    posterFileUrl: string | null;
};

export type CounterpartyLedgerCostBreakdownDto = {
    lines: Array<LedgerCostBreakdownLineDto>;
    subtotal: number;
};

export enum CounterpartyType {
    CUSTOMER = 'CUSTOMER',
    AGENCY = 'AGENCY',
    OTHER = 'OTHER'
}

export type Coupon = {
    benefits?: CouponBenefitsDto | null;
    code: string;
    comment: string | null;
    createdAt: Date;
    customerData?: CustomerDataDto;
    id: string;
    isActive: boolean;
    maxRedemptions: number | null;
    oneRedemptionPerCustomer: boolean;
    orderInvoice?: Invoice;
    originalValue: number | null;
    paymentIds?: Array<string>;
    redemptionCount: number;
    remainingValue: number | null;
    type: CouponType;
    updatedAt: Date;
    validFrom: Date | null;
    validTo: Date | null;
};

export type CouponBenefitsDto = {
    /**
     * Additional inclusive kilometers granted by the coupon
     */
    EXTRA_KM?: number;
};

export type CouponGeneratedRevenueDto = {
    /**
     * Gross booking revenue of redemptions matching the query filters
     */
    generatedRevenue: number;
};

export type CouponPaymentDataDto = {
    ccDetails?: CreditCardDetailsDto;
    couponId: string;
    refundedAmount?: number;
    service: 'coupon';
};

export enum CouponSort {
    CODE = 'code',
    REMAINING_VALUE = 'remainingValue',
    CREATED_AT = 'createdAt',
    IS_ACTIVE = 'isActive'
}

export enum CouponType {
    REGULAR = 'REGULAR',
    GOODWILL = 'GOODWILL',
    PROMO = 'PROMO'
}

export type CouponValidationResponseDto = {
    /**
     * Benefits granted by a promo coupon
     */
    benefits?: CouponBenefitsDto;
    /**
     * The validated coupon code
     */
    code?: string;
    /**
     * The deduction amount that will be applied
     */
    deduction: number;
    /**
     * Whether the coupon is valid
     */
    isValid: boolean;
    /**
     * The validated coupon type
     */
    type?: CouponType;
};

export type CreateAllocationDto = {
    carId: string;
    comment?: string | null;
    driverId?: string | null;
    dropoffLocation?: LocationDto | null;
    dropoffLocationGeocodedAddress?: LocationGeocodedNameDto | null;
    dropoffLocationType?: BookingLocationType;
    dropoffResponsibleStationId?: string | null;
    endDate: Date;
    pickupLocation?: LocationDto | null;
    pickupLocationGeocodedAddress?: LocationGeocodedNameDto | null;
    pickupLocationType?: BookingLocationType;
    pickupResponsibleStationId?: string | null;
    rentalPartner?: 'PORSCHE_DRIVE';
    startDate: Date;
    transferOfId?: string | null;
    type: AllocationType;
};

export type CreateApiKeyDto = {
    /**
     * Name for the API key
     */
    name: string;
    /**
     * CASL rules defining what this API key can/cannot do. Required if no userId is provided. Rules are applied in order - later rules can override earlier ones.
     */
    rules?: Array<ApiKeyRuleDto>;
    /**
     * User ID to associate with the API key. If provided, the API key will inherit user context for partner/agent operations. If omitted, the API key operates independently using only its defined rules.
     */
    userId?: string;
};

export type CreateApiKeyResponseDto = {
    apiKey: ApiKey;
    /**
     * The plain API key - store this securely, it will not be shown again
     */
    plainKey: string;
};

export type CreateAreaChargeDto = {
    /**
     * Surcharge in EUR used instead of a shared price.
     */
    customPrice?: number | null;
    geometry: AreaChargeGeometryDto;
    name: string;
    /**
     * Id of an area charge price from yield management settings.
     */
    priceId?: string | null;
};

export type CreateBookingContractPdfDto = {
    signatureFileKey: string;
};

export type CreateBookingPrivateDto = {
    additionalDrivers: Array<AdditionalDriverDto>;
    agencyId?: string | null;
    bookedCarId: string;
    confirmationReply?: string | null;
    customerComment?: string | null;
    customerData?: CustomerDataDto;
    customerId?: string | null;
    debitCardPaymentAtHandover?: boolean;
    deferredPayment?: boolean;
    dropoffLocation?: LocationDto | null;
    dropoffLocationGeocodedAddress?: LocationGeocodedNameDto | null;
    dropoffLocationType?: BookingLocationType;
    dropoffStationId?: string | null;
    dryRun?: boolean;
    endDate: Date;
    externalReference?: string | null;
    handoverDate?: Date;
    insuranceCaseId?: string | null;
    internalComment?: string | null;
    invoicingType?: InvoicingType;
    onlineCreditCardPayment?: AdyenPaymentDataDto | ComputopPaymentDataDto | CouponPaymentDataDto | null;
    onlinePaymentTransferId?: string | null;
    pickupLocation?: LocationDto | null;
    pickupLocationGeocodedAddress?: LocationGeocodedNameDto | null;
    pickupLocationType?: BookingLocationType;
    pickupStationId?: string | null;
    pricing: BookingPricingDto;
    startDate: Date;
    status?: BookingStatus;
    taxProcedure?: TaxProcedure;
};

export type CreateCarDocumentDto = {
    comment?: string | null;
    documentFileKey: string;
    name: string;
    type?: CarDocumentType | null;
};

export type CreateCarDto = {
    accelaration?: number | null;
    acquisitionType: CarAcquisitionType;
    additionalSeats?: number | null;
    availableFrom: Date;
    availableUntil?: Date | null;
    batteryCapacityInKwh?: number | null;
    brakedTowingCapacityInKg?: number | null;
    color: CarColor;
    currentLocationType?: CarLocationType;
    drive?: DriveType | null;
    fin?: string | null;
    firstRegistration?: Date | null;
    fuelLevel?: number;
    fuelType?: FuelType | null;
    hasDistanceControl?: boolean | null;
    hasNavigation?: boolean | null;
    hasRearViewCamera?: boolean | null;
    hasTowHitch?: boolean;
    hiddenFromPublic?: boolean;
    imageFileKey?: string | null;
    initialMilage?: number | null;
    insuranceCompany?: string | null;
    isGhostCar?: boolean;
    lastTuvDate?: Date | null;
    leasingRate?: number | null;
    legalEntities?: Array<CarLegalEntityDto>;
    licencePlate?: string | null;
    listPrice: number;
    milage?: number;
    notAtTheHub?: boolean;
    possibleUpgrades?: Array<PossibleUpgradesDto>;
    power?: number | null;
    promotionalVideoMediaId?: string | null;
    purchasePrice?: number | null;
    rangeInKm?: number | null;
    readyToHandover?: boolean;
    registrationAndOrganizationDoneDate?: Date | null;
    saleDate?: Date | null;
    salePrice?: number | null;
    seats?: number | null;
    stations: Array<CarStationDto>;
    status?: CarStatus;
    tankVolumeInLiter?: number | null;
    transmission?: TransmissionType | null;
    tyreConditionFront?: TyreCondition;
    tyreConditionRear?: TyreCondition;
    tyres: CarTyres;
    unbrakedTowingCapacityInKg?: number | null;
    vehicleTypeId: string;
};

export type CreateCarSwapProtocolPdfDto = {
    handedOverAllocationId?: string;
    returnedAllocationId?: string;
    signatureFileKey: string;
};

export type CreateCommentDto = {
    body: TipTapNode;
    parentId?: string | null;
};

export type CreateContractPenaltyDto = {
    /**
     * Whether to attempt charging the customer deposit card for the penalty invoice. Defaults to true.
     */
    attemptDepositCharge?: boolean;
    type: ContractPenaltyType;
};

export type CreateCouponDto = {
    /**
     * Benefits granted by promo coupons
     */
    benefits?: CouponBenefitsDto;
    /**
     * Custom coupon code for promo coupons
     */
    code?: string;
    /**
     * Internal note on why the coupon was issued (required for goodwill coupons)
     */
    comment?: string | null;
    /**
     * The customer data associated with the coupon
     */
    customerData?: CustomerDataDto;
    /**
     * Whether the coupon is active
     */
    isActive?: boolean;
    /**
     * Maximum total redemptions across all customers (null = unlimited)
     */
    maxRedemptions?: number | null;
    /**
     * Whether each customer account may redeem this promo only once
     */
    oneRedemptionPerCustomer?: boolean;
    orderInvoice?: Invoice;
    /**
     * The original value of the coupon (same as initial value)
     */
    originalValue?: number;
    /**
     * The initial value of the coupon
     */
    remainingValue?: number;
    /**
     * The type of the coupon
     */
    type?: CouponType;
    /**
     * Optional start date for promo coupons (start of day, Europe/Berlin)
     */
    validFrom?: Date | null;
    /**
     * Optional expiry date for promo coupons (end of day, Europe/Berlin)
     */
    validTo?: Date | null;
};

export type CreateCustomerUserDto = {
    city?: string | null;
    comment?: string | null;
    company?: string | null;
    country?: string | null;
    dateOfBirth?: Date | null;
    email: string;
    firstName: string;
    gender?: Gender | null;
    idCardNumber?: string | null;
    lastName: string;
    licenseNumber?: string | null;
    phone?: string | null;
    preferredLocal: Local;
    street?: string | null;
    vatId?: string | null;
    zip?: string | null;
};

export type CreateDamageDto = {
    bookingId?: string | null;
    carId: string;
    description: string;
    expectedPhotoCount?: number;
    id?: string;
    imageFileKeys?: Array<string>;
    positionX?: number | null;
    positionY?: number | null;
    videoExpected?: boolean;
    videoFileKey?: string | null;
};

export type CreateDeviceAuthCodeDto = {
    counterId?: string;
    role: DeviceAuthRole;
    stationId?: string;
};

export type CreateDeviceAuthCodeResponseDto = {
    /**
     * 6 digit authorization code
     */
    code: string;
    /**
     * Code expiration timestamp in ISO format
     */
    expiresAt: string;
};

export type CreateInfringementDto = {
    imageFileKey: string;
};

export type CreateInsuranceCaseDto = {
    additionalInfo?: string | null;
    customerData: CustomerDataDto;
    email?: string;
    endDate?: Date | null;
    insuranceData: AxaInsuranceDataDto | EuropInsuranceDataDto | JlrInsuranceDataDto | RolandInsuranceDataDto | VolvoInsuranceDataDto;
    insuranceProvider: InsuranceProviderName;
    location?: string;
    locationGeocodedAddress?: LocationGeocodedAddress | null;
    startDate?: Date | null;
};

export type CreateInvoiceDto = {
    bookingId?: string | null;
    comment?: string | null;
    counterpartyType?: CounterpartyType | null;
    customerId?: string | null;
    invoiceNumberPrefix?: string | null;
    legalEntityId?: string | null;
    originalInvoiceId?: string | null;
    paidAmountOfOriginalInvoice?: number | null;
    paymentIds?: Array<string> | null;
    positions: Array<InvoicePositionDto>;
    receiverData?: InvoiceReceiverDataDto;
    sentStateDate?: Date | null;
    status?: InvoiceStatus;
    taxCountry?: TaxCountry;
    taxProcedure?: TaxProcedure;
    title?: string | null;
    type?: InvoiceType;
};

export type CreateInvoiceFromLedgerEntriesDto = {
    /**
     * ID of the booking
     */
    bookingId: string;
    counterpartyType?: CounterpartyType;
    includeAllCounterparties?: boolean;
    /**
     * Ledger entries to include in the invoice
     */
    ledgerEntries: Array<LedgerEntryScope>;
    taxProcedure?: TaxProcedure;
    /**
     * Optional title for the invoice
     */
    title?: string;
};

export type CreateLegacyCouponPaymentDto = {
    /**
     * Amount to redeem in major currency units (e.g. EUR)
     */
    amount: number;
    /**
     * Booking the legacy voucher payment is booked against
     */
    bookingId: string;
    /**
     * Legacy voucher number or reference (not validated against the coupon database)
     */
    couponCode: string;
};

export type CreateLegalEntityDto = {
    adyenMerchantAccount: string;
    bankName: string;
    bic: string;
    city: LocalizedFieldDto;
    commercialRegister: string;
    countryCode: string;
    email: string;
    englishTerms: string;
    iban: string;
    invoiceNumberPrefix?: string;
    isActive?: boolean;
    isOssRegistered?: boolean;
    localLanguage: string;
    localTerms: string;
    managingDirectors: string;
    name: string;
    phone: string;
    sepaCreditorId?: string | null;
    street: string;
    taxNumber?: string | null;
    vatId: string;
    website: string;
    zip: string;
};

export type CreateMakeDto = {
    name: string;
    priceFactor?: number;
    slug: string;
};

export type CreateMediaDto = {
    fileKey: string;
    title: string;
};

export type CreateNewsDto = {
    content: string;
    status?: NewsStatus;
    title: string;
};

export type CreateNpsSurveyDto = {
    bookingId?: string;
    comment?: string | null;
    score?: number | null;
    status: NpsSurveyStatus;
};

export type CreatePartnerSubTypeDto = {
    agencySettings: PartnerSubTypeAgencySettings;
    name: LocalizedFieldDto;
    role: 'AGENCY' | 'COMPANY';
    type?: AgencyType | null;
};

export type CreatePaymentDto = {
    amount: number;
    authorizationLastRefreshDate?: Date | null;
    bookingId?: string | null;
    comment?: string | null;
    counterpartyType?: CounterpartyType | null;
    creditCardDetails?: CreditCardDetailsDto | null;
    date: Date;
    invoiceId?: string | null;
    legalEntityId?: string | null;
    paidDate?: Date | null;
    paymentAllocations?: Array<PaymentAllocation>;
    paymentData?: BasePaymentData;
    paymentType: PaymentType;
    referenceId?: string | null;
    status?: PaymentStatus;
    walletProvider?: WalletProvider | null;
};

export type CreatePaymentTerminalDto = {
    description: string;
    stationId: string;
    terminalId: number;
    userIds?: Array<string> | null;
};

export type CreatePricingModifiersDto = {
    modifiers: Array<PricingModifierDto>;
    templates: Array<PricingModifierTemplateDto>;
};

export type CreateProcessSessionDto = {
    counterId?: string | null;
    forceCounterTakeover?: boolean;
    type: ProcessSessionType;
};

export type CreateReviewDto = {
    bookingId?: string | null;
    comment?: string | null;
    rating?: number | null;
    status: ReviewStatus;
    targetEmployeeId?: string | null;
    targetType: 'HANDOVER';
};

export type CreateRotationMediaDto = {
    mediaId: string;
    stationId?: string | null;
    weight?: number;
};

export type CreateStationDto = {
    authCode?: string | null;
    city: string;
    counters?: Array<UpsertStationCounterDto>;
    countryCode?: string;
    googleMapsReviewCtaUrl?: string | null;
    icon?: StationIcon | null;
    ignoredHolidays?: Array<IgnoredHolidayDto> | null;
    info?: LocalizedFieldDto;
    invoiceSuffix?: string | null;
    isGoogleMapsReviewEnabled?: boolean;
    isHidden?: boolean;
    isInternal?: boolean;
    legalEntityId?: string;
    location: LocationDto;
    mapImageFileKey?: string | null;
    notice?: LocalizedFieldDto | null;
    openingHours: Array<StationOpeningHoursDto>;
    returnPolicy?: StationReturnPolicy;
    slug: string;
    state?: string | null;
    street: string;
    zip: string;
};

export type CreateSurveyConductedDto = {
    answerIds: Array<string>;
    bookingId: string;
    surveyId: string;
};

export type CreateSurveyDto = {
    questions: Array<SurveyQuestionDto>;
    slug: string;
    titleDe: string;
    titleEn: string;
};

export type CreateTestInfringementDto = {
    data: InfringementData;
    imageFileKey: string;
    triggerFindBooking?: boolean;
};

export type CreateUserDocumentDto = {
    comment?: string | null;
    documentFileKey: string;
    name: string;
    type: UserDocumentType;
};

export type CreateVehicleExtraDto = {
    autoAssign?: boolean;
    autoAssignValueGte?: number | null;
    autoAssignValueLt?: number | null;
    autoAssignValueType?: AutoAssignValueType | null;
    deprecated?: boolean;
    description: string;
    key?: string;
    options: Array<CreateVehicleExtraOptionDto>;
    type: VehicleExtraType;
};

export type CreateVehicleExtraOptionDto = {
    deprecated?: boolean;
    name: string;
    price?: number | null;
    pricePerDay?: Array<PricePerDay> | null;
    pricingType: VehicleExtraOptionPricingType;
    value: string;
    valueType: ValueType;
};

export type CreateVehicleTypeDto = {
    accelaration?: number | null;
    acrissCode?: string | null;
    additionalSeats?: number;
    availableExtraIds: Array<string>;
    axaCategory?: AxaVehicleCategory | null;
    basePrice: number;
    batteryCapacityInKwh?: number | null;
    categories?: Array<VehicleCategory>;
    customContractCheckboxes?: Array<CustomContractCheckboxDto>;
    customDeposit?: number | null;
    customMinAge?: number | null;
    customPricePerExtraKm?: number | null;
    discountFactor?: number | null;
    discountFrom?: Date | null;
    discountUntil?: Date | null;
    drive?: DriveType;
    europCategory?: EuropVehicleCategory | null;
    fuelType?: FuelType;
    grossPurchasePrice: number;
    hasDistanceControl?: boolean;
    hasNavigation?: boolean;
    hasRearViewCamera?: boolean;
    imageFileKey?: string | null;
    inspectionIntervalInKm: number;
    isAlwaysOnWinterTyres?: boolean;
    jlrCategory?: JlrVehicleCategory | null;
    mainCategory: VehicleCategory;
    makeId: string;
    model: string;
    power?: number | null;
    promotionalVideoMediaId?: string | null;
    rangeInKm?: number | null;
    rolandCategory?: RolandVehicleCategory | null;
    seats?: number;
    tankVolumeInLiter?: number | null;
    transmission?: TransmissionType;
    volvoCategory?: VolvoVehicleCategory | null;
};

export type CreateVideoDto = {
    description: string;
    fileKey: string;
    thumbnailFileKey?: string;
    title: string;
    type: 'TRAINING';
};

export type CreateWorkshopAppointmentDocumentDto = {
    comment?: string | null;
    documentFileKey: string;
    name: string;
    type?: WorkshopAppointmentDocumentType | null;
};

export type CreateWorkshopAppointmentDto = {
    additionalInformation?: string;
    allocationStatus?: AllocationStatus;
    carId: string;
    contactPerson?: string;
    costs?: Array<WorkshopAppointmentCostDto>;
    endDate: Date;
    location?: LocationDto | null;
    locationGeocodedAddress?: LocationGeocodedNameDto | null;
    locationType?: BookingLocationType;
    milageEnd?: number | null;
    milageStart?: number | null;
    readyForPickup?: boolean;
    /**
     * Skip car availability validation when saving overlapping appointments
     */
    skipCarAvailabilityCheck?: boolean;
    startDate: Date;
    stationId?: string;
    types: Array<WorkshopAppointmentType>;
    usesCollectAndReturnService: boolean;
};

export enum CreditCard {
    ONLINE_PAYMENT = 'ONLINE_PAYMENT',
    DEPOSIT = 'DEPOSIT',
    PERIODIC = 'PERIODIC'
}

export type CreditCardBin = {
    accountBIN: string;
    accountRangeHigh?: string;
    accountRangeLow?: string;
};

export type CreditCardBinDto = {
    accountBIN: string;
    accountRangeHigh?: string;
    accountRangeLow?: string;
};

export type CreditCardCountry = {
    countryA2?: string;
    countryA3?: string;
    countryName?: string;
    countryNumber?: string;
};

export type CreditCardCountryDto = {
    countryA2?: string;
    countryA3?: string;
    countryName?: string;
    countryNumber?: string;
};

export type CreditCardDetails = {
    bin: CreditCardBin;
    brand: string;
    cardholderName?: string;
    country: CreditCardCountry;
    expiryDate?: string;
    issuer?: string;
    number?: string;
    product?: string;
    source?: string;
    type?: string;
};

export type CreditCardDetailsDto = {
    bin: CreditCardBinDto;
    brand: string;
    cardholderName?: string;
    country: CreditCardCountryDto;
    expiryDate?: string;
    issuer?: string;
    number?: string;
    product?: string;
    source?: string;
    type?: string;
};

export type CreditWithRefundDto = {
    ledgerEntries: Array<LedgerEntryScope>;
    paymentIds: Array<string>;
};

export type CreditWithRefundResponseDto = {
    creditedAmount: number;
    payments: Array<Payment>;
};

export type CrossborderCountryDto = {
    code: string;
    labels?: LocalizedFieldDto;
};

export type CrossborderCountryLabelOverrides = {
    [key: string]: LocalizedFieldDto;
};

export type CrossborderExtraOptionDetails = {
    countryLabelOverrides?: CrossborderCountryLabelOverrides;
    permittedDrivingCountries: Array<string>;
};

export type CustomBookedExtraDto = {
    /**
     * Coupon code that created this additional extra (shown on invoice lines).
     */
    couponCode?: string;
    customVehicleExtraType: VehicleExtraType | null;
    description: string;
    /**
     * Stable identifier for this custom extra.
     */
    id?: string;
    /**
     * 'Coupon-owned additional extra — not editable as a normal custom extra.
     */
    isAdditional?: boolean;
    photoFileKeys?: Array<string>;
    photoFileUrls?: Array<string>;
    price: number;
    value?: number;
};

export type CustomContractCheckbox = {
    label: LocalizedFieldDto2;
};

export type CustomContractCheckboxDto = {
    label: LocalizedFieldDto;
};

export type CustomExtraLedgerDescription = {
    title: string;
    type: 'custom_extra';
};

export type CustomLedgerDescription = {
    count?: number;
    custom: string;
    type: 'custom';
    unitType?: InvoicePositionUnitType;
};

export type CustomerData = {
    city?: string;
    company?: string;
    contactEmail?: string;
    country?: string;
    dateOfBirth?: Date;
    firstName?: string;
    gender?: Gender;
    idCardAuthority?: string;
    idCardDate?: Date;
    idCardNumber?: string;
    lastName?: string;
    licenseAuthority?: string;
    licenseDate?: Date;
    licenseNumber?: string;
    phone?: string;
    preferredLocal?: Local;
    street?: string;
    vatId?: string;
    zip?: string;
};

export type CustomerDataDto = {
    city?: string;
    company?: string;
    contactEmail?: string;
    country?: string;
    dateOfBirth?: Date;
    firstName?: string;
    gender?: Gender;
    idCardAuthority?: string;
    idCardDate?: Date;
    idCardNumber?: string;
    lastName?: string;
    licenseAuthority?: string;
    licenseDate?: Date;
    licenseNumber?: string;
    phone?: string;
    preferredLocal: Local;
    street?: string;
    vatId?: string;
    zip?: string;
};

export type CustomerMailAttachmentMeta = {
    contentType?: string;
    /**
     * Short-lived presigned GET URL. Populated when listing audit logs for a Booking or Invoice; expires after a few minutes.
     */
    downloadUrl?: string;
    fileKey: string;
    filename: string;
};

export enum CustomerScreen {
    IDLE = 'IDLE',
    BOOKING_SUMMARY = 'BOOKING_SUMMARY',
    DEPOSIT_PAYMENT = 'DEPOSIT_PAYMENT',
    CONTACT_CONFIRMATION = 'CONTACT_CONFIRMATION',
    CONTRACT_SIGNATURE = 'CONTRACT_SIGNATURE',
    SIGNATURE_DONE = 'SIGNATURE_DONE'
}

export enum CustomerTier {
    NORMAL = 'NORMAL',
    SILVER = 'SILVER',
    GOLD = 'GOLD',
    PLATINUM = 'PLATINUM'
}

export type Damage = {
    booking: Booking | null;
    car: Car;
    createdDate: Date;
    description: string;
    expectedPhotoCount: number;
    fleetNotificationSent: boolean;
    id: string;
    imageFileKeys: Array<string>;
    imageFileUrls?: Array<string>;
    positionX: number | null;
    positionY: number | null;
    repairedDate: Date | null;
    status: DamageStatus;
    updatedDate: Date;
    videoExpected: boolean;
    videoFileKey: string | null;
    videoFileUrl?: string | null;
};

export enum DamageStatus {
    OPEN = 'OPEN',
    REPAIRED = 'REPAIRED'
}

export type DebitBookingCategoryDto = {
    categories: Array<VehicleCategory>;
    netPurchasePriceLt: number;
};

export enum DecommissionedFilter {
    ACTIVE = 'ACTIVE',
    DECOMMISSIONED = 'DECOMMISSIONED'
}

export type DeleteResult = {
    affected?: number | null;
    raw: unknown;
};

export type DepositDto = {
    deposit: number;
    netPurchasePriceLt: number | null;
};

export enum DeviceAuthRole {
    SALES_DASHBOARD = 'SALES_DASHBOARD',
    COUNTER_SIGNATURE_IPAD = 'COUNTER_SIGNATURE_IPAD',
    COUNTER_VIDEO_WALL = 'COUNTER_VIDEO_WALL'
}

export type DialDto = {
    phoneNumber: string;
};

export enum DiscoverySource {
    GOOGLE = 'GOOGLE',
    YOUTUBE = 'YOUTUBE',
    TIKTOK = 'TIKTOK',
    INSTAGRAM = 'INSTAGRAM',
    LINKEDIN = 'LINKEDIN',
    AI_CHAT = 'AI_CHAT',
    FRIENDS_AND_FAMILY = 'FRIENDS_AND_FAMILY',
    BMW_WELT = 'BMW_WELT',
    OTHER = 'OTHER'
}

export enum DriveType {
    FRONT_WHEEL_DRIVE = 'FRONT_WHEEL_DRIVE',
    REAR_WHEEL_DRIVE = 'REAR_WHEEL_DRIVE',
    ALL_WHEEL_DRIVE = 'ALL_WHEEL_DRIVE'
}

export type DryRunBookingResponseDto = {
    readonly agencyDiscountPercent?: number | null;
    agencySettings?: AgencySettings | null;
    availableExtras?: Array<VehicleExtra>;
    averagePricePerDay: number;
    basePrice: number;
    bookedExtras?: Array<BookedExtra>;
    readonly calcTotalBasePrice?: number | null;
    cancellationFee?: CancellationFee;
    cancellationFeeAmount?: number;
    createdDate?: Date;
    customBookedExtras?: Array<CustomBookedExtraDto> | null;
    customDeposit?: number | null;
    customInclusiveKm?: number | null;
    customPricePerExtraKm?: number | null;
    customTotalBasePrice?: number | null;
    days: number;
    defaultDeposit: number;
    defaultInclusiveKm: number;
    defaultPricePerExtraKm: number;
    readonly deposit: number;
    readonly hasCustomPrice: boolean;
    id?: string;
    readonly inclusiveKm: number;
    isDiscounted: boolean;
    legalEntityId: string;
    readonly pricePerExtraKm: number;
    pricingModifiersVersion?: number | null;
    /**
     * VAT rate in percent. Undefined uses the booking tax procedure default; a number is an explicit override.
     */
    taxPercent: number;
    totalBasePrice: number;
    totalPrice: number;
    type?: 'SHORT_TERM';
    undiscountedAveragePricePerDay?: number | null;
    undiscountedTotalBasePrice?: number | null;
    undiscountedTotalPrice?: number | null;
    updatedDate?: Date;
};

export type EditAutoAssignExtraOptionDto = {
    id?: string;
    price?: number | null;
    pricePerDay?: Array<PricePerDay> | null;
    pricingType: VehicleExtraOptionPricingType;
    value: string;
};

export type EditAutoAssignVehicleExtraDto = {
    priceRanges: Array<ExtraPriceRangeDto>;
    type: VehicleExtraType;
};

export type EmailData = string | {
    email: string;
    name?: string;
};

export type EmailJson = {
    email: string;
    name?: string;
};

export type EmployeeDashboardSummaryDto = {
    bookingsCreated: number;
    bookingsRevenue: number;
    businessCustomersCreated: number;
};

export type EncryptedCardDataDto = {
    encryptedCardNumber: string;
    encryptedExpiryMonth: string;
    encryptedExpiryYear: string;
    encryptedSecurityCode: string;
};

export type EuropInsuranceData = {
    acrissCode?: string;
    europCategory?: EuropVehicleCategory;
    initialDays: number;
    licencePlate?: string;
    porscheCenter?: PorscheCenter2;
    referenceNumber: string;
};

export type EuropInsuranceDataDto = {
    acrissCode?: string;
    europCategory?: EuropVehicleCategory;
    initialDays: number;
    licencePlate?: string;
    porscheCenter?: PorscheCenterDto2;
    referenceNumber: string;
};

export enum EuropVehicleCategory {
    PORSCHE_A = 'PORSCHE_A',
    PORSCHE_B = 'PORSCHE_B',
    PORSCHE_C = 'PORSCHE_C',
    RFAD = 'RFAD',
    RWAD = 'RWAD',
    LFAD = 'LFAD',
    BLOCKED = 'BLOCKED'
}

export type ExampleCalculationDayDto = {
    modifiedBasePrice: number;
    modifiers: Array<ExampleCalculationModifierDto>;
};

export type ExampleCalculationDto = {
    basePrice: number;
    days: Array<ExampleCalculationDayDto>;
    totalModifiedBasePrice: number;
};

export type ExampleCalculationModifierDto = {
    factor: number;
    templateId: number;
};

export type ExchangeDeviceAuthCodeDto = {
    /**
     * 6 digit authorization code entered as username in ROS login
     */
    code: string;
};

export type ExportInvoicesDto = {
    invoiceDateAfter?: Date;
    invoiceDateBefore?: Date;
    /**
     * Only export invoices of this legal entity
     */
    legalEntityId?: string;
};

export type ExternalHandoverLoginDto = {
    /**
     * Token from the External handover link
     */
    token: string;
};

export type ExternalHandoverLoginResponseDto = {
    bookingId: string;
};

export type ExtraKmCategoryFactorDto = {
    category: VehicleCategory;
    factor: number;
};

export type ExtraLedgerDescription = {
    couponCode?: string;
    extraType?: VehicleExtraType;
    type: 'extra';
    value: string | number | boolean;
};

export type ExtraPriceRangeDto = {
    fromPrice: number;
    id?: string;
    options: Array<EditAutoAssignExtraOptionDto>;
};

export enum FieldName {
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    DATE_OF_BIRTH = 'dateOfBirth',
    ID_CARD_NUMBER = 'idCardNumber',
    ID_CARD_AUTHORITY = 'idCardAuthority',
    ID_CARD_DATE = 'idCardDate',
    STREET = 'street',
    ZIP_CODE = 'zipCode',
    CITY = 'city',
    COUNTRY = 'country',
    LICENSE_NUMBER = 'licenseNumber',
    LICENSE_AUTHORITY = 'licenseAuthority',
    LICENSE_DATE = 'licenseDate'
}

export type FindAllAllocationsFilterDto = {
    bookingIds?: Array<string>;
    bookingNumbers?: Array<number>;
    carIds?: Array<string>;
    /**
     * Filter for allocations with a car with one of the provided station ids. OR Filter
     */
    carStationIds?: Array<string>;
    dropoffLocationType?: BookingLocationType;
    /**
     * Filter for allocations with one of the provided dropoff station ids. OR Filter
     */
    dropoffResponsibleStationIds?: Array<string> | null;
    /**
     * Filter for allocations with endDate after specified datetime
     */
    endDateAfter?: Date;
    /**
     * Filter for allocations with endDate before specified datetime
     */
    endDateBefore?: Date;
    /**
     * Filter for allocations with or without a driver
     */
    hasDriver?: boolean;
    isActive?: boolean;
    isBlocking?: boolean;
    legalEntityIds?: Array<string>;
    /**
     * Filter for allocations whose travel time (custom override, else date span minus buffer) is at least this many minutes
     */
    minTravelMinutes?: number;
    pickupLocationType?: BookingLocationType;
    /**
     * Filter for allocations with one of the provided pickup station ids. OR Filter
     */
    pickupResponsibleStationIds?: Array<string> | null;
    /**
     * Search by customer/agent name, company, email, booking number, reference and licence plate
     */
    query?: string;
    /**
     * Filter for allocations with startDate after specified datetime
     */
    startDateAfter?: Date;
    /**
     * Filter for allocations with startDate before specified datetime
     */
    startDateBefore?: Date;
    /**
     * Filter for allocations by status. OR Filter
     */
    status?: Array<AllocationStatus>;
    /**
     * Filter for allocations by types. OR Filter
     */
    types?: Array<AllocationType>;
};

export enum FindAllAllocationsSort {
    START_DATE = 'startDate',
    END_DATE = 'endDate',
    RELEVANT_DATE = 'relevantDate',
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate'
}

export type FindAllBookingsFilterDto = {
    agencyIds?: Array<string>;
    /**
     * Filter for bookings that are linked to an agent
     */
    agencyInvoicingOnly?: boolean;
    bookingNumbers?: Array<number>;
    carIds?: Array<string>;
    /**
     * Filter for bookings with a car with one of the provided station ids. OR Filter
     */
    carStationIds?: Array<string>;
    /**
     * Filter for bookings that redeemed one of the provided coupons. OR Filter
     */
    couponIds?: Array<string>;
    /**
     * Filter for bookings with createdDate after specified datetime
     */
    createdDateAfter?: Date;
    /**
     * Filter for bookings with createdDate before specified datetime
     */
    createdDateBefore?: Date;
    customerIds?: Array<string>;
    /**
     * Filter for bookings with deferred agent prepayment
     */
    deferredPayment?: boolean;
    dropoffLocationType?: BookingLocationType;
    /**
     * Filter for bookings with one of the provided dropoff station ids. OR Filter
     */
    dropoffStationIds?: Array<string> | null;
    /**
     * Filter for bookings with endDate after specified datetime
     */
    endDateAfter?: Date;
    /**
     * Filter for bookings with endDate before specified datetime
     */
    endDateBefore?: Date;
    excludeFlags?: Array<'agencyInvoiceSentDate' | 'agencyUpcomingInvoiceInternalReminderSentDate' | 'agencyUpcomingInvoiceMailSentDate' | 'agentInvoiceSentDate' | 'agentUpcomingInvoiceInternalReminderSentDate' | 'agentUpcomingInvoiceMailSentDate' | 'confirmationSentDate' | 'createdDepositPaymentLinkDate' | 'createdPaymentLinkDate' | 'insuranceCustomerInfoMailSentDate' | 'upcomingAgentBookingMailSentDate' | 'upcomingBookingMailSentDate'>;
    /**
     * Filter for bookings with handoverDate after specified datetime
     */
    handoverDateAfter?: Date;
    /**
     * Filter for bookings with handoverDate before specified datetime
     */
    handoverDateBefore?: Date;
    /**
     * Filter for bookings that have periodic invoicing
     */
    hasPeriodicInvoicing?: boolean;
    /**
     * Filter for bookings that have at least one transfer
     */
    hasTransfers?: boolean;
    hasUnhandledDamages?: boolean | null;
    includeFlags?: Array<'agencyInvoiceSentDate' | 'agencyUpcomingInvoiceInternalReminderSentDate' | 'agencyUpcomingInvoiceMailSentDate' | 'agentInvoiceSentDate' | 'agentUpcomingInvoiceInternalReminderSentDate' | 'agentUpcomingInvoiceMailSentDate' | 'confirmationSentDate' | 'createdDepositPaymentLinkDate' | 'createdPaymentLinkDate' | 'insuranceCustomerInfoMailSentDate' | 'upcomingAgentBookingMailSentDate' | 'upcomingBookingMailSentDate'>;
    insuranceCaseProvider?: string | null;
    /**
     * Filter for bookings of one of the provided legal entities. OR Filter
     */
    legalEntityIds?: Array<string>;
    pickupLocationType?: BookingLocationType;
    /**
     * Filter for bookings with one of the provided pickup station ids. OR Filter
     */
    pickupStationIds?: Array<string> | null;
    /**
     * Search for bookings by customer/agent name, company/agency, email, booking number and car.licensePlate
     */
    query?: string;
    /**
     * Filter for bookings with startDate after specified datetime
     */
    startDateAfter?: Date;
    /**
     * Filter for bookings with startDate before specified datetime
     */
    startDateBefore?: Date;
    /**
     * Filter for bookings by status. OR Filter
     */
    status?: Array<BookingStatus>;
    /**
     * Filter for bookings by vehicleTypeIds. OR Filter
     */
    vehicleTypeIds?: Array<string>;
};

export enum FindAllBookingsSort {
    BOOKING_NUMBER = 'bookingNumber',
    START_DATE = 'startDate',
    END_DATE = 'endDate',
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate',
    RELEVANT_DATE = 'relevantDate'
}

export enum FindAllCarsSort {
    CAR_LICENCE_PLATE = 'car.licencePlate',
    CAR_FIN = 'car.fin',
    CAR_MILAGE = 'car.milage',
    MAKE_NAME = 'make.name',
    VEHICLE_TYPE_MODEL = 'vehicleType.model',
    CAR_AVAILABLE_FROM = 'car.availableFrom',
    CAR_LAST_TUV_DATE = 'car.lastTuvDate',
    TYRE_CONDITION_PRIORITY = 'tyre_condition_priority',
    CAR_NEXT_ALLOCATION_START_DATE = 'car_next_allocation_start_date'
}

export enum FindAllInfringementsSort {
    CREATED_DATE = 'createdDate',
    STATUS = 'status'
}

export enum FindAllInsuranceCasesSort {
    CREATED_DATE = 'createdDate',
    END_DATE = 'endDate',
    START_DATE = 'startDate',
    STATUS = 'status',
    UPDATED_DATE = 'updatedDate'
}

export type FindAllInvoicesFilterDto = {
    /**
     * Filter for invoices with booking ids
     */
    bookingIds?: Array<string>;
    /**
     * Filter for invoices with invoiceDate after specified datetime
     */
    invoiceDateAfter?: Date;
    /**
     * Filter for invoices with invoiceDate before specified datetime
     */
    invoiceDateBefore?: Date;
    /**
     * Filter for invoices of one of the provided legal entities
     */
    legalEntityIds?: Array<string>;
    /**
     * Search for invoices by receiver firstName, lastName, company/agency and invoice number
     */
    query?: string;
    status?: Array<InvoiceStatus>;
    types?: Array<InvoiceType>;
};

export enum FindAllInvoicesSort {
    INVOICE_DATE = 'invoiceDate',
    UPDATED_DATE = 'updatedDate',
    INVOICE_NUMBER = 'invoiceNumber'
}

export enum FindAllLeadsSort {
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate',
    EMAIL = 'email',
    LAST_NAME = 'lastName'
}

export enum FindAllLedgerEntriesSort {
    AMOUNT = 'amount',
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate',
    SERVICE_DATE = 'serviceDate',
    DUE_DATE = 'dueDate',
    COUNTERPARTY_TYPE = 'counterpartyType',
    LANE = 'lane'
}

export enum FindAllMediaSort {
    CREATED_DATE = 'createdDate',
    TITLE = 'title'
}

export enum FindAllNewsSort {
    TITLE = 'title',
    STATUS = 'status',
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate',
    PUBLISHED_DATE = 'publishedDate'
}

export enum FindAllPaymentTerminalsSort {
    DESCRIPTION = 'description',
    TERMINAL_ID = 'terminalId'
}

export enum FindAllPaymentsSort {
    AMOUNT = 'amount',
    PAYMENT_TYPE = 'paymentType',
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate'
}

export enum FindAllReviewsSort {
    RATING = 'rating',
    STATUS = 'status',
    TARGET_TYPE = 'targetType',
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate',
    COMPLETED_DATE = 'completedDate'
}

export enum FindAllStationsSort {
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate'
}

export type FindAllSurveysConductedFilterDto = {
    bookingIds?: Array<string>;
    customerIds?: Array<string>;
    surveyIds?: Array<string>;
};

export enum FindAllSurveysConductedSort {
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate'
}

export enum FindAllUserSort {
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    EMAIL = 'email',
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate'
}

export enum FindAllVehicleTypesSort {
    MAKE_NAME = 'make.name',
    MODEL = 'model'
}

export enum FindAllVideosSort {
    TITLE = 'title',
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate'
}

export enum FraudDetectionFinalDecision {
    DE_CHECK_SCHUFA = 'DE: CHECK SCHUFA',
    ACCEPT = 'ACCEPT',
    MANUAL_CHECK_NEEDED = 'MANUAL CHECK NEEDED'
}

export type FraudDetectionInfo = {
    failedChecks: number | null;
    finalDecision: FraudDetectionFinalDecision | null;
    fraudProbability: number | null;
};

export enum FuelType {
    DIESEL = 'DIESEL',
    GASOLINE = 'GASOLINE',
    ELECTRIC = 'ELECTRIC'
}

export enum Gender {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    OTHER = 'OTHER'
}

export type GenerateAxaInvoicesDto = {
    insuranceProvider?: string;
    invoicesToGenerate: 'all' | 'axa' | 'porsche';
};

export type GenerateEuropInvoicesDto = {
    insuranceProvider?: string;
    invoicesToGenerate: 'all' | 'europ' | 'porsche';
};

export type GenerateInsuranceCaseInvoicesDto = {
    data: GenerateAxaInvoicesDto | GenerateEuropInvoicesDto | GenerateJlrInvoicesDto | GenerateRolandInvoicesDto | GenerateVolvoInvoicesDto;
};

export type GenerateJlrInvoicesDto = {
    insuranceProvider?: string;
    invoicesToGenerate?: unknown;
};

export type GenerateRolandInvoicesDto = {
    insuranceProvider?: string;
    invoicesToGenerate?: unknown;
};

export type GenerateVolvoInvoicesDto = {
    insuranceProvider?: string;
    invoicesToGenerate?: unknown;
};

export type GetBrevoContactBlacklistedResponseDto = {
    isBlacklisted: boolean | null;
    isEmailOnNewsletterList: boolean;
};

export type GetDepositResponseDto = {
    deposit: number;
};

export type GetMediaUploadUrlResponse = {
    fileKey: string;
    url: string;
};

export type GetMinAgeResponseDto = {
    minAge: number;
};

export enum GetOffersSort {
    MAKE = 'MAKE',
    MODEL = 'MODEL',
    TOTAL_PRICE = 'TOTAL_PRICE'
}

export type GetPresignedUploadUrlResponse = {
    fileKey: string;
    url: string;
};

export type GlobalSearchBookingDto = {
    bookingNumber: number;
    customerName: string;
    endDate: Date;
    id: string;
    licensePlate?: string;
    startDate: Date;
    status: string;
};

export type GlobalSearchCarDto = {
    fleetNumber: number;
    id: string;
    licensePlate?: string | null;
    makeName: string;
    model: string;
    status: string;
};

export type GlobalSearchCustomerDto = {
    company?: string;
    customerNumber: number;
    email: string;
    firstName: string;
    id: string;
    lastName: string;
};

export type GlobalSearchInvoiceDto = {
    bookingNumber?: number;
    completeInvoiceNumber: string;
    customerName: string;
    id: string;
    status: string;
};

export type GlobalSearchResponseDto = {
    bookings: Array<GlobalSearchBookingDto>;
    cars: Array<GlobalSearchCarDto>;
    customers: Array<GlobalSearchCustomerDto>;
    invoices: Array<GlobalSearchInvoiceDto>;
};

export type GlobalSettings = {
    id: string;
    showHandoverSurvey: string | null;
};

export type GooglePayPaymentMethodDto = {
    googlePaymentToken: string;
    type: 'googlepay';
};

export type HolidaySubdivisionDto = {
    code: string;
    name: string;
};

export type IPaginationLinks = {
    first?: string;
    last?: string;
    next?: string;
    previous?: string;
};

export type IgnoredHolidayDto = {
    alternativeOpeningHours?: AlternativeOpeningHoursDto;
    holiday: PublicHolidayDto | SpecificDateDto;
    isClosed?: boolean;
};

export type InclusiveKmPerDay = {
    fromDay: number;
    kmInclusivePerDay: number;
};

export type InclusiveKmsDto = {
    kmFromDays: Array<InclusiveKmPerDay>;
    pricePerExtraKmLte: number | null;
};

export type Infringement = {
    chargeFeeVatMode: InfringementChargeFeeVatMode | null;
    comment: string;
    createdDate: Date;
    data: InfringementData | null;
    id: string;
    imageFileKey: string;
    imageFileUrl?: string;
    rosBooking: Booking | null;
    rosInvoice: Invoice | null;
    skipSendAuthorityMail?: boolean;
    status: InfringementStatus;
    steps?: InfringementSteps;
    updatedDate: Date;
    waivedReason: InfringementWaivedReason | null;
    waivedReasonComment: string | null;
    wunderBooking: WunderBooking | null;
    wunderChargeContext: InfringementWunderChargeContext | null;
};

export enum InfringementChargeFeeVatMode {
    WITH_VAT = 'WITH_VAT',
    WITHOUT_VAT = 'WITHOUT_VAT'
}

export type InfringementData = {
    authority?: string | null;
    /**
     * Origin country of infringement as ISO 3166-1 alpha-2 code
     */
    country?: string | null;
    date?: string | null;
    /**
     * Document language as ISO 639-1 alpha-2 code
     */
    documentLanguage?: string | null;
    email?: string | null;
    fileNumber?: string | null;
    infringementType?: InfringementType | null;
    licencePlate?: string | null;
};

export type InfringementFeeDto = {
    /**
     * Fee amount in EUR
     */
    amount: number;
    /**
     * ISO 3166-1 alpha-2 countries for this fee. Use null for the default fee for all remaining countries.
     */
    countries: Array<string> | null;
};

export enum InfringementStatus {
    PENDING = 'PENDING',
    EXTRACTING_DATA = 'EXTRACTING_DATA',
    AWAITING_USER_CONFIRMATION = 'AWAITING_USER_CONFIRMATION',
    EXECUTING = 'EXECUTING',
    COMPLETED = 'COMPLETED'
}

export type InfringementStatusEventDto = {
    infringement: Infringement;
    type: InfringementStatusEventType;
};

export enum InfringementStatusEventType {
    CREATE = 'create',
    UPDATE = 'update'
}

export enum InfringementStepStatus {
    ERROR = 'error',
    SUCCESS = 'success'
}

export type InfringementSteps = {
    chargeFee?: InfringementStepStatus;
    checkDuplicateFileNumber?: InfringementStepStatus;
    extractData?: InfringementStepStatus;
    findBooking?: InfringementStepStatus;
    sendAuthorityEmail?: InfringementStepStatus;
    sendInvoice?: InfringementStepStatus;
    sendPaymentLink?: InfringementStepStatus;
};

export enum InfringementType {
    SPEEDING = 'SPEEDING',
    PARKING = 'PARKING',
    OTHER = 'OTHER'
}

export type InfringementUserActionNeededCountDto = {
    awaitingConfirmationCount: number;
    dataCollectionFailedCount: number;
    otherExecutionFailedCount: number;
    paymentFailedCount: number;
};

export enum InfringementWaivedReason {
    LATE_PARKING_VIOLATION = 'LATE_PARKING_VIOLATION',
    INTERNAL = 'INTERNAL',
    OTHER = 'OTHER'
}

export type InfringementWunderChargeContext = {
    issueId?: number;
    uploadedFileId?: number;
};

export type InspectionDto = {
    allocationId: string;
    completedDate: Date | null;
    createdDate: Date;
    /**
     * Shot keys this inspection asks for, in catalog order at creation time.
     */
    expectedShotKeys: Array<InspectionShotKey>;
    id: string;
    /**
     * True once shots can no longer be captured, retaken, or skipped.
     */
    isLocked: boolean;
    phase: InspectionPhase;
    shots: Array<InspectionShotDto>;
};

export enum InspectionPhase {
    HANDOVER = 'HANDOVER',
    RETURN = 'RETURN'
}

export type InspectionShotDto = {
    /**
     * Id of the current capture; null when skipped.
     */
    captureId: string | null;
    /**
     * Signed URL of the photo; null while it is still uploading or when skipped.
     */
    imageFileUrl: string | null;
    /**
     * True when the shot was captured but its photo has not landed yet.
     */
    isImagePending: boolean;
    /**
     * Who captured or skipped the shot. Only id, first name, and last name are loaded.
     */
    recordedBy: User | null;
    recordedDate: Date;
    shotKey: InspectionShotKey;
    skipReason: string | null;
};

export enum InspectionShotKey {
    FRONT = 'front',
    REAR = 'rear',
    SIDE_LEFT = 'side-left',
    SIDE_RIGHT = 'side-right',
    FRONT_LOWER = 'front-lower',
    WINDSHIELD = 'windshield',
    RIM_FRONT_LEFT = 'rim-front-left',
    RIM_REAR_LEFT = 'rim-rear-left',
    RIM_FRONT_RIGHT = 'rim-front-right',
    RIM_REAR_RIGHT = 'rim-rear-right',
    INTERIOR_DRIVER = 'interior-driver',
    DASHBOARD = 'dashboard',
    REAR_SEATS = 'rear-seats',
    TRUNK = 'trunk'
}

export type InsuranceCase = {
    additionalInfo: string | null;
    booking?: Booking | null;
    createdDate: Date;
    customer?: User | null;
    customerData: CustomerData;
    endDate: Date | null;
    id: string;
    insuranceData: AxaInsuranceData | EuropInsuranceData | JlrInsuranceData | RolandInsuranceData | VolvoInsuranceData | null;
    insuranceProvider: InsuranceProviderName;
    locationGeocodedAddress: LocationGeocodedAddress | null;
    startDate?: Date | null;
    status: InsuranceCaseStatus;
    updatedDate: Date;
};

export enum InsuranceCaseStatus {
    INITIAL = 'INITIAL',
    BOOKED = 'BOOKED',
    HANDED_OVER = 'HANDED_OVER',
    RETURNED = 'RETURNED',
    CLOSED = 'CLOSED'
}

export enum InsuranceProviderName {
    AXA = 'axa',
    EUROP = 'europ',
    JLR = 'jlr',
    ROLAND = 'roland',
    VOLVO = 'volvo'
}

export enum IntendedRentalFrequency {
    ONE_TO_THREE_PER_MONTH = 'ONE_TO_THREE_PER_MONTH',
    FOUR_TO_TEN_PER_MONTH = 'FOUR_TO_TEN_PER_MONTH',
    ELEVEN_OR_MORE_PER_MONTH = 'ELEVEN_OR_MORE_PER_MONTH'
}

export type Invoice = {
    booking: Booking | null;
    canceledStateDate: Date | null;
    comment: string | null;
    completeInvoiceNumber: string | null;
    counterpartyType: CounterpartyType | null;
    createdDate: Date;
    customer: User | null;
    fileKey: string | null;
    id: string;
    infringement: Infringement | null;
    invoiceAllocations: Array<InvoiceAllocation>;
    invoiceDate: Date | null;
    invoiceNumber: number | null;
    invoiceNumberPrefix: string | null;
    invoiceNumberSuffix: string | null;
    legalEntity: LegalEntity;
    openStateDate: Date | null;
    originalInvoice: Invoice | null;
    paidAmountOfOriginalInvoice: number | null;
    paidStateDate: Date | null;
    payments: Array<Payment> | null;
    positions: Array<InvoicePosition>;
    receiverData: InvoiceReceiverData;
    reversalInvoices: Array<Invoice> | null;
    sentStateDate: Date | null;
    status: InvoiceStatus;
    taxCountry: TaxCountry;
    taxProcedure: TaxProcedure;
    title: string | null;
    totalAllocatedAmount?: number | null;
    readonly totalPositionSum: number;
    type: InvoiceType;
    updatedDate: Date;
};

export type InvoiceAllocation = {
    amount: number;
    createdAt: Date;
    finalizedAt: Date | null;
    id: string;
    invoice: Invoice;
    ledgerEntry: LedgerEntry;
    updatedDate: Date;
};

export type InvoiceAllocationDto = {
    amount: number;
    createdAt: Date;
    finalizedAt: Date | null;
    id: string;
    invoice: Invoice;
    ledgerEntry: LedgerEntryDto;
    updatedDate: Date;
};

export type InvoiceDto = {
    booking: Booking | null;
    canceledStateDate: Date | null;
    comment: string | null;
    completeInvoiceNumber: string | null;
    counterpartyType: CounterpartyType | null;
    createdDate: Date;
    currentBalance: number;
    customer: User | null;
    fileKey: string | null;
    fileUrl: string | null;
    id: string;
    infringement: Infringement | null;
    invoiceAllocations: Array<InvoiceAllocation>;
    invoiceDate: Date | null;
    invoiceNumber: number | null;
    invoiceNumberPrefix: string | null;
    invoiceNumberSuffix: string | null;
    legalEntity: LegalEntity;
    openStateDate: Date | null;
    originalInvoice: Invoice | null;
    paidAmountOfOriginalInvoice: number | null;
    paidStateDate: Date | null;
    payments: Array<Payment> | null;
    positions: Array<InvoicePosition>;
    receiverData: InvoiceReceiverData;
    reversalInvoices: Array<Invoice> | null;
    sentStateDate: Date | null;
    status: InvoiceStatus;
    taxCountry: TaxCountry;
    taxProcedure: TaxProcedure;
    title: string | null;
    totalAllocatedAmount?: number | null;
    readonly totalPositionSum: number;
    type: InvoiceType;
    updatedDate: Date;
};

export type InvoicePosition = {
    amount: number;
    lane?: string;
    tax: number;
    title: string;
    titleLocal?: string;
    unitPrice: number;
    unitType: InvoicePositionUnitType;
};

export type InvoicePositionDto = {
    amount: number;
    lane?: string;
    /**
     * The tax rate in % (e.g. 0.19 for 19%)
     */
    tax?: number;
    title: string;
    titleLocal?: string;
    unitPrice: number;
    unitType?: InvoicePositionUnitType;
};

export enum InvoicePositionUnitType {
    UNKNOWN = 'UNKNOWN',
    DAYS = 'DAYS'
}

export type InvoiceReceiverData = {
    city: string;
    company: string | null;
    country: string;
    email: string;
    firstName: string;
    lastName: string;
    preferredLocal?: Local;
    street: string;
    vatId: string | null;
    zip: string;
};

export type InvoiceReceiverDataDto = {
    city: string;
    company?: string | null;
    country: string;
    email: string;
    firstName: string;
    lastName: string;
    preferredLocal?: Local;
    street: string;
    vatId?: string | null;
    zip: string;
};

export type InvoiceScopeDto = {
    bookingId?: unknown;
    /**
     * ID of the invoice to allocate to
     */
    invoiceId: string;
    ledgerEntries?: unknown;
    type: 'invoice';
};

export enum InvoiceStatus {
    PRELIMINARY = 'PRELIMINARY',
    DRAFT = 'DRAFT',
    OPEN = 'OPEN',
    CANCELED = 'CANCELED'
}

export enum InvoiceType {
    BOOKING = 'BOOKING',
    DAMAGE = 'DAMAGE',
    ADMINISTRATIVE_OFFENCE = 'ADMINISTRATIVE_OFFENCE',
    REVERSAL = 'REVERSAL',
    OTHER = 'OTHER',
    GENERIC = 'GENERIC',
    CAR_SALE = 'CAR_SALE',
    CANCELLATION_FEE = 'CANCELLATION_FEE',
    COUPON = 'COUPON',
    SELF_BILLING = 'SELF_BILLING',
    CONTRACT_PENALTY = 'CONTRACT_PENALTY'
}

export type InvoicingRunResultDto = {
    regularInvoices: Array<InvoiceDto>;
    reversalInvoices: Array<InvoiceDto>;
    unabsorbedCredits: Array<UnabsorbedInvoiceCreditDto>;
};

export enum InvoicingType {
    REGULAR = 'REGULAR',
    COMMISSION = 'COMMISSION',
    COMPANY_REGULAR = 'COMPANY_REGULAR',
    COMPANY_INVOICE = 'COMPANY_INVOICE',
    COMPANY_BULK_INVOICE = 'COMPANY_BULK_INVOICE',
    INSURANCE = 'INSURANCE',
    AGENCY = 'AGENCY',
    AGENCY_BULK_INVOICE = 'AGENCY_BULK_INVOICE'
}

export type ItemsToNetDto = {
    /**
     * Items to net for agent
     */
    AGENCY?: Array<'invoices' | 'payments'>;
    /**
     * Items to net for customer
     */
    CUSTOMER?: Array<'invoices' | 'payments'>;
};

export type JwtUserDto = {
    email: string;
    featureFlags?: RecordStringAny;
    firstName: string;
    id: string;
    isEmailConfirmed: boolean;
    lastName: string;
    partnerSettings?: JwtPartnerSettingsDto;
    role: UserRole;
    stationIds?: Array<string>;
};

export type JlrInsuranceData = {
    initialDays: number;
    jlrCategory?: JlrVehicleCategory;
    referenceNumber: string;
};

export type JlrInsuranceDataDto = {
    initialDays: number;
    jlrCategory?: JlrVehicleCategory;
    referenceNumber: string;
};

export enum JlrVehicleCategory {
    GROUP_1 = 'GROUP_1',
    GROUP_2 = 'GROUP_2',
    GROUP_3 = 'GROUP_3'
}

export type JobDto = {
    attemptsMade: number;
    data: RecordStringAny;
    failedReason?: string;
    finishedOn?: number;
    id: string;
    name: string;
    processedOn?: number;
    progress: number;
    status: QueueJobStatus;
    timestamp: number;
};

export type JwtAnonymousDto = {
    featureFlags?: RecordStringAny;
    /**
     * The ID of the anonymous user
     */
    id: null;
    partnerSettings?: JwtPartnerSettingsDto;
};

export type JwtDeviceDto = {
    counterId?: string;
    deviceRole: DeviceAuthRole;
    /**
     * Synthetic device principal id
     */
    id: string;
    stationId?: string;
};

export type JwtExternalDriverDto = {
    /**
     * Handover allocation of the booking
     */
    bookingAllocationId: string;
    /**
     * Booking whose delivery handover this token is scoped to
     */
    bookingId: string;
    /**
     * Car handed over
     */
    carId: string;
    /**
     * Delivery transfer allocation holding the External driver email
     */
    deliveryTransferId: string;
    /**
     * External driver email the magic code was sent to
     */
    email: string;
    externalDriverAccess: true;
    /**
     * Synthetic external driver principal id
     */
    id: string;
    /**
     * Stations of the handover, for station checks on booking updates
     */
    stationIds: Array<string>;
};

export type JwtPartnerSettingsDto = {
    companyInvoicingType?: CompanyInvoicingType;
    country: string;
    email?: string;
    partnerAgencyType?: AgencyType;
    partnerId: string;
    partnerName: string;
    partnerRole: UserRole;
};

export type JwtRentalKeyTagDto = {
    /**
     * Booking this access token is scoped to
     */
    bookingId: string;
    /**
     * Synthetic rental key tag principal id
     */
    id: string;
    rentalKeyTagAccess: true;
};

export type JwtTokenResponseDto = {
    access_token: string;
    expires_in: string;
    refreshToken: string;
    user: JwtUserDto;
};

export enum LanguageCode {
    DE = 'de',
    EN = 'en',
    ES = 'es'
}

export type LastTyreConditionCheckDto = {
    date: Date;
    milage: number;
    numRentals: number;
};

export type Lead = {
    approvalRequest: ApprovalRequest | null;
    company: string;
    createdDate: Date;
    email: string;
    firstName: string;
    id: string;
    lastName: string;
    outcome: LeadOutcome | null;
    phone: string;
    plannedBookingsPerMonth: string;
    source: 'WEBSITE';
    status: LeadStatus;
    updatedDate: Date;
    user: User | null;
};

export enum LeadOutcome {
    CONVERTED = 'CONVERTED',
    DISMISSED = 'DISMISSED'
}

export enum LeadStatus {
    NEW = 'NEW',
    CONTACTED = 'CONTACTED',
    COMPLETED = 'COMPLETED'
}

export enum LedgerCostBreakdownBucket {
    BOOKING_COSTS = 'BOOKING_COSTS',
    ADDITIONAL_COSTS = 'ADDITIONAL_COSTS',
    INVOICE_TYPE = 'INVOICE_TYPE',
    CANCELLATION_REBOOKING_FEES = 'CANCELLATION_REBOOKING_FEES',
    OTHER = 'OTHER'
}

export type LedgerCostBreakdownLineDto = {
    amount: number;
    bucket: LedgerCostBreakdownBucket;
    /**
     * True when booking costs are taken from quoted pricing (no ledger entries yet)
     */
    fromQuotedPrice?: boolean;
    /**
     * Set when bucket is INVOICE_TYPE
     */
    invoiceType?: InvoiceType;
};

export type LedgerDescription = ({
    type: 'cancellation_fee';
} & CancellationFeeLedgerDescription) | ({
    type: 'cancellation';
} & CancellationLedgerDescription) | ({
    type: 'custom_extra';
} & CustomExtraLedgerDescription) | ({
    type: 'custom';
} & CustomLedgerDescription) | ({
    type: 'extra';
} & ExtraLedgerDescription) | ({
    type: 'manual_lane_credit';
} & ManualLaneCreditLedgerDescription) | ({
    type: 'payment_netting';
} & PaymentNettingLedgerDescription) | ({
    type: 'rental_fee';
} & RentalFeeLedgerDescription) | ({
    type: 'write_off';
} & WriteOffLedgerDescription) | ({
    type: 'additional_costs';
} & AdditionalCostsLedgerDescription);

export type LedgerEntriesScopeDto = {
    bookingId?: unknown;
    /**
     * Optional invoice ID for filtering
     */
    invoiceId?: string;
    /**
     * Ledger entries to allocate to
     */
    ledgerEntries: Array<LedgerEntryScope>;
    type: 'ledgerEntries';
};

export type LedgerEntry = {
    amount: number;
    amountNet: number;
    amountToInvoice: number;
    amountToPay: number;
    readonly amountToRequestPay: number;
    booking: Booking | null;
    counterpartyType: CounterpartyType;
    createdDate: Date;
    currency: 'EUR';
    description: LedgerDescription;
    dueDate: Date | null;
    excludedFromReconciliation?: boolean;
    id: string;
    invoiceAllocations: Array<InvoiceAllocation>;
    invoicedAmount: number;
    lane: string;
    legalEntity: LegalEntity;
    nettedInvoiceAmount: number;
    nettedPaymentAmount: number;
    nettingAllocations: Array<NettingAllocation>;
    paidAmount: number;
    paymentAllocations: Array<PaymentAllocation>;
    previousLedgerEntry: LedgerEntry | null;
    serviceDate: Date | null;
    taxCountry: TaxCountry;
    taxPercent: number;
    taxProcedure: TaxProcedure;
    updatedDate: Date;
};

export type LedgerEntryDto = {
    amount: number;
    amountNet: number;
    amountToInvoice: number;
    amountToPay: number;
    readonly amountToRequestPay: number;
    booking: Booking | null;
    counterpartyType: CounterpartyType;
    createdDate: Date;
    currency: 'EUR';
    description: LedgerDescription;
    dueDate: Date | null;
    excludedFromReconciliation?: boolean;
    id: string;
    invoiceAllocations: Array<InvoiceAllocation>;
    invoicedAmount: number;
    lane: string;
    legalEntity: LegalEntity;
    nettedInvoiceAmount: number;
    nettedPaymentAmount: number;
    nettingAllocations: Array<NettingAllocation>;
    paidAmount: number;
    paymentAllocations: Array<PaymentAllocation>;
    previousLedgerEntry: LedgerEntry | null;
    readableDescription?: LocalizedFieldDto;
    serviceDate: Date | null;
    taxCountry: TaxCountry;
    taxPercent: number;
    taxProcedure: TaxProcedure;
    updatedDate: Date;
};

export type LedgerEntryScope = {
    /**
     * Amount to allocate to the ledger entry (cents)
     */
    customAmount?: number;
    /**
     * ID of the ledger entry to allocate to
     */
    id: string;
};

export type LegacyOpeningTimes = {
    closingTime: ClockTime | null;
    openingTime: ClockTime | null;
};

export type LegalEntity = {
    adyenMerchantAccount: string;
    bankName: string;
    bic: string;
    city: LocalizedFieldDto;
    commercialRegister: string;
    countryCode: string;
    createdDate: Date;
    email: string;
    englishTerms: string;
    iban: string;
    id: string;
    invoiceNumberPrefix: string;
    isActive: boolean;
    isOssRegistered: boolean;
    localLanguage: string;
    localTerms: string;
    managingDirectors: string;
    name: string;
    phone: string;
    sepaCreditorId: string | null;
    stations?: Array<Station>;
    street: string;
    taxNumber: string | null;
    updatedDate: Date;
    vatId: string;
    website: string;
    zip: string;
};

export type LegalEntitySummaryDto = {
    id: string;
    name: string;
};

export type LegalEntityTermsDto = {
    html: string;
    legalEntityId: string;
    name: string;
    url: string;
};

export type LiveDashboardHandoverEventDto = {
    /**
     * Empty for heartbeats.
     */
    bookingId: string;
    /**
     * Planned booking start. Null for heartbeats.
     */
    bookingStartDate: Date | null;
    carImageUrl: string | null;
    /**
     * Location coordinates as [longitude, latitude].
     */
    coordinates: [
        number,
        number
    ];
    currentStep: ProcessStep | null;
    /**
     * Handover session id. Empty for heartbeats.
     */
    sessionId: string;
    /**
     * Empty for non-station handovers and heartbeats.
     */
    stationId: string;
    /**
     * Station city or delivery/pickup address label.
     */
    stationName: string;
    type: 'handover.ended' | 'handover.heartbeat' | 'handover.started' | 'handover.updated';
};

export enum Local {
    DE_DE = 'de-DE',
    EN_US = 'en-US',
    ES_ES = 'es-ES'
}

export type LocalizedFieldDto = {
    de: string;
    en: string;
    es?: string;
};

export type LocalizedFieldDto2 = {
    de: string;
    en: string;
    es?: string;
};

export type LocationDto = {
    latitude: number;
    longitude: number;
};

export type LocationGeocodedAddress = {
    city?: string;
    country?: string;
    displayName: string;
    location: LocationDto;
    street?: string;
    zip?: string;
};

export type LocationGeocodedAddressDto = {
    city?: string;
    country?: string;
    displayName: string;
    location: LocationDto;
    street?: string;
    zip?: string;
};

export type LocationGeocodedName = {
    city?: string;
    country?: string;
    displayName: string;
    street?: string;
    zip?: string;
};

export type LocationGeocodedNameDto = {
    city?: string;
    country?: string;
    displayName: string;
    street?: string;
    zip?: string;
};

export type LongTermPricing = {
    availableExtras?: Array<VehicleExtra>;
    readonly averagePricePerDay: number;
    basePrice: number;
    customDeposit?: number | null;
    customInclusiveKm?: number | null;
    customPricePerExtraKm?: number | null;
    readonly days: number;
    defaultDeposit: number;
    defaultInclusiveKm: number;
    defaultPricePerExtraKm: number;
    readonly deposit: number;
    endDate: Date;
    extrasSnapshot: Array<VehicleExtra>;
    readonly inclusiveKm: number;
    periods: Array<LongTermPricingPeriod>;
    readonly pricePerExtraKm: number;
    startDate: Date;
    /**
     * VAT rate in percent. Undefined uses the booking tax procedure default; a number is an explicit override.
     */
    taxPercent: number;
    readonly totalBasePrice: number;
    readonly totalPrice: number;
    type?: 'LONG_TERM';
};

export type LongTermPricingPeriod = {
    readonly averagePricePerDay: number;
    bookedExtras?: Array<BookedExtra>;
    readonly calcTotalBasePrice: number;
    customBookedExtras?: Array<CustomBookedExtraDto> | null;
    customInclusiveKm?: number | null;
    customTotalBasePrice?: number | null;
    readonly days: number;
    defaultInclusiveKm?: number | null;
    endDate: Date;
    readonly inclusiveKm?: number | null;
    startDate: Date;
    totalBasePrice: number;
    readonly totalPrice: number;
};

export type MagicCodeLoginDto = {
    email?: string;
    magicCode: string;
};

export type MailContent = {
    type: string;
    value: string;
};

export type MailSettings = {
    bcc?: {
        email?: string;
        enable?: boolean;
    };
    bypassBounceManagement?: {
        enable?: boolean;
    };
    bypassListManagement?: {
        enable?: boolean;
    };
    bypassSpamManagement?: {
        enable?: boolean;
    };
    bypassUnsubscribeManagement?: {
        enable?: boolean;
    };
    footer?: {
        enable?: boolean;
        html?: string;
        text?: string;
    };
    sandboxMode?: {
        enable?: boolean;
    };
    spamCheck?: {
        enable?: boolean;
        postToUrl?: string;
        threshold?: number;
    };
};

export type Make = {
    createdDate: Date;
    id: string;
    name: string;
    priceFactor: number;
    slug: string;
    updatedDate: Date;
};

export type ManualLaneCreditDto = {
    comment: string;
    credits: Array<ManualLaneCreditItemDto>;
};

export type ManualLaneCreditItemDto = {
    /**
     * Amount to credit in euros. Positive credits the lane; negative reverses a previous credit.
     */
    amount: number;
    counterpartyType: CounterpartyType;
    lane: string;
    /**
     * Tax country of the ledger bucket to credit
     */
    taxCountry: TaxCountry;
    /**
     * Tax percent of the ledger bucket to credit
     */
    taxPercent: number;
    taxProcedure: TaxProcedure;
};

export type ManualLaneCreditLedgerDescription = {
    comment: string;
    type: 'manual_lane_credit';
};

export type Media = {
    checksum: string;
    createdDate: Date;
    encodingStatus: MediaEncodingStatus;
    fileKey: string;
    fileUrl?: string | null;
    height: number | null;
    id: string;
    posterFileUrl?: string | null;
    title: string;
    type: 'VIDEO';
    updatedDate: Date;
    width: number | null;
};

export enum MediaEncodingStatus {
    PENDING = 'PENDING',
    PROCESSING = 'PROCESSING',
    READY = 'READY',
    FAILED = 'FAILED'
}

export type MediaStatusEventDto = {
    media: Media;
};

export type MigrateBlockerToWorkshopAppointmentDto = {
    additionalInformation?: string;
    allocationStatus?: AllocationStatus;
    contactPerson?: string;
    costs?: Array<WorkshopAppointmentCostDto>;
    readyForPickup?: boolean;
    /**
     * Skip car availability validation when saving overlapping appointments
     */
    skipCarAvailabilityCheck?: boolean;
    types: Array<WorkshopAppointmentType>;
    usesCollectAndReturnService: boolean;
};

export enum MilageDeviationReason {
    INSPECTION_MAINTENANCE = 'INSPECTION_MAINTENANCE',
    TIRE_CHANGE = 'TIRE_CHANGE',
    REPAIR = 'REPAIR',
    MARKETING = 'MARKETING',
    PIGGYBACK_TRANSPORT = 'PIGGYBACK_TRANSPORT',
    OTHER = 'OTHER'
}

export enum MilageExpectationMode {
    HANDOVER = 'handover',
    RETURN = 'return',
    DIRECT = 'direct'
}

export type MilageExpectationResponseDto = {
    delta: number;
    expectedMaxDelta: number | null;
    expectedMinDelta: number | null;
    includesTransfer: boolean;
    milageAfter: number;
    milageBefore: number;
    mode: MilageExpectationMode;
    needsConfirmation: boolean;
};

export type MinAgeDto = {
    minAge: number;
    netPurchasePriceLt: number | null;
};

export type MinimalAllocationDto = {
    bookingId: string;
    bookingNumber: string | null;
    bookingStatus: BookingStatus | null;
    carId: string;
    carName: string;
    comment: string;
    customerName: string | null;
    driverName: string | null;
    dropoffLocationGeocodedAddress: LocationGeocodedAddressDto | null;
    dropoffLocationType: BookingLocationType;
    dropoffResponsibleStationId: string | null;
    dropoffResponsibleStationInfo: LocalizedFieldDto | null;
    endDate: Date;
    externalDriverEmail: string | null;
    id: string;
    insuranceCaseId: string | null;
    isBlocking: boolean;
    pickupLocationGeocodedAddress: LocationGeocodedAddressDto | null;
    pickupLocationType: BookingLocationType;
    pickupResponsibleStationId: string | null;
    pickupResponsibleStationInfo: LocalizedFieldDto | null;
    rentalPartner: string | null;
    startDate: Date;
    stationId: string;
    stationInfo: LocalizedFieldDto;
    status: AllocationStatus;
    transferOfId: string | null;
    type: AllocationType;
    workshopAppointmentId: string | null;
    workshopAppointmentTypes: Array<WorkshopAppointmentType> | null;
};

export type MockCallRecord = {
    at: number;
    phoneNumber: string;
    sipId: string;
};

export type MockMailAttachment = {
    disposition?: string;
    filename: string;
    id: string;
    size: number;
    type?: string;
};

export type MockSmsRecord = {
    at: number;
    message: string;
    phoneNumber: string;
};

export type Netting = {
    allocations: Array<NettingAllocation>;
    createdDate: Date;
    description: string | null;
    id: string;
    type: NettingType;
    updatedDate: Date;
};

export type NettingAllocation = {
    amount: number;
    createdDate: Date;
    id: string;
    ledgerEntry: LedgerEntry;
    netting: Netting;
    updatedDate: Date;
};

export enum NettingType {
    AUTO_NETTING_INVOICE = 'AUTO_NETTING_INVOICE',
    AUTO_NETTING_PAYMENT = 'AUTO_NETTING_PAYMENT',
    AUTO_NETTING_BOTH = 'AUTO_NETTING_BOTH'
}

export type News = {
    content: string;
    createdDate: Date;
    id: string;
    publishedDate: Date | null;
    status: NewsStatus;
    title: string;
    updatedDate: Date;
};

export enum NewsStatus {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED'
}

export type NovuCredentialsDto = {
    /**
     * HMAC hash for secure authentication
     */
    hmacHash: string;
    /**
     * Unique subscriber ID (user ID)
     */
    subscriberId: string;
};

export enum NpsScoreCategory {
    DETRACTOR = 'DETRACTOR',
    PASSIVE = 'PASSIVE',
    PROMOTER = 'PROMOTER'
}

export type NpsSurvey = {
    booking: Booking | null;
    comment: string | null;
    completedDate: Date | null;
    createdDate: Date;
    id: string;
    score: number | null;
    readonly scoreCategory?: NpsScoreCategory | null;
    status: NpsSurveyStatus;
    updatedDate: Date;
    wishedCar: string | null;
};

export type NpsSurveyCompletionScreenDto = {
    bookingNumber?: number;
    car?: {
        imageUrl: string;
        make: string;
        model: string;
    };
    googleMapsReviewCtaUrl?: string | null;
    id: string;
    score?: number | null;
    status: NpsSurveyStatus;
};

export enum NpsSurveyStatus {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED'
}

export type Offer = {
    car: Car;
    freeUntil?: Date | null;
    isAvailable: boolean;
    nextPossibleEndDate?: Date | null;
    nextPossibleStartDate?: Date | null;
    pricing: Pricing;
};

export type OnlineBookingRequestDto = {
    acceptedPrice?: number;
    bookedCarId: string;
    bookedExtras: Array<BookedExtraDto>;
    browserInfo?: unknown;
    cardHolderData?: CardHolderDataDto;
    couponCodes?: Array<string>;
    customerComment?: string;
    customerData?: PublicCustomerDataDto;
    deferredPayment?: boolean;
    drivingExperienceSelected?: boolean;
    dropoffLocationType: BookingLocationType;
    dropoffPlaceId?: string;
    dropoffStationId?: string | null;
    dryRun?: boolean;
    email?: string;
    encryptedCardData?: EncryptedCardDataDto;
    endDate: Date;
    externalReference?: string | null;
    partnerToken?: string | null;
    pickupLocationType: BookingLocationType;
    pickupPlaceId?: string;
    pickupStationId?: string | null;
    returnUrl?: string;
    riskData?: unknown;
    salesChannel?: SalesChannel | null;
    startDate: Date;
    trackingData?: TrackingDataDto;
};

export type OpeningHours = {
    closingTime?: ClockTime | null;
    openingTime?: ClockTime | null;
    ranges: Array<TimeRange>;
    weekday: number;
};

export enum Order {
    ASC = 'ASC',
    DESC = 'DESC'
}

export type OriginMeta = {
    handlerName: string;
    jobId?: string;
    originType: 'controller' | 'queue';
    providerName: string;
    type: 'origin';
};

export type PaginationMeta = {
    currentPage: number;
    itemCount: number;
    itemsPerPage: number;
    nextPage: number | null;
    totalItems: number;
    totalPages: number;
};

export type PaginationAllocationTransactionDtoPaginationMeta = {
    readonly items: Array<AllocationTransactionDto>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationAllocationPaginationMeta = {
    readonly items: Array<Allocation>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationApprovalRequestResponseDtoPaginationMeta = {
    readonly items: Array<ApprovalRequestResponseDto>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationAuditLogPaginationMeta = {
    readonly items: Array<AuditLog>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationBookingPaginationMeta = {
    readonly items: Array<Booking>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationCarDocumentDtoPaginationMeta = {
    readonly items: Array<CarDocumentDto>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationCompactCarPaginationMeta = {
    readonly items: Array<CompactCar>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationCouponPaginationMeta = {
    readonly items: Array<Coupon>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationInfringementPaginationMeta = {
    readonly items: Array<Infringement>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationInsuranceCasePaginationMeta = {
    readonly items: Array<InsuranceCase>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationInvoiceDtoPaginationMeta = {
    readonly items: Array<InvoiceDto>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationJobDtoPaginationMeta = {
    readonly items: Array<JobDto>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationLeadPaginationMeta = {
    readonly items: Array<Lead>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationLedgerEntryDtoPaginationMeta = {
    readonly items: Array<LedgerEntryDto>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationMediaPaginationMeta = {
    readonly items: Array<Media>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationMinimalAllocationDtoPaginationMeta = {
    readonly items: Array<MinimalAllocationDto>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationNewsPaginationMeta = {
    readonly items: Array<News>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationOfferPaginationMeta = {
    readonly items: Array<Offer>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationPaymentTerminalPaginationMeta = {
    readonly items: Array<PaymentTerminal>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationPaymentPaginationMeta = {
    readonly items: Array<Payment>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationPaymentPaginationMeta2 = {
    readonly items: Array<Payment>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationReviewPaginationMeta = {
    readonly items: Array<Review>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationSettlementBatchListItemDtoPaginationMeta = {
    readonly items: Array<SettlementBatchListItemDto>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationStationPaginationMeta = {
    readonly items: Array<Station>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationSurveyConductedPaginationMeta = {
    readonly items: Array<SurveyConducted>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationUserDocumentDtoPaginationMeta = {
    readonly items: Array<UserDocumentDto>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationUserPaginationMeta = {
    readonly items: Array<User>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationVideoPaginationMeta = {
    readonly items: Array<Video>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationWorkshopAppointmentDocumentDtoPaginationMeta = {
    readonly items: Array<WorkshopAppointmentDocumentDto>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PaginationWorkshopAppointmentPaginationMeta = {
    readonly items: Array<WorkshopAppointment>;
    readonly links?: IPaginationLinks;
    readonly meta: PaginationMeta;
};

export type PartnerSubType = {
    agencySettings: PartnerSubTypeAgencySettings;
    createdDate: Date;
    id: string;
    name: LocalizedFieldDto;
    role: 'AGENCY' | 'COMPANY';
    /**
     * AgencyType for AGENCY rows or CompanyInvoicingType for COMPANY rows
     */
    type: AgencyType | null;
    updatedDate: Date;
};

export type PartnerSubTypeAgencySettings = {
    commissionPercent: number;
    discountPercent: number;
    noDeposit: boolean;
};

export type PatchProcessSessionDto = {
    agentProcessStep?: ProcessStep | null;
    counterId?: string | null;
    customerContactConfirmed?: boolean;
    customerScreen?: CustomerScreen;
    forceCounterTakeover?: boolean;
    revision: number;
    signatureFileKey?: string;
};

export type PayPalPaymentMethodDto = {
    type: 'paypal';
};

export type Payment = {
    allocatedBookings?: Array<AttributedBooking>;
    allocatedInvoices?: Array<AttributedInvoice>;
    amount: number;
    authorizationLastRefreshDate: Date | null;
    booking: Booking | null;
    comment: string | null;
    counterpartyType: CounterpartyType | null;
    readonly couponId?: string;
    createdDate: Date;
    creditCardDetails: CreditCardDetails | null;
    date: Date;
    id: string;
    invoice: Invoice | null;
    readonly isManualPayment: boolean;
    legalEntity: LegalEntity;
    paidDate: Date | null;
    paymentAllocations: Array<PaymentAllocation>;
    paymentLinkUrl: string | null;
    paymentType: PaymentType;
    referenceId: string | null;
    readonly refundedAmount: number;
    status: PaymentStatus;
    totalAllocatedAmount?: number | null;
    updatedDate: Date;
    walletProvider: WalletProvider | null;
};

export type PaymentAllocation = {
    amount: number;
    createdAt: Date;
    finalizedAt: Date | null;
    id: string;
    ledgerEntry: LedgerEntry;
    payment: Payment;
    updatedDate: Date;
};

export type PaymentAllocationDto = {
    amount: number;
    createdAt: Date;
    finalizedAt: Date | null;
    id: string;
    ledgerEntry: LedgerEntryDto;
    payment: Payment;
    updatedDate: Date;
};

export type PaymentDetailsResponseDto = {
    action?: unknown;
    donationToken?: string;
    isSuccess: boolean;
    order?: CheckoutOrderResponse | null;
    resultCode?: 'AuthenticationFinished' | 'AuthenticationNotRequired' | 'Authorised' | 'Cancelled' | 'ChallengeShopper' | 'Error' | 'IdentifyShopper' | 'PartiallyAuthorised' | 'Pending' | 'PresentToShopper' | 'Received' | 'RedirectShopper' | 'Refused' | 'Success';
};

export type PaymentLinkDto = {
    refNr: string;
    sendPaymentLinkResult: SendPaymentLinkResult;
    url: string;
};

export enum PaymentLinkReceiver {
    CUSTOMER = 'CUSTOMER',
    AGENCY = 'AGENCY',
    NONE = 'NONE'
}

export type PaymentMethodDto = ({
    type: 'applepay';
} & ApplePayPaymentMethodDto) | ({
    type: 'card';
} & CardPaymentMethodDto) | ({
    type: 'googlepay';
} & GooglePayPaymentMethodDto) | ({
    type: 'paypal';
} & PayPalPaymentMethodDto) | ({
    type: 'sepa';
} & SepaPaymentMethodDto);

export type PaymentNettingLedgerDescription = {
    type: 'payment_netting';
};

export enum PaymentStatus {
    PENDING = 'PENDING',
    PAID = 'PAID',
    CANCELLED = 'CANCELLED',
    AUTHORIZED = 'AUTHORIZED',
    CAPTURE_REQUESTED = 'CAPTURE_REQUESTED'
}

export enum PaymentTermDayType {
    CALENDAR_DAYS = 'CALENDAR_DAYS',
    BUSINESS_DAYS = 'BUSINESS_DAYS'
}

export type PaymentTerminal = {
    description: string;
    id: string;
    station?: Station;
    terminalId: number;
    users?: Array<User> | null;
};

export enum PaymentType {
    VISA = 'VISA',
    MASTERCARD = 'MASTERCARD',
    AMERICAN_EXPRESS = 'AMERICAN_EXPRESS',
    DINERS = 'DINERS',
    MAESTRO = 'MAESTRO',
    JCB = 'JCB',
    CUP = 'CUP',
    ATM_CARD = 'ATM_CARD',
    TRANSFER = 'TRANSFER',
    PAYPAL = 'PAYPAL',
    CASH = 'CASH',
    VOUCHER = 'VOUCHER',
    DEPOSIT = 'DEPOSIT',
    COUPON = 'COUPON',
    SEPA_DIRECT_DEBIT = 'SEPA_DIRECT_DEBIT',
    OTHER = 'OTHER'
}

export type PercentageOptionDto = {
    /**
     * Human-readable label for the percentage option
     */
    label: string;
    /**
     * Percentage value (0-100)
     */
    value: number;
};

export type PersonalizationData = {
    bcc?: string | Array<EmailData> | {
        email: string;
        name?: string;
    };
    cc?: string | Array<EmailData> | {
        email: string;
        name?: string;
    };
    customArgs?: {
        [key: string]: string;
    };
    dynamicTemplateData?: {
        [key: string]: unknown;
    };
    from?: string | {
        email: string;
        name?: string;
    };
    headers?: {
        [key: string]: string;
    };
    sendAt?: number;
    subject?: string;
    substitutions?: {
        [key: string]: string;
    };
    to: string | Array<EmailData> | {
        email: string;
        name?: string;
    };
};

export type Point = {
    coordinates: [
        number,
        number
    ];
    type: 'Point';
};

export type PorscheCenter = {
    displayName: string;
    userId: string;
};

export type PorscheCenterDto = {
    displayName: string;
    userId: string;
};

export type PorscheCenterDto2 = {
    displayName: string;
    userId: string;
};

export type PorscheCenter2 = {
    displayName: string;
    userId: string;
};

export type PosSessionRequestDto = {
    bookingId?: string | null;
    setupToken: string;
};

export type PosSessionResponseDto = {
    id: string;
    sdkData: string;
};

export type PossibleUpgrade = {
    from: Car;
    id: string;
    order: number;
    to: Car;
};

export type PossibleUpgradesDto = {
    order: number;
    toId: string;
};

export type PricePerDay = {
    fromDay: number;
    pricePerDay: number;
};

export enum PriceRecalculationMode {
    USE_EXISTING = 'USE_EXISTING',
    SCALE = 'SCALE',
    RECALCULATE = 'RECALCULATE',
    REBOOK = 'REBOOK'
}

export type Pricing = ({
    type: 'LONG_TERM';
} & LongTermPricing) | ({
    type: 'SHORT_TERM';
} & ShortTermPricing);

export type PricingModifierConditionsDto = {
    allowedDiscountTimePeriod?: number;
    categories?: Array<VehicleCategory>;
    fromDayDuration?: number;
    fromStationLoad?: number;
    makes?: Array<string>;
    stations?: Array<string>;
    timePeriod?: TimePeriodConditionDto;
    weekDays?: Array<number>;
};

export type PricingModifierDto = {
    conditions: PricingModifierConditionsDto;
    factor: number;
    templateId: number;
};

export type PricingModifierTemplateConditionsDto = {
    allowedDiscountTimePeriod?: boolean;
    categories?: boolean;
    fromDayDuration?: boolean;
    fromStationLoad?: boolean;
    makes?: boolean;
    stations?: boolean;
    timePeriod?: boolean;
    weekDays?: boolean;
};

export type PricingModifierTemplateDto = {
    conditions: PricingModifierTemplateConditionsDto;
    id: number;
    name: string;
};

export type PricingModifiers = {
    createdDate: Date;
    id: number;
    modifiers: Array<PricingModifierDto>;
    templates: Array<PricingModifierTemplateDto>;
    updatedDate: Date;
};

export enum PricingType {
    SHORT_TERM = 'SHORT_TERM',
    LONG_TERM = 'LONG_TERM'
}

export type PrivateFileUrl = {
    fileUrl: string;
};

export type ProcessSessionBookingSummaryDto = {
    bookingNumber: number;
    customContractCheckboxLabels?: Array<string>;
    customerEmail?: string;
    customerFirstName?: string;
    customerLastName?: string;
    customerPhone?: string;
    depositAmount?: number | null;
    displayLocale: Local;
    dropoffLabel: string;
    endDate: string;
    licencePlate?: string;
    outstandingBalance?: number;
    pickupLabel: string;
    startDate: string;
    vehicleCategories?: Array<VehicleCategory>;
    vehicleImageUrl?: string | null;
    vehicleMake: string;
    vehicleModel: string;
};

export type ProcessSessionContractDto = {
    signatureFileKey?: string;
    signatureFileUrl?: string;
};

export type ProcessSessionEventDto = {
    bookingId: string;
    revision: number;
    type: ProcessSessionEventType;
};

export enum ProcessSessionEventType {
    SESSION_UPDATED = 'session.updated',
    SESSION_TAKEN_OVER = 'session.takenOver',
    SESSION_DETACHED = 'session.detached',
    SESSION_ENDED = 'session.ended',
    SESSION_COUNTER_RELEASED = 'session.counterReleased',
    SESSION_HEARTBEAT = 'session.heartbeat'
}

export type ProcessSessionGatesDto = {
    customerContactConfirmed: boolean;
    customerSignatureCaptured: boolean;
};

export type ProcessSessionResponseDto = {
    agentProcessStep: ProcessStep | null;
    agentUserId: string;
    bookingId: string;
    bookingSummary?: ProcessSessionBookingSummaryDto;
    contract?: ProcessSessionContractDto;
    counterId?: string | null;
    createdAt: string;
    customerScreen?: CustomerScreen;
    gates?: ProcessSessionGatesDto;
    revision: number;
    sessionId: string;
    type: ProcessSessionType;
    updatedAt: string;
};

export enum ProcessSessionType {
    HANDOVER = 'handover',
    RETURN = 'return'
}

export enum ProcessStep {
    HANDOVER_OVERVIEW = 'HANDOVER_OVERVIEW',
    HANDOVER_SURVEY = 'HANDOVER_SURVEY',
    HANDOVER_CLIENT_DATA = 'HANDOVER_CLIENT_DATA',
    HANDOVER_PAYMENT = 'HANDOVER_PAYMENT',
    HANDOVER_CAR_STATUS = 'HANDOVER_CAR_STATUS',
    HANDOVER_INSPECTION = 'HANDOVER_INSPECTION',
    HANDOVER_CONTRACT = 'HANDOVER_CONTRACT',
    RETURN_OVERVIEW = 'RETURN_OVERVIEW',
    RETURN_DAMAGES = 'RETURN_DAMAGES',
    RETURN_CAR_STATUS = 'RETURN_CAR_STATUS',
    RETURN_INSPECTION = 'RETURN_INSPECTION'
}

export type PromoteStoredPaymentMethodDto = {
    /**
     * ID of the booking that holds the stored payment method.
     */
    bookingId: string;
    /**
     * ID of the stored payment method to mark as the periodic-charge method.
     */
    storedPaymentMethodId: string;
};

export type PublicCustomerDataDto = {
    city?: string;
    company?: string;
    country?: string;
    dateOfBirth?: Date;
    firstName?: string;
    gender?: Gender;
    idCardAuthority?: string;
    idCardDate?: Date;
    idCardNumber?: string;
    lastName?: string;
    licenseAuthority?: string;
    licenseDate?: Date;
    licenseNumber?: string;
    phone?: string;
    preferredLocal: Local;
    street?: string;
    vatId?: string;
    zip?: string;
};

export type PublicHolidayDto = {
    rule: string;
    year?: number;
};

export type PublicLegalEntityDto = {
    countryCode: string;
    id: string;
    localLanguage: string;
    name: string;
};

export enum QueueJobStatus {
    ACTIVE = 'active',
    WAITING = 'waiting',
    DELAYED = 'delayed',
    FAILED = 'failed',
    COMPLETED = 'completed',
    WAITING_CHILDREN = 'waiting-children'
}

export type QueueStatsDto = {
    /**
     * Number of active jobs
     */
    active: number;
    /**
     * Number of completed jobs
     */
    completed: number;
    /**
     * Number of delayed jobs
     */
    delayed: number;
    /**
     * Number of failed jobs
     */
    failed: number;
    /**
     * Number of waiting jobs
     */
    waiting: number;
    /**
     * Number of jobs waiting on children
     */
    waitingChildren: number;
};

export type RebookingResultDto = {
    cancellationFee?: number;
    isAvailable: boolean;
    updatedPricing?: ({
        type: 'LONG_TERM';
    } & LongTermPricing) | ({
        type: 'SHORT_TERM';
    } & ShortTermPricing);
};

export type RecalculateLedgerEntriesDto = {
    /**
     * Booking whose ledger entry derived fields should be recalculated.
     * Exactly one of bookingId, invoiceId, or paymentId must be provided.
     */
    bookingId?: string;
    /**
     * Invoice whose allocated ledger entry derived fields should be recalculated.
     * Exactly one of bookingId, invoiceId, or paymentId must be provided.
     */
    invoiceId?: string;
    /**
     * Payment whose allocated ledger entry derived fields should be recalculated.
     * Exactly one of bookingId, invoiceId, or paymentId must be provided.
     */
    paymentId?: string;
};

export type ReceivablesDownpaymentItemDto = {
    /**
     * Null for the catch-all orphan row
     */
    bookingId: string | null;
    bookingNumber: number | null;
    customerName: string | null;
    /**
     * Downpayment amount in euros
     */
    downpaymentAmount: number;
};

export type ReceivablesDownpaymentsDto = {
    items: Array<ReceivablesDownpaymentItemDto>;
    /**
     * Total downpayment amount in euros
     */
    totalAmount: number;
};

export type ReceivablesItemDto = {
    bookingCustomerData: RecordStringAny | null;
    bookingHasPeriodicInvoicing: boolean | null;
    bookingId: string | null;
    bookingNumber: number | null;
    completeInvoiceNumber: string | null;
    /**
     * Total amount due as of now, in euros
     */
    dueNowAmount: number;
    /**
     * Amount due within the dueDays window, in euros
     */
    duePeriodAmount: number;
    dueSince: Date | null;
    invoiceCustomerData: RecordStringAny | null;
    invoiceDate: Date | null;
    invoiceId: string | null;
    invoiceType: InvoiceType | null;
};

export type ReceivablesItemsDto = {
    items: Array<ReceivablesItemDto>;
};

export type ReceivablesProblemBookingDto = {
    /**
     * Remaining amount to invoice, in euros
     */
    amountToInvoice: number;
    bookingId: string;
    bookingNumber: number | null;
};

export type ReceivablesProblemInvoiceMismatchDto = {
    /**
     * Allocated ledger amount in euros
     */
    allocatedAmount: number;
    bookingId: string | null;
    bookingNumber: number | null;
    completeInvoiceNumber: string | null;
    /**
     * Difference in euros (allocated - positions)
     */
    differenceAmount: number;
    invoiceId: string;
    /**
     * Invoice positions total in euros
     */
    positionsAmount: number;
};

export type ReceivablesProblemPaymentDto = {
    /**
     * Agency name of the booking or invoice
     */
    agencyName: string | null;
    /**
     * Allocated amount in euros
     */
    allocatedAmount: number;
    /**
     * Payment amount in euros
     */
    amount: number;
    bookingId: string | null;
    bookingNumber: number | null;
    completeInvoiceNumber: string | null;
    /**
     * Customer name of the booking or invoice
     */
    customerName: string | null;
    invoiceId: string | null;
    paymentId: string;
    /**
     * Unallocated amount in euros
     */
    unallocatedAmount: number;
};

export type ReceivablesProblemsDto = {
    mismatchingBookingInvoices: Array<ReceivablesProblemInvoiceMismatchDto>;
    unallocatedPayments: Array<ReceivablesProblemPaymentDto>;
    uninvoicedBookings: Array<ReceivablesProblemBookingDto>;
};

export type ReceivablesSummaryDto = {
    /**
     * Net credit amount due for at least 1 hour, in euros (same booking×invoice grouping as the items list)
     */
    credit1hAmount: number;
    /**
     * Net outstanding amount due for at least 1 hour, in euros (same booking×invoice grouping as the items list)
     */
    due1hAmount: number;
    /**
     * Net outstanding amount due for at least 30 days, in euros (same booking×invoice grouping as the items list)
     */
    due30dAmount: number;
    /**
     * Net outstanding amount due for at least 60 days, in euros (same booking×invoice grouping as the items list)
     */
    due60dAmount: number;
    /**
     * Net outstanding amount due for at least 7 days, in euros (same booking×invoice grouping as the items list)
     */
    due7dAmount: number;
};

export type ReceivablesWriteOffsDto = {
    /**
     * Write-off ledger entries with booking (id, number, customer data) and legal entity (id, name)
     */
    items: Array<LedgerEntry>;
    /**
     * Total written-off amount in euros (positive; ledger amounts are negative)
     */
    totalAmount: number;
};

export type RecordStringAny = {
    [key: string]: unknown;
};

export type RedeemRentalKeyTagCodeDto = {
    code: string;
};

export type RefundUnallocatedPaymentAmountDto = {
    /**
     * Refund amount in euros (positive, at most the unallocated balance)
     */
    amount: number;
};

export type RefundUnallocatedPaymentAmountResponseDto = {
    creditedAmount: number;
    payment: Payment;
};

export type RegisterRentalKeyTagDto = {
    bookingId: string;
    /**
     * 14-character hex UID from the programmed tag
     */
    tagUid: string;
};

export type RegisterShotCaptureDto = {
    /**
     * Client-generated id of this capture; a later photo upload must carry the same id.
     */
    captureId: string;
};

export type RegistrationCertificateExtractionDto = {
    /**
     * Extracted FIN (Fahrzeug-Identifizierungsnummer / VIN). Validated against ISO 3779 (17 alphanumeric chars, no I/O/Q). Null if not found or failed validation.
     */
    fin: string | null;
    /**
     * Date of first registration from field "B" (Datum der Erstzulassung), returned as ISO 8601 YYYY-MM-DD string. Null if not found or unreadable.
     */
    firstRegistrationDate: string | null;
    /**
     * Extracted licence plate number as printed on the registration certificate. Null if not found or unreadable.
     */
    licencePlate: string | null;
};

export type RemoveCouponDto = {
    bookingId: string;
    /**
     * The coupon id to remove from the booking
     */
    couponId: string;
};

export type RentalFeeLedgerDescription = {
    car: {
        make: string;
        model: string;
    };
    endDate: string;
    startDate: string;
    type: 'rental_fee';
};

export type RentalKeyTagBookingIdDto = {
    bookingId: string;
};

export type RentalKeyTagLinkDto = {
    rentalKeyLink: string;
};

export type RentalKeyTagPrepareDto = {
    /**
     * Key 0 as 32 hex chars: shared write/admin key for authenticating
     * and rewriting the tag (not used for tap CMAC).
     */
    currentKey: string;
    /**
     * API base for the tap NDEF URL (`…/nfc/rental-key-tag?bookingId=…`)
     */
    tapBaseUrl: string;
};

export type RentalKeyTagRegisteredDto = {
    bookingId: string;
    tagUid: string;
};

export type RentalKeyTagSdmKeyDto = {
    /**
     * Key 1 as 32 hex chars: per-tag AES-128 for SUN CMAC. Field name
     * `sdmKey` matches the NTAG Secure Dynamic Messaging key slot used by the writer.
     */
    sdmKey: string;
};

export type RentalKeyTagStatusDto = {
    registered: boolean;
    tagUid: string | null;
};

export type RentalKeyTagSummaryDto = {
    allowedCountries: Array<string>;
    bookingId: string;
    bookingNumber: string;
    dropoffLocation: Point | null;
    dropoffLocationGeocodedAddress: LocationGeocodedName | null;
    dropoffLocationType: BookingLocationType;
    dropoffStation: Station | null;
    endDate: Date;
    isHandedOver: boolean;
    licensePlate: string | null;
    locale: string;
    maskedEmail: string;
    pickupLocation: Point | null;
    pickupLocationGeocodedAddress: LocationGeocodedName | null;
    pickupLocationType: BookingLocationType;
    pickupStation: Station | null;
    startDate: Date;
    supportPhone: string;
    vehicleImageUrl: string | null;
    vehicleName: string | null;
};

export type RentalKeyTagUidDto = {
    bookingId: string;
    /**
     * 14-character hex UID of the NTAG
     */
    tagUid: string;
};

export type RequestAdditionalCostsDto = {
    bookingId: string;
    returnDate?: Date | null;
};

export type RequestMagicCodeDto = {
    email: string;
    preferredLocale?: LanguageCode;
};

export type ResetPasswordDto = {
    password: string;
    token: string;
};

export type Review = {
    booking: Booking | null;
    comment: string | null;
    completedDate: Date | null;
    createdDate: Date;
    id: string;
    rating: number | null;
    secretCompletionToken: string | null;
    status: ReviewStatus;
    targetEmployee: User | null;
    targetType: 'HANDOVER';
    updatedDate: Date;
};

export type ReviewCompletionScreenDto = {
    car?: {
        imageUrl: string;
        make: string;
        model: string;
    };
    employee?: {
        firstName: string;
        lastName: string;
    };
    id: string;
    status: ReviewStatus;
    targetType: 'HANDOVER';
};

export enum ReviewStatus {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED'
}

export type RolandInsuranceData = {
    extensionMailSentDate?: string;
    licencePlate?: string;
    referenceNumber: string;
};

export type RolandInsuranceDataDto = {
    extensionMailSentDate?: string;
    licencePlate?: string;
    referenceNumber: string;
};

export enum RolandVehicleCategory {
    BMW_1 = 'BMW_1',
    BMW_2 = 'BMW_2',
    BMW_3 = 'BMW_3',
    BMW_4 = 'BMW_4',
    BMW_5 = 'BMW_5',
    BMW_6 = 'BMW_6'
}

export type RotationMediaMediaSummaryDto = {
    encodingStatus: MediaEncodingStatus;
    id: string;
    posterFileUrl: string | null;
    title: string;
};

export type RotationMediaPoolItemDto = {
    fileUrl: string;
    mediaId: string;
    posterFileUrl: string | null;
    weight: number;
};

export type RotationMediaResponseDto = {
    createdDate: Date;
    id: string;
    media: RotationMediaMediaSummaryDto;
    station: RotationMediaStationSummaryDto | null;
    updatedDate: Date;
    weight: number;
};

export type RotationMediaStationSummaryDto = {
    id: string;
    info: LocalizedFieldDto2;
};

export enum SalesChannel {
    BMW_WELT = 'BMW_WELT',
    HERTZ = 'HERTZ'
}

export type SendBookingLinkDto = {
    params: SendBookingLinkParamsDto;
    phoneNumber: string;
};

export type SendBookingLinkExtraDto = {
    type: VehicleExtraType;
    value: string;
};

export type SendBookingLinkParamsDto = {
    carId: string;
    customerData?: CustomerDataDto;
    dropoffLocation?: string;
    dropoffStationId?: string;
    endDate: Date;
    extras: Array<SendBookingLinkExtraDto>;
    locale?: string;
    pickupLocation?: string;
    pickupStationId?: string;
    startDate: Date;
    step: BookingLinkStep;
};

export type SendDepositReceiptDto = {
    receiptText: string;
};

export type SendExternalHandoverLinkDto = {
    /**
     * Delivery transfer that holds the External driver email
     */
    deliveryTransferId: string;
    language?: LanguageCode;
};

export type SendPasswordResetMailDto = {
    email: string;
};

export enum SendPaymentLinkResult {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    DISABLED = 'DISABLED'
}

export type SendRentalKeyLinkDto = {
    bookingId: string;
    /**
     * If false, skip email and return the URL for copy.
     */
    sendMail: boolean;
};

export type SentCustomerMailMeta = {
    /**
     * Outbound attachments copied to private storage for download after send (same files as in the email).
     */
    attachments?: Array<CustomerMailAttachmentMeta>;
    bcc?: string;
    cc?: string;
    from: string;
    /**
     * Private S3 key for HTML body under booking-mail-audit/{bookingId}/bodies/ or invoice-mail-audit/{invoiceId}/bodies/.
     */
    htmlBodyKey?: string;
    /**
     * Short-lived presigned GET URL for htmlBodyKey. Set when listing audit logs for a Booking or Invoice.
     */
    htmlBodyUrl?: string;
    subject?: string;
    templateKey?: string;
    /**
     * Private S3 key for plain-text body under booking-mail-audit/{bookingId}/bodies/ or invoice-mail-audit/{invoiceId}/bodies/.
     */
    textBodyKey?: string;
    /**
     * Short-lived presigned GET URL for textBodyKey. Set when listing audit logs for a Booking or Invoice.
     */
    textBodyUrl?: string;
    to?: string;
    type: 'customer-mail';
};

export type SepaDataDto = {
    /**
     * Account holder name
     */
    accountHolderName: string;
    /**
     * IBAN (International Bank Account Number)
     */
    iban: string;
};

export type SepaPaymentMethodDto = {
    sepaData: SepaDataDto;
    type: 'sepa';
};

export type SettlementBatchDetailsDto = {
    batchNumber: number;
    id: string;
    lines: Array<SettlementDetailLineDto>;
};

export type SettlementBatchListItemDto = {
    /**
     * Batch number as assigned by Adyen; only unique per merchant account
     */
    batchNumber: number;
    /**
     * Signed net sum of DepositCorrection lines
     */
    depositCorrectionSum: number;
    /**
     * Sum of Fee net debits
     */
    feesSum: number;
    id: string;
    /**
     * Signed net sum of InvoiceDeduction lines
     */
    invoiceDeductionSum: number;
    /**
     * Count of matchable PSP lines that are unassigned (no payment link) or
     * amount-mismatched
     */
    issueCount: number;
    legalEntity: LegalEntitySummaryDto;
    /**
     * MerchantPayout net debit
     */
    payoutAmount: number;
    /**
     * Count of settlement transactions (matchable journal types)
     */
    transactionCount: number;
};

export enum SettlementBatchStatus {
    DOWNLOADING = 'DOWNLOADING',
    PROCESSING = 'PROCESSING',
    PROCESSED = 'PROCESSED',
    FAILED = 'FAILED'
}

export type SettlementCashFlowOverviewDto = {
    /**
     * Signed sum of unmatched PAID Adyen payments after the maximum matchable
     * detail creationDate across PROCESSED batches of the same legal entity
     */
    unsettledPaymentBalance: number;
    /**
     * Count of Payments that make up the unsettled payment balance
     */
    unsettledPaymentCount: number;
};

export type SettlementDetailLineDto = {
    /**
     * Signed gross amount (debits negative)
     */
    grossAmount: number;
    id: string;
    matchStatus: SettlementDetailMatchStatus | null;
    merchantReference: string | null;
    modificationMerchantReference: string | null;
    /**
     * Adyen Modification Reference (related PSP)
     */
    modificationPspReference: string | null;
    payment: Payment | null;
    paymentMethod: string | null;
    pspReference: string | null;
    type: string;
};

export enum SettlementDetailMatchStatus {
    MATCHED = 'MATCHED',
    AMOUNT_MISMATCH = 'AMOUNT_MISMATCH',
    NOT_FOUND_IN_SYSTEM = 'NOT_FOUND_IN_SYSTEM'
}

export type ShortTermPricing = {
    readonly agencyDiscountPercent?: number | null;
    agencySettings?: AgencySettings | null;
    availableExtras?: Array<VehicleExtra>;
    averagePricePerDay: number;
    basePrice: number;
    bookedExtras?: Array<BookedExtra>;
    readonly calcTotalBasePrice?: number | null;
    cancellationFee?: CancellationFee;
    cancellationFeeAmount?: number;
    createdDate?: Date;
    customBookedExtras?: Array<CustomBookedExtraDto> | null;
    customDeposit?: number | null;
    customInclusiveKm?: number | null;
    customPricePerExtraKm?: number | null;
    customTotalBasePrice?: number | null;
    days: number;
    defaultDeposit: number;
    defaultInclusiveKm: number;
    defaultPricePerExtraKm: number;
    readonly deposit: number;
    readonly hasCustomPrice: boolean;
    id?: string;
    readonly inclusiveKm: number;
    isDiscounted: boolean;
    readonly pricePerExtraKm: number;
    pricingModifiersVersion?: number | null;
    /**
     * VAT rate in percent. Undefined uses the booking tax procedure default; a number is an explicit override.
     */
    taxPercent: number;
    totalBasePrice: number;
    totalPrice: number;
    type?: 'SHORT_TERM';
    undiscountedAveragePricePerDay?: number | null;
    undiscountedTotalBasePrice?: number | null;
    undiscountedTotalPrice?: number | null;
    updatedDate?: Date;
};

export type SkipShotDto = {
    reason: string;
};

export type SpecificDateDto = {
    specificDate: string;
};

export type StartInspectionDto = {
    allocationId: string;
    phase: InspectionPhase;
};

export type Station = {
    alternativeOpeningHours?: Array<AlternativeOpeningHours>;
    authCode: string | null;
    cars?: Array<CarStations>;
    city: string;
    counters?: Array<StationCounter>;
    countryCode: string;
    createdDate: Date;
    deletedDate: Date | null;
    googleMapsReviewCtaUrl: string | null;
    holidays?: Array<Date>;
    icon: StationIcon | null;
    id: string;
    ignoredHolidays: Array<IgnoredHolidayDto> | null;
    info: LocalizedFieldDto2;
    invoiceSuffix: string | null;
    isGoogleMapsReviewEnabled: boolean;
    isHidden: boolean;
    isInternal: boolean;
    legalEntity: LegalEntity;
    location: Point;
    mapImageFileKey: string | null;
    readonly mapImageUrl?: string | null;
    notice: LocalizedFieldDto2 | null;
    openingHours: Array<OpeningHours>;
    paymentTerminals?: Array<PaymentTerminal> | null;
    returnPolicy: StationReturnPolicy;
    slug: string;
    state: string | null;
    street: string;
    timezone: Timezone;
    updatedDate: Date;
    users?: Array<User> | null;
    zip: string;
};

export type StationCounter = {
    createdDate: Date;
    id: string;
    name: string;
    station: Station;
    stationId: string;
    updatedDate: Date;
};

export enum StationIcon {
    CITY = 'city',
    AIRPORT = 'airport',
    TRAIN = 'train',
    PALM = 'palm',
    CAR = 'car'
}

export type StationOpeningHoursDto = {
    ranges: Array<TimeRange>;
    weekday: number;
};

export enum StationReturnPolicy {
    AFTER_HOURS_KEYBOX = 'AFTER_HOURS_KEYBOX',
    OPENING_HOURS_ONLY = 'OPENING_HOURS_ONLY'
}

export type StoreIbanPaymentMethodDto = {
    /**
     * Account holder name on the SEPA mandate.
     */
    accountHolderName: string;
    /**
     * ID of the booking to store the IBAN on.
     */
    bookingId: string;
    /**
     * Whose Adyen shopper the IBAN is stored under. CUSTOMER or AGENCY; not OTHER.
     */
    counterpartyType?: CounterpartyType;
    /**
     * IBAN to store as a SEPA Direct Debit payment method.
     */
    iban: string;
    /**
     * Whether a signed SEPA mandate is on file for this IBAN.
     */
    mandateSigned: boolean;
    /**
     * Purpose tag to stamp on the stored payment method. ONLINE_PAYMENT on every booking; PERIODIC on periodic-invoicing bookings.
     */
    purpose?: CreditCard;
};

export type StorePaymentMethodDto = {
    /**
     * ID of the booking to store a payment method on.
     */
    bookingId: string;
    paymentLinkReceiver?: PaymentLinkReceiver;
    /**
     * Purpose tag to stamp on the stored payment method. ONLINE_PAYMENT on every booking; PERIODIC on periodic-invoicing bookings.
     */
    purpose?: CreditCard;
};

export type StoredMockMail = {
    asm?: AsmOptions;
    attachments?: Array<MockMailAttachment>;
    batchId?: string;
    bcc?: string | Array<EmailData> | {
        email: string;
        name?: string;
    };
    bookingId?: string;
    categories?: Array<string>;
    category?: string;
    cc?: string | Array<EmailData> | {
        email: string;
        name?: string;
    };
    content?: Array<MailContent> | (Array<MailContent> & {
        0: MailContent;
    });
    customArgs?: {
        [key: string]: unknown;
    };
    dynamicTemplateData?: {
        [key: string]: unknown;
    };
    from?: string;
    headers?: {
        [key: string]: string;
    };
    hideWarnings?: boolean;
    html?: string;
    invoiceId?: string;
    ipPoolName?: string;
    isMultiple?: boolean;
    mailSettings?: MailSettings;
    personalizations?: Array<PersonalizationData>;
    replyTo?: string | {
        email: string;
        name?: string;
    };
    replyToList?: Array<EmailJson> | EmailJson;
    sections?: {
        [key: string]: string;
    };
    sendAt?: number;
    subject?: string;
    substitutionWrappers?: Array<string>;
    substitutions?: {
        [key: string]: string;
    };
    template?: 'agency-upcoming-invoice' | 'auth-code' | 'block-payment-link' | 'booking-cancelled' | 'booking-confirmed' | 'booking-created' | 'booking-payment-completed' | 'car-returned' | 'car-swapped' | 'charge-payment-link' | 'coupon-activated' | 'deposit-receipt' | 'europ-customer-info' | 'europ-weekly-bookings-report' | 'external-handover-link' | 'handed-over' | 'handover-feedback' | 'infringement-invoice' | 'invoice-to-agency' | 'nps-survey' | 'period-due-notice' | 'porsche-assistance' | 'rental-key-link' | 'roland-extension-info' | 'send-invoice' | 'sepa-mandate-confirmation' | 'store-payment-method-payment-link' | 'upcoming-booking' | 'welcome-commission-agency' | 'welcome-company-user';
    templateId?: string;
    text?: string;
    to?: string | Array<EmailData> | {
        email: string;
        name?: string;
    };
    trackingSettings?: TrackingSettings;
};

export type SubjectType = string | (AnyClassAny & {
    modelName?: string;
});

export type SuggestCustomerDataDto = {
    bookingNumber?: number | null;
    /**
     * Number of bookings with this exact address (only for source=booking)
     */
    bookingsCount?: number | null;
    customerData: CustomerDataDto;
    customerId?: string | null;
    email?: string | null;
    partner?: User | null;
    source: 'booking' | 'user';
};

export type Survey = {
    conducted: Array<SurveyConducted>;
    createdDate: Date;
    id: string;
    questions: Array<SurveyQuestion>;
    slug: string;
    titleDe: string;
    titleEn: string;
    updatedDate: Date;
};

export type SurveyAnswer = {
    conducted: Array<SurveyConducted> | null;
    createdDate: Date;
    deleted: boolean;
    id: string;
    order: number;
    question: SurveyQuestion;
    textDe: string;
    textEn: string;
    updatedDate: Date;
};

export type SurveyAnswerDto = {
    order: number;
    textDe: string;
    textEn: string;
};

export type SurveyAnswersOrderDto = {
    id: string;
    order: number;
};

export type SurveyConducted = {
    answers: Array<SurveyAnswer> | null;
    booking: Booking;
    createdDate: Date;
    id: string;
    survey: Survey;
    updatedDate: Date;
};

export type SurveyQuestion = {
    answers: Array<SurveyAnswer>;
    createdDate: Date;
    deleted: boolean;
    id: string;
    order: number;
    survey: Survey;
    textDe: string;
    textEn: string;
    updatedDate: Date;
};

export type SurveyQuestionDto = {
    answers: Array<SurveyAnswerDto>;
    order: number;
    textDe: string;
    textEn: string;
};

export type SurveyQuestionsOrderDto = {
    id: string;
    order: number;
};

export enum TaxCountry {
    AD = 'AD',
    AE = 'AE',
    AF = 'AF',
    AG = 'AG',
    AI = 'AI',
    AL = 'AL',
    AM = 'AM',
    AO = 'AO',
    AR = 'AR',
    AT = 'AT',
    AU = 'AU',
    AW = 'AW',
    AZ = 'AZ',
    BA = 'BA',
    BB = 'BB',
    BD = 'BD',
    BE = 'BE',
    BF = 'BF',
    BG = 'BG',
    BH = 'BH',
    BI = 'BI',
    BJ = 'BJ',
    BL = 'BL',
    BM = 'BM',
    BN = 'BN',
    BO = 'BO',
    BQ = 'BQ',
    BR = 'BR',
    BS = 'BS',
    BT = 'BT',
    BV = 'BV',
    BW = 'BW',
    BY = 'BY',
    BZ = 'BZ',
    CA = 'CA',
    CC = 'CC',
    CD = 'CD',
    CF = 'CF',
    CG = 'CG',
    CH = 'CH',
    CI = 'CI',
    CK = 'CK',
    CL = 'CL',
    CM = 'CM',
    CN = 'CN',
    CO = 'CO',
    CR = 'CR',
    CU = 'CU',
    CV = 'CV',
    CW = 'CW',
    CX = 'CX',
    CY = 'CY',
    CZ = 'CZ',
    DE = 'DE',
    DJ = 'DJ',
    DK = 'DK',
    DM = 'DM',
    DO = 'DO',
    DZ = 'DZ',
    EC = 'EC',
    EE = 'EE',
    EG = 'EG',
    EH = 'EH',
    ER = 'ER',
    ES = 'ES',
    ET = 'ET',
    FI = 'FI',
    FJ = 'FJ',
    FM = 'FM',
    FO = 'FO',
    FR = 'FR',
    GA = 'GA',
    GB = 'GB',
    GD = 'GD',
    GE = 'GE',
    GF = 'GF',
    GG = 'GG',
    GH = 'GH',
    GI = 'GI',
    GL = 'GL',
    GM = 'GM',
    GN = 'GN',
    GP = 'GP',
    GQ = 'GQ',
    GR = 'GR',
    GT = 'GT',
    GU = 'GU',
    GW = 'GW',
    GY = 'GY',
    HK = 'HK',
    HM = 'HM',
    HN = 'HN',
    HR = 'HR',
    HT = 'HT',
    HU = 'HU',
    ID = 'ID',
    IE = 'IE',
    IL = 'IL',
    IM = 'IM',
    IN = 'IN',
    IO = 'IO',
    IQ = 'IQ',
    IR = 'IR',
    IS = 'IS',
    IT = 'IT',
    JE = 'JE',
    JM = 'JM',
    JO = 'JO',
    JP = 'JP',
    KE = 'KE',
    KG = 'KG',
    KH = 'KH',
    KI = 'KI',
    KM = 'KM',
    KN = 'KN',
    KP = 'KP',
    KR = 'KR',
    KW = 'KW',
    KY = 'KY',
    KZ = 'KZ',
    LA = 'LA',
    LB = 'LB',
    LC = 'LC',
    LI = 'LI',
    LK = 'LK',
    LR = 'LR',
    LS = 'LS',
    LT = 'LT',
    LU = 'LU',
    LV = 'LV',
    LY = 'LY',
    MA = 'MA',
    MC = 'MC',
    MD = 'MD',
    ME = 'ME',
    MF = 'MF',
    MG = 'MG',
    MH = 'MH',
    MK = 'MK',
    ML = 'ML',
    MM = 'MM',
    MN = 'MN',
    MO = 'MO',
    MP = 'MP',
    MQ = 'MQ',
    MR = 'MR',
    MS = 'MS',
    MT = 'MT',
    MU = 'MU',
    MV = 'MV',
    MW = 'MW',
    MX = 'MX',
    MY = 'MY',
    MZ = 'MZ',
    NA = 'NA',
    NC = 'NC',
    NE = 'NE',
    NF = 'NF',
    NG = 'NG',
    NI = 'NI',
    NL = 'NL',
    NO = 'NO',
    NP = 'NP',
    NR = 'NR',
    NU = 'NU',
    NZ = 'NZ',
    OM = 'OM',
    PA = 'PA',
    PE = 'PE',
    PF = 'PF',
    PG = 'PG',
    PH = 'PH',
    PK = 'PK',
    PL = 'PL',
    PM = 'PM',
    PN = 'PN',
    PR = 'PR',
    PT = 'PT',
    PW = 'PW',
    PY = 'PY',
    QA = 'QA',
    RE = 'RE',
    RO = 'RO',
    RS = 'RS',
    RU = 'RU',
    RW = 'RW',
    SA = 'SA',
    SB = 'SB',
    SC = 'SC',
    SD = 'SD',
    SE = 'SE',
    SG = 'SG',
    SH = 'SH',
    SI = 'SI',
    SJ = 'SJ',
    SK = 'SK',
    SL = 'SL',
    SM = 'SM',
    SN = 'SN',
    SO = 'SO',
    SR = 'SR',
    SS = 'SS',
    ST = 'ST',
    SV = 'SV',
    SX = 'SX',
    SY = 'SY',
    SZ = 'SZ',
    TC = 'TC',
    TD = 'TD',
    TF = 'TF',
    TG = 'TG',
    TH = 'TH',
    TJ = 'TJ',
    TK = 'TK',
    TL = 'TL',
    TM = 'TM',
    TN = 'TN',
    TO = 'TO',
    TR = 'TR',
    TT = 'TT',
    TV = 'TV',
    TW = 'TW',
    TZ = 'TZ',
    UA = 'UA',
    UG = 'UG',
    UM = 'UM',
    US = 'US',
    UY = 'UY',
    UZ = 'UZ',
    VA = 'VA',
    VC = 'VC',
    VE = 'VE',
    VG = 'VG',
    VI = 'VI',
    VN = 'VN',
    VU = 'VU',
    WF = 'WF',
    WS = 'WS',
    YE = 'YE',
    YT = 'YT',
    ZA = 'ZA',
    ZM = 'ZM',
    ZW = 'ZW'
}

export enum TaxProcedure {
    REGULAR = 'REGULAR',
    REVERSE_CHARGE = 'REVERSE_CHARGE',
    EXPORT = 'EXPORT'
}

export enum TerminalTransactionType {
    BLOCK = 'BLOCK',
    CHARGE = 'CHARGE'
}

export enum TestQueueJobType {
    DELAY_THEN_SUCCEED = 'delay-then-succeed',
    DELAY_UNTIL_FAIL = 'delay-until-fail',
    IMMEDIATE_FAIL = 'immediate-fail',
    IMMEDIATE_SUCCESS = 'immediate-success',
    TWO_STEP_DELAY = 'two-step-delay'
}

export type TimePeriodConditionDto = {
    /**
     * Defaults to 1 when omitted.
     */
    fromDay?: number;
    fromMonth: number;
    fromYear?: number;
    isYearly: boolean;
    /**
     * Defaults to end of toMonth when omitted.
     */
    toDay?: number;
    toMonth: number;
};

export type TimeRange = {
    end: number;
    start: number;
};

export type TimeTrackingEntry = {
    endDate?: Date | null;
    startDate?: Date | null;
    user: User;
};

export enum Timezone {
    AFRICA_ALGIERS = "Africa/Algiers",
    ATLANTIC_CAPE_VERDE = "Atlantic/Cape_Verde",
    AFRICA_NDJAMENA = "Africa/Ndjamena",
    AFRICA_ABIDJAN = "Africa/Abidjan",
    AFRICA_BAMAKO = "Africa/Bamako",
    AFRICA_BANJUL = "Africa/Banjul",
    AFRICA_CONAKRY = "Africa/Conakry",
    AFRICA_DAKAR = "Africa/Dakar",
    AFRICA_FREETOWN = "Africa/Freetown",
    AFRICA_LOME = "Africa/Lome",
    AFRICA_NOUAKCHOTT = "Africa/Nouakchott",
    AFRICA_OUAGADOUGOU = "Africa/Ouagadougou",
    ATLANTIC_ST_HELENA = "Atlantic/St_Helena",
    AFRICA_CAIRO = "Africa/Cairo",
    AFRICA_ACCRA = "Africa/Accra",
    AFRICA_BISSAU = "Africa/Bissau",
    AFRICA_NAIROBI = "Africa/Nairobi",
    AFRICA_ADDIS_ABABA = "Africa/Addis_Ababa",
    AFRICA_ASMARA = "Africa/Asmara",
    AFRICA_DAR_ES_SALAAM = "Africa/Dar_es_Salaam",
    AFRICA_DJIBOUTI = "Africa/Djibouti",
    AFRICA_KAMPALA = "Africa/Kampala",
    AFRICA_MOGADISHU = "Africa/Mogadishu",
    INDIAN_ANTANANARIVO = "Indian/Antananarivo",
    INDIAN_COMORO = "Indian/Comoro",
    INDIAN_MAYOTTE = "Indian/Mayotte",
    AFRICA_MONROVIA = "Africa/Monrovia",
    AFRICA_TRIPOLI = "Africa/Tripoli",
    INDIAN_MAURITIUS = "Indian/Mauritius",
    AFRICA_CASABLANCA = "Africa/Casablanca",
    AFRICA_EL_AAIUN = "Africa/El_Aaiun",
    AFRICA_MAPUTO = "Africa/Maputo",
    AFRICA_BLANTYRE = "Africa/Blantyre",
    AFRICA_BUJUMBURA = "Africa/Bujumbura",
    AFRICA_GABORONE = "Africa/Gaborone",
    AFRICA_HARARE = "Africa/Harare",
    AFRICA_KIGALI = "Africa/Kigali",
    AFRICA_LUBUMBASHI = "Africa/Lubumbashi",
    AFRICA_LUSAKA = "Africa/Lusaka",
    AFRICA_WINDHOEK = "Africa/Windhoek",
    AFRICA_LAGOS = "Africa/Lagos",
    AFRICA_BANGUI = "Africa/Bangui",
    AFRICA_BRAZZAVILLE = "Africa/Brazzaville",
    AFRICA_DOUALA = "Africa/Douala",
    AFRICA_KINSHASA = "Africa/Kinshasa",
    AFRICA_LIBREVILLE = "Africa/Libreville",
    AFRICA_LUANDA = "Africa/Luanda",
    AFRICA_MALABO = "Africa/Malabo",
    AFRICA_NIAMEY = "Africa/Niamey",
    AFRICA_PORTO_NOVO = "Africa/Porto-Novo",
    INDIAN_REUNION = "Indian/Reunion",
    AFRICA_SAO_TOME = "Africa/Sao_Tome",
    INDIAN_MAHE = "Indian/Mahe",
    AFRICA_JOHANNESBURG = "Africa/Johannesburg",
    AFRICA_MASERU = "Africa/Maseru",
    AFRICA_MBABANE = "Africa/Mbabane",
    AFRICA_KHARTOUM = "Africa/Khartoum",
    AFRICA_JUBA = "Africa/Juba",
    AFRICA_TUNIS = "Africa/Tunis",
    ANTARCTICA_CASEY = "Antarctica/Casey",
    ANTARCTICA_DAVIS = "Antarctica/Davis",
    ANTARCTICA_MAWSON = "Antarctica/Mawson",
    INDIAN_KERGUELEN = "Indian/Kerguelen",
    ANTARCTICA_DUMONT_D_URVILLE = "Antarctica/DumontDUrville",
    ANTARCTICA_SYOWA = "Antarctica/Syowa",
    ANTARCTICA_TROLL = "Antarctica/Troll",
    ANTARCTICA_VOSTOK = "Antarctica/Vostok",
    ANTARCTICA_ROTHERA = "Antarctica/Rothera",
    ASIA_KABUL = "Asia/Kabul",
    ASIA_YEREVAN = "Asia/Yerevan",
    ASIA_BAKU = "Asia/Baku",
    ASIA_DHAKA = "Asia/Dhaka",
    ASIA_THIMPHU = "Asia/Thimphu",
    INDIAN_CHAGOS = "Indian/Chagos",
    ASIA_BRUNEI = "Asia/Brunei",
    ASIA_YANGON = "Asia/Yangon",
    ASIA_SHANGHAI = "Asia/Shanghai",
    ASIA_URUMQI = "Asia/Urumqi",
    ASIA_HONG_KONG = "Asia/Hong_Kong",
    ASIA_TAIPEI = "Asia/Taipei",
    ASIA_MACAU = "Asia/Macau",
    ASIA_NICOSIA = "Asia/Nicosia",
    ASIA_FAMAGUSTA = "Asia/Famagusta",
    EUROPE_NICOSIA = "Europe/Nicosia",
    ASIA_TBILISI = "Asia/Tbilisi",
    ASIA_DILI = "Asia/Dili",
    ASIA_KOLKATA = "Asia/Kolkata",
    ASIA_JAKARTA = "Asia/Jakarta",
    ASIA_PONTIANAK = "Asia/Pontianak",
    ASIA_MAKASSAR = "Asia/Makassar",
    ASIA_JAYAPURA = "Asia/Jayapura",
    ASIA_TEHRAN = "Asia/Tehran",
    ASIA_BAGHDAD = "Asia/Baghdad",
    ASIA_JERUSALEM = "Asia/Jerusalem",
    ASIA_TOKYO = "Asia/Tokyo",
    ASIA_AMMAN = "Asia/Amman",
    ASIA_ALMATY = "Asia/Almaty",
    ASIA_QYZYLORDA = "Asia/Qyzylorda",
    ASIA_QOSTANAY = "Asia/Qostanay",
    ASIA_AQTOBE = "Asia/Aqtobe",
    ASIA_AQTAU = "Asia/Aqtau",
    ASIA_ATYRAU = "Asia/Atyrau",
    ASIA_ORAL = "Asia/Oral",
    ASIA_BISHKEK = "Asia/Bishkek",
    ASIA_SEOUL = "Asia/Seoul",
    ASIA_PYONGYANG = "Asia/Pyongyang",
    ASIA_BEIRUT = "Asia/Beirut",
    ASIA_KUALA_LUMPUR = "Asia/Kuala_Lumpur",
    ASIA_KUCHING = "Asia/Kuching",
    INDIAN_MALDIVES = "Indian/Maldives",
    ASIA_HOVD = "Asia/Hovd",
    ASIA_ULAANBAATAR = "Asia/Ulaanbaatar",
    ASIA_CHOIBALSAN = "Asia/Choibalsan",
    ASIA_KATHMANDU = "Asia/Kathmandu",
    ASIA_KARACHI = "Asia/Karachi",
    ASIA_GAZA = "Asia/Gaza",
    ASIA_HEBRON = "Asia/Hebron",
    ASIA_MANILA = "Asia/Manila",
    ASIA_QATAR = "Asia/Qatar",
    ASIA_BAHRAIN = "Asia/Bahrain",
    ASIA_RIYADH = "Asia/Riyadh",
    ASIA_ADEN = "Asia/Aden",
    ASIA_KUWAIT = "Asia/Kuwait",
    ASIA_SINGAPORE = "Asia/Singapore",
    ASIA_COLOMBO = "Asia/Colombo",
    ASIA_DAMASCUS = "Asia/Damascus",
    ASIA_DUSHANBE = "Asia/Dushanbe",
    ASIA_BANGKOK = "Asia/Bangkok",
    ASIA_PHNOM_PENH = "Asia/Phnom_Penh",
    ASIA_VIENTIANE = "Asia/Vientiane",
    ASIA_ASHGABAT = "Asia/Ashgabat",
    ASIA_DUBAI = "Asia/Dubai",
    ASIA_MUSCAT = "Asia/Muscat",
    ASIA_SAMARKAND = "Asia/Samarkand",
    ASIA_TASHKENT = "Asia/Tashkent",
    ASIA_HO_CHI_MINH = "Asia/Ho_Chi_Minh",
    AUSTRALIA_DARWIN = "Australia/Darwin",
    AUSTRALIA_PERTH = "Australia/Perth",
    AUSTRALIA_EUCLA = "Australia/Eucla",
    AUSTRALIA_BRISBANE = "Australia/Brisbane",
    AUSTRALIA_LINDEMAN = "Australia/Lindeman",
    AUSTRALIA_ADELAIDE = "Australia/Adelaide",
    AUSTRALIA_HOBART = "Australia/Hobart",
    AUSTRALIA_CURRIE = "Australia/Currie",
    AUSTRALIA_MELBOURNE = "Australia/Melbourne",
    AUSTRALIA_SYDNEY = "Australia/Sydney",
    AUSTRALIA_BROKEN_HILL = "Australia/Broken_Hill",
    AUSTRALIA_LORD_HOWE = "Australia/Lord_Howe",
    ANTARCTICA_MACQUARIE = "Antarctica/Macquarie",
    INDIAN_CHRISTMAS = "Indian/Christmas",
    INDIAN_COCOS = "Indian/Cocos",
    PACIFIC_FIJI = "Pacific/Fiji",
    PACIFIC_GAMBIER = "Pacific/Gambier",
    PACIFIC_MARQUESAS = "Pacific/Marquesas",
    PACIFIC_TAHITI = "Pacific/Tahiti",
    PACIFIC_GUAM = "Pacific/Guam",
    PACIFIC_SAIPAN = "Pacific/Saipan",
    PACIFIC_TARAWA = "Pacific/Tarawa",
    PACIFIC_ENDERBURY = "Pacific/Enderbury",
    PACIFIC_KIRITIMATI = "Pacific/Kiritimati",
    PACIFIC_MAJURO = "Pacific/Majuro",
    PACIFIC_KWAJALEIN = "Pacific/Kwajalein",
    PACIFIC_CHUUK = "Pacific/Chuuk",
    PACIFIC_POHNPEI = "Pacific/Pohnpei",
    PACIFIC_KOSRAE = "Pacific/Kosrae",
    PACIFIC_NAURU = "Pacific/Nauru",
    PACIFIC_NOUMEA = "Pacific/Noumea",
    PACIFIC_AUCKLAND = "Pacific/Auckland",
    PACIFIC_CHATHAM = "Pacific/Chatham",
    ANTARCTICA_MC_MURDO = "Antarctica/McMurdo",
    PACIFIC_RAROTONGA = "Pacific/Rarotonga",
    PACIFIC_NIUE = "Pacific/Niue",
    PACIFIC_NORFOLK = "Pacific/Norfolk",
    PACIFIC_PALAU = "Pacific/Palau",
    PACIFIC_PORT_MORESBY = "Pacific/Port_Moresby",
    PACIFIC_BOUGAINVILLE = "Pacific/Bougainville",
    PACIFIC_PITCAIRN = "Pacific/Pitcairn",
    PACIFIC_PAGO_PAGO = "Pacific/Pago_Pago",
    PACIFIC_MIDWAY = "Pacific/Midway",
    PACIFIC_APIA = "Pacific/Apia",
    PACIFIC_GUADALCANAL = "Pacific/Guadalcanal",
    PACIFIC_FAKAOFO = "Pacific/Fakaofo",
    PACIFIC_TONGATAPU = "Pacific/Tongatapu",
    PACIFIC_FUNAFUTI = "Pacific/Funafuti",
    PACIFIC_WAKE = "Pacific/Wake",
    PACIFIC_EFATE = "Pacific/Efate",
    PACIFIC_WALLIS = "Pacific/Wallis",
    AFRICA_ASMERA = "Africa/Asmera",
    AFRICA_TIMBUKTU = "Africa/Timbuktu",
    AMERICA_ARGENTINA_COMOD_RIVADAVIA = "America/Argentina/ComodRivadavia",
    AMERICA_ATKA = "America/Atka",
    AMERICA_BUENOS_AIRES = "America/Buenos_Aires",
    AMERICA_CATAMARCA = "America/Catamarca",
    AMERICA_CORAL_HARBOUR = "America/Coral_Harbour",
    AMERICA_CORDOBA = "America/Cordoba",
    AMERICA_ENSENADA = "America/Ensenada",
    AMERICA_FORT_WAYNE = "America/Fort_Wayne",
    AMERICA_INDIANAPOLIS = "America/Indianapolis",
    AMERICA_JUJUY = "America/Jujuy",
    AMERICA_KNOX_IN = "America/Knox_IN",
    AMERICA_LOUISVILLE = "America/Louisville",
    AMERICA_MENDOZA = "America/Mendoza",
    AMERICA_MONTREAL = "America/Montreal",
    AMERICA_PORTO_ACRE = "America/Porto_Acre",
    AMERICA_ROSARIO = "America/Rosario",
    AMERICA_SANTA_ISABEL = "America/Santa_Isabel",
    AMERICA_SHIPROCK = "America/Shiprock",
    AMERICA_VIRGIN = "America/Virgin",
    ANTARCTICA_SOUTH_POLE = "Antarctica/South_Pole",
    ASIA_ASHKHABAD = "Asia/Ashkhabad",
    ASIA_CALCUTTA = "Asia/Calcutta",
    ASIA_CHONGQING = "Asia/Chongqing",
    ASIA_CHUNGKING = "Asia/Chungking",
    ASIA_DACCA = "Asia/Dacca",
    ASIA_HARBIN = "Asia/Harbin",
    ASIA_KASHGAR = "Asia/Kashgar",
    ASIA_KATMANDU = "Asia/Katmandu",
    ASIA_MACAO = "Asia/Macao",
    ASIA_RANGOON = "Asia/Rangoon",
    ASIA_SAIGON = "Asia/Saigon",
    ASIA_TEL_AVIV = "Asia/Tel_Aviv",
    ASIA_THIMBU = "Asia/Thimbu",
    ASIA_UJUNG_PANDANG = "Asia/Ujung_Pandang",
    ASIA_ULAN_BATOR = "Asia/Ulan_Bator",
    ATLANTIC_FAEROE = "Atlantic/Faeroe",
    ATLANTIC_JAN_MAYEN = "Atlantic/Jan_Mayen",
    AUSTRALIA_ACT = "Australia/ACT",
    AUSTRALIA_CANBERRA = "Australia/Canberra",
    AUSTRALIA_LHI = "Australia/LHI",
    AUSTRALIA_NSW = "Australia/NSW",
    AUSTRALIA_NORTH = "Australia/North",
    AUSTRALIA_QUEENSLAND = "Australia/Queensland",
    AUSTRALIA_SOUTH = "Australia/South",
    AUSTRALIA_TASMANIA = "Australia/Tasmania",
    AUSTRALIA_VICTORIA = "Australia/Victoria",
    AUSTRALIA_WEST = "Australia/West",
    AUSTRALIA_YANCOWINNA = "Australia/Yancowinna",
    BRAZIL_ACRE = "Brazil/Acre",
    BRAZIL_DE_NORONHA = "Brazil/DeNoronha",
    BRAZIL_EAST = "Brazil/East",
    BRAZIL_WEST = "Brazil/West",
    CANADA_ATLANTIC = "Canada/Atlantic",
    CANADA_CENTRAL = "Canada/Central",
    CANADA_EASTERN = "Canada/Eastern",
    CANADA_MOUNTAIN = "Canada/Mountain",
    CANADA_NEWFOUNDLAND = "Canada/Newfoundland",
    CANADA_PACIFIC = "Canada/Pacific",
    CANADA_SASKATCHEWAN = "Canada/Saskatchewan",
    CANADA_YUKON = "Canada/Yukon",
    CHILE_CONTINENTAL = "Chile/Continental",
    CHILE_EASTER_ISLAND = "Chile/EasterIsland",
    CUBA = "Cuba",
    EGYPT = "Egypt",
    EIRE = "Eire",
    ETC_UCT = "Etc/UCT",
    EUROPE_BELFAST = "Europe/Belfast",
    EUROPE_TIRASPOL = "Europe/Tiraspol",
    GB = "GB",
    GB_EIRE = "GB-Eire",
    GMT_0 = "GMT+0",
    GMT_02 = "GMT-0",
    GMT0 = "GMT0",
    GREENWICH = "Greenwich",
    HONGKONG = "Hongkong",
    ICELAND = "Iceland",
    IRAN = "Iran",
    ISRAEL = "Israel",
    JAMAICA = "Jamaica",
    JAPAN = "Japan",
    KWAJALEIN = "Kwajalein",
    LIBYA = "Libya",
    MEXICO_BAJA_NORTE = "Mexico/BajaNorte",
    MEXICO_BAJA_SUR = "Mexico/BajaSur",
    MEXICO_GENERAL = "Mexico/General",
    NZ = "NZ",
    NZ_CHAT = "NZ-CHAT",
    NAVAJO = "Navajo",
    PRC = "PRC",
    PACIFIC_JOHNSTON = "Pacific/Johnston",
    PACIFIC_PONAPE = "Pacific/Ponape",
    PACIFIC_SAMOA = "Pacific/Samoa",
    PACIFIC_TRUK = "Pacific/Truk",
    PACIFIC_YAP = "Pacific/Yap",
    POLAND = "Poland",
    PORTUGAL = "Portugal",
    ROC = "ROC",
    ROK = "ROK",
    SINGAPORE = "Singapore",
    TURKEY = "Turkey",
    UCT = "UCT",
    US_ALASKA = "US/Alaska",
    US_ALEUTIAN = "US/Aleutian",
    US_ARIZONA = "US/Arizona",
    US_CENTRAL = "US/Central",
    US_EAST_INDIANA = "US/East-Indiana",
    US_EASTERN = "US/Eastern",
    US_HAWAII = "US/Hawaii",
    US_INDIANA_STARKE = "US/Indiana-Starke",
    US_MICHIGAN = "US/Michigan",
    US_MOUNTAIN = "US/Mountain",
    US_PACIFIC = "US/Pacific",
    US_SAMOA = "US/Samoa",
    UTC = "UTC",
    UNIVERSAL = "Universal",
    W_SU = "W-SU",
    ZULU = "Zulu",
    ETC_GMT = "Etc/GMT",
    ETC_UTC = "Etc/UTC",
    GMT = "GMT",
    ETC_UNIVERSAL = "Etc/Universal",
    ETC_ZULU = "Etc/Zulu",
    ETC_GREENWICH = "Etc/Greenwich",
    ETC_GMT_0 = "Etc/GMT-0",
    ETC_GMT_PLUS_0 = "Etc/GMT+0",
    ETC_GMT0 = "Etc/GMT0",
    ETC_GMT_14 = "Etc/GMT-14",
    ETC_GMT_13 = "Etc/GMT-13",
    ETC_GMT_12 = "Etc/GMT-12",
    ETC_GMT_11 = "Etc/GMT-11",
    ETC_GMT_10 = "Etc/GMT-10",
    ETC_GMT_9 = "Etc/GMT-9",
    ETC_GMT_8 = "Etc/GMT-8",
    ETC_GMT_7 = "Etc/GMT-7",
    ETC_GMT_6 = "Etc/GMT-6",
    ETC_GMT_5 = "Etc/GMT-5",
    ETC_GMT_4 = "Etc/GMT-4",
    ETC_GMT_3 = "Etc/GMT-3",
    ETC_GMT_2 = "Etc/GMT-2",
    ETC_GMT_1 = "Etc/GMT-1",
    ETC_GMT_PLUS_1 = "Etc/GMT+1",
    ETC_GMT_PLUS_2 = "Etc/GMT+2",
    ETC_GMT_PLUS_3 = "Etc/GMT+3",
    ETC_GMT_PLUS_4 = "Etc/GMT+4",
    ETC_GMT_PLUS_5 = "Etc/GMT+5",
    ETC_GMT_PLUS_6 = "Etc/GMT+6",
    ETC_GMT_PLUS_7 = "Etc/GMT+7",
    ETC_GMT_PLUS_8 = "Etc/GMT+8",
    ETC_GMT_PLUS_9 = "Etc/GMT+9",
    ETC_GMT_PLUS_10 = "Etc/GMT+10",
    ETC_GMT_PLUS_11 = "Etc/GMT+11",
    ETC_GMT_PLUS_12 = "Etc/GMT+12",
    EUROPE_LONDON = "Europe/London",
    EUROPE_JERSEY = "Europe/Jersey",
    EUROPE_GUERNSEY = "Europe/Guernsey",
    EUROPE_ISLE_OF_MAN = "Europe/Isle_of_Man",
    EUROPE_DUBLIN = "Europe/Dublin",
    WET = "WET",
    CET = "CET",
    MET = "MET",
    EET = "EET",
    EUROPE_TIRANE = "Europe/Tirane",
    EUROPE_ANDORRA = "Europe/Andorra",
    EUROPE_VIENNA = "Europe/Vienna",
    EUROPE_MINSK = "Europe/Minsk",
    EUROPE_BRUSSELS = "Europe/Brussels",
    EUROPE_SOFIA = "Europe/Sofia",
    EUROPE_PRAGUE = "Europe/Prague",
    EUROPE_COPENHAGEN = "Europe/Copenhagen",
    ATLANTIC_FAROE = "Atlantic/Faroe",
    AMERICA_DANMARKSHAVN = "America/Danmarkshavn",
    AMERICA_SCORESBYSUND = "America/Scoresbysund",
    AMERICA_GODTHAB = "America/Godthab",
    AMERICA_THULE = "America/Thule",
    EUROPE_TALLINN = "Europe/Tallinn",
    EUROPE_HELSINKI = "Europe/Helsinki",
    EUROPE_MARIEHAMN = "Europe/Mariehamn",
    EUROPE_PARIS = "Europe/Paris",
    EUROPE_BERLIN = "Europe/Berlin",
    EUROPE_BUSINGEN = "Europe/Busingen",
    EUROPE_GIBRALTAR = "Europe/Gibraltar",
    EUROPE_ATHENS = "Europe/Athens",
    EUROPE_BUDAPEST = "Europe/Budapest",
    ATLANTIC_REYKJAVIK = "Atlantic/Reykjavik",
    EUROPE_ROME = "Europe/Rome",
    EUROPE_VATICAN = "Europe/Vatican",
    EUROPE_SAN_MARINO = "Europe/San_Marino",
    EUROPE_RIGA = "Europe/Riga",
    EUROPE_VADUZ = "Europe/Vaduz",
    EUROPE_VILNIUS = "Europe/Vilnius",
    EUROPE_LUXEMBOURG = "Europe/Luxembourg",
    EUROPE_MALTA = "Europe/Malta",
    EUROPE_CHISINAU = "Europe/Chisinau",
    EUROPE_MONACO = "Europe/Monaco",
    EUROPE_AMSTERDAM = "Europe/Amsterdam",
    EUROPE_OSLO = "Europe/Oslo",
    ARCTIC_LONGYEARBYEN = "Arctic/Longyearbyen",
    EUROPE_WARSAW = "Europe/Warsaw",
    EUROPE_LISBON = "Europe/Lisbon",
    ATLANTIC_AZORES = "Atlantic/Azores",
    ATLANTIC_MADEIRA = "Atlantic/Madeira",
    EUROPE_BUCHAREST = "Europe/Bucharest",
    EUROPE_KALININGRAD = "Europe/Kaliningrad",
    EUROPE_MOSCOW = "Europe/Moscow",
    EUROPE_SIMFEROPOL = "Europe/Simferopol",
    EUROPE_ASTRAKHAN = "Europe/Astrakhan",
    EUROPE_VOLGOGRAD = "Europe/Volgograd",
    EUROPE_SARATOV = "Europe/Saratov",
    EUROPE_KIROV = "Europe/Kirov",
    EUROPE_SAMARA = "Europe/Samara",
    EUROPE_ULYANOVSK = "Europe/Ulyanovsk",
    ASIA_YEKATERINBURG = "Asia/Yekaterinburg",
    ASIA_OMSK = "Asia/Omsk",
    ASIA_BARNAUL = "Asia/Barnaul",
    ASIA_NOVOSIBIRSK = "Asia/Novosibirsk",
    ASIA_TOMSK = "Asia/Tomsk",
    ASIA_NOVOKUZNETSK = "Asia/Novokuznetsk",
    ASIA_KRASNOYARSK = "Asia/Krasnoyarsk",
    ASIA_IRKUTSK = "Asia/Irkutsk",
    ASIA_CHITA = "Asia/Chita",
    ASIA_YAKUTSK = "Asia/Yakutsk",
    ASIA_VLADIVOSTOK = "Asia/Vladivostok",
    ASIA_KHANDYGA = "Asia/Khandyga",
    ASIA_SAKHALIN = "Asia/Sakhalin",
    ASIA_MAGADAN = "Asia/Magadan",
    ASIA_SREDNEKOLYMSK = "Asia/Srednekolymsk",
    ASIA_UST_NERA = "Asia/Ust-Nera",
    ASIA_KAMCHATKA = "Asia/Kamchatka",
    ASIA_ANADYR = "Asia/Anadyr",
    EUROPE_BELGRADE = "Europe/Belgrade",
    EUROPE_LJUBLJANA = "Europe/Ljubljana",
    EUROPE_PODGORICA = "Europe/Podgorica",
    EUROPE_SARAJEVO = "Europe/Sarajevo",
    EUROPE_SKOPJE = "Europe/Skopje",
    EUROPE_ZAGREB = "Europe/Zagreb",
    EUROPE_BRATISLAVA = "Europe/Bratislava",
    EUROPE_MADRID = "Europe/Madrid",
    AFRICA_CEUTA = "Africa/Ceuta",
    ATLANTIC_CANARY = "Atlantic/Canary",
    EUROPE_STOCKHOLM = "Europe/Stockholm",
    EUROPE_ZURICH = "Europe/Zurich",
    EUROPE_ISTANBUL = "Europe/Istanbul",
    ASIA_ISTANBUL = "Asia/Istanbul",
    EUROPE_KIEV = "Europe/Kiev",
    EUROPE_UZHGOROD = "Europe/Uzhgorod",
    EUROPE_ZAPOROZHYE = "Europe/Zaporozhye",
    FACTORY = "Factory",
    EST = "EST",
    MST = "MST",
    HST = "HST",
    EST5EDT = "EST5EDT",
    CST6CDT = "CST6CDT",
    MST7MDT = "MST7MDT",
    PST8PDT = "PST8PDT",
    AMERICA_NEW_YORK = "America/New_York",
    AMERICA_CHICAGO = "America/Chicago",
    AMERICA_NORTH_DAKOTA_CENTER = "America/North_Dakota/Center",
    AMERICA_NORTH_DAKOTA_NEW_SALEM = "America/North_Dakota/New_Salem",
    AMERICA_NORTH_DAKOTA_BEULAH = "America/North_Dakota/Beulah",
    AMERICA_DENVER = "America/Denver",
    AMERICA_LOS_ANGELES = "America/Los_Angeles",
    AMERICA_JUNEAU = "America/Juneau",
    AMERICA_SITKA = "America/Sitka",
    AMERICA_METLAKATLA = "America/Metlakatla",
    AMERICA_YAKUTAT = "America/Yakutat",
    AMERICA_ANCHORAGE = "America/Anchorage",
    AMERICA_NOME = "America/Nome",
    AMERICA_ADAK = "America/Adak",
    PACIFIC_HONOLULU = "Pacific/Honolulu",
    AMERICA_PHOENIX = "America/Phoenix",
    AMERICA_BOISE = "America/Boise",
    AMERICA_INDIANA_INDIANAPOLIS = "America/Indiana/Indianapolis",
    AMERICA_INDIANA_MARENGO = "America/Indiana/Marengo",
    AMERICA_INDIANA_VINCENNES = "America/Indiana/Vincennes",
    AMERICA_INDIANA_TELL_CITY = "America/Indiana/Tell_City",
    AMERICA_INDIANA_PETERSBURG = "America/Indiana/Petersburg",
    AMERICA_INDIANA_KNOX = "America/Indiana/Knox",
    AMERICA_INDIANA_WINAMAC = "America/Indiana/Winamac",
    AMERICA_INDIANA_VEVAY = "America/Indiana/Vevay",
    AMERICA_KENTUCKY_LOUISVILLE = "America/Kentucky/Louisville",
    AMERICA_KENTUCKY_MONTICELLO = "America/Kentucky/Monticello",
    AMERICA_DETROIT = "America/Detroit",
    AMERICA_MENOMINEE = "America/Menominee",
    AMERICA_ST_JOHNS = "America/St_Johns",
    AMERICA_GOOSE_BAY = "America/Goose_Bay",
    AMERICA_HALIFAX = "America/Halifax",
    AMERICA_GLACE_BAY = "America/Glace_Bay",
    AMERICA_MONCTON = "America/Moncton",
    AMERICA_BLANC_SABLON = "America/Blanc-Sablon",
    AMERICA_TORONTO = "America/Toronto",
    AMERICA_THUNDER_BAY = "America/Thunder_Bay",
    AMERICA_NIPIGON = "America/Nipigon",
    AMERICA_RAINY_RIVER = "America/Rainy_River",
    AMERICA_ATIKOKAN = "America/Atikokan",
    AMERICA_WINNIPEG = "America/Winnipeg",
    AMERICA_REGINA = "America/Regina",
    AMERICA_SWIFT_CURRENT = "America/Swift_Current",
    AMERICA_EDMONTON = "America/Edmonton",
    AMERICA_VANCOUVER = "America/Vancouver",
    AMERICA_DAWSON_CREEK = "America/Dawson_Creek",
    AMERICA_FORT_NELSON = "America/Fort_Nelson",
    AMERICA_CRESTON = "America/Creston",
    AMERICA_PANGNIRTUNG = "America/Pangnirtung",
    AMERICA_IQALUIT = "America/Iqaluit",
    AMERICA_RESOLUTE = "America/Resolute",
    AMERICA_RANKIN_INLET = "America/Rankin_Inlet",
    AMERICA_CAMBRIDGE_BAY = "America/Cambridge_Bay",
    AMERICA_YELLOWKNIFE = "America/Yellowknife",
    AMERICA_INUVIK = "America/Inuvik",
    AMERICA_WHITEHORSE = "America/Whitehorse",
    AMERICA_DAWSON = "America/Dawson",
    AMERICA_CANCUN = "America/Cancun",
    AMERICA_MERIDA = "America/Merida",
    AMERICA_MATAMOROS = "America/Matamoros",
    AMERICA_MONTERREY = "America/Monterrey",
    AMERICA_MEXICO_CITY = "America/Mexico_City",
    AMERICA_OJINAGA = "America/Ojinaga",
    AMERICA_CHIHUAHUA = "America/Chihuahua",
    AMERICA_HERMOSILLO = "America/Hermosillo",
    AMERICA_MAZATLAN = "America/Mazatlan",
    AMERICA_BAHIA_BANDERAS = "America/Bahia_Banderas",
    AMERICA_TIJUANA = "America/Tijuana",
    AMERICA_NASSAU = "America/Nassau",
    AMERICA_BARBADOS = "America/Barbados",
    AMERICA_BELIZE = "America/Belize",
    ATLANTIC_BERMUDA = "Atlantic/Bermuda",
    AMERICA_COSTA_RICA = "America/Costa_Rica",
    AMERICA_HAVANA = "America/Havana",
    AMERICA_SANTO_DOMINGO = "America/Santo_Domingo",
    AMERICA_EL_SALVADOR = "America/El_Salvador",
    AMERICA_GUATEMALA = "America/Guatemala",
    AMERICA_PORT_AU_PRINCE = "America/Port-au-Prince",
    AMERICA_TEGUCIGALPA = "America/Tegucigalpa",
    AMERICA_JAMAICA = "America/Jamaica",
    AMERICA_MARTINIQUE = "America/Martinique",
    AMERICA_MANAGUA = "America/Managua",
    AMERICA_PANAMA = "America/Panama",
    AMERICA_CAYMAN = "America/Cayman",
    AMERICA_PUERTO_RICO = "America/Puerto_Rico",
    AMERICA_MIQUELON = "America/Miquelon",
    AMERICA_GRAND_TURK = "America/Grand_Turk",
    US_PACIFIC_NEW = "US/Pacific-New",
    AMERICA_ARGENTINA_BUENOS_AIRES = "America/Argentina/Buenos_Aires",
    AMERICA_ARGENTINA_CORDOBA = "America/Argentina/Cordoba",
    AMERICA_ARGENTINA_SALTA = "America/Argentina/Salta",
    AMERICA_ARGENTINA_TUCUMAN = "America/Argentina/Tucuman",
    AMERICA_ARGENTINA_LA_RIOJA = "America/Argentina/La_Rioja",
    AMERICA_ARGENTINA_SAN_JUAN = "America/Argentina/San_Juan",
    AMERICA_ARGENTINA_JUJUY = "America/Argentina/Jujuy",
    AMERICA_ARGENTINA_CATAMARCA = "America/Argentina/Catamarca",
    AMERICA_ARGENTINA_MENDOZA = "America/Argentina/Mendoza",
    AMERICA_ARGENTINA_SAN_LUIS = "America/Argentina/San_Luis",
    AMERICA_ARGENTINA_RIO_GALLEGOS = "America/Argentina/Rio_Gallegos",
    AMERICA_ARGENTINA_USHUAIA = "America/Argentina/Ushuaia",
    AMERICA_ARUBA = "America/Aruba",
    AMERICA_LA_PAZ = "America/La_Paz",
    AMERICA_NORONHA = "America/Noronha",
    AMERICA_BELEM = "America/Belem",
    AMERICA_SANTAREM = "America/Santarem",
    AMERICA_FORTALEZA = "America/Fortaleza",
    AMERICA_RECIFE = "America/Recife",
    AMERICA_ARAGUAINA = "America/Araguaina",
    AMERICA_MACEIO = "America/Maceio",
    AMERICA_BAHIA = "America/Bahia",
    AMERICA_SAO_PAULO = "America/Sao_Paulo",
    AMERICA_CAMPO_GRANDE = "America/Campo_Grande",
    AMERICA_CUIABA = "America/Cuiaba",
    AMERICA_PORTO_VELHO = "America/Porto_Velho",
    AMERICA_BOA_VISTA = "America/Boa_Vista",
    AMERICA_MANAUS = "America/Manaus",
    AMERICA_EIRUNEPE = "America/Eirunepe",
    AMERICA_RIO_BRANCO = "America/Rio_Branco",
    AMERICA_SANTIAGO = "America/Santiago",
    AMERICA_PUNTA_ARENAS = "America/Punta_Arenas",
    PACIFIC_EASTER = "Pacific/Easter",
    ANTARCTICA_PALMER = "Antarctica/Palmer",
    AMERICA_BOGOTA = "America/Bogota",
    AMERICA_CURACAO = "America/Curacao",
    AMERICA_LOWER_PRINCES = "America/Lower_Princes",
    AMERICA_KRALENDIJK = "America/Kralendijk",
    AMERICA_GUAYAQUIL = "America/Guayaquil",
    PACIFIC_GALAPAGOS = "Pacific/Galapagos",
    ATLANTIC_STANLEY = "Atlantic/Stanley",
    AMERICA_CAYENNE = "America/Cayenne",
    AMERICA_GUYANA = "America/Guyana",
    AMERICA_ASUNCION = "America/Asuncion",
    AMERICA_LIMA = "America/Lima",
    ATLANTIC_SOUTH_GEORGIA = "Atlantic/South_Georgia",
    AMERICA_PARAMARIBO = "America/Paramaribo",
    AMERICA_PORT_OF_SPAIN = "America/Port_of_Spain",
    AMERICA_ANGUILLA = "America/Anguilla",
    AMERICA_ANTIGUA = "America/Antigua",
    AMERICA_DOMINICA = "America/Dominica",
    AMERICA_GRENADA = "America/Grenada",
    AMERICA_GUADELOUPE = "America/Guadeloupe",
    AMERICA_MARIGOT = "America/Marigot",
    AMERICA_MONTSERRAT = "America/Montserrat",
    AMERICA_ST_BARTHELEMY = "America/St_Barthelemy",
    AMERICA_ST_KITTS = "America/St_Kitts",
    AMERICA_ST_LUCIA = "America/St_Lucia",
    AMERICA_ST_THOMAS = "America/St_Thomas",
    AMERICA_ST_VINCENT = "America/St_Vincent",
    AMERICA_TORTOLA = "America/Tortola",
    AMERICA_MONTEVIDEO = "America/Montevideo",
    AMERICA_CARACAS = "America/Caracas",
}

export type TipTapMark = {
    attrs?: {
        [key: string]: unknown;
    };
    type: string;
};

export type TipTapNode = {
    attrs?: {
        [key: string]: unknown;
    };
    content?: Array<TipTapNode>;
    marks?: Array<TipTapMark>;
    text?: string;
    type: string;
};

export type ToggleCommentReactionDto = {
    emoji: string;
};

export type TrackingAttributionDto = {
    campaign?: string;
    /**
     * Set server-side when persisting; derived from utmTerm and BOOKING_BRAND_UTM_TERM_KEYWORDS. Ignored from client input.
     */
    isBrand?: boolean;
    landingLanguage?: string;
    landingLocation?: string;
    medium?: string;
    referrerUrl?: string;
    source?: string;
    utmTerm?: string;
};

export type TrackingDataDto = {
    bookingOrigin?: BookingOriginDto;
    firstOrigin?: BookingOriginDto;
    gclid?: string | null;
    pageTitle: string;
    pageUrl: string;
    trackingAttribution?: TrackingAttributionDto;
};

export type TrackingDeviceData = {
    ip?: string;
    language?: string;
    'user-agent'?: string;
};

export type TrackingPageData = {
    referrer?: string;
    title?: string;
    url?: string;
};

export type TrackingSettings = {
    clickTracking?: {
        enable?: boolean;
        enableText?: boolean;
    };
    ganalytics?: {
        enable?: boolean;
        utmCampaign?: string;
        utmContent?: string;
        utmMedium?: string;
        utmSource?: string;
        utmTerm?: string;
    };
    openTracking?: {
        enable?: boolean;
        substitutionTag?: string;
    };
    subscriptionTracking?: {
        enable?: boolean;
        html?: string;
        substitutionTag?: string;
        text?: string;
    };
};

export enum TransmissionType {
    AUTOMATIC = 'AUTOMATIC',
    MANUAL = 'MANUAL'
}

export enum TyreCondition {
    GOOD = 'GOOD',
    NEAR_WEAR_LIMIT = 'NEAR_WEAR_LIMIT',
    NEEDS_IMMEDIATE_CHANGE = 'NEEDS_IMMEDIATE_CHANGE'
}

export type UnabsorbedInvoiceCreditDto = {
    /**
     * Remaining uninvoiced credit amount in cents (negative).
     */
    amount: number;
    ledgerEntryId: string;
};

export enum UnavailableReason {
    BEFORE_CAR_AVAILABILITY = 'BEFORE_CAR_AVAILABILITY',
    AFTER_CAR_AVAILABILITY = 'AFTER_CAR_AVAILABILITY',
    BLOCKING_BOOKING = 'BLOCKING_BOOKING',
    STARTS_IN_PAST = 'STARTS_IN_PAST',
    NO_UPGRADE_AVAILABLE = 'NO_UPGRADE_AVAILABLE',
    UNKNOWN = 'UNKNOWN'
}

export type UpdateAllocationDto = {
    bufferMinutes?: number;
    carId?: string;
    comment?: string | null;
    customTransferMinutes?: number | null;
    driverId?: string | null;
    dropoffLocation?: LocationDto | null;
    dropoffLocationGeocodedAddress?: LocationGeocodedNameDto | null;
    dropoffLocationType?: BookingLocationType;
    dropoffResponsibleStationId?: string | null;
    endDate?: Date;
    externalDriverEmail?: string | null;
    fuelLevelEnd?: number | null;
    fuelLevelStart?: number | null;
    handoverDate?: Date;
    milageDeviationComment?: string;
    milageDeviationReason?: MilageDeviationReason;
    milageEnd?: number | null;
    milageStart?: number | null;
    pickupLocation?: LocationDto | null;
    pickupLocationGeocodedAddress?: LocationGeocodedNameDto | null;
    pickupLocationType?: BookingLocationType;
    pickupResponsibleStationId?: string | null;
    rentalPartner?: 'PORSCHE_DRIVE';
    returnDate?: Date;
    startDate?: Date;
    status?: AllocationStatus;
};

export type UpdateAreaChargeDto = {
    /**
     * Surcharge in EUR used instead of a shared price.
     */
    customPrice?: number | null;
    geometry?: AreaChargeGeometryDto;
    name?: string;
    /**
     * Id of an area charge price from yield management settings.
     */
    priceId?: string | null;
};

export type UpdateBookingDto = {
    additionalDrivers?: Array<AdditionalDriverDto>;
    agencyId?: string | null;
    allocations?: Array<BookingAllocationDto>;
    blockedCreditCard?: BasePaymentData | null;
    blockedCreditCardAmount?: number | null;
    blockedCreditCardDate?: Date;
    blockedCreditCardIncludesOpenFee?: boolean | null;
    blockedCreditCardLastRefreshDate?: Date;
    blockedCreditCardRefNr?: string;
    bookedCarId?: string;
    calculatedInclusiveKm?: number;
    collectDeposit?: boolean;
    confirmationFileKey?: string;
    confirmationReply?: string | null;
    contractFileKey?: string;
    customInclusiveKm?: number | null;
    customerComment?: string | null;
    customerData?: CustomerDataDto;
    customerId?: string | null;
    debitCardPaymentAtHandover?: boolean;
    deferredPayment?: boolean;
    dropoffLocation?: LocationDto | null;
    dropoffLocationGeocodedAddress?: LocationGeocodedNameDto | null;
    dropoffLocationType?: BookingLocationType;
    dropoffStationId?: string | null;
    dryRun?: boolean;
    endDate?: Date;
    externalReference?: string | null;
    flags?: BookingFlags;
    handoverDate?: Date;
    hasPeriodicInvoicing?: boolean;
    hasUnhandledDamages?: boolean;
    insuranceCaseId?: string | null;
    internalComment?: string | null;
    invoicingType?: InvoicingType;
    onlineCreditCardPayment?: AdyenPaymentDataDto | ComputopPaymentDataDto | CouponPaymentDataDto | null;
    onlinePaymentTransferId?: string | null;
    pickupLocation?: LocationDto | null;
    pickupLocationGeocodedAddress?: LocationGeocodedNameDto | null;
    pickupLocationType?: BookingLocationType;
    pickupStationId?: string | null;
    pricing?: BookingPricingDto;
    returnDate?: Date;
    signatureFileKey?: string | null;
    startDate?: Date;
    status?: BookingStatus;
    /**
     * ID of stored payment method to charge the extension surcharge. Required if surchargeAmount is being sent
     */
    storedPaymentMethodId?: string | null;
    /**
     * Amount to be charged when extending the booking duration. Requires a valid storedPaymentMethodId
     */
    surchargeAmount?: number | null;
    taxProcedure?: TaxProcedure;
    terminalPaymentCreditCardRefNr?: string | null;
};

export type UpdateBrevoContactBlacklistedDto = {
    blacklisted: boolean;
    email: string;
};

export type UpdateCarDocumentDto = {
    comment?: string | null;
    documentFileKey?: string;
    name?: string;
    type?: CarDocumentType | null;
};

export type UpdateCarDto = {
    accelaration?: number | null;
    acquisitionType?: CarAcquisitionType;
    additionalSeats?: number | null;
    availableFrom?: Date;
    availableUntil?: Date | null;
    batteryCapacityInKwh?: number | null;
    brakedTowingCapacityInKg?: number | null;
    color?: CarColor;
    currentLocationType?: CarLocationType;
    drive?: DriveType | null;
    fin?: string | null;
    firstRegistration?: Date | null;
    fuelLevel?: number;
    fuelType?: FuelType | null;
    hasDistanceControl?: boolean | null;
    hasNavigation?: boolean | null;
    hasRearViewCamera?: boolean | null;
    hasTowHitch?: boolean;
    hiddenFromPublic?: boolean;
    imageFileKey?: string | null;
    initialMilage?: number | null;
    insuranceCompany?: string | null;
    isGhostCar?: boolean;
    lastTuvDate?: Date | null;
    leasingRate?: number | null;
    legalEntities?: Array<CarLegalEntityDto>;
    licencePlate?: string | null;
    listPrice?: number;
    merchantConsultedDate?: Date;
    milage?: number;
    milageDeviationComment?: string;
    milageDeviationReason?: MilageDeviationReason;
    notAtTheHub?: boolean;
    possibleUpgrades?: Array<PossibleUpgradesDto>;
    power?: number | null;
    promotionalVideoMediaId?: string | null;
    purchasePrice?: number | null;
    rangeInKm?: number | null;
    readyToHandover?: boolean;
    registrationAndOrganizationDoneDate?: Date | null;
    saleDate?: Date | null;
    salePrice?: number | null;
    seats?: number | null;
    stations?: Array<CarStationDto>;
    status?: CarStatus;
    tankVolumeInLiter?: number | null;
    transmission?: TransmissionType | null;
    tyreConditionFront?: TyreCondition;
    tyreConditionRear?: TyreCondition;
    tyres?: CarTyres;
    unbrakedTowingCapacityInKg?: number | null;
    vehicleTypeId?: string;
};

export type UpdateCommentDto = {
    body: TipTapNode;
};

export type UpdateCouponDto = {
    benefits?: CouponBenefitsDto | null;
    /**
     * Internal note on why the coupon was issued (required for goodwill coupons)
     */
    comment?: string | null;
    customerData?: CustomerDataDto;
    isActive?: boolean;
    maxRedemptions?: number | null;
    oneRedemptionPerCustomer?: boolean;
    orderInvoice?: Invoice;
    paymentIds?: Array<string>;
    remainingValue?: number;
    validFrom?: Date | null;
    validTo?: Date | null;
};

export type UpdateCustomBookedExtraDto = {
    /**
     * Coupon code that created this additional extra (shown on invoice lines).
     */
    couponCode?: string;
    customVehicleExtraType: VehicleExtraType | null;
    description: string;
    /**
     * Stable identifier for this custom extra.
     */
    id?: string;
    /**
     * 'Coupon-owned additional extra — not editable as a normal custom extra.
     */
    isAdditional?: boolean;
    photoFileKeys?: Array<string>;
    price: number;
    value?: number;
};

export type UpdateDamageDto = {
    bookingId?: string | null;
    carId?: string;
    description?: string;
    expectedPhotoCount?: number;
    id?: string;
    imageFileKeys?: Array<string>;
    positionX?: number | null;
    positionY?: number | null;
    status?: DamageStatus;
    videoExpected?: boolean;
    videoFileKey?: string | null;
};

export type UpdateDiscoverySurveyDto = {
    aiAssistant?: AiAssistant;
    aiPrompt?: string;
    language?: LanguageCode;
    otherText?: string | null;
    source?: DiscoverySource;
};

export type UpdateGlobalSettingDto = {
    showHandoverSurvey?: string | null;
};

export type UpdateInfringementDto = {
    chargeFeeVatMode?: InfringementChargeFeeVatMode | null;
    comment?: string;
    data?: InfringementData;
    rosBookingId?: string;
    skipSendAuthorityMail?: boolean;
    status?: InfringementStatus;
    waivedReason?: InfringementWaivedReason;
    waivedReasonComment?: string;
    wunderRentalId?: number;
};

export type UpdateInsuranceCaseDto = {
    additionalInfo?: string | null;
    customerData?: CustomerDataDto;
    customerId?: string;
    endDate?: Date | null;
    insuranceData?: AxaInsuranceDataDto | EuropInsuranceDataDto | JlrInsuranceDataDto | RolandInsuranceDataDto | VolvoInsuranceDataDto;
    insuranceProvider?: InsuranceProviderName;
    locationGeocodedAddress?: LocationGeocodedAddress | null;
    startDate?: Date | null;
    status?: InsuranceCaseStatus;
};

export type UpdateInvoiceDto = {
    bookingId?: string | null;
    comment?: string | null;
    counterpartyType?: CounterpartyType | null;
    customerId?: string | null;
    invoiceNumberPrefix?: string | null;
    originalInvoiceId?: string | null;
    paidAmountOfOriginalInvoice?: number | null;
    paymentIds?: Array<string> | null;
    positions?: Array<InvoicePositionDto>;
    receiverData?: InvoiceReceiverDataDto;
    sentStateDate?: Date | null;
    status?: InvoiceStatus;
    taxCountry?: TaxCountry;
    taxProcedure?: TaxProcedure;
    title?: string | null;
    type?: InvoiceType;
};

export type UpdateLeadDto = {
    outcome?: LeadOutcome | null;
    status?: LeadStatus;
    userId?: string;
};

export type UpdateLegalEntityDto = {
    adyenMerchantAccount?: string;
    bankName?: string;
    bic?: string;
    city?: LocalizedFieldDto;
    commercialRegister?: string;
    countryCode?: string;
    email?: string;
    englishTerms?: string;
    iban?: string;
    invoiceNumberPrefix?: string;
    isActive?: boolean;
    isOssRegistered?: boolean;
    localLanguage?: string;
    localTerms?: string;
    managingDirectors?: string;
    name?: string;
    phone?: string;
    sepaCreditorId?: string | null;
    street?: string;
    taxNumber?: string | null;
    vatId?: string;
    website?: string;
    zip?: string;
};

export type UpdateMakeDto = {
    name?: string;
    priceFactor?: number;
    slug?: string;
};

export type UpdateMeDto = {
    city?: string | null;
    comment?: string | null;
    company?: string | null;
    country?: string | null;
    dateOfBirth?: Date | null;
    email?: string;
    firstName?: string;
    functions?: Array<UserFunction>;
    gender?: Gender | null;
    idCardAuthority?: string | null;
    idCardDate?: Date | null;
    idCardNumber?: string | null;
    lastName?: string;
    licenseAuthority?: string | null;
    licenseDate?: Date | null;
    licenseNumber?: string | null;
    password?: string;
    phone?: string | null;
    preferredLocal?: Local;
    preferredPaymentTerminalId?: string | null;
    refreshToken?: string | null;
    stationIds?: Array<string> | null;
    street?: string | null;
    vatId?: string | null;
    zip?: string | null;
};

export type UpdateMediaDto = {
    title: string;
};

export type UpdateNewsDto = {
    content?: string;
    status?: NewsStatus;
    title?: string;
};

export type UpdateOnlineBookingDto = {
    acceptedPrice?: number;
    bookedExtras?: Array<BookedExtraDto>;
    customerData?: PublicCustomerDataDto;
    endDate?: Date;
    isCancelled?: boolean;
    startDate?: Date;
    /**
     * ID of the stored deposit payment method to charge the surcharge from (same card as the deposit / block-amount link). Required together with surchargeAmount when the booking is HANDED_OVER and the rebook increases totalPrice.
     */
    storedPaymentMethodId?: string;
    /**
     * Amount to be charged immediately when a handed-over booking change increases totalPrice. Must match the price delta; requires storedPaymentMethodId (deposit card).
     */
    surchargeAmount?: number;
};

export type UpdatePartnerSubTypeDto = {
    agencySettings?: PartnerSubTypeAgencySettings;
    name?: LocalizedFieldDto;
    role?: 'AGENCY' | 'COMPANY';
    type?: AgencyType | null;
};

export type UpdatePaymentDto = {
    amount?: number;
    authorizationLastRefreshDate?: Date | null;
    bookingId?: string | null;
    comment?: string | null;
    counterpartyType?: CounterpartyType | null;
    creditCardDetails?: CreditCardDetailsDto | null;
    date?: Date;
    invoiceId?: string | null;
    paidDate?: Date | null;
    paymentAllocations?: Array<PaymentAllocation>;
    paymentData?: BasePaymentData;
    paymentType?: PaymentType;
    referenceId?: string | null;
    status?: PaymentStatus;
    walletProvider?: WalletProvider | null;
};

export type UpdatePaymentTerminalDto = {
    description?: string;
    stationId?: string;
    terminalId?: number;
    userIds?: Array<string> | null;
};

export type UpdateRotationMediaDto = {
    mediaId?: string;
    stationId?: string | null;
    weight?: number;
};

export type UpdateStationDto = {
    authCode?: string | null;
    city?: string;
    counters?: Array<UpsertStationCounterDto>;
    countryCode?: string;
    googleMapsReviewCtaUrl?: string | null;
    icon?: StationIcon | null;
    ignoredHolidays?: Array<IgnoredHolidayDto> | null;
    info?: LocalizedFieldDto;
    invoiceSuffix?: string | null;
    isGoogleMapsReviewEnabled?: boolean;
    isHidden?: boolean;
    isInternal?: boolean;
    legalEntityId?: string;
    location?: LocationDto;
    mapImageFileKey?: string | null;
    notice?: LocalizedFieldDto | null;
    openingHours?: Array<StationOpeningHoursDto>;
    returnPolicy?: StationReturnPolicy;
    slug?: string;
    state?: string | null;
    street?: string;
    zip?: string;
};

export type UpdateSurveyDto = {
    questionsOrder?: Array<SurveyQuestionsOrderDto>;
    slug?: string;
    titleDe?: string;
    titleEn?: string;
};

export type UpdateSurveyQuestionDto = {
    answersOrder?: Array<SurveyAnswersOrderDto>;
};

export type UpdateUserDocumentDto = {
    comment?: string | null;
    documentFileKey?: string;
    name?: string;
    type?: UserDocumentType;
};

export type UpdateVehicleExtraDto = {
    autoAssign?: boolean;
    autoAssignValueGte?: number | null;
    autoAssignValueLt?: number | null;
    autoAssignValueType?: AutoAssignValueType | null;
    deprecated?: boolean;
    description?: string;
    key?: string;
    options?: Array<CreateVehicleExtraOptionDto>;
    type?: VehicleExtraType;
};

export type UpdateVehicleTypeDto = {
    accelaration?: number | null;
    acrissCode?: string | null;
    additionalSeats?: number;
    availableExtraIds?: Array<string>;
    axaCategory?: AxaVehicleCategory | null;
    basePrice?: number;
    batteryCapacityInKwh?: number | null;
    categories?: Array<VehicleCategory>;
    customContractCheckboxes?: Array<CustomContractCheckboxDto>;
    customDeposit?: number | null;
    customMinAge?: number | null;
    customPricePerExtraKm?: number | null;
    discountFactor?: number | null;
    discountFrom?: Date | null;
    discountUntil?: Date | null;
    drive?: DriveType;
    europCategory?: EuropVehicleCategory | null;
    fuelType?: FuelType;
    grossPurchasePrice?: number;
    hasDistanceControl?: boolean;
    hasNavigation?: boolean;
    hasRearViewCamera?: boolean;
    imageFileKey?: string | null;
    inspectionIntervalInKm?: number;
    isAlwaysOnWinterTyres?: boolean;
    jlrCategory?: JlrVehicleCategory | null;
    mainCategory?: VehicleCategory;
    makeId?: string;
    model?: string;
    power?: number | null;
    promotionalVideoMediaId?: string | null;
    rangeInKm?: number | null;
    rolandCategory?: RolandVehicleCategory | null;
    seats?: number;
    tankVolumeInLiter?: number | null;
    transmission?: TransmissionType;
    volvoCategory?: VolvoVehicleCategory | null;
};

export type UpdateVideoDto = {
    description?: string;
    fileKey?: string;
    thumbnailFileKey?: string;
    title?: string;
    type?: 'TRAINING';
};

export type UpdateWorkshopAppointmentDocumentDto = {
    comment?: string | null;
    documentFileKey?: string;
    name?: string;
    type?: WorkshopAppointmentDocumentType | null;
};

export type UpdateWorkshopAppointmentDto = {
    additionalInformation?: string;
    allocationStatus?: AllocationStatus;
    carId?: string;
    contactPerson?: string;
    costs?: Array<WorkshopAppointmentCostDto>;
    endDate?: Date;
    location?: LocationDto | null;
    locationGeocodedAddress?: LocationGeocodedNameDto | null;
    locationType?: BookingLocationType;
    milageEnd?: number | null;
    milageStart?: number | null;
    readyForPickup?: boolean;
    /**
     * Skip car availability validation when saving overlapping appointments
     */
    skipCarAvailabilityCheck?: boolean;
    startDate?: Date;
    stationId?: string;
    types?: Array<WorkshopAppointmentType>;
    usesCollectAndReturnService?: boolean;
};

export type UpdateYieldManagementSettingsDto = {
    areaChargePrices?: Array<AreaChargePriceDto>;
    chargingPricePerKwh?: number;
    cleaningFees?: Array<CleaningFeeDto>;
    commissionPercentageOptions?: Array<PercentageOptionDto>;
    crossborderCountries?: Array<CrossborderCountryDto>;
    debitBookingCategories?: Array<DebitBookingCategoryDto>;
    /**
     * Whether the default payment term counts calendar days or business days.
     */
    defaultPaymentTermDayType?: PaymentTermDayType;
    /**
     * Payment term in days for customers without their own payment term.
     */
    defaultPaymentTermDays?: number;
    deposits?: Array<DepositDto>;
    /**
     * Inspection catalog shot keys left out of new handover and return inspections.
     */
    disabledInspectionShotKeys?: Array<InspectionShotKey>;
    discountPercentageOptions?: Array<PercentageOptionDto>;
    extraKmCategoryFactors?: Array<ExtraKmCategoryFactorDto>;
    fuelingPricePerLiter?: number;
    inclusiveKms?: Array<InclusiveKmsDto>;
    infringementFees?: Array<InfringementFeeDto>;
    minAges?: Array<MinAgeDto>;
    pricePerExtraKmSteps?: Array<number>;
    /**
     * Station ids whose short-term handovers include the vehicle photo step.
     */
    requireInspectionStationIds?: Array<string>;
    /**
     * Multiplier on the transfer price when pickup and return are at the same station (0.7 = 30% off).
     */
    stationTransferDiscountModifier?: number;
    /**
     * Offers with transfers are shown for same-station pickup+return only below this multiple of the rental price.
     */
    stationTransferPriceLimitModifier?: number;
    vatRates?: Array<VatRateDto>;
    youngDriverUntilAge?: number;
};

export type UpsertStationCounterDto = {
    id?: string;
    name: string;
};

export type User = {
    agencySettings?: AgencySettings | null;
    readonly agencyType?: AgencyType | null;
    callerId: string | null;
    city: string | null;
    comment: string | null;
    company: string | null;
    country: string | null;
    createdDate: Date;
    creator?: User | null;
    customAgencySettings: AgencySettings | null;
    customerNumber: number;
    readonly customerTier: CustomerTier;
    dateOfBirth: Date | null;
    deletedDate: Date | null;
    did: string | null;
    documents: Array<UserDocument>;
    email: string;
    firstName: string;
    functions: Array<UserFunction>;
    gender: Gender | null;
    handedOverAllocations: Array<Allocation>;
    id: string;
    idCardAuthority: string | null;
    idCardDate: Date | null;
    idCardNumber: string | null;
    isEmailConfirmed: boolean;
    lastName: string;
    licenseAuthority: string | null;
    licenseDate: Date | null;
    licenseNumber: string | null;
    normalizeAgencySettings: unknown;
    partnerSubType: PartnerSubType | null;
    paymentTermDayType: PaymentTermDayType | null;
    paymentTermDays: number | null;
    phone: string | null;
    preferredLocal: Local;
    preferredPaymentTerminal?: PaymentTerminal | null;
    preferredTimezone: Timezone;
    refreshToken: string | null;
    returnedAllocations: Array<Allocation>;
    reviews: Array<Review>;
    role: UserRole;
    sipId: string | null;
    staffomaticUserId: string | null;
    stations: Array<Station> | null;
    street: string | null;
    totalRevenue: number;
    updatedDate: Date;
    vatId: string | null;
    zip: string | null;
};

export type UserAndBookingDataDto = {
    bookings?: Array<Booking>;
    users?: Array<User>;
};

export type UserDocument = {
    comment: string | null;
    createdDate: Date;
    documentFileKey: string;
    id: string;
    name: string;
    type: UserDocumentType;
    updatedDate: Date;
    user: User;
};

export type UserDocumentDto = {
    comment: string | null;
    createdDate: Date;
    documentFileKey: string;
    documentFileUrl: string;
    id: string;
    name: string;
    type: UserDocumentType;
    updatedDate: Date;
    user: User;
};

export enum UserDocumentType {
    AGREEMENT = 'AGREEMENT',
    OTHER = 'OTHER'
}

export enum UserFunction {
    SALES_DIRECTOR = 'SalesDirector',
    AGENCY_APPROVER = 'AgencyApprover',
    DEVELOPER = 'Developer'
}

export enum UserRole {
    ADMIN = 'ADMIN',
    HUB_MANAGER = 'HUB_MANAGER',
    OPERATOR = 'OPERATOR',
    CUSTOMER = 'CUSTOMER',
    AGENCY = 'AGENCY',
    COMPANY = 'COMPANY',
    FRANCHISE_AGENT = 'FRANCHISE_AGENT',
    HUB_AGENT = 'HUB_AGENT'
}

export type ValidateCouponDto = {
    /**
     * The coupon code to validate
     */
    couponCode: string;
    /**
     * The total amount of the booking
     */
    totalAmount: number;
};

export type ValidateLocationResponseDto = {
    nearestDistanceKm: number | null;
    nearestStation: Station | null;
    valid: boolean;
};

export type ValidateVatIdDto = {
    country?: string;
    vatId: string;
};

export type ValidationResult = {
    candidates: Array<string>;
    match: 'correction' | 'extracted' | 'match' | 'mismatch';
    value: string | null;
};

export type ValidationRow = {
    field: FieldName;
    validation: ValidationResult;
};

export enum ValueType {
    STRING = 'STRING',
    NUMBER = 'NUMBER',
    BOOLEAN = 'BOOLEAN'
}

export type VatIdValidationResult = {
    address?: string | null;
    name?: string | null;
    normalizedVatId: string;
    status: 'invalid' | 'unavailable' | 'valid';
};

export type VatRateDto = {
    /**
     * ISO 3166-1 alpha-2 country code
     */
    country: string;
    /**
     * VAT rate in percent (0-100)
     */
    taxPercent: number;
    /**
     * Date from which this VAT rate applies. Null means no start date.
     */
    validFrom: Date | null;
};

export enum VehicleCategory {
    CONVERTIBLE = 'CONVERTIBLE',
    CITY_RACER = 'CITY_RACER',
    ELECTRIC_CAR = 'ELECTRIC_CAR',
    LIMOUSINE = 'LIMOUSINE',
    SPORTS_CAR = 'SPORTS_CAR',
    SUPER_CAR = 'SUPER_CAR',
    SUV = 'SUV',
    STATION_WAGON = 'STATION_WAGON',
    VAN = 'VAN'
}

export enum VehicleClassPreference {
    SMALL_CAR = 'SMALL_CAR',
    MID_CLASS = 'MID_CLASS',
    PREMIUM = 'PREMIUM',
    MULTI_SEATER = 'MULTI_SEATER',
    LUXURY = 'LUXURY'
}

export type VehicleExtra = {
    autoAssign: boolean;
    autoAssignValueGte: number | null;
    autoAssignValueLt: number | null;
    autoAssignValueType: AutoAssignValueType | null;
    deprecated: boolean;
    description: string;
    id: string;
    key?: string;
    options: Array<VehicleExtraOption>;
    type: VehicleExtraType;
    usedInVehicleTypes?: Array<VehicleType>;
};

export type VehicleExtraOption = {
    calculatedPrice?: number;
    deprecated: boolean;
    /**
     * Type-specific metadata, set at pricing time.
     */
    details?: CrossborderExtraOptionDetails | {
        [key: string]: unknown;
    } | null;
    id: string;
    name: string;
    price: number | null;
    pricePerDay: Array<PricePerDay> | null;
    pricingType: VehicleExtraOptionPricingType;
    value: string;
    valueType: ValueType;
    vehicleExtra?: VehicleExtra;
};

export enum VehicleExtraOptionPricingType {
    FIXED_PER_DAY = 'FIXED_PER_DAY',
    FIXED = 'FIXED'
}

export enum VehicleExtraType {
    EXTRA_KM = 'EXTRA_KM',
    ADDITIONAL_DRIVER = 'ADDITIONAL_DRIVER',
    CROSSBORDER = 'CROSSBORDER',
    DEDUCTIBLE = 'DEDUCTIBLE',
    YOUNG_DRIVER = 'YOUNG_DRIVER',
    GLASS_TYRE_WAIVER_AND_MOBILITY = 'GLASS_TYRE_WAIVER_AND_MOBILITY',
    TRANSFER_PICKUP = 'TRANSFER_PICKUP',
    TRANSFER_RETURN = 'TRANSFER_RETURN',
    EMERGENCY_SERVICE = 'EMERGENCY_SERVICE',
    BABY_SEAT = 'BABY_SEAT',
    CHILD_SEAT_0 = 'CHILD_SEAT_0',
    CHILD_SEAT_1 = 'CHILD_SEAT_1',
    BOOSTER_SEAT = 'BOOSTER_SEAT',
    CLEANING_FEE = 'CLEANING_FEE',
    PRICE_REDUCTION = 'PRICE_REDUCTION',
    TOW_HITCH = 'TOW_HITCH'
}

export type VehicleType = {
    accelaration: number | null;
    acrissCode?: string | null;
    additionalSeats: number;
    availableExtras?: Array<VehicleExtra>;
    axaCategory: AxaVehicleCategory | null;
    basePrice: number;
    batteryCapacityInKwh: number | null;
    canBeBookedWithDebitCard?: boolean;
    cars?: Array<Car>;
    categories: Array<VehicleCategory>;
    createdDate: Date;
    customContractCheckboxes: Array<CustomContractCheckbox>;
    customDeposit: number | null;
    customMinAge: number | null;
    customPricePerExtraKm: number | null;
    deposit: number;
    discountFactor?: number | null;
    discountFrom: Date | null;
    discountUntil: Date | null;
    drive: DriveType;
    europCategory: EuropVehicleCategory | null;
    fuelType: FuelType;
    grossPurchasePrice: number;
    hasDistanceControl: boolean | null;
    hasNavigation: boolean | null;
    hasRearViewCamera: boolean | null;
    id: string;
    imageFileKey: string | null;
    readonly imageUrl?: string | null;
    inspectionIntervalInKm: number;
    isAlwaysOnWinterTyres: boolean;
    isBlocked?: boolean;
    isMysteryCar: boolean;
    jlrCategory: JlrVehicleCategory | null;
    readonly licenceNeededForXYears?: number | null;
    mainCategory: VehicleCategory;
    make: Make;
    minAge: number;
    minPricePerDay?: number | null;
    model: string;
    readonly netPurchasePrice: number;
    nextAvailableStartDate?: Date | null;
    numCars?: number;
    power: number | null;
    pricePerExtraKm: number;
    promotionalVideo?: Media | null;
    rangeInKm: number | null;
    rentalDuration?: number | null;
    rolandCategory: RolandVehicleCategory | null;
    seats: number;
    tankVolumeInLiter: number | null;
    totalBasePrice?: number | null;
    totalPrice?: number | null;
    transmission: TransmissionType;
    undiscountedTotalPrice?: number | null;
    updatedDate: Date;
    volvoCategory: VolvoVehicleCategory | null;
};

export type Video = {
    createdDate: Date;
    description: string;
    fileKey: string;
    fileUrl?: string | null;
    id: string;
    thumbnailFileKey: string | null;
    thumbnailUrl?: string | null;
    title: string;
    type: 'TRAINING';
    updatedDate: Date;
};

export type VolvoInsuranceData = {
    initialDays: number;
    referenceNumber: string;
    volvoCategory?: VolvoVehicleCategory;
};

export type VolvoInsuranceDataDto = {
    initialDays: number;
    referenceNumber: string;
    volvoCategory?: VolvoVehicleCategory;
};

export enum VolvoVehicleCategory {
    VOLVO_40 = 'VOLVO_40',
    VOLVO_60 = 'VOLVO_60',
    VOLVO_90 = 'VOLVO_90'
}

export enum WalletProvider {
    GOOGLE_PAY = 'GOOGLE_PAY',
    APPLE_PAY = 'APPLE_PAY'
}

export type WorkshopAppointment = {
    additionalInformation?: string | null;
    allocations: Array<Allocation>;
    car: Car;
    contactPerson?: string | null;
    costs: Array<WorkshopAppointmentCost>;
    createdDate: Date;
    documents: Array<WorkshopAppointmentDocument>;
    id: string;
    readyForPickup: boolean;
    readonly totalCosts: number;
    types: Array<WorkshopAppointmentType>;
    updatedDate: Date;
    usesCollectAndReturnService: boolean;
};

export type WorkshopAppointmentCost = {
    cost: number;
    type: WorkshopAppointmentType;
};

export type WorkshopAppointmentCostDto = {
    cost: number;
    type: WorkshopAppointmentType;
};

export type WorkshopAppointmentDocument = {
    comment: string | null;
    createdDate: Date;
    documentFileKey: string;
    id: string;
    name: string;
    type: WorkshopAppointmentDocumentType | null;
    updatedDate: Date;
    workshopAppointment: WorkshopAppointment;
};

export type WorkshopAppointmentDocumentDto = {
    comment: string | null;
    createdDate: Date;
    documentFileKey: string;
    documentFileUrl: string;
    id: string;
    name: string;
    type: WorkshopAppointmentDocumentType | null;
    updatedDate: Date;
    workshopAppointment: WorkshopAppointment;
};

export enum WorkshopAppointmentDocumentType {
    INVOICE = 'INVOICE',
    OTHER = 'OTHER'
}

export enum WorkshopAppointmentListType {
    REQUIRES_WORKSHOP = 'REQUIRES_WORKSHOP',
    UPCOMING = 'UPCOMING',
    AT_WORKSHOP = 'AT_WORKSHOP',
    READY_FOR_PICKUP = 'READY_FOR_PICKUP',
    ALL = 'ALL'
}

export type WorkshopAppointmentTotalCostsDto = {
    totalCosts: number;
};

export enum WorkshopAppointmentType {
    INSPECTION = 'INSPECTION',
    OTHER_MAINTENANCE = 'OTHER_MAINTENANCE',
    RECALL_OR_WARRANTY = 'RECALL_OR_WARRANTY',
    TUV = 'TUV',
    BRAKES_RENEWAL = 'BRAKES_RENEWAL',
    TYRE_CHANGE = 'TYRE_CHANGE',
    TYRE_CHANGE_WINTER_SUMMER_FIRST_EQUIPMENT = 'TYRE_CHANGE_WINTER_SUMMER_FIRST_EQUIPMENT',
    TYRE_CHANGE_WEAR = 'TYRE_CHANGE_WEAR',
    WINDSHIELD = 'WINDSHIELD',
    RIM_REPAIR = 'RIM_REPAIR',
    BODY_REPAIR = 'BODY_REPAIR',
    DETAILING_FOR_RETURN = 'DETAILING_FOR_RETURN',
    OTHER = 'OTHER'
}

export type WriteOffAmountDto = {
    /**
     * Amount to be written off (only positive)
     */
    amount: number;
    counterpartyType: CounterpartyType;
};

export type WriteOffLedgerDescription = {
    type: 'write_off';
};

export type WunderBooking = {
    customer?: WunderBookingCustomer;
    customerId: number;
    endDate?: string;
    id: number;
    licencePlate: string;
    rentalId: number;
    startDate: string;
    vehicleName: string;
};

export type WunderBookingCustomer = {
    city?: string;
    country?: string;
    dateOfBirth?: string;
    email: string;
    firstName: string;
    id: number;
    language?: string;
    lastName: string;
    phone?: string;
    street?: string;
    zip?: string;
};

export type YearlyRevenueDto = {
    /**
     * Net sum of ROS and Wunder invoices issued in the current year, in EUR (VAT excluded)
     */
    yearlyRevenueEur: number;
    /**
     * Yearly revenue target in EUR
     */
    yearlyTargetEur: number;
};

export type YieldManagementSettings = {
    areaChargePrices: Array<AreaChargePriceDto>;
    chargingPricePerKwh: number;
    cleaningFees: Array<CleaningFeeDto>;
    commissionPercentageOptions: Array<PercentageOptionDto>;
    crossborderCountries: Array<CrossborderCountryDto>;
    debitBookingCategories: Array<DebitBookingCategoryDto>;
    defaultPaymentTermDayType: PaymentTermDayType;
    defaultPaymentTermDays: number;
    deposits: Array<DepositDto>;
    disabledInspectionShotKeys: Array<InspectionShotKey>;
    discountPercentageOptions: Array<PercentageOptionDto>;
    extraKmCategoryFactors: Array<ExtraKmCategoryFactorDto>;
    fuelingPricePerLiter: number;
    id: string;
    inclusiveKms: Array<InclusiveKmsDto>;
    infringementFees: Array<InfringementFeeDto>;
    minAges: Array<MinAgeDto>;
    pricePerExtraKmSteps: Array<number>;
    requireInspectionStationIds: Array<string>;
    stationTransferDiscountModifier: number;
    stationTransferPriceLimitModifier: number;
    vatRates: Array<VatRateDto>;
    youngDriverUntilAge: number;
};

export type ApprovalRequestsControllerRejectBody = {
    rejectionReason: string;
};

export type AdyenSettlementBatchWritable = {
    batchNumber: number;
    createdDate: Date;
    details: Array<AdyenSettlementDetailWritable>;
    id: string;
    legalEntity: LegalEntityWritable;
    merchantAccount: string;
    reportUrl: string;
    status: SettlementBatchStatus;
    updatedDate: Date;
};

export type AdyenSettlementDetailWritable = {
    batch: AdyenSettlementBatchWritable;
    commission: number;
    creationDate: Date | null;
    grossCredit: number;
    grossCurrency: string | null;
    grossDebit: number;
    id: string;
    interchange: number;
    markup: number;
    matchStatus: SettlementDetailMatchStatus | null;
    merchantReference: string | null;
    modificationMerchantReference: string | null;
    modificationPspReference: string | null;
    netCredit: number;
    netCurrency: string | null;
    netDebit: number;
    payment: PaymentWritable | null;
    paymentMethod: string | null;
    paymentMethodVariant: string | null;
    pspReference: string | null;
    schemeFees: number;
    shopperReference: string | null;
    type: string;
};

export type AllocationWritable = {
    booking: BookingWritable | null;
    bufferMinutes: number;
    calculatedTransferMinutes?: number;
    car: CarWritable;
    carSwapReason: CarSwapReason | null;
    comment: string | null;
    createdDate: Date;
    customTransferMinutes: number | null;
    distanceInKm: number | null;
    driver?: UserWritable | null;
    dropoffLocation: Point | null;
    dropoffLocationGeocodedAddress: LocationGeocodedName | null;
    dropoffLocationType: BookingLocationType;
    dropoffResponsibleStation?: StationWritable | null;
    endDate: Date;
    externalDriverEmail: string | null;
    fuelLevelEnd: number | null;
    fuelLevelStart: number | null;
    handingOverAgent?: UserWritable | null;
    handoverDate: Date | null;
    id: string;
    isActive: boolean;
    isBlocking: boolean;
    milageEnd: number | null;
    milageStart: number | null;
    pickupLocation: Point | null;
    pickupLocationGeocodedAddress: LocationGeocodedName | null;
    pickupLocationType: BookingLocationType;
    pickupResponsibleStation?: StationWritable | null;
    rentalPartner: 'PORSCHE_DRIVE' | null;
    returnDate: Date | null;
    returningAgent?: UserWritable | null;
    startDate: Date;
    status: AllocationStatus;
    transferOf: AllocationWritable | null;
    transfers: Array<AllocationWritable> | null;
    type: AllocationType;
    updatedDate: Date;
    workshopAppointment?: WorkshopAppointmentWritable | null;
};

export type ApiKeyWritable = {
    createdDate: Date;
    id: string;
    keyHash: string;
    keyPrefix: string;
    lastUsedAt: Date | null;
    name: string;
    rules?: Array<ApiKeyRuleDto> | null;
    updatedDate: Date;
    user?: UserWritable | null;
};

export type ApprovalRequestWritable = {
    approver?: UserWritable;
    createdDate: Date;
    id: string;
    jobData: RecordStringAny;
    jobName: string;
    rejectionReason?: string;
    requester: UserWritable;
    requiredPermissions?: Array<string>;
    result?: RecordStringAny;
    status: ApprovalRequestStatus;
    tags?: Array<string>;
    updatedDate: Date;
};

export type ApprovalRequestResponseDtoWritable = {
    /**
     * The approver user information (if approved/rejected)
     */
    approver?: UserWritable;
    /**
     * When the approval request was created
     */
    createdDate: Date;
    /**
     * The unique identifier of the approval request
     */
    id: string;
    /**
     * The job data associated with the approval request
     */
    jobData: RecordStringAny;
    /**
     * The job name/type of the approval request
     */
    jobName: string;
    /**
     * The rejection reason (if the request was rejected)
     */
    rejectionReason?: string;
    /**
     * The requester user information
     */
    requester: UserWritable;
    /**
     * The required permissions for approval
     */
    requiredPermissions: Array<string>;
    /**
     * The result data after the approval request was processed
     */
    result?: RecordStringAny;
    /**
     * The status of the approval request
     */
    status: ApprovalRequestStatus;
    /**
     * Tags for categorizing and filtering approval requests
     */
    tags: Array<string>;
    /**
     * The human-readable title of the approval request
     */
    title: string;
    /**
     * When the approval request was last updated
     */
    updatedDate: Date;
};

export type AuditLogWritable = {
    approvalRequest?: ApprovalRequestWritable;
    changedFields: ChangedFields;
    createdAt: Date;
    entityId: string;
    entityType: AuditLogEntityType;
    id: string;
    meta: Array<AuditLogMeta> | null;
    modelName?: string;
    operation: AuditLogOperation;
    user: UserWritable | null;
};

export type BankStatementEntryDtoWritable = {
    accountIban: string;
    action: BankStatementAction | null;
    amount: number;
    bankEntryReference: string;
    bankTransactionId: string | null;
    bookedDate: Date;
    /**
     * Instant an agent confirmed the Bank statement action (create payment, link payment, link settlement, or ignore). Unrelated to booking CONFIRMED.
     */
    confirmedAt: Date | null;
    counterpartyIban: string | null;
    counterpartyName: string | null;
    creditDebit: string | null;
    endToEndId: string | null;
    id: string;
    /**
     * The linked Payment has neither booking nor invoice and is distributed separately.
     */
    isCollectivePayment: boolean;
    /**
     * Legal entity that owns the account IBAN.
     */
    legalEntity: LegalEntitySummaryDto;
    paymentId: string | null;
    remittance: string | null;
    remittanceLines: Array<string>;
    settlementDetailId: string | null;
    suggestion: BankStatementSuggestionDtoWritable | null;
    unconfirmedTarget: boolean;
    valueDate: Date | null;
};

export type BankStatementEntryPageDtoWritable = {
    items: Array<BankStatementEntryDtoWritable>;
    /**
     * Cursor for the next page, null on the last page.
     */
    nextCursor: string | null;
};

export type BankStatementOpenAmountDtoWritable = {
    amount: number;
    /**
     * The booking it belongs to; only id, number, status and start date are set.
     */
    booking: BookingWritable | null;
    counterpartyName: string | null;
    counterpartyType: CounterpartyType | null;
    /**
     * Key of the booking remaining to pay that already includes this invoice
     * remainder; the two are never chosen together.
     */
    coveredByKey: string | null;
    dueSince: Date | null;
    /**
     * Unlinked PAID transfer payments of this invoice or booking (target picker only).
     */
    existingPayments?: Array<PaymentWritable>;
    highlights?: BankStatementMatchHighlights;
    id: string;
    /**
     * The invoice it belongs to; only id, number and invoice date are set.
     */
    invoice: InvoiceWritable | null;
    key: string;
    /**
     * User owing this open amount (booking customer or agency); null for guests.
     */
    payerUserId: string | null;
    /**
     * The unlinked Payment; only id, reference and dates are set.
     */
    payment: PaymentWritable | null;
    /**
     * The Merchant payout; only its id and the batch number are set.
     */
    settlementDetail: AdyenSettlementDetailWritable | null;
    type: BankStatementOpenAmountType;
};

export type BankStatementSuggestionDtoWritable = {
    action: BankStatementAction;
    certainty: BankStatementMatchCertainty;
    needsCounterparty: boolean;
    source: BankStatementSuggestionSource;
    /**
     * The first of `targets`.
     */
    target: BankStatementOpenAmountDtoWritable;
    /**
     * One target, or several open amounts of one payer for a collective payment,
     * oldest due first.
     */
    targets: Array<BankStatementOpenAmountDtoWritable>;
    unconfirmedTarget: boolean;
};

export type BaseStoredPaymentMethodWritable = {
    ccDetails?: CreditCardDetails;
    createdAt: Date;
    id: string;
    /**
     * Payment type (VISA, MASTERCARD, etc.) - may be null for deposit-only entries
     */
    paymentType?: PaymentType | null;
    /**
     * What this payment method was used/stored for (can have multiple purposes)
     */
    purposes: Array<CreditCard>;
    service?: 'adyen' | 'computop';
    /**
     * Wallet provider if this is a wallet payment (Apple Pay, Google Pay)
     */
    walletProvider?: WalletProvider | null;
};

export type BookedExtraWritable = {
    calculatedPrice: number | null;
    createdDate?: Date;
    id?: string;
    updatedDate?: Date;
    vehicleExtraOptionSnapshot: VehicleExtraOptionWritable;
    vehicleExtraSnapshot: VehicleExtraWritable;
};

export type BookingWritable = {
    additionalDrivers: Array<AdditionalDriver>;
    agency: UserWritable | null;
    allocations: Array<AllocationWritable>;
    blockedCreditCardAmount: number | null;
    blockedCreditCardDate: Date | null;
    blockedCreditCardIncludesOpenFee: boolean | null;
    blockedCreditCardLastRefreshDate: Date | null;
    blockedCreditCardRefNr: string | null;
    bookedCar?: CarWritable;
    bookingIpInfo: unknown;
    bookingNumber: number;
    calculatedAdditionalCosts: AdditionalCostsDto | null;
    calculatedInclusiveKm: number | null;
    carSwaps: Array<CarSwapDto>;
    /**
     * Derived from ledger; not stored on the booking row.
     */
    collectDeposit?: boolean;
    confirmationFileKey: string | null;
    confirmationReply: string | null;
    contractFileKey: string | null;
    coupons?: Array<CouponWritable>;
    createdBy?: UserWritable | null;
    createdDate: Date;
    creationSource: BookingCreationSource | null;
    customInclusiveKm: number | null;
    customer?: UserWritable | null;
    customerComment: string | null;
    customerData: CustomerData;
    damages?: Array<DamageWritable> | null;
    debitCardPaymentAtHandover: boolean;
    deferredPayment: boolean;
    deposit: number | null;
    depositPaymentLinkUrl: string | null;
    dropoffLocation: Point | null;
    dropoffLocationGeocodedAddress: LocationGeocodedName | null;
    dropoffLocationType: BookingLocationType;
    dropoffStation?: StationWritable | null;
    endDate: Date;
    externalReference: string | null;
    flags: BookingFlags;
    handoverDate: Date | null;
    hasPeriodicInvoicing: boolean;
    hasUnhandledDamages: boolean;
    id: string;
    inclusiveKm: Array<InclusiveKmPerDay>;
    infringements?: Array<InfringementWritable> | null;
    insuranceCase?: InsuranceCaseWritable | null;
    internalComment: string | null;
    invoicingType: InvoicingType;
    ledgerEntries?: Array<LedgerEntryWritable>;
    legalEntity: LegalEntityWritable;
    npsSurveys: Array<NpsSurveyWritable>;
    onlinePaymentTransferId: string | null;
    pickupLocation: Point | null;
    pickupLocationGeocodedAddress: LocationGeocodedName | null;
    pickupLocationType: BookingLocationType;
    pickupStation?: StationWritable | null;
    priceCalculation?: ({
        type: 'LONG_TERM';
    } & LongTermPricingWritable) | ({
        type: 'SHORT_TERM';
    } & ShortTermPricingWritable) | null;
    pricePerExtraKm: number | null;
    returnDate: Date | null;
    reviews: Array<ReviewWritable>;
    salesChannel: SalesChannel | null;
    signatureFileKey: string | null;
    startDate: Date;
    status: BookingStatus;
    surveysConducted?: Array<SurveyConductedWritable>;
    taxCountry: TaxCountry;
    taxProcedure: TaxProcedure;
    trackingData: AdditionalTrackingData | null;
    /**
     * Unpaid customer deposit-lane amount in euros. Derived from ledger.
     */
    unpaidDeposit?: number;
    updatedDate: Date;
};

export type BookingDtoWritable = {
    additionalDrivers: Array<AdditionalDriver>;
    agency: UserWritable | null;
    allocations: Array<AllocationWritable>;
    blockedCreditCardAmount: number | null;
    blockedCreditCardDate: Date | null;
    blockedCreditCardIncludesOpenFee: boolean | null;
    blockedCreditCardLastRefreshDate: Date | null;
    blockedCreditCardRefNr: string | null;
    bookedCar?: CarWritable;
    bookingIpInfo: unknown;
    bookingNumber: number;
    calculatedAdditionalCosts: AdditionalCostsDto | null;
    calculatedInclusiveKm: number | null;
    carSwaps: Array<CarSwapDto>;
    /**
     * Derived from ledger; not stored on the booking row.
     */
    collectDeposit?: boolean;
    confirmationFileKey: string | null;
    confirmationFileUrl?: string | null;
    confirmationReply: string | null;
    contractFileKey: string | null;
    contractFileUrl?: string | null;
    coupons?: Array<CouponWritable>;
    createdBy?: UserWritable | null;
    createdDate: Date;
    creationSource: BookingCreationSource | null;
    currentBalance?: BookingBalanceDto;
    customInclusiveKm: number | null;
    customer?: UserWritable | null;
    customerComment: string | null;
    customerData: CustomerData;
    damages?: Array<DamageWritable> | null;
    debitCardPaymentAtHandover: boolean;
    deferredPayment: boolean;
    deposit: number | null;
    depositPaymentLinkUrl: string | null;
    displayLocale: Local;
    dropoffLocation: Point | null;
    dropoffLocationGeocodedAddress: LocationGeocodedName | null;
    dropoffLocationType: BookingLocationType;
    dropoffStation?: StationWritable | null;
    endDate: Date;
    externalReference: string | null;
    flags: BookingFlags;
    handoverDate: Date | null;
    hasPeriodicInvoicing: boolean;
    hasUnhandledDamages: boolean;
    id: string;
    inclusiveKm: Array<InclusiveKmPerDay>;
    infringements?: Array<InfringementWritable> | null;
    insuranceCase?: InsuranceCaseWritable | null;
    internalComment: string | null;
    invoicingType: InvoicingType;
    isReadyToFinalize?: boolean;
    ledgerCostBreakdown?: BookingLedgerCostBreakdownDto;
    ledgerEntries?: Array<LedgerEntryWritable>;
    legalEntity: LegalEntityWritable;
    npsSurveys: Array<NpsSurveyWritable>;
    onlinePaymentTransferId: string | null;
    pickupLocation: Point | null;
    pickupLocationGeocodedAddress: LocationGeocodedName | null;
    pickupLocationType: BookingLocationType;
    pickupStation?: StationWritable | null;
    priceCalculation?: ({
        type: 'LONG_TERM';
    } & LongTermPricingWritable) | ({
        type: 'SHORT_TERM';
    } & ShortTermPricingWritable) | null;
    pricePerExtraKm: number | null;
    returnDate: Date | null;
    reviews: Array<ReviewWritable>;
    salesChannel: SalesChannel | null;
    signatureFileKey: string | null;
    startDate: Date;
    status: BookingStatus;
    surveysConducted?: Array<SurveyConductedWritable>;
    taxCountry: TaxCountry;
    taxProcedure: TaxProcedure;
    trackingData: AdditionalTrackingData | null;
    /**
     * Unpaid customer deposit-lane amount in euros. Derived from ledger.
     */
    unpaidDeposit?: number;
    updatedDate: Date;
};

export type CallDtoWritable = {
    callId: string;
    endedAt?: Date;
    number: string;
    relevantBookings?: Array<BookingWritable>;
    relevantUsers?: Array<UserWritable>;
    sipId: string;
    startedAt: Date;
    type: 'in' | 'out';
};

export type CarWritable = {
    accelaration: number | null;
    acquisitionType: CarAcquisitionType;
    additionalSeats: number | null;
    allocations?: Array<AllocationWritable> | null;
    availableFrom: Date;
    availableRange?: CarAvailability;
    availableUntil: Date | null;
    batteryCapacityInKwh: number | null;
    bookings?: Array<BookingWritable> | null;
    brakedTowingCapacityInKg: number | null;
    color: CarColor | null;
    createdDate: Date;
    currentLocationType: CarLocationType;
    damages: Array<DamageWritable>;
    documents: Array<CarDocumentWritable>;
    drive: DriveType | null;
    fin: string | null;
    firstRegistration: Date | null;
    fleetNumber: number;
    fuelLevel: number;
    fuelType: FuelType | null;
    hasDistanceControl: boolean | null;
    hasNavigation: boolean | null;
    hasRearViewCamera: boolean | null;
    hasTowHitch: boolean;
    hiddenFromPublic: boolean;
    id: string;
    imageFileKey: string | null;
    initialMilage: number | null;
    insuranceCompany: string | null;
    isBlocked?: boolean;
    isGhostCar: boolean;
    lastTuvDate: Date | null;
    lastTyreConditionCheck: LastTyreConditionCheckDto | null;
    leasingRate: number | null;
    legalEntities?: Array<CarLegalEntityWritable>;
    licencePlate: string | null;
    listPrice: number;
    merchantConsultedDate: Date | null;
    milage: number;
    needsTyreCheck?: boolean;
    newCarAnnouncenmentMailSentDate: Date | null;
    nextAllocationStartDate?: Date | null;
    nextAvailableStartDate?: Date | null;
    notAtTheHub: boolean;
    possibleUpgradeFrom: Array<PossibleUpgradeWritable>;
    possibleUpgradesTo: Array<PossibleUpgradeWritable>;
    power: number | null;
    promotionalVideo?: Media | null;
    purchasePrice: number | null;
    purchaseReminderMailSentDate: Date | null;
    rangeInKm: number | null;
    readyToHandover?: boolean;
    registrationAndOrganizationDoneDate: Date | null;
    rentalDuration?: number | null;
    saleDate: Date | null;
    salePrice: number | null;
    seats: number | null;
    stations: Array<CarStationsWritable>;
    status: CarStatus;
    tankVolumeInLiter: number | null;
    totalBasePrice?: number | null;
    totalPrice?: number | null;
    transferDeliveryPrice?: number;
    transferReturnPrice?: number;
    transmission: TransmissionType | null;
    tyreConditionFront: TyreCondition;
    tyreConditionRear: TyreCondition;
    tyres: CarTyres;
    unbrakedTowingCapacityInKg: number | null;
    undiscountedTotalPrice?: number | null;
    updatedDate: Date;
    vehicleType?: VehicleTypeWritable;
    workshopAppointments?: Array<WorkshopAppointmentWritable> | null;
};

export type CarDocumentWritable = {
    car: CarWritable;
    comment: string | null;
    createdDate: Date;
    documentFileKey: string;
    id: string;
    name: string;
    type: CarDocumentType | null;
    updatedDate: Date;
};

export type CarDocumentDtoWritable = {
    car: CarWritable;
    comment: string | null;
    createdDate: Date;
    documentFileKey: string;
    documentFileUrl: string;
    id: string;
    name: string;
    type: CarDocumentType | null;
    updatedDate: Date;
};

export type CarLegalEntityWritable = {
    car: CarWritable;
    fromDate: Date | null;
    id: string;
    legalEntity: LegalEntityWritable;
    untilDate: Date | null;
};

export type CarStationsWritable = {
    car: CarWritable;
    fromDate: Date | null;
    id: string;
    primary: boolean;
    station: StationWritable;
    stationId: string;
    untilDate: Date | null;
};

export type ChargeAmountResponseDtoWritable = {
    charged: boolean;
    paymentLink?: PaymentLinkDto;
    payments: Array<PaymentWritable>;
};

export type CompactCarWritable = {
    accelaration: number | null;
    acquisitionType: CarAcquisitionType;
    additionalSeats: number | null;
    allocations?: Array<AllocationWritable> | null;
    availableFrom: Date;
    availableRange?: CarAvailability;
    availableUntil: Date | null;
    batteryCapacityInKwh: number | null;
    bookings?: Array<BookingWritable> | null;
    brakedTowingCapacityInKg: number | null;
    color: CarColor | null;
    createdDate: Date;
    currentLocationType: CarLocationType;
    damages: Array<DamageWritable>;
    documents: Array<CarDocumentWritable>;
    drive: DriveType | null;
    fin: string | null;
    firstRegistration: Date | null;
    fleetNumber: number;
    fuelLevel: number;
    fuelType: FuelType | null;
    hasDistanceControl: boolean | null;
    hasNavigation: boolean | null;
    hasRearViewCamera: boolean | null;
    hasTowHitch: boolean;
    hiddenFromPublic: boolean;
    id: string;
    imageFileKey: string | null;
    initialMilage: number | null;
    insuranceCompany: string | null;
    isBlocked?: boolean;
    isGhostCar: boolean;
    lastTuvDate: Date | null;
    lastTyreConditionCheck: LastTyreConditionCheckDto | null;
    leasingRate: number | null;
    legalEntities?: Array<CarLegalEntityWritable>;
    licencePlate: string | null;
    listPrice: number;
    merchantConsultedDate: Date | null;
    milage: number;
    needsTyreCheck?: boolean;
    newCarAnnouncenmentMailSentDate: Date | null;
    nextAllocationStartDate?: Date | null;
    nextAvailableStartDate?: Date | null;
    notAtTheHub: boolean;
    possibleUpgradeFrom: Array<PossibleUpgradeWritable>;
    possibleUpgradesTo: Array<CompactPossibleUpgradesToWritable>;
    power: number | null;
    promotionalVideo?: Media | null;
    purchasePrice: number | null;
    purchaseReminderMailSentDate: Date | null;
    rangeInKm: number | null;
    readyToHandover?: boolean;
    registrationAndOrganizationDoneDate: Date | null;
    rentalDuration?: number | null;
    saleDate: Date | null;
    salePrice: number | null;
    seats: number | null;
    stations: Array<CarStationsWritable>;
    status: CarStatus;
    tankVolumeInLiter: number | null;
    totalBasePrice?: number | null;
    totalPrice?: number | null;
    transferDeliveryPrice?: number;
    transferReturnPrice?: number;
    transmission: TransmissionType | null;
    tyreConditionFront: TyreCondition;
    tyreConditionRear: TyreCondition;
    tyres: CarTyres;
    unbrakedTowingCapacityInKg: number | null;
    undiscountedTotalPrice?: number | null;
    updatedDate: Date;
    vehicleType: CompactVehicleTypeWritable;
    workshopAppointments?: Array<WorkshopAppointmentWritable> | null;
};

export type CompactPossibleUpgradesToWritable = {
    from: CarWritable;
    id: string;
    order: number;
    to: {
        id: string;
    };
};

export type CompactVehicleTypeWritable = {
    accelaration: number | null;
    acrissCode?: string | null;
    additionalSeats: number;
    axaCategory: AxaVehicleCategory | null;
    basePrice: number;
    batteryCapacityInKwh: number | null;
    canBeBookedWithDebitCard?: boolean;
    cars?: Array<CarWritable>;
    categories: Array<VehicleCategory>;
    createdDate: Date;
    customContractCheckboxes: Array<CustomContractCheckbox>;
    customDeposit: number | null;
    customMinAge: number | null;
    customPricePerExtraKm: number | null;
    deposit: number;
    discountFactor?: number | null;
    discountFrom: Date | null;
    discountUntil: Date | null;
    drive: DriveType;
    europCategory: EuropVehicleCategory | null;
    fuelType: FuelType;
    grossPurchasePrice: number;
    hasDistanceControl: boolean | null;
    hasNavigation: boolean | null;
    hasRearViewCamera: boolean | null;
    id: string;
    imageFileKey: string | null;
    inspectionIntervalInKm: number;
    isAlwaysOnWinterTyres: boolean;
    isBlocked?: boolean;
    isMysteryCar: boolean;
    jlrCategory: JlrVehicleCategory | null;
    mainCategory: VehicleCategory;
    make: Make;
    minAge: number;
    minPricePerDay?: number | null;
    model: string;
    nextAvailableStartDate?: Date | null;
    numCars?: number;
    power: number | null;
    pricePerExtraKm: number;
    promotionalVideo?: Media | null;
    rangeInKm: number | null;
    rentalDuration?: number | null;
    rolandCategory: RolandVehicleCategory | null;
    seats: number;
    tankVolumeInLiter: number | null;
    totalBasePrice?: number | null;
    totalPrice?: number | null;
    transmission: TransmissionType;
    undiscountedTotalPrice?: number | null;
    updatedDate: Date;
    volvoCategory: VolvoVehicleCategory | null;
};

export type ContractPenaltyResponseDtoWritable = {
    damage?: DamageWritable | null;
    invoice?: InvoiceWritable | null;
};

export type CouponWritable = {
    benefits?: CouponBenefitsDto | null;
    code: string;
    comment: string | null;
    createdAt: Date;
    customerData?: CustomerDataDto;
    id: string;
    isActive: boolean;
    maxRedemptions: number | null;
    oneRedemptionPerCustomer: boolean;
    orderInvoice?: InvoiceWritable;
    originalValue: number | null;
    paymentIds?: Array<string>;
    redemptionCount: number;
    remainingValue: number | null;
    type: CouponType;
    updatedAt: Date;
    validFrom: Date | null;
    validTo: Date | null;
};

export type CreateApiKeyResponseDtoWritable = {
    apiKey: ApiKeyWritable;
    /**
     * The plain API key - store this securely, it will not be shown again
     */
    plainKey: string;
};

export type CreateCouponDtoWritable = {
    /**
     * Benefits granted by promo coupons
     */
    benefits?: CouponBenefitsDto;
    /**
     * Custom coupon code for promo coupons
     */
    code?: string;
    /**
     * Internal note on why the coupon was issued (required for goodwill coupons)
     */
    comment?: string | null;
    /**
     * The customer data associated with the coupon
     */
    customerData?: CustomerDataDto;
    /**
     * Whether the coupon is active
     */
    isActive?: boolean;
    /**
     * Maximum total redemptions across all customers (null = unlimited)
     */
    maxRedemptions?: number | null;
    /**
     * Whether each customer account may redeem this promo only once
     */
    oneRedemptionPerCustomer?: boolean;
    orderInvoice?: InvoiceWritable;
    /**
     * The original value of the coupon (same as initial value)
     */
    originalValue?: number;
    /**
     * The initial value of the coupon
     */
    remainingValue?: number;
    /**
     * The type of the coupon
     */
    type?: CouponType;
    /**
     * Optional start date for promo coupons (start of day, Europe/Berlin)
     */
    validFrom?: Date | null;
    /**
     * Optional expiry date for promo coupons (end of day, Europe/Berlin)
     */
    validTo?: Date | null;
};

export type CreatePaymentDtoWritable = {
    amount: number;
    authorizationLastRefreshDate?: Date | null;
    bookingId?: string | null;
    comment?: string | null;
    counterpartyType?: CounterpartyType | null;
    creditCardDetails?: CreditCardDetailsDto | null;
    date: Date;
    invoiceId?: string | null;
    legalEntityId?: string | null;
    paidDate?: Date | null;
    paymentAllocations?: Array<PaymentAllocationWritable>;
    paymentData?: BasePaymentData;
    paymentType: PaymentType;
    referenceId?: string | null;
    status?: PaymentStatus;
    walletProvider?: WalletProvider | null;
};

export type CreditWithRefundResponseDtoWritable = {
    creditedAmount: number;
    payments: Array<PaymentWritable>;
};

export type DamageWritable = {
    booking: BookingWritable | null;
    car: CarWritable;
    createdDate: Date;
    description: string;
    expectedPhotoCount: number;
    fleetNotificationSent: boolean;
    id: string;
    imageFileKeys: Array<string>;
    imageFileUrls?: Array<string>;
    positionX: number | null;
    positionY: number | null;
    repairedDate: Date | null;
    status: DamageStatus;
    updatedDate: Date;
    videoExpected: boolean;
    videoFileKey: string | null;
    videoFileUrl?: string | null;
};

export type DryRunBookingResponseDtoWritable = {
    agencySettings?: AgencySettings | null;
    availableExtras?: Array<VehicleExtraWritable>;
    averagePricePerDay: number;
    basePrice: number;
    bookedExtras?: Array<BookedExtraWritable>;
    cancellationFee?: CancellationFee;
    cancellationFeeAmount?: number;
    createdDate?: Date;
    customBookedExtras?: Array<CustomBookedExtraDto> | null;
    customDeposit?: number | null;
    customInclusiveKm?: number | null;
    customPricePerExtraKm?: number | null;
    customTotalBasePrice?: number | null;
    days: number;
    defaultDeposit: number;
    defaultInclusiveKm: number;
    defaultPricePerExtraKm: number;
    id?: string;
    isDiscounted: boolean;
    legalEntityId: string;
    pricingModifiersVersion?: number | null;
    /**
     * VAT rate in percent. Undefined uses the booking tax procedure default; a number is an explicit override.
     */
    taxPercent: number;
    totalBasePrice: number;
    totalPrice: number;
    type?: 'SHORT_TERM';
    undiscountedAveragePricePerDay?: number | null;
    undiscountedTotalBasePrice?: number | null;
    undiscountedTotalPrice?: number | null;
    updatedDate?: Date;
};

export type InfringementWritable = {
    chargeFeeVatMode: InfringementChargeFeeVatMode | null;
    comment: string;
    createdDate: Date;
    data: InfringementData | null;
    id: string;
    imageFileKey: string;
    imageFileUrl?: string;
    rosBooking: BookingWritable | null;
    rosInvoice: InvoiceWritable | null;
    skipSendAuthorityMail?: boolean;
    status: InfringementStatus;
    steps?: InfringementSteps;
    updatedDate: Date;
    waivedReason: InfringementWaivedReason | null;
    waivedReasonComment: string | null;
    wunderBooking: WunderBooking | null;
    wunderChargeContext: InfringementWunderChargeContext | null;
};

export type InfringementStatusEventDtoWritable = {
    infringement: InfringementWritable;
    type: InfringementStatusEventType;
};

export type InspectionDtoWritable = {
    allocationId: string;
    completedDate: Date | null;
    createdDate: Date;
    /**
     * Shot keys this inspection asks for, in catalog order at creation time.
     */
    expectedShotKeys: Array<InspectionShotKey>;
    id: string;
    /**
     * True once shots can no longer be captured, retaken, or skipped.
     */
    isLocked: boolean;
    phase: InspectionPhase;
    shots: Array<InspectionShotDtoWritable>;
};

export type InspectionShotDtoWritable = {
    /**
     * Id of the current capture; null when skipped.
     */
    captureId: string | null;
    /**
     * Signed URL of the photo; null while it is still uploading or when skipped.
     */
    imageFileUrl: string | null;
    /**
     * True when the shot was captured but its photo has not landed yet.
     */
    isImagePending: boolean;
    /**
     * Who captured or skipped the shot. Only id, first name, and last name are loaded.
     */
    recordedBy: UserWritable | null;
    recordedDate: Date;
    shotKey: InspectionShotKey;
    skipReason: string | null;
};

export type InsuranceCaseWritable = {
    additionalInfo: string | null;
    booking?: BookingWritable | null;
    createdDate: Date;
    customer?: UserWritable | null;
    customerData: CustomerData;
    endDate: Date | null;
    id: string;
    insuranceData: AxaInsuranceData | EuropInsuranceData | JlrInsuranceData | RolandInsuranceData | VolvoInsuranceData | null;
    insuranceProvider: InsuranceProviderName;
    locationGeocodedAddress: LocationGeocodedAddress | null;
    startDate?: Date | null;
    status: InsuranceCaseStatus;
    updatedDate: Date;
};

export type InvoiceWritable = {
    booking: BookingWritable | null;
    canceledStateDate: Date | null;
    comment: string | null;
    completeInvoiceNumber: string | null;
    counterpartyType: CounterpartyType | null;
    createdDate: Date;
    customer: UserWritable | null;
    fileKey: string | null;
    id: string;
    infringement: InfringementWritable | null;
    invoiceAllocations: Array<InvoiceAllocationWritable>;
    invoiceDate: Date | null;
    invoiceNumber: number | null;
    invoiceNumberPrefix: string | null;
    invoiceNumberSuffix: string | null;
    legalEntity: LegalEntityWritable;
    openStateDate: Date | null;
    originalInvoice: InvoiceWritable | null;
    paidAmountOfOriginalInvoice: number | null;
    paidStateDate: Date | null;
    payments: Array<PaymentWritable> | null;
    positions: Array<InvoicePosition>;
    receiverData: InvoiceReceiverData;
    reversalInvoices: Array<InvoiceWritable> | null;
    sentStateDate: Date | null;
    status: InvoiceStatus;
    taxCountry: TaxCountry;
    taxProcedure: TaxProcedure;
    title: string | null;
    totalAllocatedAmount?: number | null;
    type: InvoiceType;
    updatedDate: Date;
};

export type InvoiceAllocationWritable = {
    amount: number;
    createdAt: Date;
    finalizedAt: Date | null;
    id: string;
    invoice: InvoiceWritable;
    ledgerEntry: LedgerEntryWritable;
    updatedDate: Date;
};

export type InvoiceAllocationDtoWritable = {
    amount: number;
    createdAt: Date;
    finalizedAt: Date | null;
    id: string;
    invoice: InvoiceWritable;
    ledgerEntry: LedgerEntryDtoWritable;
    updatedDate: Date;
};

export type InvoiceDtoWritable = {
    booking: BookingWritable | null;
    canceledStateDate: Date | null;
    comment: string | null;
    completeInvoiceNumber: string | null;
    counterpartyType: CounterpartyType | null;
    createdDate: Date;
    currentBalance: number;
    customer: UserWritable | null;
    fileKey: string | null;
    fileUrl: string | null;
    id: string;
    infringement: InfringementWritable | null;
    invoiceAllocations: Array<InvoiceAllocationWritable>;
    invoiceDate: Date | null;
    invoiceNumber: number | null;
    invoiceNumberPrefix: string | null;
    invoiceNumberSuffix: string | null;
    legalEntity: LegalEntityWritable;
    openStateDate: Date | null;
    originalInvoice: InvoiceWritable | null;
    paidAmountOfOriginalInvoice: number | null;
    paidStateDate: Date | null;
    payments: Array<PaymentWritable> | null;
    positions: Array<InvoicePosition>;
    receiverData: InvoiceReceiverData;
    reversalInvoices: Array<InvoiceWritable> | null;
    sentStateDate: Date | null;
    status: InvoiceStatus;
    taxCountry: TaxCountry;
    taxProcedure: TaxProcedure;
    title: string | null;
    totalAllocatedAmount?: number | null;
    type: InvoiceType;
    updatedDate: Date;
};

export type InvoicingRunResultDtoWritable = {
    regularInvoices: Array<InvoiceDtoWritable>;
    reversalInvoices: Array<InvoiceDtoWritable>;
    unabsorbedCredits: Array<UnabsorbedInvoiceCreditDto>;
};

export type LeadWritable = {
    approvalRequest: ApprovalRequestWritable | null;
    company: string;
    createdDate: Date;
    email: string;
    firstName: string;
    id: string;
    lastName: string;
    outcome: LeadOutcome | null;
    phone: string;
    plannedBookingsPerMonth: string;
    source: 'WEBSITE';
    status: LeadStatus;
    updatedDate: Date;
    user: UserWritable | null;
};

export type LedgerEntryWritable = {
    amount: number;
    amountNet: number;
    amountToInvoice: number;
    amountToPay: number;
    booking: BookingWritable | null;
    counterpartyType: CounterpartyType;
    createdDate: Date;
    currency: 'EUR';
    description: LedgerDescription;
    dueDate: Date | null;
    excludedFromReconciliation?: boolean;
    id: string;
    invoiceAllocations: Array<InvoiceAllocationWritable>;
    invoicedAmount: number;
    lane: string;
    legalEntity: LegalEntityWritable;
    nettedInvoiceAmount: number;
    nettedPaymentAmount: number;
    nettingAllocations: Array<NettingAllocationWritable>;
    paidAmount: number;
    paymentAllocations: Array<PaymentAllocationWritable>;
    previousLedgerEntry: LedgerEntryWritable | null;
    serviceDate: Date | null;
    taxCountry: TaxCountry;
    taxPercent: number;
    taxProcedure: TaxProcedure;
    updatedDate: Date;
};

export type LedgerEntryDtoWritable = {
    amount: number;
    amountNet: number;
    amountToInvoice: number;
    amountToPay: number;
    booking: BookingWritable | null;
    counterpartyType: CounterpartyType;
    createdDate: Date;
    currency: 'EUR';
    description: LedgerDescription;
    dueDate: Date | null;
    excludedFromReconciliation?: boolean;
    id: string;
    invoiceAllocations: Array<InvoiceAllocationWritable>;
    invoicedAmount: number;
    lane: string;
    legalEntity: LegalEntityWritable;
    nettedInvoiceAmount: number;
    nettedPaymentAmount: number;
    nettingAllocations: Array<NettingAllocationWritable>;
    paidAmount: number;
    paymentAllocations: Array<PaymentAllocationWritable>;
    previousLedgerEntry: LedgerEntryWritable | null;
    readableDescription?: LocalizedFieldDto;
    serviceDate: Date | null;
    taxCountry: TaxCountry;
    taxPercent: number;
    taxProcedure: TaxProcedure;
    updatedDate: Date;
};

export type LegalEntityWritable = {
    adyenMerchantAccount: string;
    bankName: string;
    bic: string;
    city: LocalizedFieldDto;
    commercialRegister: string;
    countryCode: string;
    createdDate: Date;
    email: string;
    englishTerms: string;
    iban: string;
    id: string;
    invoiceNumberPrefix: string;
    isActive: boolean;
    isOssRegistered: boolean;
    localLanguage: string;
    localTerms: string;
    managingDirectors: string;
    name: string;
    phone: string;
    sepaCreditorId: string | null;
    stations?: Array<StationWritable>;
    street: string;
    taxNumber: string | null;
    updatedDate: Date;
    vatId: string;
    website: string;
    zip: string;
};

export type LongTermPricingWritable = {
    availableExtras?: Array<VehicleExtraWritable>;
    basePrice: number;
    customDeposit?: number | null;
    customInclusiveKm?: number | null;
    customPricePerExtraKm?: number | null;
    defaultDeposit: number;
    defaultInclusiveKm: number;
    defaultPricePerExtraKm: number;
    endDate: Date;
    extrasSnapshot: Array<VehicleExtraWritable>;
    periods: Array<LongTermPricingPeriodWritable>;
    startDate: Date;
    /**
     * VAT rate in percent. Undefined uses the booking tax procedure default; a number is an explicit override.
     */
    taxPercent: number;
    type?: 'LONG_TERM';
};

export type LongTermPricingPeriodWritable = {
    bookedExtras?: Array<BookedExtraWritable>;
    customBookedExtras?: Array<CustomBookedExtraDto> | null;
    customInclusiveKm?: number | null;
    customTotalBasePrice?: number | null;
    defaultInclusiveKm?: number | null;
    endDate: Date;
    startDate: Date;
    totalBasePrice: number;
};

export type NettingWritable = {
    allocations: Array<NettingAllocationWritable>;
    createdDate: Date;
    description: string | null;
    id: string;
    type: NettingType;
    updatedDate: Date;
};

export type NettingAllocationWritable = {
    amount: number;
    createdDate: Date;
    id: string;
    ledgerEntry: LedgerEntryWritable;
    netting: NettingWritable;
    updatedDate: Date;
};

export type NpsSurveyWritable = {
    booking: BookingWritable | null;
    comment: string | null;
    completedDate: Date | null;
    createdDate: Date;
    id: string;
    score: number | null;
    status: NpsSurveyStatus;
    updatedDate: Date;
    wishedCar: string | null;
};

export type OfferWritable = {
    car: CarWritable;
    freeUntil?: Date | null;
    isAvailable: boolean;
    nextPossibleEndDate?: Date | null;
    nextPossibleStartDate?: Date | null;
    pricing: PricingWritable;
};

export type PaginationAllocationTransactionDtoPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationAllocationPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationApprovalRequestResponseDtoPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationAuditLogPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationBookingPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationCarDocumentDtoPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationCompactCarPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationCouponPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationInfringementPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationInsuranceCasePaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationInvoiceDtoPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationJobDtoPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationLeadPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationLedgerEntryDtoPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationMediaPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationMinimalAllocationDtoPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationNewsPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationOfferPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationPaymentTerminalPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationPaymentPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationPaymentPaginationMeta2Writable = {
    [key: string]: unknown;
};

export type PaginationReviewPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationSettlementBatchListItemDtoPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationStationPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationSurveyConductedPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationUserDocumentDtoPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationUserPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationVideoPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationWorkshopAppointmentDocumentDtoPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaginationWorkshopAppointmentPaginationMetaWritable = {
    [key: string]: unknown;
};

export type PaymentWritable = {
    allocatedBookings?: Array<AttributedBooking>;
    allocatedInvoices?: Array<AttributedInvoice>;
    amount: number;
    authorizationLastRefreshDate: Date | null;
    booking: BookingWritable | null;
    comment: string | null;
    counterpartyType: CounterpartyType | null;
    createdDate: Date;
    creditCardDetails: CreditCardDetails | null;
    date: Date;
    id: string;
    invoice: InvoiceWritable | null;
    legalEntity: LegalEntityWritable;
    paidDate: Date | null;
    paymentAllocations: Array<PaymentAllocationWritable>;
    paymentLinkUrl: string | null;
    paymentType: PaymentType;
    referenceId: string | null;
    status: PaymentStatus;
    totalAllocatedAmount?: number | null;
    updatedDate: Date;
    walletProvider: WalletProvider | null;
};

export type PaymentAllocationWritable = {
    amount: number;
    createdAt: Date;
    finalizedAt: Date | null;
    id: string;
    ledgerEntry: LedgerEntryWritable;
    payment: PaymentWritable;
    updatedDate: Date;
};

export type PaymentAllocationDtoWritable = {
    amount: number;
    createdAt: Date;
    finalizedAt: Date | null;
    id: string;
    ledgerEntry: LedgerEntryDtoWritable;
    payment: PaymentWritable;
    updatedDate: Date;
};

export type PaymentTerminalWritable = {
    description: string;
    id: string;
    station?: StationWritable;
    terminalId: number;
    users?: Array<UserWritable> | null;
};

export type PossibleUpgradeWritable = {
    from: CarWritable;
    id: string;
    order: number;
    to: CarWritable;
};

export type PricingWritable = ({
    type: 'LONG_TERM';
} & LongTermPricingWritable) | ({
    type: 'SHORT_TERM';
} & ShortTermPricingWritable);

export type RebookingResultDtoWritable = {
    cancellationFee?: number;
    isAvailable: boolean;
    updatedPricing?: ({
        type: 'LONG_TERM';
    } & LongTermPricingWritable) | ({
        type: 'SHORT_TERM';
    } & ShortTermPricingWritable);
};

export type ReceivablesWriteOffsDtoWritable = {
    /**
     * Write-off ledger entries with booking (id, number, customer data) and legal entity (id, name)
     */
    items: Array<LedgerEntryWritable>;
    /**
     * Total written-off amount in euros (positive; ledger amounts are negative)
     */
    totalAmount: number;
};

export type RefundUnallocatedPaymentAmountResponseDtoWritable = {
    creditedAmount: number;
    payment: PaymentWritable;
};

export type RentalKeyTagSummaryDtoWritable = {
    allowedCountries: Array<string>;
    bookingId: string;
    bookingNumber: string;
    dropoffLocation: Point | null;
    dropoffLocationGeocodedAddress: LocationGeocodedName | null;
    dropoffLocationType: BookingLocationType;
    dropoffStation: StationWritable | null;
    endDate: Date;
    isHandedOver: boolean;
    licensePlate: string | null;
    locale: string;
    maskedEmail: string;
    pickupLocation: Point | null;
    pickupLocationGeocodedAddress: LocationGeocodedName | null;
    pickupLocationType: BookingLocationType;
    pickupStation: StationWritable | null;
    startDate: Date;
    supportPhone: string;
    vehicleImageUrl: string | null;
    vehicleName: string | null;
};

export type ReviewWritable = {
    booking: BookingWritable | null;
    comment: string | null;
    completedDate: Date | null;
    createdDate: Date;
    id: string;
    rating: number | null;
    secretCompletionToken: string | null;
    status: ReviewStatus;
    targetEmployee: UserWritable | null;
    targetType: 'HANDOVER';
    updatedDate: Date;
};

export type SettlementBatchDetailsDtoWritable = {
    batchNumber: number;
    id: string;
    lines: Array<SettlementDetailLineDtoWritable>;
};

export type SettlementDetailLineDtoWritable = {
    /**
     * Signed gross amount (debits negative)
     */
    grossAmount: number;
    id: string;
    matchStatus: SettlementDetailMatchStatus | null;
    merchantReference: string | null;
    modificationMerchantReference: string | null;
    /**
     * Adyen Modification Reference (related PSP)
     */
    modificationPspReference: string | null;
    payment: PaymentWritable | null;
    paymentMethod: string | null;
    pspReference: string | null;
    type: string;
};

export type ShortTermPricingWritable = {
    agencySettings?: AgencySettings | null;
    availableExtras?: Array<VehicleExtraWritable>;
    averagePricePerDay: number;
    basePrice: number;
    bookedExtras?: Array<BookedExtraWritable>;
    cancellationFee?: CancellationFee;
    cancellationFeeAmount?: number;
    createdDate?: Date;
    customBookedExtras?: Array<CustomBookedExtraDto> | null;
    customDeposit?: number | null;
    customInclusiveKm?: number | null;
    customPricePerExtraKm?: number | null;
    customTotalBasePrice?: number | null;
    days: number;
    defaultDeposit: number;
    defaultInclusiveKm: number;
    defaultPricePerExtraKm: number;
    id?: string;
    isDiscounted: boolean;
    pricingModifiersVersion?: number | null;
    /**
     * VAT rate in percent. Undefined uses the booking tax procedure default; a number is an explicit override.
     */
    taxPercent: number;
    totalBasePrice: number;
    totalPrice: number;
    type?: 'SHORT_TERM';
    undiscountedAveragePricePerDay?: number | null;
    undiscountedTotalBasePrice?: number | null;
    undiscountedTotalPrice?: number | null;
    updatedDate?: Date;
};

export type StationWritable = {
    alternativeOpeningHours?: Array<AlternativeOpeningHours>;
    authCode: string | null;
    cars?: Array<CarStationsWritable>;
    city: string;
    counters?: Array<StationCounterWritable>;
    countryCode: string;
    createdDate: Date;
    deletedDate: Date | null;
    googleMapsReviewCtaUrl: string | null;
    holidays?: Array<Date>;
    icon: StationIcon | null;
    id: string;
    ignoredHolidays: Array<IgnoredHolidayDto> | null;
    info: LocalizedFieldDto2;
    invoiceSuffix: string | null;
    isGoogleMapsReviewEnabled: boolean;
    isHidden: boolean;
    isInternal: boolean;
    legalEntity: LegalEntityWritable;
    location: Point;
    mapImageFileKey: string | null;
    notice: LocalizedFieldDto2 | null;
    openingHours: Array<OpeningHours>;
    paymentTerminals?: Array<PaymentTerminalWritable> | null;
    returnPolicy: StationReturnPolicy;
    slug: string;
    state: string | null;
    street: string;
    timezone: Timezone;
    updatedDate: Date;
    users?: Array<UserWritable> | null;
    zip: string;
};

export type StationCounterWritable = {
    createdDate: Date;
    id: string;
    name: string;
    station: StationWritable;
    stationId: string;
    updatedDate: Date;
};

export type SuggestCustomerDataDtoWritable = {
    bookingNumber?: number | null;
    /**
     * Number of bookings with this exact address (only for source=booking)
     */
    bookingsCount?: number | null;
    customerData: CustomerDataDto;
    customerId?: string | null;
    email?: string | null;
    partner?: UserWritable | null;
    source: 'booking' | 'user';
};

export type SurveyWritable = {
    conducted: Array<SurveyConductedWritable>;
    createdDate: Date;
    id: string;
    questions: Array<SurveyQuestionWritable>;
    slug: string;
    titleDe: string;
    titleEn: string;
    updatedDate: Date;
};

export type SurveyAnswerWritable = {
    conducted: Array<SurveyConductedWritable> | null;
    createdDate: Date;
    deleted: boolean;
    id: string;
    order: number;
    question: SurveyQuestionWritable;
    textDe: string;
    textEn: string;
    updatedDate: Date;
};

export type SurveyConductedWritable = {
    answers: Array<SurveyAnswerWritable> | null;
    booking: BookingWritable;
    createdDate: Date;
    id: string;
    survey: SurveyWritable;
    updatedDate: Date;
};

export type SurveyQuestionWritable = {
    answers: Array<SurveyAnswerWritable>;
    createdDate: Date;
    deleted: boolean;
    id: string;
    order: number;
    survey: SurveyWritable;
    textDe: string;
    textEn: string;
    updatedDate: Date;
};

export type TimeTrackingEntryWritable = {
    endDate?: Date | null;
    startDate?: Date | null;
    user: UserWritable;
};

export type UpdateCouponDtoWritable = {
    benefits?: CouponBenefitsDto | null;
    /**
     * Internal note on why the coupon was issued (required for goodwill coupons)
     */
    comment?: string | null;
    customerData?: CustomerDataDto;
    isActive?: boolean;
    maxRedemptions?: number | null;
    oneRedemptionPerCustomer?: boolean;
    orderInvoice?: InvoiceWritable;
    paymentIds?: Array<string>;
    remainingValue?: number;
    validFrom?: Date | null;
    validTo?: Date | null;
};

export type UpdatePaymentDtoWritable = {
    amount?: number;
    authorizationLastRefreshDate?: Date | null;
    bookingId?: string | null;
    comment?: string | null;
    counterpartyType?: CounterpartyType | null;
    creditCardDetails?: CreditCardDetailsDto | null;
    date?: Date;
    invoiceId?: string | null;
    paidDate?: Date | null;
    paymentAllocations?: Array<PaymentAllocationWritable>;
    paymentData?: BasePaymentData;
    paymentType?: PaymentType;
    referenceId?: string | null;
    status?: PaymentStatus;
    walletProvider?: WalletProvider | null;
};

export type UserWritable = {
    agencySettings?: AgencySettings | null;
    callerId: string | null;
    city: string | null;
    comment: string | null;
    company: string | null;
    country: string | null;
    createdDate: Date;
    creator?: UserWritable | null;
    customAgencySettings: AgencySettings | null;
    customerNumber: number;
    dateOfBirth: Date | null;
    deletedDate: Date | null;
    did: string | null;
    documents: Array<UserDocumentWritable>;
    email: string;
    firstName: string;
    functions: Array<UserFunction>;
    gender: Gender | null;
    handedOverAllocations: Array<AllocationWritable>;
    id: string;
    idCardAuthority: string | null;
    idCardDate: Date | null;
    idCardNumber: string | null;
    isEmailConfirmed: boolean;
    lastName: string;
    licenseAuthority: string | null;
    licenseDate: Date | null;
    licenseNumber: string | null;
    normalizeAgencySettings: unknown;
    partnerSubType: PartnerSubType | null;
    paymentTermDayType: PaymentTermDayType | null;
    paymentTermDays: number | null;
    phone: string | null;
    preferredLocal: Local;
    preferredPaymentTerminal?: PaymentTerminalWritable | null;
    preferredTimezone: Timezone;
    refreshToken: string | null;
    returnedAllocations: Array<AllocationWritable>;
    reviews: Array<ReviewWritable>;
    role: UserRole;
    sipId: string | null;
    staffomaticUserId: string | null;
    stations: Array<StationWritable> | null;
    street: string | null;
    totalRevenue: number;
    updatedDate: Date;
    vatId: string | null;
    zip: string | null;
};

export type UserAndBookingDataDtoWritable = {
    bookings?: Array<BookingWritable>;
    users?: Array<UserWritable>;
};

export type UserDocumentWritable = {
    comment: string | null;
    createdDate: Date;
    documentFileKey: string;
    id: string;
    name: string;
    type: UserDocumentType;
    updatedDate: Date;
    user: UserWritable;
};

export type UserDocumentDtoWritable = {
    comment: string | null;
    createdDate: Date;
    documentFileKey: string;
    documentFileUrl: string;
    id: string;
    name: string;
    type: UserDocumentType;
    updatedDate: Date;
    user: UserWritable;
};

export type ValidateLocationResponseDtoWritable = {
    nearestDistanceKm: number | null;
    nearestStation: StationWritable | null;
    valid: boolean;
};

export type VehicleExtraWritable = {
    autoAssign: boolean;
    autoAssignValueGte: number | null;
    autoAssignValueLt: number | null;
    autoAssignValueType: AutoAssignValueType | null;
    deprecated: boolean;
    description: string;
    id: string;
    key?: string;
    options: Array<VehicleExtraOptionWritable>;
    type: VehicleExtraType;
    usedInVehicleTypes?: Array<VehicleTypeWritable>;
};

export type VehicleExtraOptionWritable = {
    calculatedPrice?: number;
    deprecated: boolean;
    /**
     * Type-specific metadata, set at pricing time.
     */
    details?: CrossborderExtraOptionDetails | {
        [key: string]: unknown;
    } | null;
    id: string;
    name: string;
    price: number | null;
    pricePerDay: Array<PricePerDay> | null;
    pricingType: VehicleExtraOptionPricingType;
    value: string;
    valueType: ValueType;
    vehicleExtra?: VehicleExtraWritable;
};

export type VehicleTypeWritable = {
    accelaration: number | null;
    acrissCode?: string | null;
    additionalSeats: number;
    availableExtras?: Array<VehicleExtraWritable>;
    axaCategory: AxaVehicleCategory | null;
    basePrice: number;
    batteryCapacityInKwh: number | null;
    canBeBookedWithDebitCard?: boolean;
    cars?: Array<CarWritable>;
    categories: Array<VehicleCategory>;
    createdDate: Date;
    customContractCheckboxes: Array<CustomContractCheckbox>;
    customDeposit: number | null;
    customMinAge: number | null;
    customPricePerExtraKm: number | null;
    deposit: number;
    discountFactor?: number | null;
    discountFrom: Date | null;
    discountUntil: Date | null;
    drive: DriveType;
    europCategory: EuropVehicleCategory | null;
    fuelType: FuelType;
    grossPurchasePrice: number;
    hasDistanceControl: boolean | null;
    hasNavigation: boolean | null;
    hasRearViewCamera: boolean | null;
    id: string;
    imageFileKey: string | null;
    inspectionIntervalInKm: number;
    isAlwaysOnWinterTyres: boolean;
    isBlocked?: boolean;
    isMysteryCar: boolean;
    jlrCategory: JlrVehicleCategory | null;
    mainCategory: VehicleCategory;
    make: Make;
    minAge: number;
    minPricePerDay?: number | null;
    model: string;
    nextAvailableStartDate?: Date | null;
    numCars?: number;
    power: number | null;
    pricePerExtraKm: number;
    promotionalVideo?: Media | null;
    rangeInKm: number | null;
    rentalDuration?: number | null;
    rolandCategory: RolandVehicleCategory | null;
    seats: number;
    tankVolumeInLiter: number | null;
    totalBasePrice?: number | null;
    totalPrice?: number | null;
    transmission: TransmissionType;
    undiscountedTotalPrice?: number | null;
    updatedDate: Date;
    volvoCategory: VolvoVehicleCategory | null;
};

export type WorkshopAppointmentWritable = {
    additionalInformation?: string | null;
    allocations: Array<AllocationWritable>;
    car: CarWritable;
    contactPerson?: string | null;
    costs: Array<WorkshopAppointmentCost>;
    createdDate: Date;
    documents: Array<WorkshopAppointmentDocumentWritable>;
    id: string;
    readyForPickup: boolean;
    types: Array<WorkshopAppointmentType>;
    updatedDate: Date;
    usesCollectAndReturnService: boolean;
};

export type WorkshopAppointmentDocumentWritable = {
    comment: string | null;
    createdDate: Date;
    documentFileKey: string;
    id: string;
    name: string;
    type: WorkshopAppointmentDocumentType | null;
    updatedDate: Date;
    workshopAppointment: WorkshopAppointmentWritable;
};

export type WorkshopAppointmentDocumentDtoWritable = {
    comment: string | null;
    createdDate: Date;
    documentFileKey: string;
    documentFileUrl: string;
    id: string;
    name: string;
    type: WorkshopAppointmentDocumentType | null;
    updatedDate: Date;
    workshopAppointment: WorkshopAppointmentWritable;
};

export type AppControllerGetHelloData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/';
};

export type AppControllerGetHelloResponses = {
    /**
     * OK
     */
    200: string;
};

export type AppControllerGetHelloResponse = AppControllerGetHelloResponses[keyof AppControllerGetHelloResponses];

export type AdyenControllerValidateApplePayMerchantData = {
    body: ApplePayMerchantValidationDto;
    path?: never;
    query?: never;
    url: '/v1/adyen/apple-pay/validate-merchant';
};

export type AdyenControllerValidateApplePayMerchantResponses = {
    /**
     * Created
     */
    201: unknown;
};

export type AdyenControllerSubmitPaymentDetailsData = {
    body: unknown;
    path?: never;
    query?: never;
    url: '/v1/adyen/payment-details';
};

export type AdyenControllerSubmitPaymentDetailsResponses = {
    /**
     * Created
     */
    201: PaymentDetailsResponseDto;
};

export type AdyenControllerSubmitPaymentDetailsResponse = AdyenControllerSubmitPaymentDetailsResponses[keyof AdyenControllerSubmitPaymentDetailsResponses];

export type AdyenControllerCreatePosSessionData = {
    body: PosSessionRequestDto;
    path?: never;
    query?: never;
    url: '/v1/adyen/pos-session';
};

export type AdyenControllerCreatePosSessionResponses = {
    /**
     * Created
     */
    201: PosSessionResponseDto;
};

export type AdyenControllerCreatePosSessionResponse = AdyenControllerCreatePosSessionResponses[keyof AdyenControllerCreatePosSessionResponses];

export type AdyenControllerWebhookData = {
    body: unknown;
    path?: never;
    query?: never;
    url: '/v1/adyen/webhook';
};

export type AdyenControllerWebhookResponses = {
    /**
     * Created
     */
    201: unknown;
};

export type AgentProvisionControllerMonthlySummaryData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/agent-provision/monthly-summary';
};

export type AgentProvisionControllerMonthlySummaryResponses = {
    /**
     * OK
     */
    200: AgentProvisionSummaryDto;
};

export type AgentProvisionControllerMonthlySummaryResponse = AgentProvisionControllerMonthlySummaryResponses[keyof AgentProvisionControllerMonthlySummaryResponses];

export type AgentProvisionControllerMonthlySummaryJsonData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/agent-provision/payouts';
};

export type AgentProvisionControllerMonthlySummaryJsonResponses = {
    /**
     * OK
     */
    200: string;
};

export type AgentProvisionControllerMonthlySummaryJsonResponse = AgentProvisionControllerMonthlySummaryJsonResponses[keyof AgentProvisionControllerMonthlySummaryJsonResponses];

export type AgentProvisionControllerYearlySummaryData = {
    body?: never;
    path: {
        userId: string;
    };
    query?: never;
    url: '/v1/agent-provision/yearly-summary/{userId}';
};

export type AgentProvisionControllerYearlySummaryResponses = {
    /**
     * OK
     */
    200: AgentProvisionSummaryDto;
};

export type AgentProvisionControllerYearlySummaryResponse = AgentProvisionControllerYearlySummaryResponses[keyof AgentProvisionControllerYearlySummaryResponses];

export type AllocationsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        filter?: Array<FindAllAllocationsFilterDto>;
        order?: Order;
        sort?: Array<FindAllAllocationsSort>;
        limit?: number;
        page?: number;
    };
    url: '/v1/allocations';
};

export type AllocationsControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationAllocationPaginationMeta;
};

export type AllocationsControllerFindAllResponse = AllocationsControllerFindAllResponses[keyof AllocationsControllerFindAllResponses];

export type AllocationsControllerCreateData = {
    body: CreateAllocationDto;
    path?: never;
    query?: never;
    url: '/v1/allocations';
};

export type AllocationsControllerCreateResponses = {
    /**
     * Created
     */
    201: Allocation | null;
};

export type AllocationsControllerCreateResponse = AllocationsControllerCreateResponses[keyof AllocationsControllerCreateResponses];

export type AllocationsControllerFindAllMinimalData = {
    body?: never;
    path?: never;
    query?: {
        filter?: Array<FindAllAllocationsFilterDto>;
        order?: Order;
        sort?: Array<FindAllAllocationsSort>;
        limit?: number;
        page?: number;
    };
    url: '/v1/allocations/minimal';
};

export type AllocationsControllerFindAllMinimalResponses = {
    /**
     * OK
     */
    200: PaginationMinimalAllocationDtoPaginationMeta;
};

export type AllocationsControllerFindAllMinimalResponse = AllocationsControllerFindAllMinimalResponses[keyof AllocationsControllerFindAllMinimalResponses];

export type AllocationsControllerGetAllocationTransactionsData = {
    body?: never;
    path?: never;
    query?: {
        order?: Order;
        sort?: Array<'relevantDate'>;
        dateAfter?: Date;
        dateBefore?: Date;
        stationIds?: Array<string>;
        transactionTypes?: Array<AllocationTransactionType>;
        limit?: number;
        page?: number;
    };
    url: '/v1/allocations/transactions';
};

export type AllocationsControllerGetAllocationTransactionsResponses = {
    /**
     * OK
     */
    200: PaginationAllocationTransactionDtoPaginationMeta;
};

export type AllocationsControllerGetAllocationTransactionsResponse = AllocationsControllerGetAllocationTransactionsResponses[keyof AllocationsControllerGetAllocationTransactionsResponses];

export type AllocationsControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/allocations/{id}';
};

export type AllocationsControllerRemoveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type AllocationsControllerRemoveResponse = AllocationsControllerRemoveResponses[keyof AllocationsControllerRemoveResponses];

export type AllocationsControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/allocations/{id}';
};

export type AllocationsControllerFindOneResponses = {
    /**
     * OK
     */
    200: Allocation;
};

export type AllocationsControllerFindOneResponse = AllocationsControllerFindOneResponses[keyof AllocationsControllerFindOneResponses];

export type AllocationsControllerUpdateData = {
    body: UpdateAllocationDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/allocations/{id}';
};

export type AllocationsControllerUpdateResponses = {
    /**
     * OK
     */
    200: Allocation | null;
};

export type AllocationsControllerUpdateResponse = AllocationsControllerUpdateResponses[keyof AllocationsControllerUpdateResponses];

export type AllocationsControllerGetAllocationMilageExpectationData = {
    body?: never;
    path: {
        id: string;
    };
    query: {
        mode: 'handover' | 'return';
        proposedMilage: number;
    };
    url: '/v1/allocations/{id}/milage-expectation';
};

export type AllocationsControllerGetAllocationMilageExpectationResponses = {
    /**
     * OK
     */
    200: MilageExpectationResponseDto;
};

export type AllocationsControllerGetAllocationMilageExpectationResponse = AllocationsControllerGetAllocationMilageExpectationResponses[keyof AllocationsControllerGetAllocationMilageExpectationResponses];

export type ApiKeysControllerListAllApiKeysData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/api-keys';
};

export type ApiKeysControllerListAllApiKeysResponses = {
    /**
     * OK
     */
    200: Array<ApiKey>;
};

export type ApiKeysControllerListAllApiKeysResponse = ApiKeysControllerListAllApiKeysResponses[keyof ApiKeysControllerListAllApiKeysResponses];

export type ApiKeysControllerCreateApiKeyData = {
    body: CreateApiKeyDto;
    path?: never;
    query?: never;
    url: '/v1/api-keys';
};

export type ApiKeysControllerCreateApiKeyResponses = {
    /**
     * Created
     */
    201: CreateApiKeyResponseDto;
};

export type ApiKeysControllerCreateApiKeyResponse = ApiKeysControllerCreateApiKeyResponses[keyof ApiKeysControllerCreateApiKeyResponses];

export type ApiKeysControllerListApiKeysData = {
    body?: never;
    path: {
        userId: string;
    };
    query?: never;
    url: '/v1/api-keys/user/{userId}';
};

export type ApiKeysControllerListApiKeysResponses = {
    /**
     * OK
     */
    200: Array<ApiKey>;
};

export type ApiKeysControllerListApiKeysResponse = ApiKeysControllerListApiKeysResponses[keyof ApiKeysControllerListApiKeysResponses];

export type ApiKeysControllerDeleteApiKeyData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/api-keys/{id}';
};

export type ApiKeysControllerDeleteApiKeyResponses = {
    /**
     * API key deleted successfully
     */
    200: {
        success: boolean;
    };
};

export type ApiKeysControllerDeleteApiKeyResponse = ApiKeysControllerDeleteApiKeyResponses[keyof ApiKeysControllerDeleteApiKeyResponses];

export type ApiKeysControllerUpdateRulesData = {
    body: ApiKeyRulesDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/api-keys/{id}/rules';
};

export type ApiKeysControllerUpdateRulesResponses = {
    /**
     * OK
     */
    200: ApiKey;
};

export type ApiKeysControllerUpdateRulesResponse = ApiKeysControllerUpdateRulesResponses[keyof ApiKeysControllerUpdateRulesResponses];

export type ApprovalRequestsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        sort?: Array<ApprovalRequestSort>;
        filter?: ApprovalRequestFilter;
        ids?: Array<string>;
        status?: ApprovalRequestStatus;
        tags?: Array<string>;
        order?: Order;
        limit?: number;
        page?: number;
    };
    url: '/v1/approval-requests';
};

export type ApprovalRequestsControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationApprovalRequestResponseDtoPaginationMeta;
};

export type ApprovalRequestsControllerFindAllResponse = ApprovalRequestsControllerFindAllResponses[keyof ApprovalRequestsControllerFindAllResponses];

export type ApprovalRequestsControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/approval-requests/{id}';
};

export type ApprovalRequestsControllerFindOneResponses = {
    /**
     * Approval request found successfully
     */
    200: ApprovalRequestResponseDto;
};

export type ApprovalRequestsControllerFindOneResponse = ApprovalRequestsControllerFindOneResponses[keyof ApprovalRequestsControllerFindOneResponses];

export type ApprovalRequestsControllerApproveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/approval-requests/{id}/approve';
};

export type ApprovalRequestsControllerApproveResponses = {
    /**
     * Approval request approved successfully
     */
    200: ApprovalRequest;
};

export type ApprovalRequestsControllerApproveResponse = ApprovalRequestsControllerApproveResponses[keyof ApprovalRequestsControllerApproveResponses];

export type ApprovalRequestsControllerRejectData = {
    body: ApprovalRequestsControllerRejectBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/approval-requests/{id}/reject';
};

export type ApprovalRequestsControllerRejectResponses = {
    /**
     * Approval request rejected successfully
     */
    200: ApprovalRequest;
};

export type ApprovalRequestsControllerRejectResponse = ApprovalRequestsControllerRejectResponses[keyof ApprovalRequestsControllerRejectResponses];

export type ApprovalRequestsControllerWithdrawData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/approval-requests/{id}/withdraw';
};

export type ApprovalRequestsControllerWithdrawResponses = {
    /**
     * Approval request withdrawn successfully
     */
    200: ApprovalRequest;
};

export type ApprovalRequestsControllerWithdrawResponse = ApprovalRequestsControllerWithdrawResponses[keyof ApprovalRequestsControllerWithdrawResponses];

export type AreaChargesControllerFindAllData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/area-charges';
};

export type AreaChargesControllerFindAllResponses = {
    /**
     * OK
     */
    200: Array<AreaCharge>;
};

export type AreaChargesControllerFindAllResponse = AreaChargesControllerFindAllResponses[keyof AreaChargesControllerFindAllResponses];

export type AreaChargesControllerCreateData = {
    body: CreateAreaChargeDto;
    path?: never;
    query?: never;
    url: '/v1/area-charges';
};

export type AreaChargesControllerCreateResponses = {
    /**
     * Created
     */
    201: AreaCharge;
};

export type AreaChargesControllerCreateResponse = AreaChargesControllerCreateResponses[keyof AreaChargesControllerCreateResponses];

export type AreaChargesControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/area-charges/{id}';
};

export type AreaChargesControllerRemoveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type AreaChargesControllerRemoveResponse = AreaChargesControllerRemoveResponses[keyof AreaChargesControllerRemoveResponses];

export type AreaChargesControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/area-charges/{id}';
};

export type AreaChargesControllerFindOneResponses = {
    /**
     * OK
     */
    200: AreaCharge;
};

export type AreaChargesControllerFindOneResponse = AreaChargesControllerFindOneResponses[keyof AreaChargesControllerFindOneResponses];

export type AreaChargesControllerUpdateData = {
    body: UpdateAreaChargeDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/area-charges/{id}';
};

export type AreaChargesControllerUpdateResponses = {
    /**
     * OK
     */
    200: AreaCharge;
};

export type AreaChargesControllerUpdateResponse = AreaChargesControllerUpdateResponses[keyof AreaChargesControllerUpdateResponses];

export type AuditLogControllerGetByEntityData = {
    body?: never;
    path: {
        entityType: AuditLogEntityType;
        entityId: string;
    };
    query?: {
        order?: Order;
        page?: number;
        changedFields?: Array<string>;
        operation?: AuditLogOperation;
        sort?: Array<'createdAt'>;
        limit?: number;
    };
    url: '/v1/audit-log/entity/{entityType}/{entityId}';
};

export type AuditLogControllerGetByEntityResponses = {
    /**
     * OK
     */
    200: PaginationAuditLogPaginationMeta;
};

export type AuditLogControllerGetByEntityResponse = AuditLogControllerGetByEntityResponses[keyof AuditLogControllerGetByEntityResponses];

export type AuthControllerGetAbilitiesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/auth/abilities';
};

export type AuthControllerGetAbilitiesResponses = {
    /**
     * OK
     */
    200: Array<{
        action: string | Array<string>;
        conditions?: unknown;
        fields?: string | Array<string>;
        inverted?: boolean;
        reason?: string;
        subject: string | Array<SubjectType> | (AnyClassAny & {
            modelName?: string;
        });
    }>;
};

export type AuthControllerGetAbilitiesResponse = AuthControllerGetAbilitiesResponses[keyof AuthControllerGetAbilitiesResponses];

export type AuthControllerCreateDeviceAuthCodeData = {
    body: CreateDeviceAuthCodeDto;
    path?: never;
    query?: never;
    url: '/v1/auth/device/code';
};

export type AuthControllerCreateDeviceAuthCodeResponses = {
    /**
     * Created
     */
    201: CreateDeviceAuthCodeResponseDto;
};

export type AuthControllerCreateDeviceAuthCodeResponse = AuthControllerCreateDeviceAuthCodeResponses[keyof AuthControllerCreateDeviceAuthCodeResponses];

export type AuthControllerExchangeDeviceAuthCodeData = {
    body: ExchangeDeviceAuthCodeDto;
    path?: never;
    query?: never;
    url: '/v1/auth/device/exchange';
};

export type AuthControllerExchangeDeviceAuthCodeResponses = {
    /**
     * Created
     */
    201: unknown;
};

export type AuthControllerGoogleAuthData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/auth/google/login';
};

export type AuthControllerGoogleAuthResponses = {
    /**
     * No Content
     */
    204: void;
};

export type AuthControllerGoogleAuthResponse = AuthControllerGoogleAuthResponses[keyof AuthControllerGoogleAuthResponses];

export type AuthControllerGoogleAuthRedirectData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/auth/google/verify';
};

export type AuthControllerGoogleAuthRedirectResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type AuthControllerLoginData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/auth/login';
};

export type AuthControllerLoginResponses = {
    /**
     * Created
     */
    201: JwtTokenResponseDto;
};

export type AuthControllerLoginResponse = AuthControllerLoginResponses[keyof AuthControllerLoginResponses];

export type AuthControllerLogoutData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/auth/logout';
};

export type AuthControllerLogoutResponses = {
    /**
     * No Content
     */
    204: void;
};

export type AuthControllerLogoutResponse = AuthControllerLogoutResponses[keyof AuthControllerLogoutResponses];

export type AuthControllerLoginWithMagicCodeData = {
    body: MagicCodeLoginDto;
    path?: never;
    query?: never;
    url: '/v1/auth/magic-code';
};

export type AuthControllerLoginWithMagicCodeResponses = {
    /**
     * Created
     */
    201: unknown;
};

export type AuthControllerGetMeData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/auth/me';
};

export type AuthControllerGetMeResponses = {
    /**
     * OK
     */
    200: User | null;
};

export type AuthControllerGetMeResponse = AuthControllerGetMeResponses[keyof AuthControllerGetMeResponses];

export type AuthControllerRefreshTokensData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/auth/refresh';
};

export type AuthControllerRefreshTokensResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type AuthControllerRequestMagicCodeData = {
    body: RequestMagicCodeDto;
    path?: never;
    query?: never;
    url: '/v1/auth/request-magic-code';
};

export type AuthControllerRequestMagicCodeResponses = {
    /**
     * Created
     */
    201: unknown;
};

export type AuthControllerResetPasswordData = {
    body: ResetPasswordDto;
    path?: never;
    query?: never;
    url: '/v1/auth/reset-password';
};

export type AuthControllerResetPasswordResponses = {
    /**
     * Created
     */
    201: unknown;
};

export type AuthControllerSendPasswordResetMailData = {
    body: SendPasswordResetMailDto;
    path?: never;
    query?: never;
    url: '/v1/auth/send-password-reset-mail';
};

export type AuthControllerSendPasswordResetMailResponses = {
    /**
     * No Content
     */
    204: void;
};

export type AuthControllerSendPasswordResetMailResponse = AuthControllerSendPasswordResetMailResponses[keyof AuthControllerSendPasswordResetMailResponses];

export type AuthControllerGetProfileData = {
    body?: never;
    path?: never;
    query?: {
        requireUser?: boolean;
    };
    url: '/v1/auth/token-payload';
};

export type AuthControllerGetProfileResponses = {
    /**
     * OK
     */
    200: JwtUserDto | JwtAnonymousDto | JwtDeviceDto | JwtExternalDriverDto | JwtRentalKeyTagDto;
};

export type AuthControllerGetProfileResponse = AuthControllerGetProfileResponses[keyof AuthControllerGetProfileResponses];

export type AuthControllerUpdateMeData = {
    body: UpdateMeDto;
    path?: never;
    query?: never;
    url: '/v1/auth/update-me';
};

export type AuthControllerUpdateMeResponses = {
    /**
     * OK
     */
    200: User | null;
};

export type AuthControllerUpdateMeResponse = AuthControllerUpdateMeResponses[keyof AuthControllerUpdateMeResponses];

export type BankStatementsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        accountIban?: string;
        cursor?: string;
        endDate?: Date;
        legalEntityId?: string;
        limit?: number;
        startDate?: Date;
        status?: BankStatementListStatus;
    };
    url: '/v1/bank-statements';
};

export type BankStatementsControllerFindAllResponses = {
    /**
     * OK
     */
    200: BankStatementEntryPageDto;
};

export type BankStatementsControllerFindAllResponse = BankStatementsControllerFindAllResponses[keyof BankStatementsControllerFindAllResponses];

export type BankStatementsControllerListAccountsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/bank-statements/accounts';
};

export type BankStatementsControllerListAccountsResponses = {
    /**
     * Distinct account IBANs on ingested Bank statement entries
     */
    200: Array<string>;
};

export type BankStatementsControllerListAccountsResponse = BankStatementsControllerListAccountsResponses[keyof BankStatementsControllerListAccountsResponses];

export type BankStatementsControllerIngestData = {
    body: BankStatementWebhookPayloadDto;
    path?: never;
    query?: never;
    url: '/v1/bank-statements/webhook';
};

export type BankStatementsControllerIngestResponses = {
    /**
     * OK
     */
    200: BankStatementIngestResultDto;
};

export type BankStatementsControllerIngestResponse = BankStatementsControllerIngestResponses[keyof BankStatementsControllerIngestResponses];

export type BankStatementsControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bank-statements/{id}';
};

export type BankStatementsControllerFindOneResponses = {
    /**
     * OK
     */
    200: BankStatementEntryDto;
};

export type BankStatementsControllerFindOneResponse = BankStatementsControllerFindOneResponses[keyof BankStatementsControllerFindOneResponses];

export type BankStatementsControllerConfirmData = {
    body: ConfirmBankStatementActionDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bank-statements/{id}/confirm';
};

export type BankStatementsControllerConfirmResponses = {
    /**
     * OK
     */
    200: BankStatementEntryDto;
};

export type BankStatementsControllerConfirmResponse = BankStatementsControllerConfirmResponses[keyof BankStatementsControllerConfirmResponses];

export type BankStatementsControllerFindOpenAmountsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        payerUserId?: string;
        q?: string;
        order?: Order;
        sort?: Array<{
            [key: string]: unknown;
        }>;
        limit?: number;
        page?: number;
    };
    url: '/v1/bank-statements/{id}/open-amounts';
};

export type BankStatementsControllerFindOpenAmountsResponses = {
    /**
     * OK
     */
    200: Array<BankStatementOpenAmountDto>;
};

export type BankStatementsControllerFindOpenAmountsResponse = BankStatementsControllerFindOpenAmountsResponses[keyof BankStatementsControllerFindOpenAmountsResponses];

export type BookingsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        filter?: Array<FindAllBookingsFilterDto>;
        order?: Order;
        sort?: Array<FindAllBookingsSort>;
        limit?: number;
        page?: number;
    };
    url: '/v1/bookings';
};

export type BookingsControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationBookingPaginationMeta;
};

export type BookingsControllerFindAllResponse = BookingsControllerFindAllResponses[keyof BookingsControllerFindAllResponses];

export type BookingsControllerCreateData = {
    body: CreateBookingPrivateDto;
    path?: never;
    query?: never;
    url: '/v1/bookings';
};

export type BookingsControllerCreateResponses = {
    /**
     * Created
     */
    201: BookingDto | null;
};

export type BookingsControllerCreateResponse = BookingsControllerCreateResponses[keyof BookingsControllerCreateResponses];

export type BookingsControllerGetActionNeededCountsData = {
    body?: never;
    path?: never;
    query?: {
        bookingNumber?: number;
        legalEntityId?: string;
        query?: string;
        stationId?: string;
    };
    url: '/v1/bookings/action-needed-counts';
};

export type BookingsControllerGetActionNeededCountsResponses = {
    /**
     * OK
     */
    200: BookingsActionNeededCountsDto;
};

export type BookingsControllerGetActionNeededCountsResponse = BookingsControllerGetActionNeededCountsResponses[keyof BookingsControllerGetActionNeededCountsResponses];

export type BookingsControllerCountBookingsOfUserData = {
    body?: never;
    path: {
        userId: string;
    };
    query?: never;
    url: '/v1/bookings/count-bookings-of-user/{userId}';
};

export type BookingsControllerCountBookingsOfUserResponses = {
    /**
     * OK
     */
    200: CountBookingsOfUserDto;
};

export type BookingsControllerCountBookingsOfUserResponse = BookingsControllerCountBookingsOfUserResponses[keyof BookingsControllerCountBookingsOfUserResponses];

export type BookingsControllerSuggestCustomerDataData = {
    body?: never;
    path?: never;
    query: {
        q: string;
    };
    url: '/v1/bookings/suggest-customer-data';
};

export type BookingsControllerSuggestCustomerDataResponses = {
    /**
     * OK
     */
    200: Array<SuggestCustomerDataDto>;
};

export type BookingsControllerSuggestCustomerDataResponse = BookingsControllerSuggestCustomerDataResponses[keyof BookingsControllerSuggestCustomerDataResponses];

export type BookingsControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        withForce?: boolean;
    };
    url: '/v1/bookings/{id}';
};

export type BookingsControllerRemoveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type BookingsControllerRemoveResponse = BookingsControllerRemoveResponses[keyof BookingsControllerRemoveResponses];

export type BookingsControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        handoverAdjustment?: boolean;
    };
    url: '/v1/bookings/{id}';
};

export type BookingsControllerFindOneResponses = {
    /**
     * OK
     */
    200: BookingDto;
};

export type BookingsControllerFindOneResponse = BookingsControllerFindOneResponses[keyof BookingsControllerFindOneResponses];

export type BookingsControllerUpdateData = {
    body: UpdateBookingDto;
    path: {
        id: string;
    };
    query?: {
        cancelCancellationFeeInvoice?: boolean;
        cancelledBy?: CancelledBy;
        handoverAdjustment?: boolean;
        overrideCancellationFee?: CancellationFee;
        overrideCancellationFeeComment?: string;
        sendCancelledMail?: boolean;
    };
    url: '/v1/bookings/{id}';
};

export type BookingsControllerUpdateResponses = {
    /**
     * OK
     */
    200: BookingDto;
};

export type BookingsControllerUpdateResponse = BookingsControllerUpdateResponses[keyof BookingsControllerUpdateResponses];

export type BookingsControllerGenerateCarSwapProtocolPdfData = {
    body: CreateCarSwapProtocolPdfDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/car-swap-protocol';
};

export type BookingsControllerGenerateCarSwapProtocolPdfResponses = {
    /**
     * Created
     */
    201: Booking;
};

export type BookingsControllerGenerateCarSwapProtocolPdfResponse = BookingsControllerGenerateCarSwapProtocolPdfResponses[keyof BookingsControllerGenerateCarSwapProtocolPdfResponses];

export type BookingsControllerGetCarSwapProtocolTemplateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        handedOverAllocationId?: string;
        returnedAllocationId?: string;
    };
    url: '/v1/bookings/{id}/car-swap-protocol-template';
};

export type BookingsControllerGetCarSwapProtocolTemplateResponses = {
    /**
     * OK
     */
    200: string;
};

export type BookingsControllerGetCarSwapProtocolTemplateResponse = BookingsControllerGetCarSwapProtocolTemplateResponses[keyof BookingsControllerGetCarSwapProtocolTemplateResponses];

export type BookingsControllerCompleteHandoverData = {
    body: CompleteHandoverDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/complete-handover';
};

export type BookingsControllerCompleteHandoverResponses = {
    /**
     * Created
     */
    201: Booking;
};

export type BookingsControllerCompleteHandoverResponse = BookingsControllerCompleteHandoverResponses[keyof BookingsControllerCompleteHandoverResponses];

export type BookingsControllerGetBookingContractPdfData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/contract';
};

export type BookingsControllerGetBookingContractPdfResponses = {
    /**
     * OK
     */
    200: Blob | File;
};

export type BookingsControllerGetBookingContractPdfResponse = BookingsControllerGetBookingContractPdfResponses[keyof BookingsControllerGetBookingContractPdfResponses];

export type BookingsControllerGenerateBookingContractPdfData = {
    body: CreateBookingContractPdfDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/contract';
};

export type BookingsControllerGenerateBookingContractPdfResponses = {
    /**
     * Created
     */
    201: Booking;
};

export type BookingsControllerGenerateBookingContractPdfResponse = BookingsControllerGenerateBookingContractPdfResponses[keyof BookingsControllerGenerateBookingContractPdfResponses];

export type BookingsControllerAddContractPenaltyData = {
    body: CreateContractPenaltyDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/contract-penalties';
};

export type BookingsControllerAddContractPenaltyResponses = {
    /**
     * Created
     */
    201: ContractPenaltyResponseDto;
};

export type BookingsControllerAddContractPenaltyResponse = BookingsControllerAddContractPenaltyResponses[keyof BookingsControllerAddContractPenaltyResponses];

export type BookingsControllerGetBookingContractTemplateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/contract-template';
};

export type BookingsControllerGetBookingContractTemplateResponses = {
    /**
     * OK
     */
    200: string;
};

export type BookingsControllerGetBookingContractTemplateResponse = BookingsControllerGetBookingContractTemplateResponses[keyof BookingsControllerGetBookingContractTemplateResponses];

export type BookingsControllerConvertToLongTermData = {
    body: ConvertToLongTermDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/convert-to-long-term';
};

export type BookingsControllerConvertToLongTermResponses = {
    /**
     * Created
     */
    201: BookingDto;
};

export type BookingsControllerConvertToLongTermResponse = BookingsControllerConvertToLongTermResponses[keyof BookingsControllerConvertToLongTermResponses];

export type BookingsControllerEnsureCustomerLinkedData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/ensure-customer-linked';
};

export type BookingsControllerEnsureCustomerLinkedResponses = {
    /**
     * Created
     */
    201: Booking;
};

export type BookingsControllerEnsureCustomerLinkedResponse = BookingsControllerEnsureCustomerLinkedResponses[keyof BookingsControllerEnsureCustomerLinkedResponses];

export type BookingsControllerGetInvoicePositionsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/invoice-positions';
};

export type BookingsControllerGetInvoicePositionsResponses = {
    /**
     * OK
     */
    200: Array<InvoicePositionDto>;
};

export type BookingsControllerGetInvoicePositionsResponse = BookingsControllerGetInvoicePositionsResponses[keyof BookingsControllerGetInvoicePositionsResponses];

export type BookingsControllerGetJobEventsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/job-events';
};

export type BookingsControllerGetJobEventsResponses = {
    /**
     * Server-Sent Events stream
     */
    200: unknown;
};

export type BookingsControllerGetJobsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/jobs';
};

export type BookingsControllerGetJobsResponses = {
    /**
     * OK
     */
    200: Array<BookingJobDto>;
};

export type BookingsControllerGetJobsResponse = BookingsControllerGetJobsResponses[keyof BookingsControllerGetJobsResponses];

export type BookingsControllerResendBookingConfirmationMailData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/mails/booking-confirmation';
};

export type BookingsControllerResendBookingConfirmationMailResponses = {
    /**
     * No Content
     */
    204: void;
};

export type BookingsControllerResendBookingConfirmationMailResponse = BookingsControllerResendBookingConfirmationMailResponses[keyof BookingsControllerResendBookingConfirmationMailResponses];

export type BookingsControllerSendDepositReceiptMailData = {
    body: SendDepositReceiptDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/mails/deposit-receipt';
};

export type BookingsControllerSendDepositReceiptMailResponses = {
    /**
     * No Content
     */
    204: void;
};

export type BookingsControllerSendDepositReceiptMailResponse = BookingsControllerSendDepositReceiptMailResponses[keyof BookingsControllerSendDepositReceiptMailResponses];

export type BookingsControllerResendHandedOverMailData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/mails/handed-over';
};

export type BookingsControllerResendHandedOverMailResponses = {
    /**
     * No Content
     */
    204: void;
};

export type BookingsControllerResendHandedOverMailResponse = BookingsControllerResendHandedOverMailResponses[keyof BookingsControllerResendHandedOverMailResponses];

export type BookingsControllerResendUpdatedContractImmediatelyData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/mails/updated-contract';
};

export type BookingsControllerResendUpdatedContractImmediatelyResponses = {
    /**
     * No Content
     */
    204: void;
};

export type BookingsControllerResendUpdatedContractImmediatelyResponse = BookingsControllerResendUpdatedContractImmediatelyResponses[keyof BookingsControllerResendUpdatedContractImmediatelyResponses];

export type BookingsControllerCreateManualLaneCreditData = {
    body: ManualLaneCreditDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/manual-lane-credits';
};

export type BookingsControllerCreateManualLaneCreditResponses = {
    /**
     * Created
     */
    201: Array<LedgerEntry>;
};

export type BookingsControllerCreateManualLaneCreditResponse = BookingsControllerCreateManualLaneCreditResponses[keyof BookingsControllerCreateManualLaneCreditResponses];

export type BookingProcessSessionControllerDeleteProcessSessionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/process-session';
};

export type BookingProcessSessionControllerDeleteProcessSessionResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type BookingProcessSessionControllerGetProcessSessionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/process-session';
};

export type BookingProcessSessionControllerGetProcessSessionResponses = {
    /**
     * OK
     */
    200: ProcessSessionResponseDto | null;
};

export type BookingProcessSessionControllerGetProcessSessionResponse = BookingProcessSessionControllerGetProcessSessionResponses[keyof BookingProcessSessionControllerGetProcessSessionResponses];

export type BookingProcessSessionControllerPatchProcessSessionData = {
    body: PatchProcessSessionDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/process-session';
};

export type BookingProcessSessionControllerPatchProcessSessionResponses = {
    /**
     * OK
     */
    200: ProcessSessionResponseDto;
};

export type BookingProcessSessionControllerPatchProcessSessionResponse = BookingProcessSessionControllerPatchProcessSessionResponses[keyof BookingProcessSessionControllerPatchProcessSessionResponses];

export type BookingProcessSessionControllerCreateProcessSessionData = {
    body: CreateProcessSessionDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/process-session';
};

export type BookingProcessSessionControllerCreateProcessSessionResponses = {
    /**
     * OK
     */
    200: ProcessSessionResponseDto;
};

export type BookingProcessSessionControllerCreateProcessSessionResponse = BookingProcessSessionControllerCreateProcessSessionResponses[keyof BookingProcessSessionControllerCreateProcessSessionResponses];

export type BookingProcessSessionControllerProcessSessionEventsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/process-session/events';
};

export type BookingProcessSessionControllerProcessSessionEventsResponses = {
    /**
     * Server-Sent Events stream
     */
    200: unknown;
};

export type BookingsControllerRefreshBookingConfirmationPdfData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/refresh-booking-confirmation';
};

export type BookingsControllerRefreshBookingConfirmationPdfResponses = {
    /**
     * OK
     */
    200: PrivateFileUrl;
};

export type BookingsControllerRefreshBookingConfirmationPdfResponse = BookingsControllerRefreshBookingConfirmationPdfResponses[keyof BookingsControllerRefreshBookingConfirmationPdfResponses];

export type BookingsControllerWriteOffAmountData = {
    body: WriteOffAmountDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/bookings/{id}/write-off';
};

export type BookingsControllerWriteOffAmountResponses = {
    /**
     * Created
     */
    201: LedgerEntryDto;
};

export type BookingsControllerWriteOffAmountResponse = BookingsControllerWriteOffAmountResponses[keyof BookingsControllerWriteOffAmountResponses];

export type CarsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        available?: boolean;
        availableFromDateBefore?: Date;
        availableUntilDateBefore?: Date;
        categories?: Array<VehicleCategory>;
        decommissioned?: DecommissionedFilter;
        forceVehicleTypeIds?: Array<string> | null;
        hasAxaCategory?: boolean;
        hasEuropCategory?: boolean;
        hasHiddenStation?: boolean;
        hasInternalStation?: boolean;
        hasJlrCategory?: boolean;
        hasNextAllocationStartDate?: boolean;
        hasTowHitch?: boolean;
        hasVolvoCategory?: boolean;
        hiddenFromPublic?: boolean;
        includeNextAllocationStartDate?: boolean;
        isAlwaysOnWinterTyres?: boolean;
        isGhostCar?: boolean;
        isSetmerchantConsultedDate?: boolean;
        isSetNewCarAnnouncenmentMailSentDate?: boolean;
        isSetPurchaseReminderMailSentDate?: boolean;
        isSetregistrationAndOrganizationDoneDate?: boolean;
        lastTuvDateBefore?: Date;
        licencePlateFinQuery?: string;
        makeIds?: Array<string>;
        minSeats?: number;
        needInspection?: boolean;
        needsTuv?: boolean;
        query?: string;
        readyToHandover?: boolean;
        requiresWorkshop?: boolean;
        stationDate?: Date;
        stationIds?: Array<string>;
        status?: Array<CarStatus>;
        tyreConditions?: Array<TyreCondition>;
        tyres?: CarTyres;
        vehicleTypeIds?: Array<string>;
        order?: Order;
        sort?: Array<FindAllCarsSort>;
        limit?: number;
        page?: number;
    };
    url: '/v1/cars';
};

export type CarsControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationCompactCarPaginationMeta;
};

export type CarsControllerFindAllResponse = CarsControllerFindAllResponses[keyof CarsControllerFindAllResponses];

export type CarsControllerCreateData = {
    body: CreateCarDto;
    path?: never;
    query?: never;
    url: '/v1/cars';
};

export type CarsControllerCreateResponses = {
    /**
     * Created
     */
    201: Car | null;
};

export type CarsControllerCreateResponse = CarsControllerCreateResponses[keyof CarsControllerCreateResponses];

export type CarsControllerRemoveCarData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/cars/{id}';
};

export type CarsControllerRemoveCarResponses = {
    /**
     * No Content
     */
    204: void;
};

export type CarsControllerRemoveCarResponse = CarsControllerRemoveCarResponses[keyof CarsControllerRemoveCarResponses];

export type CarsControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/cars/{id}';
};

export type CarsControllerFindOneResponses = {
    /**
     * OK
     */
    200: Car;
};

export type CarsControllerFindOneResponse = CarsControllerFindOneResponses[keyof CarsControllerFindOneResponses];

export type CarsControllerUpdateData = {
    body: UpdateCarDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/cars/{id}';
};

export type CarsControllerUpdateResponses = {
    /**
     * OK
     */
    200: Car | null;
};

export type CarsControllerUpdateResponse = CarsControllerUpdateResponses[keyof CarsControllerUpdateResponses];

export type CarsControllerFindAllCarDocumentsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        order?: Order;
        sort?: Array<'name'>;
        page?: number;
        query?: string;
        type?: Array<CarDocumentType>;
        limit?: number;
    };
    url: '/v1/cars/{id}/documents';
};

export type CarsControllerFindAllCarDocumentsResponses = {
    /**
     * OK
     */
    200: PaginationCarDocumentDtoPaginationMeta;
};

export type CarsControllerFindAllCarDocumentsResponse = CarsControllerFindAllCarDocumentsResponses[keyof CarsControllerFindAllCarDocumentsResponses];

export type CarsControllerCreateCarDocumentData = {
    body: CreateCarDocumentDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/cars/{id}/documents';
};

export type CarsControllerCreateCarDocumentResponses = {
    /**
     * Created
     */
    201: CarDocumentDto;
};

export type CarsControllerCreateCarDocumentResponse = CarsControllerCreateCarDocumentResponses[keyof CarsControllerCreateCarDocumentResponses];

export type CarsControllerRemoveCarDocumentData = {
    body?: never;
    path: {
        documentId: string;
        id: string;
    };
    query?: never;
    url: '/v1/cars/{id}/documents/{documentId}';
};

export type CarsControllerRemoveCarDocumentResponses = {
    /**
     * No Content
     */
    204: void;
};

export type CarsControllerRemoveCarDocumentResponse = CarsControllerRemoveCarDocumentResponses[keyof CarsControllerRemoveCarDocumentResponses];

export type CarsControllerFindOneCarDocumentData = {
    body?: never;
    path: {
        documentId: string;
        id: string;
    };
    query?: never;
    url: '/v1/cars/{id}/documents/{documentId}';
};

export type CarsControllerFindOneCarDocumentResponses = {
    /**
     * OK
     */
    200: CarDocumentDto;
};

export type CarsControllerFindOneCarDocumentResponse = CarsControllerFindOneCarDocumentResponses[keyof CarsControllerFindOneCarDocumentResponses];

export type CarsControllerUpdateCarDocumentData = {
    body: UpdateCarDocumentDto;
    path: {
        documentId: string;
        id: string;
    };
    query?: never;
    url: '/v1/cars/{id}/documents/{documentId}';
};

export type CarsControllerUpdateCarDocumentResponses = {
    /**
     * OK
     */
    200: CarDocumentDto;
};

export type CarsControllerUpdateCarDocumentResponse = CarsControllerUpdateCarDocumentResponses[keyof CarsControllerUpdateCarDocumentResponses];

export type CarsControllerExtractRegistrationCertificateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/cars/{id}/extract-registration-certificate';
};

export type CarsControllerExtractRegistrationCertificateResponses = {
    /**
     * OK
     */
    200: RegistrationCertificateExtractionDto;
};

export type CarsControllerExtractRegistrationCertificateResponse = CarsControllerExtractRegistrationCertificateResponses[keyof CarsControllerExtractRegistrationCertificateResponses];

export type CarsControllerGetCarMilageExpectationData = {
    body?: never;
    path: {
        id: string;
    };
    query: {
        proposedMilage: number;
    };
    url: '/v1/cars/{id}/milage-expectation';
};

export type CarsControllerGetCarMilageExpectationResponses = {
    /**
     * OK
     */
    200: MilageExpectationResponseDto;
};

export type CarsControllerGetCarMilageExpectationResponse = CarsControllerGetCarMilageExpectationResponses[keyof CarsControllerGetCarMilageExpectationResponses];

export type CleaningFeeReturnControllerGetAvailableCleaningFeesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/cleaning-fee-return/available';
};

export type CleaningFeeReturnControllerGetAvailableCleaningFeesResponses = {
    /**
     * Array of available cleaning fees with id, name, price, and photoRequired
     */
    200: Array<CleaningFeeDto>;
};

export type CleaningFeeReturnControllerGetAvailableCleaningFeesResponse = CleaningFeeReturnControllerGetAvailableCleaningFeesResponses[keyof CleaningFeeReturnControllerGetAvailableCleaningFeesResponses];

export type CleaningFeeReturnControllerAddCleaningFeeToBookingData = {
    body: CleaningFeeSelectionDto;
    path: {
        bookingId: string;
    };
    query?: never;
    url: '/v1/cleaning-fee-return/booking/{bookingId}';
};

export type CleaningFeeReturnControllerAddCleaningFeeToBookingResponses = {
    /**
     * Cleaning fee added successfully
     */
    200: unknown;
};

export type CommentsControllerCreateData = {
    body: CreateCommentDto;
    path: {
        entityId: string;
        entityType: CommentableEntityType;
    };
    query?: never;
    url: '/v1/comments/{entityType}/{entityId}';
};

export type CommentsControllerCreateResponses = {
    /**
     * Created
     */
    201: CommentDto;
};

export type CommentsControllerCreateResponse = CommentsControllerCreateResponses[keyof CommentsControllerCreateResponses];

export type CommentsControllerMentionCandidatesData = {
    body?: never;
    path: {
        entityId: string;
        entityType: CommentableEntityType;
    };
    query?: {
        query?: string;
    };
    url: '/v1/comments/{entityType}/{entityId}/mention-candidates';
};

export type CommentsControllerMentionCandidatesResponses = {
    /**
     * OK
     */
    200: CommentMentionCandidatesDto;
};

export type CommentsControllerMentionCandidatesResponse = CommentsControllerMentionCandidatesResponses[keyof CommentsControllerMentionCandidatesResponses];

export type CommentsControllerDeleteCommentData = {
    body?: never;
    path: {
        id: string;
        entityId: string;
        entityType: CommentableEntityType;
    };
    query?: never;
    url: '/v1/comments/{entityType}/{entityId}/{id}';
};

export type CommentsControllerDeleteCommentResponses = {
    /**
     * No Content
     */
    204: void;
};

export type CommentsControllerDeleteCommentResponse = CommentsControllerDeleteCommentResponses[keyof CommentsControllerDeleteCommentResponses];

export type CommentsControllerUpdateData = {
    body: UpdateCommentDto;
    path: {
        id: string;
        entityId: string;
        entityType: CommentableEntityType;
    };
    query?: never;
    url: '/v1/comments/{entityType}/{entityId}/{id}';
};

export type CommentsControllerUpdateResponses = {
    /**
     * OK
     */
    200: CommentDto;
};

export type CommentsControllerUpdateResponse = CommentsControllerUpdateResponses[keyof CommentsControllerUpdateResponses];

export type CommentsControllerToggleReactionData = {
    body: ToggleCommentReactionDto;
    path: {
        id: string;
        entityId: string;
        entityType: CommentableEntityType;
    };
    query?: never;
    url: '/v1/comments/{entityType}/{entityId}/{id}/reactions';
};

export type CommentsControllerToggleReactionResponses = {
    /**
     * OK
     */
    200: CommentDto;
};

export type CommentsControllerToggleReactionResponse = CommentsControllerToggleReactionResponses[keyof CommentsControllerToggleReactionResponses];

export type CommentsControllerResolveData = {
    body?: never;
    path: {
        id: string;
        entityId: string;
        entityType: CommentableEntityType;
    };
    query?: never;
    url: '/v1/comments/{entityType}/{entityId}/{id}/resolve';
};

export type CommentsControllerResolveResponses = {
    /**
     * OK
     */
    200: CommentDto;
};

export type CommentsControllerResolveResponse = CommentsControllerResolveResponses[keyof CommentsControllerResolveResponses];

export type CommentsControllerUnresolveData = {
    body?: never;
    path: {
        id: string;
        entityId: string;
        entityType: CommentableEntityType;
    };
    query?: never;
    url: '/v1/comments/{entityType}/{entityId}/{id}/unresolve';
};

export type CommentsControllerUnresolveResponses = {
    /**
     * OK
     */
    200: CommentDto;
};

export type CommentsControllerUnresolveResponse = CommentsControllerUnresolveResponses[keyof CommentsControllerUnresolveResponses];

export type CounterProcessSessionControllerGetCounterProcessSessionData = {
    body?: never;
    path: {
        counterId: string;
    };
    query?: never;
    url: '/v1/counters/{counterId}/process-session';
};

export type CounterProcessSessionControllerGetCounterProcessSessionResponses = {
    /**
     * OK
     */
    200: ProcessSessionResponseDto | null;
};

export type CounterProcessSessionControllerGetCounterProcessSessionResponse = CounterProcessSessionControllerGetCounterProcessSessionResponses[keyof CounterProcessSessionControllerGetCounterProcessSessionResponses];

export type CounterProcessSessionControllerUnconfirmContactData = {
    body?: never;
    path: {
        counterId: string;
    };
    query?: never;
    url: '/v1/counters/{counterId}/process-session/contact';
};

export type CounterProcessSessionControllerUnconfirmContactResponses = {
    /**
     * OK
     */
    200: ProcessSessionResponseDto;
};

export type CounterProcessSessionControllerUnconfirmContactResponse = CounterProcessSessionControllerUnconfirmContactResponses[keyof CounterProcessSessionControllerUnconfirmContactResponses];

export type CounterProcessSessionControllerConfirmContactData = {
    body: ConfirmContactDto;
    path: {
        counterId: string;
    };
    query?: never;
    url: '/v1/counters/{counterId}/process-session/contact';
};

export type CounterProcessSessionControllerConfirmContactResponses = {
    /**
     * OK
     */
    200: ProcessSessionResponseDto;
};

export type CounterProcessSessionControllerConfirmContactResponse = CounterProcessSessionControllerConfirmContactResponses[keyof CounterProcessSessionControllerConfirmContactResponses];

export type CounterProcessSessionControllerGetCounterContractData = {
    body?: never;
    path: {
        counterId: string;
    };
    query?: never;
    url: '/v1/counters/{counterId}/process-session/contract';
};

export type CounterProcessSessionControllerGetCounterContractResponses = {
    /**
     * OK
     */
    200: string;
};

export type CounterProcessSessionControllerGetCounterContractResponse = CounterProcessSessionControllerGetCounterContractResponses[keyof CounterProcessSessionControllerGetCounterContractResponses];

export type CounterProcessSessionControllerCounterProcessSessionEventsData = {
    body?: never;
    path: {
        counterId: string;
    };
    query?: never;
    url: '/v1/counters/{counterId}/process-session/events';
};

export type CounterProcessSessionControllerCounterProcessSessionEventsResponses = {
    /**
     * Server-Sent Events stream
     */
    200: unknown;
};

export type CounterProcessSessionControllerCaptureSignatureData = {
    body: CaptureSignatureDto;
    path: {
        counterId: string;
    };
    query?: never;
    url: '/v1/counters/{counterId}/process-session/signature';
};

export type CounterProcessSessionControllerCaptureSignatureResponses = {
    /**
     * OK
     */
    200: ProcessSessionResponseDto;
};

export type CounterProcessSessionControllerCaptureSignatureResponse = CounterProcessSessionControllerCaptureSignatureResponses[keyof CounterProcessSessionControllerCaptureSignatureResponses];

export type CounterProcessSessionControllerGetCounterSignatureUploadUrlData = {
    body?: never;
    path: {
        counterId: string;
    };
    query?: never;
    url: '/v1/counters/{counterId}/process-session/signature/upload-url';
};

export type CounterProcessSessionControllerGetCounterSignatureUploadUrlResponses = {
    /**
     * OK
     */
    200: GetPresignedUploadUrlResponse;
};

export type CounterProcessSessionControllerGetCounterSignatureUploadUrlResponse = CounterProcessSessionControllerGetCounterSignatureUploadUrlResponses[keyof CounterProcessSessionControllerGetCounterSignatureUploadUrlResponses];

export type CouponsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        order?: Order;
        page?: number;
        isActive?: boolean;
        search?: string;
        type?: CouponType;
        sort?: Array<CouponSort>;
        limit?: number;
    };
    url: '/v1/coupons';
};

export type CouponsControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationCouponPaginationMeta;
};

export type CouponsControllerFindAllResponse = CouponsControllerFindAllResponses[keyof CouponsControllerFindAllResponses];

export type CouponsControllerCreateData = {
    body: CreateCouponDtoWritable;
    path?: never;
    query?: never;
    url: '/v1/coupons';
};

export type CouponsControllerCreateResponses = {
    /**
     * Created
     */
    201: Coupon;
};

export type CouponsControllerCreateResponse = CouponsControllerCreateResponses[keyof CouponsControllerCreateResponses];

export type CouponsControllerApplyCouponData = {
    body: ApplyCouponDto;
    path?: never;
    query?: never;
    url: '/v1/coupons/apply';
};

export type CouponsControllerApplyCouponResponses = {
    /**
     * OK
     */
    200: CouponValidationResponseDto;
};

export type CouponsControllerApplyCouponResponse = CouponsControllerApplyCouponResponses[keyof CouponsControllerApplyCouponResponses];

export type CouponsControllerCreateLegacyCouponPaymentData = {
    body: CreateLegacyCouponPaymentDto;
    path?: never;
    query?: never;
    url: '/v1/coupons/legacy-coupon';
};

export type CouponsControllerCreateLegacyCouponPaymentResponses = {
    /**
     * Created
     */
    201: Payment;
};

export type CouponsControllerCreateLegacyCouponPaymentResponse = CouponsControllerCreateLegacyCouponPaymentResponses[keyof CouponsControllerCreateLegacyCouponPaymentResponses];

export type CouponsControllerRemoveCouponData = {
    body: RemoveCouponDto;
    path?: never;
    query?: never;
    url: '/v1/coupons/remove';
};

export type CouponsControllerRemoveCouponResponses = {
    /**
     * Created
     */
    201: {
        success: true;
    };
};

export type CouponsControllerRemoveCouponResponse = CouponsControllerRemoveCouponResponses[keyof CouponsControllerRemoveCouponResponses];

export type CouponsControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/coupons/{id}';
};

export type CouponsControllerRemoveResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type CouponsControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/coupons/{id}';
};

export type CouponsControllerFindOneResponses = {
    /**
     * OK
     */
    200: Coupon;
};

export type CouponsControllerFindOneResponse = CouponsControllerFindOneResponses[keyof CouponsControllerFindOneResponses];

export type CouponsControllerUpdateData = {
    body: UpdateCouponDtoWritable;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/coupons/{id}';
};

export type CouponsControllerUpdateResponses = {
    /**
     * OK
     */
    200: Coupon;
};

export type CouponsControllerUpdateResponse = CouponsControllerUpdateResponses[keyof CouponsControllerUpdateResponses];

export type CouponsControllerGeneratePdfData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/coupons/{id}/pdf';
};

export type CouponsControllerGeneratePdfResponses = {
    /**
     * Returns the coupon PDF
     */
    200: unknown;
};

export type CouponsControllerGetGeneratedRevenueData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        createdDateAfter?: Date;
        createdDateBefore?: Date;
        status?: Array<BookingStatus>;
    };
    url: '/v1/coupons/{id}/revenue';
};

export type CouponsControllerGetGeneratedRevenueResponses = {
    /**
     * OK
     */
    200: CouponGeneratedRevenueDto;
};

export type CouponsControllerGetGeneratedRevenueResponse = CouponsControllerGetGeneratedRevenueResponses[keyof CouponsControllerGetGeneratedRevenueResponses];

export type CustomerInterfaceControllerBookOnlineData = {
    body: OnlineBookingRequestDto;
    path?: never;
    query?: never;
    url: '/v1/customer-interface/bookings';
};

export type CustomerInterfaceControllerBookOnlineResponses = {
    /**
     * Pricing result in case of dry run
     */
    200: DryRunBookingResponseDto;
    /**
     * Booking checkout result
     */
    201: CheckoutResponseDto;
};

export type CustomerInterfaceControllerBookOnlineResponse = CustomerInterfaceControllerBookOnlineResponses[keyof CustomerInterfaceControllerBookOnlineResponses];

export type CustomerInterfaceControllerUpdateOnlineBookingData = {
    body: UpdateOnlineBookingDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/customer-interface/bookings/{id}';
};

export type CustomerInterfaceControllerUpdateOnlineBookingResponses = {
    /**
     * OK
     */
    200: BookingDto;
};

export type CustomerInterfaceControllerUpdateOnlineBookingResponse = CustomerInterfaceControllerUpdateOnlineBookingResponses[keyof CustomerInterfaceControllerUpdateOnlineBookingResponses];

export type CustomerInterfaceControllerGetBookingInvoicesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/customer-interface/bookings/{id}/invoices';
};

export type CustomerInterfaceControllerGetBookingInvoicesResponses = {
    /**
     * OK
     */
    200: Array<InvoiceDto>;
};

export type CustomerInterfaceControllerGetBookingInvoicesResponse = CustomerInterfaceControllerGetBookingInvoicesResponses[keyof CustomerInterfaceControllerGetBookingInvoicesResponses];

export type CustomerInterfaceControllerGetUpdatedPricingData = {
    body: UpdateOnlineBookingDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/customer-interface/bookings/{id}/price';
};

export type CustomerInterfaceControllerGetUpdatedPricingResponses = {
    /**
     * OK
     */
    200: RebookingResultDto;
};

export type CustomerInterfaceControllerGetUpdatedPricingResponse = CustomerInterfaceControllerGetUpdatedPricingResponses[keyof CustomerInterfaceControllerGetUpdatedPricingResponses];

export type CustomerInterfaceControllerGetStoredPaymentMethodsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/customer-interface/bookings/{id}/stored-payment-methods';
};

export type CustomerInterfaceControllerGetStoredPaymentMethodsResponses = {
    /**
     * OK
     */
    200: Array<BaseStoredPaymentMethod>;
};

export type CustomerInterfaceControllerGetStoredPaymentMethodsResponse = CustomerInterfaceControllerGetStoredPaymentMethodsResponses[keyof CustomerInterfaceControllerGetStoredPaymentMethodsResponses];

export type CustomerInterfaceControllerBuyCouponData = {
    body: BuyCouponRequestDto;
    path?: never;
    query?: never;
    url: '/v1/customer-interface/coupons/buy';
};

export type CustomerInterfaceControllerBuyCouponResponses = {
    /**
     * OK
     */
    200: CheckoutResponseDto;
};

export type CustomerInterfaceControllerBuyCouponResponse = CustomerInterfaceControllerBuyCouponResponses[keyof CustomerInterfaceControllerBuyCouponResponses];

export type CustomerInterfaceControllerDownloadInvoiceData = {
    body?: never;
    path: {
        invoiceId: string;
    };
    query?: never;
    url: '/v1/customer-interface/invoices/{invoiceId}/download';
};

export type CustomerInterfaceControllerDownloadInvoiceResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type CustomerInterfaceControllerUpdateProfileData = {
    body: PublicCustomerDataDto;
    path?: never;
    query?: never;
    url: '/v1/customer-interface/profile';
};

export type CustomerInterfaceControllerUpdateProfileResponses = {
    /**
     * OK
     */
    200: User;
};

export type CustomerInterfaceControllerUpdateProfileResponse = CustomerInterfaceControllerUpdateProfileResponses[keyof CustomerInterfaceControllerUpdateProfileResponses];

export type CustomerInterfaceControllerValidateCouponCodeData = {
    body: ValidateCouponDto;
    path?: never;
    query?: never;
    url: '/v1/customer-interface/validate-coupon';
};

export type CustomerInterfaceControllerValidateCouponCodeResponses = {
    /**
     * OK
     */
    200: CouponValidationResponseDto;
};

export type CustomerInterfaceControllerValidateCouponCodeResponse = CustomerInterfaceControllerValidateCouponCodeResponses[keyof CustomerInterfaceControllerValidateCouponCodeResponses];

export type DamagesControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        bookingIds?: Array<string>;
        carIds?: Array<string>;
        status?: Array<DamageStatus>;
        withPosition?: boolean;
    };
    url: '/v1/damages';
};

export type DamagesControllerFindAllResponses = {
    /**
     * OK
     */
    200: Array<Damage>;
};

export type DamagesControllerFindAllResponse = DamagesControllerFindAllResponses[keyof DamagesControllerFindAllResponses];

export type DamagesControllerCreateData = {
    body: CreateDamageDto;
    path?: never;
    query?: never;
    url: '/v1/damages';
};

export type DamagesControllerCreateResponses = {
    /**
     * Created
     */
    201: Damage | null;
};

export type DamagesControllerCreateResponse = DamagesControllerCreateResponses[keyof DamagesControllerCreateResponses];

export type DamagesControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/damages/{id}';
};

export type DamagesControllerRemoveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DamagesControllerRemoveResponse = DamagesControllerRemoveResponses[keyof DamagesControllerRemoveResponses];

export type DamagesControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/damages/{id}';
};

export type DamagesControllerFindOneResponses = {
    /**
     * OK
     */
    200: Damage;
};

export type DamagesControllerFindOneResponse = DamagesControllerFindOneResponses[keyof DamagesControllerFindOneResponses];

export type DamagesControllerUpdateData = {
    body: UpdateDamageDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/damages/{id}';
};

export type DamagesControllerUpdateResponses = {
    /**
     * OK
     */
    200: Damage | null;
};

export type DamagesControllerUpdateResponse = DamagesControllerUpdateResponses[keyof DamagesControllerUpdateResponses];

export type DamagesControllerAttachEvidenceData = {
    body: AttachDamageEvidenceDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/damages/{id}/evidence';
};

export type DamagesControllerAttachEvidenceResponses = {
    /**
     * OK
     */
    200: Damage;
};

export type DamagesControllerAttachEvidenceResponse = DamagesControllerAttachEvidenceResponses[keyof DamagesControllerAttachEvidenceResponses];

export type DiscoverySurveysControllerUpdateData = {
    body: UpdateDiscoverySurveyDto;
    path: {
        token: string;
    };
    query?: never;
    url: '/v1/discovery-surveys/{token}';
};

export type DiscoverySurveysControllerUpdateResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DiscoverySurveysControllerUpdateResponse = DiscoverySurveysControllerUpdateResponses[keyof DiscoverySurveysControllerUpdateResponses];

export type EmailConfirmationControllerConfirmData = {
    body: ConfirmEmailDto;
    path?: never;
    query?: never;
    url: '/v1/email-confirmation/confirm';
};

export type EmailConfirmationControllerConfirmResponses = {
    /**
     * Created
     */
    201: unknown;
};

export type EmailConfirmationControllerResendConfirmationLinkData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/email-confirmation/resend-confirmation-link';
};

export type EmailConfirmationControllerResendConfirmationLinkResponses = {
    /**
     * Created
     */
    201: unknown;
};

export type EmployeeDashboardControllerGetSummaryData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/employee-dashboard/summary';
};

export type EmployeeDashboardControllerGetSummaryResponses = {
    /**
     * OK
     */
    200: EmployeeDashboardSummaryDto;
};

export type EmployeeDashboardControllerGetSummaryResponse = EmployeeDashboardControllerGetSummaryResponses[keyof EmployeeDashboardControllerGetSummaryResponses];

export type ExternalHandoverControllerLoginData = {
    body: ExternalHandoverLoginDto;
    path?: never;
    query?: never;
    url: '/v1/external-handover/login';
};

export type ExternalHandoverControllerLoginResponses = {
    /**
     * Created
     */
    201: ExternalHandoverLoginResponseDto;
};

export type ExternalHandoverControllerLoginResponse = ExternalHandoverControllerLoginResponses[keyof ExternalHandoverControllerLoginResponses];

export type ExternalHandoverControllerSendLinkData = {
    body: SendExternalHandoverLinkDto;
    path?: never;
    query?: never;
    url: '/v1/external-handover/send-link';
};

export type ExternalHandoverControllerSendLinkResponses = {
    /**
     * No Content
     */
    204: void;
};

export type ExternalHandoverControllerSendLinkResponse = ExternalHandoverControllerSendLinkResponses[keyof ExternalHandoverControllerSendLinkResponses];

export type ExternalHandoverControllerSendPaymentLinkData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/external-handover/{id}/payment-link';
};

export type ExternalHandoverControllerSendPaymentLinkResponses = {
    /**
     * Created
     */
    201: ChargeAmountResponseDto;
};

export type ExternalHandoverControllerSendPaymentLinkResponse = ExternalHandoverControllerSendPaymentLinkResponses[keyof ExternalHandoverControllerSendPaymentLinkResponses];

export type GlobalSettingsControllerGetSettingsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/global-settings';
};

export type GlobalSettingsControllerGetSettingsResponses = {
    /**
     * OK
     */
    200: GlobalSettings | null;
};

export type GlobalSettingsControllerGetSettingsResponse = GlobalSettingsControllerGetSettingsResponses[keyof GlobalSettingsControllerGetSettingsResponses];

export type GlobalSettingsControllerUpdateSettingsData = {
    body: UpdateGlobalSettingDto;
    path?: never;
    query?: never;
    url: '/v1/global-settings';
};

export type GlobalSettingsControllerUpdateSettingsResponses = {
    /**
     * OK
     */
    200: GlobalSettings | null;
};

export type GlobalSettingsControllerUpdateSettingsResponse = GlobalSettingsControllerUpdateSettingsResponses[keyof GlobalSettingsControllerUpdateSettingsResponses];

export type AppControllerCheckHealthData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/health';
};

export type AppControllerCheckHealthResponses = {
    /**
     * OK
     */
    200: string;
};

export type AppControllerCheckHealthResponse = AppControllerCheckHealthResponses[keyof AppControllerCheckHealthResponses];

export type InfringementsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        order?: Order;
        sort?: Array<FindAllInfringementsSort>;
        limit?: number;
        page?: number;
        dateFrom?: Date;
        dateTo?: Date;
        search?: string;
        hasSomeErrorsOf?: Array<'chargeFee' | 'checkDuplicateFileNumber' | 'extractData' | 'findBooking' | 'sendAuthorityEmail' | 'sendInvoice' | 'sendPaymentLink'>;
        statuses?: Array<InfringementStatus>;
        types?: Array<InfringementType>;
    };
    url: '/v1/infringements';
};

export type InfringementsControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationInfringementPaginationMeta;
};

export type InfringementsControllerFindAllResponse = InfringementsControllerFindAllResponses[keyof InfringementsControllerFindAllResponses];

export type InfringementsControllerCreateData = {
    body: CreateInfringementDto;
    path?: never;
    query?: never;
    url: '/v1/infringements';
};

export type InfringementsControllerCreateResponses = {
    /**
     * Created
     */
    201: Infringement;
};

export type InfringementsControllerCreateResponse = InfringementsControllerCreateResponses[keyof InfringementsControllerCreateResponses];

export type InfringementsControllerEventsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/infringements/events';
};

export type InfringementsControllerEventsResponses = {
    /**
     * Server-Sent Events stream
     */
    200: unknown;
};

export type InfringementsControllerGetUserActionNeededCountData = {
    body?: never;
    path?: never;
    query?: {
        dateFrom?: Date;
        dateTo?: Date;
        search?: string;
    };
    url: '/v1/infringements/user-action-needed-count';
};

export type InfringementsControllerGetUserActionNeededCountResponses = {
    /**
     * OK
     */
    200: InfringementUserActionNeededCountDto;
};

export type InfringementsControllerGetUserActionNeededCountResponse = InfringementsControllerGetUserActionNeededCountResponses[keyof InfringementsControllerGetUserActionNeededCountResponses];

export type InfringementsControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        withForce?: boolean;
    };
    url: '/v1/infringements/{id}';
};

export type InfringementsControllerRemoveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type InfringementsControllerRemoveResponse = InfringementsControllerRemoveResponses[keyof InfringementsControllerRemoveResponses];

export type InfringementsControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/infringements/{id}';
};

export type InfringementsControllerFindOneResponses = {
    /**
     * OK
     */
    200: Infringement;
};

export type InfringementsControllerFindOneResponse = InfringementsControllerFindOneResponses[keyof InfringementsControllerFindOneResponses];

export type InfringementsControllerUpdateData = {
    body: UpdateInfringementDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/infringements/{id}';
};

export type InfringementsControllerUpdateResponses = {
    /**
     * OK
     */
    200: Infringement;
};

export type InfringementsControllerUpdateResponse = InfringementsControllerUpdateResponses[keyof InfringementsControllerUpdateResponses];

export type InfringementsControllerExecuteData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/infringements/{id}/execute';
};

export type InfringementsControllerExecuteResponses = {
    /**
     * OK
     */
    200: Infringement;
};

export type InfringementsControllerExecuteResponse = InfringementsControllerExecuteResponses[keyof InfringementsControllerExecuteResponses];

export type InfringementsControllerRetryChargeFeeData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/infringements/{id}/retry/charge-fee';
};

export type InfringementsControllerRetryChargeFeeResponses = {
    /**
     * OK
     */
    200: Infringement;
};

export type InfringementsControllerRetryChargeFeeResponse = InfringementsControllerRetryChargeFeeResponses[keyof InfringementsControllerRetryChargeFeeResponses];

export type InfringementsControllerRetryFindBookingData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/infringements/{id}/retry/find-booking';
};

export type InfringementsControllerRetryFindBookingResponses = {
    /**
     * OK
     */
    200: Infringement;
};

export type InfringementsControllerRetryFindBookingResponse = InfringementsControllerRetryFindBookingResponses[keyof InfringementsControllerRetryFindBookingResponses];

export type InfringementsControllerRetrySendAuthorityEmailData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/infringements/{id}/retry/send-authority-email';
};

export type InfringementsControllerRetrySendAuthorityEmailResponses = {
    /**
     * OK
     */
    200: Infringement;
};

export type InfringementsControllerRetrySendAuthorityEmailResponse = InfringementsControllerRetrySendAuthorityEmailResponses[keyof InfringementsControllerRetrySendAuthorityEmailResponses];

export type InspectionsControllerFindAllData = {
    body?: never;
    path?: never;
    query: {
        bookingId: string;
    };
    url: '/v1/inspections';
};

export type InspectionsControllerFindAllResponses = {
    /**
     * OK
     */
    200: Array<InspectionDto>;
};

export type InspectionsControllerFindAllResponse = InspectionsControllerFindAllResponses[keyof InspectionsControllerFindAllResponses];

export type InspectionsControllerStartData = {
    body: StartInspectionDto;
    path?: never;
    query?: never;
    url: '/v1/inspections';
};

export type InspectionsControllerStartResponses = {
    /**
     * Created
     */
    201: InspectionDto;
};

export type InspectionsControllerStartResponse = InspectionsControllerStartResponses[keyof InspectionsControllerStartResponses];

export type InspectionsControllerCompleteData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/inspections/{id}/complete';
};

export type InspectionsControllerCompleteResponses = {
    /**
     * Created
     */
    201: InspectionDto;
};

export type InspectionsControllerCompleteResponse = InspectionsControllerCompleteResponses[keyof InspectionsControllerCompleteResponses];

export type InspectionsControllerRegisterCaptureData = {
    body: RegisterShotCaptureDto;
    path: {
        id: string;
        shotKey: InspectionShotKey;
    };
    query?: never;
    url: '/v1/inspections/{id}/shots/{shotKey}/capture';
};

export type InspectionsControllerRegisterCaptureResponses = {
    /**
     * Created
     */
    201: InspectionDto;
};

export type InspectionsControllerRegisterCaptureResponse = InspectionsControllerRegisterCaptureResponses[keyof InspectionsControllerRegisterCaptureResponses];

export type InspectionsControllerAttachImageData = {
    body: AttachShotImageDto;
    path: {
        id: string;
        shotKey: InspectionShotKey;
    };
    query?: never;
    url: '/v1/inspections/{id}/shots/{shotKey}/image';
};

export type InspectionsControllerAttachImageResponses = {
    /**
     * Created
     */
    201: InspectionDto;
};

export type InspectionsControllerAttachImageResponse = InspectionsControllerAttachImageResponses[keyof InspectionsControllerAttachImageResponses];

export type InspectionsControllerSkipData = {
    body: SkipShotDto;
    path: {
        id: string;
        shotKey: InspectionShotKey;
    };
    query?: never;
    url: '/v1/inspections/{id}/shots/{shotKey}/skip';
};

export type InspectionsControllerSkipResponses = {
    /**
     * Created
     */
    201: InspectionDto;
};

export type InspectionsControllerSkipResponse = InspectionsControllerSkipResponses[keyof InspectionsControllerSkipResponses];

export type InspectionsControllerGetUploadUrlData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/inspections/{id}/upload-url';
};

export type InspectionsControllerGetUploadUrlResponses = {
    /**
     * OK
     */
    200: GetPresignedUploadUrlResponse;
};

export type InspectionsControllerGetUploadUrlResponse = InspectionsControllerGetUploadUrlResponses[keyof InspectionsControllerGetUploadUrlResponses];

export type InsuranceCasesControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        sort?: Array<FindAllInsuranceCasesSort>;
        insuranceProvider?: InsuranceProviderName;
        referenceNumber?: string;
        status?: Array<InsuranceCaseStatus>;
        order?: Order;
        limit?: number;
        page?: number;
    };
    url: '/v1/insurance-cases';
};

export type InsuranceCasesControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationInsuranceCasePaginationMeta;
};

export type InsuranceCasesControllerFindAllResponse = InsuranceCasesControllerFindAllResponses[keyof InsuranceCasesControllerFindAllResponses];

export type InsuranceCasesControllerCreateData = {
    body: CreateInsuranceCaseDto;
    path?: never;
    query?: never;
    url: '/v1/insurance-cases';
};

export type InsuranceCasesControllerCreateResponses = {
    /**
     * Created
     */
    201: InsuranceCase;
};

export type InsuranceCasesControllerCreateResponse = InsuranceCasesControllerCreateResponses[keyof InsuranceCasesControllerCreateResponses];

export type InsuranceCasesControllerDeleteData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/insurance-cases/{id}';
};

export type InsuranceCasesControllerDeleteResponses = {
    /**
     * OK
     */
    200: InsuranceCase;
};

export type InsuranceCasesControllerDeleteResponse = InsuranceCasesControllerDeleteResponses[keyof InsuranceCasesControllerDeleteResponses];

export type InsuranceCasesControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/insurance-cases/{id}';
};

export type InsuranceCasesControllerFindOneResponses = {
    /**
     * OK
     */
    200: InsuranceCase;
};

export type InsuranceCasesControllerFindOneResponse = InsuranceCasesControllerFindOneResponses[keyof InsuranceCasesControllerFindOneResponses];

export type InsuranceCasesControllerUpdateData = {
    body: UpdateInsuranceCaseDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/insurance-cases/{id}';
};

export type InsuranceCasesControllerUpdateResponses = {
    /**
     * OK
     */
    200: InsuranceCase;
};

export type InsuranceCasesControllerUpdateResponse = InsuranceCasesControllerUpdateResponses[keyof InsuranceCasesControllerUpdateResponses];

export type InsuranceCasesControllerGenerateInvoicesData = {
    body: GenerateInsuranceCaseInvoicesDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/insurance-cases/{id}/generate-invoices';
};

export type InsuranceCasesControllerGenerateInvoicesResponses = {
    /**
     * OK
     */
    200: InsuranceCase;
};

export type InsuranceCasesControllerGenerateInvoicesResponse = InsuranceCasesControllerGenerateInvoicesResponses[keyof InsuranceCasesControllerGenerateInvoicesResponses];

export type InvoicesControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        filter?: Array<FindAllInvoicesFilterDto>;
        order?: Order;
        sort?: Array<FindAllInvoicesSort>;
        limit?: number;
        page?: number;
    };
    url: '/v1/invoices';
};

export type InvoicesControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationInvoiceDtoPaginationMeta;
};

export type InvoicesControllerFindAllResponse = InvoicesControllerFindAllResponses[keyof InvoicesControllerFindAllResponses];

export type InvoicesControllerCreateData = {
    body: CreateInvoiceDto;
    path?: never;
    query?: never;
    url: '/v1/invoices';
};

export type InvoicesControllerCreateResponses = {
    /**
     * Created
     */
    201: InvoiceDto | null;
};

export type InvoicesControllerCreateResponse = InvoicesControllerCreateResponses[keyof InvoicesControllerCreateResponses];

export type InvoicesControllerCreateAndSendAgencyInvoiceData = {
    body?: never;
    path: {
        bookingId: string;
    };
    query?: never;
    url: '/v1/invoices/agency-invoice/{bookingId}';
};

export type InvoicesControllerCreateAndSendAgencyInvoiceResponses = {
    /**
     * No Content
     */
    204: void;
};

export type InvoicesControllerCreateAndSendAgencyInvoiceResponse = InvoicesControllerCreateAndSendAgencyInvoiceResponses[keyof InvoicesControllerCreateAndSendAgencyInvoiceResponses];

export type InvoicesControllerExportInvoicesData = {
    body: ExportInvoicesDto;
    path?: never;
    query?: never;
    url: '/v1/invoices/export';
};

export type InvoicesControllerExportInvoicesResponses = {
    /**
     * Created
     */
    201: string | null;
};

export type InvoicesControllerExportInvoicesResponse = InvoicesControllerExportInvoicesResponses[keyof InvoicesControllerExportInvoicesResponses];

export type InvoicesControllerExportInvoicesPdfsData = {
    body: ExportInvoicesDto;
    path?: never;
    query?: never;
    url: '/v1/invoices/export/pdfs';
};

export type InvoicesControllerExportInvoicesPdfsResponses = {
    /**
     * Created
     */
    201: unknown;
};

export type InvoicesControllerCreateFromLedgerEntriesData = {
    body: CreateInvoiceFromLedgerEntriesDto;
    path?: never;
    query?: never;
    url: '/v1/invoices/from-ledger-entries';
};

export type InvoicesControllerCreateFromLedgerEntriesResponses = {
    /**
     * Created
     */
    201: InvoicingRunResultDto;
};

export type InvoicesControllerCreateFromLedgerEntriesResponse = InvoicesControllerCreateFromLedgerEntriesResponses[keyof InvoicesControllerCreateFromLedgerEntriesResponses];

export type InvoicesControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/invoices/{id}';
};

export type InvoicesControllerRemoveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type InvoicesControllerRemoveResponse = InvoicesControllerRemoveResponses[keyof InvoicesControllerRemoveResponses];

export type InvoicesControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/invoices/{id}';
};

export type InvoicesControllerFindOneResponses = {
    /**
     * OK
     */
    200: InvoiceDto;
};

export type InvoicesControllerFindOneResponse = InvoicesControllerFindOneResponses[keyof InvoicesControllerFindOneResponses];

export type InvoicesControllerUpdateData = {
    body: UpdateInvoiceDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/invoices/{id}';
};

export type InvoicesControllerUpdateResponses = {
    /**
     * OK
     */
    200: InvoiceDto | null;
};

export type InvoicesControllerUpdateResponse = InvoicesControllerUpdateResponses[keyof InvoicesControllerUpdateResponses];

export type InvoicesControllerSendToCustomerData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/invoices/{id}/mails/invoice';
};

export type InvoicesControllerSendToCustomerResponses = {
    /**
     * No Content
     */
    204: void;
};

export type InvoicesControllerSendToCustomerResponse = InvoicesControllerSendToCustomerResponses[keyof InvoicesControllerSendToCustomerResponses];

export type InvoicesControllerRegeneratePdfData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/invoices/{id}/pdf';
};

export type InvoicesControllerRegeneratePdfResponses = {
    /**
     * No Content
     */
    204: void;
};

export type InvoicesControllerRegeneratePdfResponse = InvoicesControllerRegeneratePdfResponses[keyof InvoicesControllerRegeneratePdfResponses];

export type LeadsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        order?: Order;
        sort?: Array<FindAllLeadsSort>;
        page?: number;
        email?: string;
        query?: string;
        status?: LeadStatus;
        limit?: number;
    };
    url: '/v1/leads';
};

export type LeadsControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationLeadPaginationMeta;
};

export type LeadsControllerFindAllResponse = LeadsControllerFindAllResponses[keyof LeadsControllerFindAllResponses];

export type LeadsControllerCaptureData = {
    body: CaptureLeadDto;
    path?: never;
    query?: never;
    url: '/v1/leads/capture';
};

export type LeadsControllerCaptureResponses = {
    /**
     * Created
     */
    201: Lead;
};

export type LeadsControllerCaptureResponse = LeadsControllerCaptureResponses[keyof LeadsControllerCaptureResponses];

export type LeadsControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/leads/{id}';
};

export type LeadsControllerFindOneResponses = {
    /**
     * OK
     */
    200: Lead;
};

export type LeadsControllerFindOneResponse = LeadsControllerFindOneResponses[keyof LeadsControllerFindOneResponses];

export type LeadsControllerUpdateData = {
    body: UpdateLeadDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/leads/{id}';
};

export type LeadsControllerUpdateResponses = {
    /**
     * OK
     */
    200: Lead;
};

export type LeadsControllerUpdateResponse = LeadsControllerUpdateResponses[keyof LeadsControllerUpdateResponses];

export type LedgerControllerAllocateInvoiceToLedgerEntriesData = {
    body: AllocateInvoiceToLedgerEntriesDto;
    path?: never;
    query?: never;
    url: '/v1/ledger/allocate-invoice';
};

export type LedgerControllerAllocateInvoiceToLedgerEntriesResponses = {
    /**
     * OK
     */
    200: Array<InvoiceAllocation>;
};

export type LedgerControllerAllocateInvoiceToLedgerEntriesResponse = LedgerControllerAllocateInvoiceToLedgerEntriesResponses[keyof LedgerControllerAllocateInvoiceToLedgerEntriesResponses];

export type LedgerControllerAllocatePaymentToLedgerEntriesData = {
    body: AllocatePaymentToLedgerEntriesDto;
    path?: never;
    query?: never;
    url: '/v1/ledger/allocate-payment';
};

export type LedgerControllerAllocatePaymentToLedgerEntriesResponses = {
    /**
     * OK
     */
    200: Array<PaymentAllocation>;
};

export type LedgerControllerAllocatePaymentToLedgerEntriesResponse = LedgerControllerAllocatePaymentToLedgerEntriesResponses[keyof LedgerControllerAllocatePaymentToLedgerEntriesResponses];

export type LedgerControllerAutoNetBookingLedgerEntriesData = {
    body?: never;
    path: {
        bookingId: string;
    };
    query?: never;
    url: '/v1/ledger/auto-net-booking-ledger-entries/{bookingId}';
};

export type LedgerControllerAutoNetBookingLedgerEntriesResponses = {
    /**
     * OK
     */
    200: number;
};

export type LedgerControllerAutoNetBookingLedgerEntriesResponse = LedgerControllerAutoNetBookingLedgerEntriesResponses[keyof LedgerControllerAutoNetBookingLedgerEntriesResponses];

export type LedgerControllerCheckNettingEligibilityData = {
    body?: never;
    path: {
        bookingId: string;
    };
    query?: never;
    url: '/v1/ledger/check-netting-eligibility/{bookingId}';
};

export type LedgerControllerCheckNettingEligibilityResponses = {
    /**
     * OK
     */
    200: ItemsToNetDto;
};

export type LedgerControllerCheckNettingEligibilityResponse = LedgerControllerCheckNettingEligibilityResponses[keyof LedgerControllerCheckNettingEligibilityResponses];

export type LedgerControllerGetInvoiceAllocationsByInvoiceIdData = {
    body?: never;
    path: {
        invoiceId: string;
    };
    query?: never;
    url: '/v1/ledger/invoice-allocations/{invoiceId}';
};

export type LedgerControllerGetInvoiceAllocationsByInvoiceIdResponses = {
    /**
     * OK
     */
    200: Array<InvoiceAllocationDto>;
};

export type LedgerControllerGetInvoiceAllocationsByInvoiceIdResponse = LedgerControllerGetInvoiceAllocationsByInvoiceIdResponses[keyof LedgerControllerGetInvoiceAllocationsByInvoiceIdResponses];

export type LedgerControllerFindAllLedgerEntriesData = {
    body?: never;
    path?: never;
    query?: {
        order?: Order;
        sort?: Array<FindAllLedgerEntriesSort>;
        page?: number;
        bookingIds?: Array<string>;
        counterpartyTypes?: Array<CounterpartyType>;
        invoiceIds?: Array<string>;
        ledgerEntryIds?: Array<string>;
        paymentIds?: Array<string>;
        limit?: number;
    };
    url: '/v1/ledger/ledger-entries';
};

export type LedgerControllerFindAllLedgerEntriesResponses = {
    /**
     * OK
     */
    200: PaginationLedgerEntryDtoPaginationMeta;
};

export type LedgerControllerFindAllLedgerEntriesResponse = LedgerControllerFindAllLedgerEntriesResponses[keyof LedgerControllerFindAllLedgerEntriesResponses];

export type LedgerControllerGetPaymentAllocationsByPaymentIdData = {
    body?: never;
    path: {
        paymentId: string;
    };
    query?: never;
    url: '/v1/ledger/payment-allocations/{paymentId}';
};

export type LedgerControllerGetPaymentAllocationsByPaymentIdResponses = {
    /**
     * OK
     */
    200: Array<PaymentAllocationDto>;
};

export type LedgerControllerGetPaymentAllocationsByPaymentIdResponse = LedgerControllerGetPaymentAllocationsByPaymentIdResponses[keyof LedgerControllerGetPaymentAllocationsByPaymentIdResponses];

export type LedgerControllerRecalculateLedgerEntriesData = {
    body: RecalculateLedgerEntriesDto;
    path?: never;
    query?: never;
    url: '/v1/ledger/recalculate-ledger-entries';
};

export type LedgerControllerRecalculateLedgerEntriesResponses = {
    /**
     * No Content
     */
    204: void;
};

export type LedgerControllerRecalculateLedgerEntriesResponse = LedgerControllerRecalculateLedgerEntriesResponses[keyof LedgerControllerRecalculateLedgerEntriesResponses];

export type LegalEntitiesControllerFindAllData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/legal-entities';
};

export type LegalEntitiesControllerFindAllResponses = {
    /**
     * OK
     */
    200: Array<LegalEntity>;
};

export type LegalEntitiesControllerFindAllResponse = LegalEntitiesControllerFindAllResponses[keyof LegalEntitiesControllerFindAllResponses];

export type LegalEntitiesControllerCreateData = {
    body: CreateLegalEntityDto;
    path?: never;
    query?: never;
    url: '/v1/legal-entities';
};

export type LegalEntitiesControllerCreateResponses = {
    /**
     * Created
     */
    201: LegalEntity;
};

export type LegalEntitiesControllerCreateResponse = LegalEntitiesControllerCreateResponses[keyof LegalEntitiesControllerCreateResponses];

export type LegalEntitiesControllerFindAllPublicData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/legal-entities/public';
};

export type LegalEntitiesControllerFindAllPublicResponses = {
    /**
     * OK
     */
    200: Array<PublicLegalEntityDto>;
};

export type LegalEntitiesControllerFindAllPublicResponse = LegalEntitiesControllerFindAllPublicResponses[keyof LegalEntitiesControllerFindAllPublicResponses];

export type LegalEntitiesControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/legal-entities/{id}';
};

export type LegalEntitiesControllerFindOneResponses = {
    /**
     * OK
     */
    200: LegalEntity;
};

export type LegalEntitiesControllerFindOneResponse = LegalEntitiesControllerFindOneResponses[keyof LegalEntitiesControllerFindOneResponses];

export type LegalEntitiesControllerUpdateData = {
    body: UpdateLegalEntityDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/legal-entities/{id}';
};

export type LegalEntitiesControllerUpdateResponses = {
    /**
     * OK
     */
    200: LegalEntity;
};

export type LegalEntitiesControllerUpdateResponse = LegalEntitiesControllerUpdateResponses[keyof LegalEntitiesControllerUpdateResponses];

export type LegalEntitiesControllerGetTermsData = {
    body?: never;
    path: {
        id: string;
    };
    query: {
        language: string;
    };
    url: '/v1/legal-entities/{id}/terms';
};

export type LegalEntitiesControllerGetTermsResponses = {
    /**
     * OK
     */
    200: LegalEntityTermsDto;
};

export type LegalEntitiesControllerGetTermsResponse = LegalEntitiesControllerGetTermsResponses[keyof LegalEntitiesControllerGetTermsResponses];

export type LiveDashboardControllerGetBookingOverviewData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/live-dashboard/booking-overview';
};

export type LiveDashboardControllerGetBookingOverviewResponses = {
    /**
     * OK
     */
    200: BookingOverviewDto;
};

export type LiveDashboardControllerGetBookingOverviewResponse = LiveDashboardControllerGetBookingOverviewResponses[keyof LiveDashboardControllerGetBookingOverviewResponses];

export type LiveDashboardControllerBookingConfirmationNotificationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/live-dashboard/notifications/booking-confirmation';
};

export type LiveDashboardControllerBookingConfirmationNotificationResponses = {
    /**
     * Server-Sent Events stream
     */
    200: unknown;
};

export type LiveDashboardControllerHandoverEventsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/live-dashboard/notifications/handover-events';
};

export type LiveDashboardControllerHandoverEventsResponses = {
    /**
     * Server-Sent Events stream
     */
    200: unknown;
};

export type LiveDashboardControllerYearlyRevenueNotificationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/live-dashboard/notifications/yearly-revenue';
};

export type LiveDashboardControllerYearlyRevenueNotificationResponses = {
    /**
     * Server-Sent Events stream
     */
    200: unknown;
};

export type LiveDashboardControllerGetYearlyRevenueData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/live-dashboard/yearly-revenue';
};

export type LiveDashboardControllerGetYearlyRevenueResponses = {
    /**
     * OK
     */
    200: YearlyRevenueDto;
};

export type LiveDashboardControllerGetYearlyRevenueResponse = LiveDashboardControllerGetYearlyRevenueResponses[keyof LiveDashboardControllerGetYearlyRevenueResponses];

export type MakesControllerFindAllData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/makes';
};

export type MakesControllerFindAllResponses = {
    /**
     * OK
     */
    200: Array<Make>;
};

export type MakesControllerFindAllResponse = MakesControllerFindAllResponses[keyof MakesControllerFindAllResponses];

export type MakesControllerCreateData = {
    body: CreateMakeDto;
    path?: never;
    query?: never;
    url: '/v1/makes';
};

export type MakesControllerCreateResponses = {
    /**
     * Created
     */
    201: Make | null;
};

export type MakesControllerCreateResponse = MakesControllerCreateResponses[keyof MakesControllerCreateResponses];

export type MakesControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/makes/{id}';
};

export type MakesControllerRemoveResponses = {
    /**
     * No Content
     */
    204: DeleteResult;
};

export type MakesControllerRemoveResponse = MakesControllerRemoveResponses[keyof MakesControllerRemoveResponses];

export type MakesControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/makes/{id}';
};

export type MakesControllerFindOneResponses = {
    /**
     * OK
     */
    200: Make;
};

export type MakesControllerFindOneResponse = MakesControllerFindOneResponses[keyof MakesControllerFindOneResponses];

export type MakesControllerUpdateData = {
    body: UpdateMakeDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/makes/{id}';
};

export type MakesControllerUpdateResponses = {
    /**
     * OK
     */
    200: Make | null;
};

export type MakesControllerUpdateResponse = MakesControllerUpdateResponses[keyof MakesControllerUpdateResponses];

export type MediaControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        order?: Order;
        sort?: Array<FindAllMediaSort>;
        limit?: number;
        page?: number;
    };
    url: '/v1/media';
};

export type MediaControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationMediaPaginationMeta;
};

export type MediaControllerFindAllResponse = MediaControllerFindAllResponses[keyof MediaControllerFindAllResponses];

export type MediaControllerCreateData = {
    body: CreateMediaDto;
    path?: never;
    query?: never;
    url: '/v1/media';
};

export type MediaControllerCreateResponses = {
    /**
     * Created
     */
    201: Media;
};

export type MediaControllerCreateResponse = MediaControllerCreateResponses[keyof MediaControllerCreateResponses];

export type MediaRotationControllerFindAllData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/media-rotation';
};

export type MediaRotationControllerFindAllResponses = {
    /**
     * OK
     */
    200: Array<RotationMediaResponseDto>;
};

export type MediaRotationControllerFindAllResponse = MediaRotationControllerFindAllResponses[keyof MediaRotationControllerFindAllResponses];

export type MediaRotationControllerCreateData = {
    body: CreateRotationMediaDto;
    path?: never;
    query?: never;
    url: '/v1/media-rotation';
};

export type MediaRotationControllerCreateResponses = {
    /**
     * Created
     */
    201: RotationMediaResponseDto;
};

export type MediaRotationControllerCreateResponse = MediaRotationControllerCreateResponses[keyof MediaRotationControllerCreateResponses];

export type MediaRotationControllerGetCurrentData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/media-rotation/current';
};

export type MediaRotationControllerGetCurrentResponses = {
    /**
     * OK
     */
    200: Array<RotationMediaPoolItemDto>;
};

export type MediaRotationControllerGetCurrentResponse = MediaRotationControllerGetCurrentResponses[keyof MediaRotationControllerGetCurrentResponses];

export type MediaRotationControllerHandoverEventsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/media-rotation/handover-events';
};

export type MediaRotationControllerHandoverEventsResponses = {
    /**
     * Server-Sent Events stream
     */
    200: unknown;
};

export type MediaRotationControllerGetVideoWallCurrentData = {
    body?: never;
    path: {
        stationSlug: string;
    };
    query: {
        code: string;
    };
    url: '/v1/media-rotation/video-wall/{stationSlug}/current';
};

export type MediaRotationControllerGetVideoWallCurrentResponses = {
    /**
     * OK
     */
    200: Array<RotationMediaPoolItemDto>;
};

export type MediaRotationControllerGetVideoWallCurrentResponse = MediaRotationControllerGetVideoWallCurrentResponses[keyof MediaRotationControllerGetVideoWallCurrentResponses];

export type MediaRotationControllerVideoWallHandoverEventsData = {
    body?: never;
    path: {
        stationSlug: string;
    };
    query: {
        code: string;
    };
    url: '/v1/media-rotation/video-wall/{stationSlug}/handover-events';
};

export type MediaRotationControllerVideoWallHandoverEventsResponses = {
    /**
     * Server-Sent Events stream
     */
    200: unknown;
};

export type MediaRotationControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/media-rotation/{id}';
};

export type MediaRotationControllerRemoveResponses = {
    /**
     * No Content
     */
    204: DeleteResult;
};

export type MediaRotationControllerRemoveResponse = MediaRotationControllerRemoveResponses[keyof MediaRotationControllerRemoveResponses];

export type MediaRotationControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/media-rotation/{id}';
};

export type MediaRotationControllerFindOneResponses = {
    /**
     * OK
     */
    200: RotationMediaResponseDto;
};

export type MediaRotationControllerFindOneResponse = MediaRotationControllerFindOneResponses[keyof MediaRotationControllerFindOneResponses];

export type MediaRotationControllerUpdateData = {
    body: UpdateRotationMediaDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/media-rotation/{id}';
};

export type MediaRotationControllerUpdateResponses = {
    /**
     * OK
     */
    200: RotationMediaResponseDto;
};

export type MediaRotationControllerUpdateResponse = MediaRotationControllerUpdateResponses[keyof MediaRotationControllerUpdateResponses];

export type MediaControllerEventsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/media/events';
};

export type MediaControllerEventsResponses = {
    /**
     * Server-Sent Events stream
     */
    200: unknown;
};

export type MediaControllerGetUploadUrlData = {
    body?: never;
    path?: never;
    query: {
        mimeType: string;
        originalFileName: string;
    };
    url: '/v1/media/upload-url';
};

export type MediaControllerGetUploadUrlResponses = {
    /**
     * OK
     */
    200: GetMediaUploadUrlResponse;
};

export type MediaControllerGetUploadUrlResponse = MediaControllerGetUploadUrlResponses[keyof MediaControllerGetUploadUrlResponses];

export type MediaControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/media/{id}';
};

export type MediaControllerRemoveResponses = {
    /**
     * No Content
     */
    204: DeleteResult;
};

export type MediaControllerRemoveResponse = MediaControllerRemoveResponses[keyof MediaControllerRemoveResponses];

export type MediaControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/media/{id}';
};

export type MediaControllerFindOneResponses = {
    /**
     * OK
     */
    200: Media;
};

export type MediaControllerFindOneResponse = MediaControllerFindOneResponses[keyof MediaControllerFindOneResponses];

export type MediaControllerUpdateData = {
    body: UpdateMediaDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/media/{id}';
};

export type MediaControllerUpdateResponses = {
    /**
     * OK
     */
    200: Media;
};

export type MediaControllerUpdateResponse = MediaControllerUpdateResponses[keyof MediaControllerUpdateResponses];

export type MockPlacetelControllerGetCallsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/mock-placetel/calls';
};

export type MockPlacetelControllerGetCallsResponses = {
    /**
     * OK
     */
    200: Array<MockCallRecord>;
};

export type MockPlacetelControllerGetCallsResponse = MockPlacetelControllerGetCallsResponses[keyof MockPlacetelControllerGetCallsResponses];

export type MockPlacetelControllerGetSmsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/mock-placetel/sms';
};

export type MockPlacetelControllerGetSmsResponses = {
    /**
     * OK
     */
    200: Array<MockSmsRecord>;
};

export type MockPlacetelControllerGetSmsResponse = MockPlacetelControllerGetSmsResponses[keyof MockPlacetelControllerGetSmsResponses];

export type MockSendgridControllerGetAttachmentData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/mock-sendgrid/attachments/{id}';
};

export type MockSendgridControllerGetAttachmentResponses = {
    /**
     * OK
     */
    200: {
        content: string;
    };
};

export type MockSendgridControllerGetAttachmentResponse = MockSendgridControllerGetAttachmentResponses[keyof MockSendgridControllerGetAttachmentResponses];

export type MockSendgridControllerGetMailsData = {
    body?: never;
    path?: never;
    query?: {
        to?: string;
    };
    url: '/v1/mock-sendgrid/mails';
};

export type MockSendgridControllerGetMailsResponses = {
    /**
     * OK
     */
    200: Array<StoredMockMail>;
};

export type MockSendgridControllerGetMailsResponse = MockSendgridControllerGetMailsResponses[keyof MockSendgridControllerGetMailsResponses];

export type NewsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        status?: NewsStatus;
        order?: Order;
        sort?: Array<FindAllNewsSort>;
        limit?: number;
        page?: number;
    };
    url: '/v1/news';
};

export type NewsControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationNewsPaginationMeta;
};

export type NewsControllerFindAllResponse = NewsControllerFindAllResponses[keyof NewsControllerFindAllResponses];

export type NewsControllerCreateData = {
    body: CreateNewsDto;
    path?: never;
    query?: never;
    url: '/v1/news';
};

export type NewsControllerCreateResponses = {
    /**
     * Created
     */
    201: News | null;
};

export type NewsControllerCreateResponse = NewsControllerCreateResponses[keyof NewsControllerCreateResponses];

export type NewsControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/news/{id}';
};

export type NewsControllerRemoveResponses = {
    /**
     * No Content
     */
    204: DeleteResult;
};

export type NewsControllerRemoveResponse = NewsControllerRemoveResponses[keyof NewsControllerRemoveResponses];

export type NewsControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/news/{id}';
};

export type NewsControllerFindOneResponses = {
    /**
     * OK
     */
    200: News;
};

export type NewsControllerFindOneResponse = NewsControllerFindOneResponses[keyof NewsControllerFindOneResponses];

export type NewsControllerUpdateData = {
    body: UpdateNewsDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/news/{id}';
};

export type NewsControllerUpdateResponses = {
    /**
     * OK
     */
    200: News | null;
};

export type NewsControllerUpdateResponse = NewsControllerUpdateResponses[keyof NewsControllerUpdateResponses];

export type NewsletterControllerGetBrevoContactBlacklistedData = {
    body?: never;
    path?: never;
    query: {
        email: string;
    };
    url: '/v1/newsletter/brevo-contact-blacklisted';
};

export type NewsletterControllerGetBrevoContactBlacklistedResponses = {
    /**
     * OK
     */
    200: GetBrevoContactBlacklistedResponseDto;
};

export type NewsletterControllerGetBrevoContactBlacklistedResponse = NewsletterControllerGetBrevoContactBlacklistedResponses[keyof NewsletterControllerGetBrevoContactBlacklistedResponses];

export type NewsletterControllerSetBrevoContactToBlacklistedData = {
    body: UpdateBrevoContactBlacklistedDto;
    path?: never;
    query?: never;
    url: '/v1/newsletter/brevo-contact-to-blacklisted';
};

export type NewsletterControllerSetBrevoContactToBlacklistedResponses = {
    /**
     * Created
     */
    201: unknown;
};

export type NfcControllerHandleRentalKeyTagTapData = {
    body?: never;
    path?: never;
    query: {
        bookingId: string;
        uid: string;
        ctr: string;
        cmac: string;
    };
    url: '/v1/nfc/rental-key-tag';
};

export type NovuControllerGetCredentialsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/novu/credentials';
};

export type NovuControllerGetCredentialsResponses = {
    /**
     * OK
     */
    200: NovuCredentialsDto;
};

export type NovuControllerGetCredentialsResponse = NovuControllerGetCredentialsResponses[keyof NovuControllerGetCredentialsResponses];

export type NpsSurveysControllerCreateData = {
    body: CreateNpsSurveyDto;
    path?: never;
    query?: never;
    url: '/v1/nps-surveys';
};

export type NpsSurveysControllerCreateResponses = {
    /**
     * Created
     */
    201: NpsSurvey | null;
};

export type NpsSurveysControllerCreateResponse = NpsSurveysControllerCreateResponses[keyof NpsSurveysControllerCreateResponses];

export type NpsSurveysControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/nps-surveys/{id}';
};

export type NpsSurveysControllerRemoveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type NpsSurveysControllerRemoveResponse = NpsSurveysControllerRemoveResponses[keyof NpsSurveysControllerRemoveResponses];

export type NpsSurveysControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/nps-surveys/{id}';
};

export type NpsSurveysControllerFindOneResponses = {
    /**
     * OK
     */
    200: NpsSurvey | null;
};

export type NpsSurveysControllerFindOneResponse = NpsSurveysControllerFindOneResponses[keyof NpsSurveysControllerFindOneResponses];

export type NpsSurveysControllerCompleteData = {
    body: CompleteNpsSurveyDto;
    path: {
        id: string;
    };
    query: {
        secretCompletionToken: string;
    };
    url: '/v1/nps-surveys/{id}/complete';
};

export type NpsSurveysControllerCompleteResponses = {
    /**
     * No Content
     */
    204: void;
};

export type NpsSurveysControllerCompleteResponse = NpsSurveysControllerCompleteResponses[keyof NpsSurveysControllerCompleteResponses];

export type NpsSurveysControllerGetCompletionScreenData = {
    body?: never;
    path: {
        id: string;
    };
    query: {
        secretCompletionToken: string;
    };
    url: '/v1/nps-surveys/{id}/completion-screen';
};

export type NpsSurveysControllerGetCompletionScreenResponses = {
    /**
     * OK
     */
    200: NpsSurveyCompletionScreenDto;
};

export type NpsSurveysControllerGetCompletionScreenResponse = NpsSurveysControllerGetCompletionScreenResponses[keyof NpsSurveysControllerGetCompletionScreenResponses];

export type OffersControllerGetOffersData = {
    body?: never;
    path?: never;
    query: {
        bookingCreatedDate?: Date | null;
        categories?: Array<VehicleCategory>;
        country?: string;
        endDate: Date;
        excludeStartsInPast?: boolean;
        forceVehicleTypeIds?: Array<string> | null;
        ignoreOccupationOfCarId?: string | null;
        ignoreOpeningHoursAndHolidays?: boolean;
        includeHidden?: boolean;
        includeInternalStations?: boolean;
        insuranceCaseId?: string | null;
        insuranceCaseProvider?: 'axa' | 'europ' | 'jlr' | 'roland' | 'volvo' | null;
        isAvailable?: boolean | null;
        isGhostCar?: boolean;
        makeIds?: Array<string>;
        onlyClosestToDeliveryLocation?: boolean;
        partnerId?: string | null;
        pricingType?: PricingType;
        reduceCarsToOnePerVehicleType?: boolean;
        startDate: Date;
        stationIds?: Array<string>;
        suggestLongerStationTransfer?: boolean;
        taxProcedure?: TaxProcedure;
        transferDeliveryLocation?: [
            number,
            number
        ] | null;
        transferReturnLocation?: [
            number,
            number
        ] | null;
        vehicleTypeIds?: Array<string>;
        order?: Order;
        sort?: Array<GetOffersSort>;
        limit?: number;
        page?: number;
    };
    url: '/v1/offers';
};

export type OffersControllerGetOffersResponses = {
    /**
     * OK
     */
    200: PaginationOfferPaginationMeta;
};

export type OffersControllerGetOffersResponse = OffersControllerGetOffersResponses[keyof OffersControllerGetOffersResponses];

export type PaymentApiControllerBlockAmountData = {
    body: BlockAmountDto;
    path?: never;
    query?: never;
    url: '/v1/payment-api/block-amount';
};

export type PaymentApiControllerBlockAmountResponses = {
    /**
     * Created
     */
    201: ChargeAmountResponseDto;
};

export type PaymentApiControllerBlockAmountResponse = PaymentApiControllerBlockAmountResponses[keyof PaymentApiControllerBlockAmountResponses];

export type PaymentApiControllerChargeAmountData = {
    body: ChargeAmountDto;
    path?: never;
    query?: never;
    url: '/v1/payment-api/charge-amount';
};

export type PaymentApiControllerChargeAmountResponses = {
    /**
     * Created
     */
    201: ChargeAmountResponseDto;
};

export type PaymentApiControllerChargeAmountResponse = PaymentApiControllerChargeAmountResponses[keyof PaymentApiControllerChargeAmountResponses];

export type PaymentApiControllerCreditLedgerEntriesWithRefundData = {
    body: CreditWithRefundDto;
    path?: never;
    query?: never;
    url: '/v1/payment-api/credit-with-refund';
};

export type PaymentApiControllerCreditLedgerEntriesWithRefundResponses = {
    /**
     * Created
     */
    201: CreditWithRefundResponseDto;
};

export type PaymentApiControllerCreditLedgerEntriesWithRefundResponse = PaymentApiControllerCreditLedgerEntriesWithRefundResponses[keyof PaymentApiControllerCreditLedgerEntriesWithRefundResponses];

export type PaymentApiControllerStorePaymentMethodData = {
    body: StorePaymentMethodDto;
    path?: never;
    query?: never;
    url: '/v1/payment-api/store-payment-method';
};

export type PaymentApiControllerStorePaymentMethodResponses = {
    /**
     * Created
     */
    201: ChargeAmountResponseDto;
};

export type PaymentApiControllerStorePaymentMethodResponse = PaymentApiControllerStorePaymentMethodResponses[keyof PaymentApiControllerStorePaymentMethodResponses];

export type PaymentApiControllerGetStoredPaymentMethodsData = {
    body?: never;
    path?: never;
    query: {
        bookingId: string;
    };
    url: '/v1/payment-api/stored-payment-methods';
};

export type PaymentApiControllerGetStoredPaymentMethodsResponses = {
    /**
     * OK
     */
    200: Array<BaseStoredPaymentMethod>;
};

export type PaymentApiControllerGetStoredPaymentMethodsResponse = PaymentApiControllerGetStoredPaymentMethodsResponses[keyof PaymentApiControllerGetStoredPaymentMethodsResponses];

export type PaymentApiControllerStoreIbanPaymentMethodData = {
    body: StoreIbanPaymentMethodDto;
    path?: never;
    query?: never;
    url: '/v1/payment-api/stored-payment-methods/iban';
};

export type PaymentApiControllerStoreIbanPaymentMethodResponses = {
    /**
     * Created
     */
    201: Array<BaseStoredPaymentMethod>;
};

export type PaymentApiControllerStoreIbanPaymentMethodResponse = PaymentApiControllerStoreIbanPaymentMethodResponses[keyof PaymentApiControllerStoreIbanPaymentMethodResponses];

export type PaymentApiControllerPromoteStoredPaymentMethodToPeriodicChargeData = {
    body: PromoteStoredPaymentMethodDto;
    path?: never;
    query?: never;
    url: '/v1/payment-api/stored-payment-methods/promote-periodic-charge';
};

export type PaymentApiControllerPromoteStoredPaymentMethodToPeriodicChargeResponses = {
    /**
     * OK
     */
    200: Array<BaseStoredPaymentMethod>;
};

export type PaymentApiControllerPromoteStoredPaymentMethodToPeriodicChargeResponse = PaymentApiControllerPromoteStoredPaymentMethodToPeriodicChargeResponses[keyof PaymentApiControllerPromoteStoredPaymentMethodToPeriodicChargeResponses];

export type PaymentTerminalsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        order?: Order;
        page?: number;
        query?: string;
        stationIds?: Array<string>;
        sort?: Array<FindAllPaymentTerminalsSort>;
        limit?: number;
    };
    url: '/v1/payment-terminals';
};

export type PaymentTerminalsControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationPaymentTerminalPaginationMeta;
};

export type PaymentTerminalsControllerFindAllResponse = PaymentTerminalsControllerFindAllResponses[keyof PaymentTerminalsControllerFindAllResponses];

export type PaymentTerminalsControllerCreateData = {
    body: CreatePaymentTerminalDto;
    path?: never;
    query?: never;
    url: '/v1/payment-terminals';
};

export type PaymentTerminalsControllerCreateResponses = {
    /**
     * Created
     */
    201: PaymentTerminal | null;
};

export type PaymentTerminalsControllerCreateResponse = PaymentTerminalsControllerCreateResponses[keyof PaymentTerminalsControllerCreateResponses];

export type PaymentTerminalsControllerChargeCreditCardData = {
    body: ChargeCreditCardDto;
    path?: never;
    query?: never;
    url: '/v1/payment-terminals/charge-credit-card';
};

export type PaymentTerminalsControllerChargeCreditCardResponses = {
    /**
     * Created
     */
    201: ChargeCreditCardResponseDto;
};

export type PaymentTerminalsControllerChargeCreditCardResponse = PaymentTerminalsControllerChargeCreditCardResponses[keyof PaymentTerminalsControllerChargeCreditCardResponses];

export type PaymentTerminalsControllerNotificationFromTerminalData = {
    body: ComputopNotifyDto;
    path?: never;
    query?: never;
    url: '/v1/payment-terminals/computop-notify';
};

export type PaymentTerminalsControllerNotificationFromTerminalResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PaymentTerminalsControllerNotificationFromTerminalResponse = PaymentTerminalsControllerNotificationFromTerminalResponses[keyof PaymentTerminalsControllerNotificationFromTerminalResponses];

export type PaymentTerminalsControllerPaymentNotificationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/payment-terminals/payment-notification';
};

export type PaymentTerminalsControllerPaymentNotificationResponses = {
    /**
     * Server-Sent Events stream
     */
    200: unknown;
};

export type PaymentTerminalsControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/payment-terminals/{id}';
};

export type PaymentTerminalsControllerRemoveResponses = {
    /**
     * No Content
     */
    204: DeleteResult;
};

export type PaymentTerminalsControllerRemoveResponse = PaymentTerminalsControllerRemoveResponses[keyof PaymentTerminalsControllerRemoveResponses];

export type PaymentTerminalsControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/payment-terminals/{id}';
};

export type PaymentTerminalsControllerFindOneResponses = {
    /**
     * OK
     */
    200: PaymentTerminal;
};

export type PaymentTerminalsControllerFindOneResponse = PaymentTerminalsControllerFindOneResponses[keyof PaymentTerminalsControllerFindOneResponses];

export type PaymentTerminalsControllerUpdateData = {
    body: UpdatePaymentTerminalDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/payment-terminals/{id}';
};

export type PaymentTerminalsControllerUpdateResponses = {
    /**
     * OK
     */
    200: PaymentTerminal;
};

export type PaymentTerminalsControllerUpdateResponse = PaymentTerminalsControllerUpdateResponses[keyof PaymentTerminalsControllerUpdateResponses];

export type PaymentsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        bookingIds?: Array<string>;
        counterpartyType?: Array<CounterpartyType>;
        createdDateAfter?: Date;
        createdDateBefore?: Date;
        invoiceIds?: Array<string>;
        legalEntityIds?: Array<string>;
        paymentType?: Array<PaymentType>;
        status?: Array<PaymentStatus>;
        order?: Order;
        sort?: Array<FindAllPaymentsSort>;
        limit?: number;
        page?: number;
    };
    url: '/v1/payments';
};

export type PaymentsControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationPaymentPaginationMeta2;
};

export type PaymentsControllerFindAllResponse = PaymentsControllerFindAllResponses[keyof PaymentsControllerFindAllResponses];

export type PaymentsControllerCreateData = {
    body: CreatePaymentDtoWritable;
    path?: never;
    query?: never;
    url: '/v1/payments';
};

export type PaymentsControllerCreateResponses = {
    /**
     * Created
     */
    201: Payment | null;
};

export type PaymentsControllerCreateResponse = PaymentsControllerCreateResponses[keyof PaymentsControllerCreateResponses];

export type PaymentsControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/payments/{id}';
};

export type PaymentsControllerRemoveResponses = {
    /**
     * No Content
     */
    204: DeleteResult;
};

export type PaymentsControllerRemoveResponse = PaymentsControllerRemoveResponses[keyof PaymentsControllerRemoveResponses];

export type PaymentsControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/payments/{id}';
};

export type PaymentsControllerFindOneResponses = {
    /**
     * OK
     */
    200: Payment;
};

export type PaymentsControllerFindOneResponse = PaymentsControllerFindOneResponses[keyof PaymentsControllerFindOneResponses];

export type PaymentsControllerUpdateData = {
    body: UpdatePaymentDtoWritable;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/payments/{id}';
};

export type PaymentsControllerUpdateResponses = {
    /**
     * OK
     */
    200: Payment | null;
};

export type PaymentsControllerUpdateResponse = PaymentsControllerUpdateResponses[keyof PaymentsControllerUpdateResponses];

export type PaymentsControllerRefundUnallocatedPaymentAmountData = {
    body: RefundUnallocatedPaymentAmountDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/payments/{id}/refund-unallocated-payment-amount';
};

export type PaymentsControllerRefundUnallocatedPaymentAmountResponses = {
    /**
     * Created
     */
    201: RefundUnallocatedPaymentAmountResponseDto;
};

export type PaymentsControllerRefundUnallocatedPaymentAmountResponse = PaymentsControllerRefundUnallocatedPaymentAmountResponses[keyof PaymentsControllerRefundUnallocatedPaymentAmountResponses];

export type PhoneControllerDialData = {
    body: DialDto;
    path?: never;
    query?: never;
    url: '/v1/phone/dial';
};

export type PhoneControllerDialResponses = {
    /**
     * Created
     */
    201: {
        status: 'OK';
    } | {
        message: string;
        status: 'ERROR';
    };
};

export type PhoneControllerDialResponse = PhoneControllerDialResponses[keyof PhoneControllerDialResponses];

export type PhoneControllerEventsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/phone/events';
};

export type PhoneControllerEventsResponses = {
    /**
     * Server-Sent Events stream
     */
    200: unknown;
};

export type PhoneControllerRecentData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/phone/recent';
};

export type PhoneControllerRecentResponses = {
    /**
     * OK
     */
    200: Array<CallDto>;
};

export type PhoneControllerRecentResponse = PhoneControllerRecentResponses[keyof PhoneControllerRecentResponses];

export type PhoneControllerSendBookingLinkData = {
    body: SendBookingLinkDto;
    path?: never;
    query?: never;
    url: '/v1/phone/send-booking-link';
};

export type PhoneControllerSendBookingLinkResponses = {
    /**
     * Booking link sent
     */
    200: {
        status: 'OK';
    };
};

export type PhoneControllerSendBookingLinkResponse = PhoneControllerSendBookingLinkResponses[keyof PhoneControllerSendBookingLinkResponses];

export type PhoneControllerGetUserAndBookingDataByPhoneData = {
    body?: never;
    path?: never;
    query: {
        phone: string;
    };
    url: '/v1/phone/user-and-booking-data';
};

export type PhoneControllerGetUserAndBookingDataByPhoneResponses = {
    /**
     * OK
     */
    200: UserAndBookingDataDto;
};

export type PhoneControllerGetUserAndBookingDataByPhoneResponse = PhoneControllerGetUserAndBookingDataByPhoneResponses[keyof PhoneControllerGetUserAndBookingDataByPhoneResponses];

export type PlacetelControllerWebhookData = {
    body?: never;
    headers: {
        'x-placetel-signature': string;
    };
    path?: never;
    query?: never;
    url: '/v1/placetel/webhook';
};

export type PlacetelControllerWebhookResponses = {
    /**
     * Created
     */
    201: unknown;
};

export type PricingModifiersControllerCreateData = {
    body: CreatePricingModifiersDto;
    path?: never;
    query?: never;
    url: '/v1/pricing-modifiers';
};

export type PricingModifiersControllerCreateResponses = {
    /**
     * Created
     */
    201: PricingModifiers | null;
};

export type PricingModifiersControllerCreateResponse = PricingModifiersControllerCreateResponses[keyof PricingModifiersControllerCreateResponses];

export type PricingModifiersControllerCalculateExampleData = {
    body: CalculateExampleDto;
    path?: never;
    query?: never;
    url: '/v1/pricing-modifiers/calculate-example';
};

export type PricingModifiersControllerCalculateExampleResponses = {
    /**
     * Created
     */
    201: ExampleCalculationDto;
};

export type PricingModifiersControllerCalculateExampleResponse = PricingModifiersControllerCalculateExampleResponses[keyof PricingModifiersControllerCalculateExampleResponses];

export type PricingModifiersControllerFindLatestData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/pricing-modifiers/latest';
};

export type PricingModifiersControllerFindLatestResponses = {
    /**
     * OK
     */
    200: PricingModifiers | null;
};

export type PricingModifiersControllerFindLatestResponse = PricingModifiersControllerFindLatestResponses[keyof PricingModifiersControllerFindLatestResponses];

export type PricingModifiersControllerFindOneData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/v1/pricing-modifiers/{id}';
};

export type PricingModifiersControllerFindOneResponses = {
    /**
     * OK
     */
    200: PricingModifiers | null;
};

export type PricingModifiersControllerFindOneResponse = PricingModifiersControllerFindOneResponses[keyof PricingModifiersControllerFindOneResponses];

export type PricingControllerRequestAdditionalCostsData = {
    body: RequestAdditionalCostsDto;
    path?: never;
    query?: never;
    url: '/v1/pricing/additional-costs';
};

export type PricingControllerRequestAdditionalCostsResponses = {
    /**
     * Created
     */
    201: AdditionalCostsDto | null;
};

export type PricingControllerRequestAdditionalCostsResponse = PricingControllerRequestAdditionalCostsResponses[keyof PricingControllerRequestAdditionalCostsResponses];

export type QueueInspectorControllerGetAvailableQueuesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/queue-inspector/queues';
};

export type QueueInspectorControllerGetAvailableQueuesResponses = {
    /**
     * List of available queue names
     */
    200: Array<string>;
};

export type QueueInspectorControllerGetAvailableQueuesResponse = QueueInspectorControllerGetAvailableQueuesResponses[keyof QueueInspectorControllerGetAvailableQueuesResponses];

export type QueueInspectorControllerGetQueueJobsData = {
    body?: never;
    path: {
        queueName: string;
    };
    query?: {
        order?: Order;
        sort?: Array<{
            [key: string]: unknown;
        }>;
        limit?: number;
        page?: number;
        status?: Array<QueueJobStatus>;
    };
    url: '/v1/queue-inspector/queues/{queueName}/jobs';
};

export type QueueInspectorControllerGetQueueJobsResponses = {
    /**
     * OK
     */
    200: PaginationJobDtoPaginationMeta;
};

export type QueueInspectorControllerGetQueueJobsResponse = QueueInspectorControllerGetQueueJobsResponses[keyof QueueInspectorControllerGetQueueJobsResponses];

export type QueueInspectorControllerDeleteJobData = {
    body?: never;
    path: {
        queueName: string;
        jobId: string;
    };
    query?: never;
    url: '/v1/queue-inspector/queues/{queueName}/jobs/{jobId}';
};

export type QueueInspectorControllerDeleteJobResponses = {
    /**
     * Job deleted successfully
     */
    200: unknown;
};

export type QueueInspectorControllerGetJobLogsData = {
    body?: never;
    path: {
        queueName: string;
        jobId: string;
    };
    query?: never;
    url: '/v1/queue-inspector/queues/{queueName}/jobs/{jobId}/logs';
};

export type QueueInspectorControllerGetJobLogsResponses = {
    /**
     * Job logs
     */
    200: Array<string>;
};

export type QueueInspectorControllerGetJobLogsResponse = QueueInspectorControllerGetJobLogsResponses[keyof QueueInspectorControllerGetJobLogsResponses];

export type QueueInspectorControllerRetryJobData = {
    body?: never;
    path: {
        queueName: string;
        jobId: string;
    };
    query?: never;
    url: '/v1/queue-inspector/queues/{queueName}/jobs/{jobId}/retry';
};

export type QueueInspectorControllerRetryJobResponses = {
    /**
     * Job retry initiated successfully
     */
    200: unknown;
};

export type QueueInspectorControllerGetQueueStatsData = {
    body?: never;
    path: {
        queueName: string;
    };
    query?: never;
    url: '/v1/queue-inspector/queues/{queueName}/stats';
};

export type QueueInspectorControllerGetQueueStatsResponses = {
    /**
     * Queue statistics
     */
    200: QueueStatsDto;
};

export type QueueInspectorControllerGetQueueStatsResponse = QueueInspectorControllerGetQueueStatsResponses[keyof QueueInspectorControllerGetQueueStatsResponses];

export type ReceivablesControllerGetDownpaymentsData = {
    body?: never;
    path?: never;
    query?: {
        hasPeriodicInvoicing?: boolean;
        isDeposit?: boolean;
        legalEntityId?: string;
        search?: string;
    };
    url: '/v1/receivables/downpayments';
};

export type ReceivablesControllerGetDownpaymentsResponses = {
    /**
     * OK
     */
    200: ReceivablesDownpaymentsDto;
};

export type ReceivablesControllerGetDownpaymentsResponse = ReceivablesControllerGetDownpaymentsResponses[keyof ReceivablesControllerGetDownpaymentsResponses];

export type ReceivablesControllerGetItemsData = {
    body?: never;
    path?: never;
    query: {
        dueDays: number;
        hasPeriodicInvoicing?: boolean;
        invoiceTypes?: Array<string>;
        isCredit?: boolean;
        isDeposit?: boolean;
        legalEntityId?: string;
        search?: string;
    };
    url: '/v1/receivables/items';
};

export type ReceivablesControllerGetItemsResponses = {
    /**
     * OK
     */
    200: ReceivablesItemsDto;
};

export type ReceivablesControllerGetItemsResponse = ReceivablesControllerGetItemsResponses[keyof ReceivablesControllerGetItemsResponses];

export type ReceivablesControllerGetProblemsData = {
    body?: never;
    path?: never;
    query?: {
        legalEntityId?: string;
    };
    url: '/v1/receivables/problems';
};

export type ReceivablesControllerGetProblemsResponses = {
    /**
     * OK
     */
    200: ReceivablesProblemsDto;
};

export type ReceivablesControllerGetProblemsResponse = ReceivablesControllerGetProblemsResponses[keyof ReceivablesControllerGetProblemsResponses];

export type ReceivablesControllerGetSummaryData = {
    body?: never;
    path?: never;
    query?: {
        hasPeriodicInvoicing?: boolean;
        invoiceTypes?: Array<string>;
        isDeposit?: boolean;
        legalEntityId?: string;
        search?: string;
    };
    url: '/v1/receivables/summary';
};

export type ReceivablesControllerGetSummaryResponses = {
    /**
     * OK
     */
    200: ReceivablesSummaryDto;
};

export type ReceivablesControllerGetSummaryResponse = ReceivablesControllerGetSummaryResponses[keyof ReceivablesControllerGetSummaryResponses];

export type ReceivablesControllerGetWriteOffsData = {
    body?: never;
    path?: never;
    query: {
        dateAfter: Date;
        dateBefore: Date;
        legalEntityId?: string;
    };
    url: '/v1/receivables/write-offs';
};

export type ReceivablesControllerGetWriteOffsResponses = {
    /**
     * OK
     */
    200: ReceivablesWriteOffsDto;
};

export type ReceivablesControllerGetWriteOffsResponse = ReceivablesControllerGetWriteOffsResponses[keyof ReceivablesControllerGetWriteOffsResponses];

export type ReceivablesControllerExportWriteOffsData = {
    body?: never;
    path?: never;
    query: {
        dateAfter: Date;
        dateBefore: Date;
        legalEntityId?: string;
    };
    url: '/v1/receivables/write-offs/export';
};

export type ReceivablesControllerExportWriteOffsResponses = {
    /**
     * OK
     */
    200: string;
};

export type ReceivablesControllerExportWriteOffsResponse = ReceivablesControllerExportWriteOffsResponses[keyof ReceivablesControllerExportWriteOffsResponses];

export type AppControllerReloadFeatureFlagsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/reload-feature-flags';
};

export type AppControllerReloadFeatureFlagsResponses = {
    /**
     * Created
     */
    201: string;
};

export type AppControllerReloadFeatureFlagsResponse = AppControllerReloadFeatureFlagsResponses[keyof AppControllerReloadFeatureFlagsResponses];

export type RentalKeyTagMockControllerMockRegisterData = {
    body: RentalKeyTagBookingIdDto;
    path?: never;
    query?: never;
    url: '/v1/rental-key-tag/mock/register';
};

export type RentalKeyTagMockControllerMockRegisterResponses = {
    /**
     * Created
     */
    201: {
        registration: RentalKeyTagRegisteredDto;
        sdmKey: string;
        tagUid: string;
    };
};

export type RentalKeyTagMockControllerMockRegisterResponse = RentalKeyTagMockControllerMockRegisterResponses[keyof RentalKeyTagMockControllerMockRegisterResponses];

export type RentalKeyTagMockControllerListMockTapUrlsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/rental-key-tag/mock/tap-urls';
};

export type RentalKeyTagMockControllerListMockTapUrlsResponses = {
    /**
     * OK
     */
    200: Array<{
        bookingId: string;
        bookingNumber: string | null;
        bookingStatus: string | null;
        counter: string | null;
        tagUid: string;
        tapUnavailableReason: string | null;
        tapUrl: string | null;
    }>;
};

export type RentalKeyTagMockControllerListMockTapUrlsResponse = RentalKeyTagMockControllerListMockTapUrlsResponses[keyof RentalKeyTagMockControllerListMockTapUrlsResponses];

export type RentalKeyTagControllerPrepareData = {
    body: RentalKeyTagBookingIdDto;
    path?: never;
    query?: never;
    url: '/v1/rental-key-tag/prepare';
};

export type RentalKeyTagControllerPrepareResponses = {
    /**
     * Created
     */
    201: RentalKeyTagPrepareDto;
};

export type RentalKeyTagControllerPrepareResponse = RentalKeyTagControllerPrepareResponses[keyof RentalKeyTagControllerPrepareResponses];

export type RentalKeyTagControllerRedeemData = {
    body: RedeemRentalKeyTagCodeDto;
    path?: never;
    query?: never;
    url: '/v1/rental-key-tag/redeem';
};

export type RentalKeyTagControllerRedeemResponses = {
    /**
     * Created
     */
    201: unknown;
};

export type RentalKeyTagControllerRegisterData = {
    body: RegisterRentalKeyTagDto;
    path?: never;
    query?: never;
    url: '/v1/rental-key-tag/register';
};

export type RentalKeyTagControllerRegisterResponses = {
    /**
     * Created
     */
    201: RentalKeyTagRegisteredDto;
};

export type RentalKeyTagControllerRegisterResponse = RentalKeyTagControllerRegisterResponses[keyof RentalKeyTagControllerRegisterResponses];

export type RentalKeyTagControllerRequestEditCodeData = {
    body: RentalKeyTagBookingIdDto;
    path?: never;
    query?: never;
    url: '/v1/rental-key-tag/request-edit-code';
};

export type RentalKeyTagControllerRequestEditCodeResponses = {
    /**
     * Created
     */
    201: {
        maskedEmail: string;
    };
};

export type RentalKeyTagControllerRequestEditCodeResponse = RentalKeyTagControllerRequestEditCodeResponses[keyof RentalKeyTagControllerRequestEditCodeResponses];

export type RentalKeyTagControllerSdmKeyData = {
    body: RentalKeyTagUidDto;
    path?: never;
    query?: never;
    url: '/v1/rental-key-tag/sdm-key';
};

export type RentalKeyTagControllerSdmKeyResponses = {
    /**
     * Created
     */
    201: RentalKeyTagSdmKeyDto;
};

export type RentalKeyTagControllerSdmKeyResponse = RentalKeyTagControllerSdmKeyResponses[keyof RentalKeyTagControllerSdmKeyResponses];

export type RentalKeyTagControllerSendLinkData = {
    body: SendRentalKeyLinkDto;
    path?: never;
    query?: never;
    url: '/v1/rental-key-tag/send-link';
};

export type RentalKeyTagControllerSendLinkResponses = {
    /**
     * OK
     */
    200: RentalKeyTagLinkDto;
};

export type RentalKeyTagControllerSendLinkResponse = RentalKeyTagControllerSendLinkResponses[keyof RentalKeyTagControllerSendLinkResponses];

export type RentalKeyTagControllerStatusData = {
    body?: never;
    path: {
        bookingId: string;
    };
    query?: never;
    url: '/v1/rental-key-tag/status/{bookingId}';
};

export type RentalKeyTagControllerStatusResponses = {
    /**
     * OK
     */
    200: RentalKeyTagStatusDto;
};

export type RentalKeyTagControllerStatusResponse = RentalKeyTagControllerStatusResponses[keyof RentalKeyTagControllerStatusResponses];

export type RentalKeyTagControllerSummaryData = {
    body?: never;
    path: {
        bookingId: string;
    };
    query?: never;
    url: '/v1/rental-key-tag/summary/{bookingId}';
};

export type RentalKeyTagControllerSummaryResponses = {
    /**
     * OK
     */
    200: RentalKeyTagSummaryDto;
};

export type RentalKeyTagControllerSummaryResponse = RentalKeyTagControllerSummaryResponses[keyof RentalKeyTagControllerSummaryResponses];

export type ReviewsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        sort?: Array<FindAllReviewsSort>;
        bookingIds?: Array<string>;
        endDate?: Date;
        rating?: number | null;
        startDate?: Date;
        status?: Array<ReviewStatus>;
        targetEmployeeIds?: Array<string>;
        targetTypes?: Array<'HANDOVER'>;
        order?: Order;
        limit?: number;
        page?: number;
    };
    url: '/v1/reviews';
};

export type ReviewsControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationReviewPaginationMeta;
};

export type ReviewsControllerFindAllResponse = ReviewsControllerFindAllResponses[keyof ReviewsControllerFindAllResponses];

export type ReviewsControllerCreateData = {
    body: CreateReviewDto;
    path?: never;
    query?: never;
    url: '/v1/reviews';
};

export type ReviewsControllerCreateResponses = {
    /**
     * Created
     */
    201: Review | null;
};

export type ReviewsControllerCreateResponse = ReviewsControllerCreateResponses[keyof ReviewsControllerCreateResponses];

export type ReviewsControllerCompleteData = {
    body: CompleteReviewDto;
    path: {
        id: string;
    };
    query: {
        secretCompletionToken: string;
    };
    url: '/v1/reviews/{id}/complete';
};

export type ReviewsControllerCompleteResponses = {
    /**
     * No Content
     */
    204: void;
};

export type ReviewsControllerCompleteResponse = ReviewsControllerCompleteResponses[keyof ReviewsControllerCompleteResponses];

export type ReviewsControllerGetEmployeeReviewData = {
    body?: never;
    path: {
        id: string;
    };
    query: {
        secretCompletionToken: string;
    };
    url: '/v1/reviews/{id}/completion-screen';
};

export type ReviewsControllerGetEmployeeReviewResponses = {
    /**
     * OK
     */
    200: ReviewCompletionScreenDto;
};

export type ReviewsControllerGetEmployeeReviewResponse = ReviewsControllerGetEmployeeReviewResponses[keyof ReviewsControllerGetEmployeeReviewResponses];

export type SearchControllerSearchData = {
    body?: never;
    path?: never;
    query: {
        q: string;
    };
    url: '/v1/search';
};

export type SearchControllerSearchResponses = {
    /**
     * OK
     */
    200: GlobalSearchResponseDto;
};

export type SearchControllerSearchResponse = SearchControllerSearchResponses[keyof SearchControllerSearchResponses];

export type SettlementControllerGetProcessedBatchesData = {
    body?: never;
    path?: never;
    query?: {
        legalEntityId?: string;
        order?: Order;
        sort?: Array<{
            [key: string]: unknown;
        }>;
        limit?: number;
        page?: number;
    };
    url: '/v1/settlement/batches';
};

export type SettlementControllerGetProcessedBatchesResponses = {
    /**
     * OK
     */
    200: PaginationSettlementBatchListItemDtoPaginationMeta;
};

export type SettlementControllerGetProcessedBatchesResponse = SettlementControllerGetProcessedBatchesResponses[keyof SettlementControllerGetProcessedBatchesResponses];

export type SettlementControllerGetProcessedBatchData = {
    body?: never;
    path: {
        batchId: string;
    };
    query?: never;
    url: '/v1/settlement/batches/{batchId}';
};

export type SettlementControllerGetProcessedBatchResponses = {
    /**
     * OK
     */
    200: SettlementBatchListItemDto;
};

export type SettlementControllerGetProcessedBatchResponse = SettlementControllerGetProcessedBatchResponses[keyof SettlementControllerGetProcessedBatchResponses];

export type SettlementControllerGetBatchDetailsData = {
    body?: never;
    path: {
        batchId: string;
    };
    query?: never;
    url: '/v1/settlement/batches/{batchId}/details';
};

export type SettlementControllerGetBatchDetailsResponses = {
    /**
     * OK
     */
    200: SettlementBatchDetailsDto;
};

export type SettlementControllerGetBatchDetailsResponse = SettlementControllerGetBatchDetailsResponses[keyof SettlementControllerGetBatchDetailsResponses];

export type SettlementControllerGetCashFlowOverviewData = {
    body?: never;
    path?: never;
    query?: {
        legalEntityId?: string;
    };
    url: '/v1/settlement/cash-flow';
};

export type SettlementControllerGetCashFlowOverviewResponses = {
    /**
     * OK
     */
    200: SettlementCashFlowOverviewDto;
};

export type SettlementControllerGetCashFlowOverviewResponse = SettlementControllerGetCashFlowOverviewResponses[keyof SettlementControllerGetCashFlowOverviewResponses];

export type SettlementControllerAssignPaymentData = {
    body: AssignSettlementPaymentDto;
    path: {
        detailId: string;
    };
    query?: never;
    url: '/v1/settlement/details/{detailId}/assign';
};

export type SettlementControllerAssignPaymentResponses = {
    /**
     * OK
     */
    200: SettlementDetailLineDto;
};

export type SettlementControllerAssignPaymentResponse = SettlementControllerAssignPaymentResponses[keyof SettlementControllerAssignPaymentResponses];

export type SettlementControllerGetPaymentCandidatesData = {
    body?: never;
    path?: never;
    query: {
        detailId: string;
        q?: string;
        order?: Order;
        sort?: Array<{
            [key: string]: unknown;
        }>;
        limit?: number;
        page?: number;
    };
    url: '/v1/settlement/payment-candidates';
};

export type SettlementControllerGetPaymentCandidatesResponses = {
    /**
     * OK
     */
    200: PaginationPaymentPaginationMeta;
};

export type SettlementControllerGetPaymentCandidatesResponse = SettlementControllerGetPaymentCandidatesResponses[keyof SettlementControllerGetPaymentCandidatesResponses];

export type SettlementControllerGetUnsettledPaymentsData = {
    body?: never;
    path?: never;
    query?: {
        legalEntityId?: string;
        q?: string;
        order?: Order;
        sort?: Array<{
            [key: string]: unknown;
        }>;
        limit?: number;
        page?: number;
    };
    url: '/v1/settlement/unsettled-payments';
};

export type SettlementControllerGetUnsettledPaymentsResponses = {
    /**
     * OK
     */
    200: PaginationPaymentPaginationMeta;
};

export type SettlementControllerGetUnsettledPaymentsResponse = SettlementControllerGetUnsettledPaymentsResponses[keyof SettlementControllerGetUnsettledPaymentsResponses];

export type StationsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        order?: Order;
        sort?: Array<FindAllStationsSort>;
        limit?: number;
        page?: number;
        addHolidays?: boolean | null;
        isHidden?: boolean;
        isInternal?: boolean;
        query?: string | null;
        stationIds?: Array<string>;
    };
    url: '/v1/stations';
};

export type StationsControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationStationPaginationMeta;
};

export type StationsControllerFindAllResponse = StationsControllerFindAllResponses[keyof StationsControllerFindAllResponses];

export type StationsControllerCreateData = {
    body: CreateStationDto;
    path?: never;
    query?: never;
    url: '/v1/stations';
};

export type StationsControllerCreateResponses = {
    /**
     * Created
     */
    201: Station | null;
};

export type StationsControllerCreateResponse = StationsControllerCreateResponses[keyof StationsControllerCreateResponses];

export type StationsControllerGetAvailableHolidaysData = {
    body?: never;
    path?: never;
    query: {
        countryCode: string;
        state?: string;
    };
    url: '/v1/stations/available-holidays';
};

export type StationsControllerGetAvailableHolidaysResponses = {
    /**
     * OK
     */
    200: Array<AvailableHolidayRuleDto>;
};

export type StationsControllerGetAvailableHolidaysResponse = StationsControllerGetAvailableHolidaysResponses[keyof StationsControllerGetAvailableHolidaysResponses];

export type StationsControllerGetHolidaySubdivisionsData = {
    body?: never;
    path?: never;
    query: {
        countryCode: string;
        lang?: string;
    };
    url: '/v1/stations/holiday-subdivisions';
};

export type StationsControllerGetHolidaySubdivisionsResponses = {
    /**
     * OK
     */
    200: Array<HolidaySubdivisionDto>;
};

export type StationsControllerGetHolidaySubdivisionsResponse = StationsControllerGetHolidaySubdivisionsResponses[keyof StationsControllerGetHolidaySubdivisionsResponses];

export type StationsControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/stations/{id}';
};

export type StationsControllerRemoveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type StationsControllerRemoveResponse = StationsControllerRemoveResponses[keyof StationsControllerRemoveResponses];

export type StationsControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        addHolidays?: boolean | null;
    };
    url: '/v1/stations/{id}';
};

export type StationsControllerFindOneResponses = {
    /**
     * OK
     */
    200: Station;
};

export type StationsControllerFindOneResponse = StationsControllerFindOneResponses[keyof StationsControllerFindOneResponses];

export type StationsControllerUpdateData = {
    body: UpdateStationDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/stations/{id}';
};

export type StationsControllerUpdateResponses = {
    /**
     * OK
     */
    200: Station | null;
};

export type StationsControllerUpdateResponse = StationsControllerUpdateResponses[keyof StationsControllerUpdateResponses];

export type SurveyQuestionsControllerUpdateData = {
    body: UpdateSurveyQuestionDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/survey-questions/{id}';
};

export type SurveyQuestionsControllerUpdateResponses = {
    /**
     * OK
     */
    200: SurveyQuestion | null;
};

export type SurveyQuestionsControllerUpdateResponse = SurveyQuestionsControllerUpdateResponses[keyof SurveyQuestionsControllerUpdateResponses];

export type SurveysControllerFindAllData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/surveys';
};

export type SurveysControllerFindAllResponses = {
    /**
     * OK
     */
    200: Array<Survey>;
};

export type SurveysControllerFindAllResponse = SurveysControllerFindAllResponses[keyof SurveysControllerFindAllResponses];

export type SurveysControllerCreateData = {
    body: CreateSurveyDto;
    path?: never;
    query?: never;
    url: '/v1/surveys';
};

export type SurveysControllerCreateResponses = {
    /**
     * Created
     */
    201: Survey | null;
};

export type SurveysControllerCreateResponse = SurveysControllerCreateResponses[keyof SurveysControllerCreateResponses];

export type SurveysConductedControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        filter?: Array<FindAllSurveysConductedFilterDto>;
        order?: Order;
        sort?: Array<FindAllSurveysConductedSort>;
        limit?: number;
        page?: number;
    };
    url: '/v1/surveys-conducted';
};

export type SurveysConductedControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationSurveyConductedPaginationMeta;
};

export type SurveysConductedControllerFindAllResponse = SurveysConductedControllerFindAllResponses[keyof SurveysConductedControllerFindAllResponses];

export type SurveysConductedControllerCreateData = {
    body: CreateSurveyConductedDto;
    path?: never;
    query?: never;
    url: '/v1/surveys-conducted';
};

export type SurveysConductedControllerCreateResponses = {
    /**
     * Created
     */
    201: SurveyConducted | null;
};

export type SurveysConductedControllerCreateResponse = SurveysConductedControllerCreateResponses[keyof SurveysConductedControllerCreateResponses];

export type SurveysConductedControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/surveys-conducted/{id}';
};

export type SurveysConductedControllerFindOneResponses = {
    /**
     * OK
     */
    200: SurveyConducted | null;
};

export type SurveysConductedControllerFindOneResponse = SurveysConductedControllerFindOneResponses[keyof SurveysConductedControllerFindOneResponses];

export type SurveysControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/surveys/{id}';
};

export type SurveysControllerFindOneResponses = {
    /**
     * OK
     */
    200: Survey | null;
};

export type SurveysControllerFindOneResponse = SurveysControllerFindOneResponses[keyof SurveysControllerFindOneResponses];

export type SurveysControllerUpdateData = {
    body: UpdateSurveyDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/surveys/{id}';
};

export type SurveysControllerUpdateResponses = {
    /**
     * OK
     */
    200: Survey | null;
};

export type SurveysControllerUpdateResponse = SurveysControllerUpdateResponses[keyof SurveysControllerUpdateResponses];

export type SurveysControllerExportData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/surveys/{id}/export';
};

export type SurveysControllerExportResponses = {
    /**
     * Created
     */
    201: string;
};

export type SurveysControllerExportResponse = SurveysControllerExportResponses[keyof SurveysControllerExportResponses];

export type TestInfringementsControllerCreateData = {
    body: CreateTestInfringementDto;
    path?: never;
    query?: never;
    url: '/v1/test-infringements';
};

export type TestInfringementsControllerCreateResponses = {
    /**
     * Created
     */
    201: Infringement;
};

export type TestInfringementsControllerCreateResponse = TestInfringementsControllerCreateResponses[keyof TestInfringementsControllerCreateResponses];

export type TestQueueControllerWaitForJobData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/test-queue/job/{id}/wait';
};

export type TestQueueControllerWaitForJobResponses = {
    /**
     * OK
     */
    200: {
        error: string;
    } | {
        here: 1;
        id: string;
        result: unknown;
        state: unknown;
    } | {
        failedReason: string;
        id: string;
        state: unknown;
    };
};

export type TestQueueControllerWaitForJobResponse = TestQueueControllerWaitForJobResponses[keyof TestQueueControllerWaitForJobResponses];

export type TestQueueControllerAddJobData = {
    body: unknown;
    path: {
        jobType: TestQueueJobType;
    };
    query?: never;
    url: '/v1/test-queue/{jobType}';
};

export type TestQueueControllerAddJobResponses = {
    /**
     * Created
     */
    201: {
        jobId: string;
        name: string;
    };
};

export type TestQueueControllerAddJobResponse = TestQueueControllerAddJobResponses[keyof TestQueueControllerAddJobResponses];

export type TimeTrackingControllerListActiveEntriesData = {
    body?: never;
    path?: never;
    query?: {
        agencyTypes?: Array<AgencyType>;
        hasSipId?: boolean;
        hasStaffomaticUserId?: boolean;
        isEmailConfirmed?: boolean;
        partnerSubTypeId?: string;
        query?: string;
        role?: Array<UserRole>;
        stationIds?: Array<string>;
    };
    url: '/v1/time-tracking/active-entries';
};

export type TimeTrackingControllerListActiveEntriesResponses = {
    /**
     * OK
     */
    200: Array<TimeTrackingEntry>;
};

export type TimeTrackingControllerListActiveEntriesResponse = TimeTrackingControllerListActiveEntriesResponses[keyof TimeTrackingControllerListActiveEntriesResponses];

export type TimeTrackingControllerGetMyActiveEntryData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/time-tracking/active-entry/me';
};

export type TimeTrackingControllerGetMyActiveEntryResponses = {
    /**
     * OK
     */
    200: TimeTrackingEntry | null;
};

export type TimeTrackingControllerGetMyActiveEntryResponse = TimeTrackingControllerGetMyActiveEntryResponses[keyof TimeTrackingControllerGetMyActiveEntryResponses];

export type TimeTrackingControllerClockInMyActiveEntryData = {
    body: ClockInDto;
    path?: never;
    query?: never;
    url: '/v1/time-tracking/active-entry/me/clock-in';
};

export type TimeTrackingControllerClockInMyActiveEntryResponses = {
    /**
     * OK
     */
    200: {
        clockedIn: true;
    };
};

export type TimeTrackingControllerClockInMyActiveEntryResponse = TimeTrackingControllerClockInMyActiveEntryResponses[keyof TimeTrackingControllerClockInMyActiveEntryResponses];

export type TimeTrackingControllerClockOutMyActiveEntryData = {
    body: ClockOutDto;
    path?: never;
    query?: never;
    url: '/v1/time-tracking/active-entry/me/clock-out';
};

export type TimeTrackingControllerClockOutMyActiveEntryResponses = {
    /**
     * OK
     */
    200: {
        clockedOut: true;
    };
};

export type TimeTrackingControllerClockOutMyActiveEntryResponse = TimeTrackingControllerClockOutMyActiveEntryResponses[keyof TimeTrackingControllerClockOutMyActiveEntryResponses];

export type TimeTrackingControllerValidateLocationData = {
    body: LocationDto;
    path?: never;
    query?: never;
    url: '/v1/time-tracking/validate-location';
};

export type TimeTrackingControllerValidateLocationResponses = {
    /**
     * OK
     */
    200: ValidateLocationResponseDto;
};

export type TimeTrackingControllerValidateLocationResponse = TimeTrackingControllerValidateLocationResponses[keyof TimeTrackingControllerValidateLocationResponses];

export type UploadControllerGetCarDocumentUploadUrlData = {
    body?: never;
    path?: never;
    query: {
        carId: string;
        fileName: string;
    };
    url: '/v1/uploads/upload-url/car-document';
};

export type UploadControllerGetCarDocumentUploadUrlResponses = {
    /**
     * OK
     */
    200: GetPresignedUploadUrlResponse;
};

export type UploadControllerGetCarDocumentUploadUrlResponse = UploadControllerGetCarDocumentUploadUrlResponses[keyof UploadControllerGetCarDocumentUploadUrlResponses];

export type UploadControllerGetCarImageUploadUrlData = {
    body?: never;
    path?: never;
    query: {
        carId: string;
        originalFileName: string;
    };
    url: '/v1/uploads/upload-url/car-image';
};

export type UploadControllerGetCarImageUploadUrlResponses = {
    /**
     * OK
     */
    200: GetPresignedUploadUrlResponse;
};

export type UploadControllerGetCarImageUploadUrlResponse = UploadControllerGetCarImageUploadUrlResponses[keyof UploadControllerGetCarImageUploadUrlResponses];

export type UploadControllerGetCleaningFeeUploadUrlData = {
    body?: never;
    path?: never;
    query: {
        bookingId: string;
    };
    url: '/v1/uploads/upload-url/cleaning-fee';
};

export type UploadControllerGetCleaningFeeUploadUrlResponses = {
    /**
     * OK
     */
    200: GetPresignedUploadUrlResponse;
};

export type UploadControllerGetCleaningFeeUploadUrlResponse = UploadControllerGetCleaningFeeUploadUrlResponses[keyof UploadControllerGetCleaningFeeUploadUrlResponses];

export type UploadControllerGetContractSignatureUploadUrlData = {
    body?: never;
    path?: never;
    query: {
        bookingId: string;
        handedOverAllocationId?: string;
        returnedAllocationId?: string;
    };
    url: '/v1/uploads/upload-url/contract-signature';
};

export type UploadControllerGetContractSignatureUploadUrlResponses = {
    /**
     * OK
     */
    200: GetPresignedUploadUrlResponse;
};

export type UploadControllerGetContractSignatureUploadUrlResponse = UploadControllerGetContractSignatureUploadUrlResponses[keyof UploadControllerGetContractSignatureUploadUrlResponses];

export type UploadControllerGetDamageMediaUploadUrlData = {
    body?: never;
    path?: never;
    query: {
        carId: string;
        originalFileName: string;
    };
    url: '/v1/uploads/upload-url/damage-media';
};

export type UploadControllerGetDamageMediaUploadUrlResponses = {
    /**
     * OK
     */
    200: GetPresignedUploadUrlResponse;
};

export type UploadControllerGetDamageMediaUploadUrlResponse = UploadControllerGetDamageMediaUploadUrlResponses[keyof UploadControllerGetDamageMediaUploadUrlResponses];

export type UploadControllerGetInfringementUploadUrlData = {
    body?: never;
    path?: never;
    query: {
        filename: string;
    };
    url: '/v1/uploads/upload-url/infringement';
};

export type UploadControllerGetInfringementUploadUrlResponses = {
    /**
     * OK
     */
    200: GetPresignedUploadUrlResponse;
};

export type UploadControllerGetInfringementUploadUrlResponse = UploadControllerGetInfringementUploadUrlResponses[keyof UploadControllerGetInfringementUploadUrlResponses];

export type UploadControllerGetUserDocumentUploadUrlData = {
    body?: never;
    path?: never;
    query: {
        fileName: string;
        userId: string;
    };
    url: '/v1/uploads/upload-url/user-document';
};

export type UploadControllerGetUserDocumentUploadUrlResponses = {
    /**
     * OK
     */
    200: GetPresignedUploadUrlResponse;
};

export type UploadControllerGetUserDocumentUploadUrlResponse = UploadControllerGetUserDocumentUploadUrlResponses[keyof UploadControllerGetUserDocumentUploadUrlResponses];

export type UploadControllerGetVehicleTypeImageUploadUrlData = {
    body?: never;
    path?: never;
    query: {
        originalFileName: string;
        vehicleTypeId: string;
    };
    url: '/v1/uploads/upload-url/vehicle-type-image';
};

export type UploadControllerGetVehicleTypeImageUploadUrlResponses = {
    /**
     * OK
     */
    200: GetPresignedUploadUrlResponse;
};

export type UploadControllerGetVehicleTypeImageUploadUrlResponse = UploadControllerGetVehicleTypeImageUploadUrlResponses[keyof UploadControllerGetVehicleTypeImageUploadUrlResponses];

export type UploadControllerGetTrainingVideoUploadUrlData = {
    body?: never;
    path?: never;
    query: {
        originalFileName: string;
        type: 'TRAINING';
    };
    url: '/v1/uploads/upload-url/video';
};

export type UploadControllerGetTrainingVideoUploadUrlResponses = {
    /**
     * OK
     */
    200: GetPresignedUploadUrlResponse;
};

export type UploadControllerGetTrainingVideoUploadUrlResponse = UploadControllerGetTrainingVideoUploadUrlResponses[keyof UploadControllerGetTrainingVideoUploadUrlResponses];

export type UploadControllerGetWorkshopAppointmentDocumentUploadUrlData = {
    body?: never;
    path?: never;
    query: {
        fileName: string;
        workshopAppointmentId: string;
    };
    url: '/v1/uploads/upload-url/workshop-appointment-document';
};

export type UploadControllerGetWorkshopAppointmentDocumentUploadUrlResponses = {
    /**
     * OK
     */
    200: GetPresignedUploadUrlResponse;
};

export type UploadControllerGetWorkshopAppointmentDocumentUploadUrlResponse = UploadControllerGetWorkshopAppointmentDocumentUploadUrlResponses[keyof UploadControllerGetWorkshopAppointmentDocumentUploadUrlResponses];

export type UsersControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        order?: Order;
        sort?: Array<FindAllUserSort>;
        agencyTypes?: Array<AgencyType>;
        hasSipId?: boolean;
        hasStaffomaticUserId?: boolean;
        isEmailConfirmed?: boolean;
        partnerSubTypeId?: string;
        query?: string;
        role?: Array<UserRole>;
        stationIds?: Array<string>;
        limit?: number;
        page?: number;
    };
    url: '/v1/users';
};

export type UsersControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationUserPaginationMeta;
};

export type UsersControllerFindAllResponse = UsersControllerFindAllResponses[keyof UsersControllerFindAllResponses];

export type UsersControllerCreateData = {
    body: AdminCreateUserDto;
    path?: never;
    query?: never;
    url: '/v1/users';
};

export type UsersControllerCreateErrors = {
    /**
     * Bad Request
     */
    400: BadRequestErrorDto;
};

export type UsersControllerCreateError = UsersControllerCreateErrors[keyof UsersControllerCreateErrors];

export type UsersControllerCreateResponses = {
    /**
     * Created
     */
    201: User;
    /**
     * Accepted
     */
    202: ApprovalRequest;
};

export type UsersControllerCreateResponse = UsersControllerCreateResponses[keyof UsersControllerCreateResponses];

export type UsersControllerCreateOrReturnUserIdData = {
    body: CreateCustomerUserDto;
    path?: never;
    query?: never;
    url: '/v1/users/create-or-return-id';
};

export type UsersControllerCreateOrReturnUserIdResponses = {
    /**
     * Created
     */
    201: {
        id: string;
    };
};

export type UsersControllerCreateOrReturnUserIdResponse = UsersControllerCreateOrReturnUserIdResponses[keyof UsersControllerCreateOrReturnUserIdResponses];

export type UsersControllerCreateCustomerData = {
    body: CreateCustomerUserDto;
    path?: never;
    query?: never;
    url: '/v1/users/customer';
};

export type UsersControllerCreateCustomerResponses = {
    /**
     * Created
     */
    201: User;
};

export type UsersControllerCreateCustomerResponse = UsersControllerCreateCustomerResponses[keyof UsersControllerCreateCustomerResponses];

export type UsersControllerFindOneByEmailIfExistsData = {
    body?: never;
    path: {
        email: string;
    };
    query?: never;
    url: '/v1/users/email-if-exists/{email}';
};

export type UsersControllerFindOneByEmailIfExistsResponses = {
    /**
     * OK
     */
    200: User | null;
};

export type UsersControllerFindOneByEmailIfExistsResponse = UsersControllerFindOneByEmailIfExistsResponses[keyof UsersControllerFindOneByEmailIfExistsResponses];

export type UsersControllerExtractDocumentInfoData = {
    body: string;
    path?: never;
    query: {
        bookingNumber: string;
        onlyLicenseData?: boolean;
    };
    url: '/v1/users/extract-documents';
};

export type UsersControllerExtractDocumentInfoResponses = {
    /**
     * Created
     */
    201: Array<ValidationRow>;
};

export type UsersControllerExtractDocumentInfoResponse = UsersControllerExtractDocumentInfoResponses[keyof UsersControllerExtractDocumentInfoResponses];

export type UsersControllerFindOneIdByEmailIfExistsData = {
    body?: never;
    path: {
        email: string;
    };
    query?: never;
    url: '/v1/users/id-by-email-if-exists/{email}';
};

export type UsersControllerFindOneIdByEmailIfExistsResponses = {
    /**
     * OK
     */
    200: {
        id: string;
    } | null;
};

export type UsersControllerFindOneIdByEmailIfExistsResponse = UsersControllerFindOneIdByEmailIfExistsResponses[keyof UsersControllerFindOneIdByEmailIfExistsResponses];

export type UsersControllerFindAllPartnerSubTypesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/users/partner-sub-types';
};

export type UsersControllerFindAllPartnerSubTypesResponses = {
    /**
     * OK
     */
    200: Array<PartnerSubType>;
};

export type UsersControllerFindAllPartnerSubTypesResponse = UsersControllerFindAllPartnerSubTypesResponses[keyof UsersControllerFindAllPartnerSubTypesResponses];

export type UsersControllerCreatePartnerSubTypeData = {
    body: CreatePartnerSubTypeDto;
    path?: never;
    query?: never;
    url: '/v1/users/partner-sub-types';
};

export type UsersControllerCreatePartnerSubTypeResponses = {
    /**
     * Created
     */
    201: PartnerSubType;
};

export type UsersControllerCreatePartnerSubTypeResponse = UsersControllerCreatePartnerSubTypeResponses[keyof UsersControllerCreatePartnerSubTypeResponses];

export type UsersControllerFindOnePartnerSubTypeData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/users/partner-sub-types/{id}';
};

export type UsersControllerFindOnePartnerSubTypeResponses = {
    /**
     * OK
     */
    200: PartnerSubType;
};

export type UsersControllerFindOnePartnerSubTypeResponse = UsersControllerFindOnePartnerSubTypeResponses[keyof UsersControllerFindOnePartnerSubTypeResponses];

export type UsersControllerUpdatePartnerSubTypeData = {
    body: UpdatePartnerSubTypeDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/users/partner-sub-types/{id}';
};

export type UsersControllerUpdatePartnerSubTypeResponses = {
    /**
     * OK
     */
    200: PartnerSubType;
};

export type UsersControllerUpdatePartnerSubTypeResponse = UsersControllerUpdatePartnerSubTypeResponses[keyof UsersControllerUpdatePartnerSubTypeResponses];

export type UsersControllerValidateVatIdData = {
    body: ValidateVatIdDto;
    path?: never;
    query?: never;
    url: '/v1/users/vat-id/validate';
};

export type UsersControllerValidateVatIdResponses = {
    /**
     * OK
     */
    200: VatIdValidationResult;
};

export type UsersControllerValidateVatIdResponse = UsersControllerValidateVatIdResponses[keyof UsersControllerValidateVatIdResponses];

export type UsersControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/users/{id}';
};

export type UsersControllerRemoveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type UsersControllerRemoveResponse = UsersControllerRemoveResponses[keyof UsersControllerRemoveResponses];

export type UsersControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/users/{id}';
};

export type UsersControllerFindOneResponses = {
    /**
     * OK
     */
    200: User;
};

export type UsersControllerFindOneResponse = UsersControllerFindOneResponses[keyof UsersControllerFindOneResponses];

export type UsersControllerUpdateData = {
    body: AdminUpdateUserDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/users/{id}';
};

export type UsersControllerUpdateResponses = {
    /**
     * OK
     */
    200: User;
};

export type UsersControllerUpdateResponse = UsersControllerUpdateResponses[keyof UsersControllerUpdateResponses];

export type UsersControllerFindAllUserDocumentsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        order?: Order;
        sort?: Array<'name'>;
        page?: number;
        query?: string;
        type?: Array<UserDocumentType>;
        limit?: number;
    };
    url: '/v1/users/{id}/documents';
};

export type UsersControllerFindAllUserDocumentsResponses = {
    /**
     * OK
     */
    200: PaginationUserDocumentDtoPaginationMeta;
};

export type UsersControllerFindAllUserDocumentsResponse = UsersControllerFindAllUserDocumentsResponses[keyof UsersControllerFindAllUserDocumentsResponses];

export type UsersControllerCreateUserDocumentData = {
    body: CreateUserDocumentDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/users/{id}/documents';
};

export type UsersControllerCreateUserDocumentResponses = {
    /**
     * Created
     */
    201: UserDocumentDto;
};

export type UsersControllerCreateUserDocumentResponse = UsersControllerCreateUserDocumentResponses[keyof UsersControllerCreateUserDocumentResponses];

export type UsersControllerRemoveUserDocumentData = {
    body?: never;
    path: {
        documentId: string;
        id: string;
    };
    query?: never;
    url: '/v1/users/{id}/documents/{documentId}';
};

export type UsersControllerRemoveUserDocumentResponses = {
    /**
     * No Content
     */
    204: void;
};

export type UsersControllerRemoveUserDocumentResponse = UsersControllerRemoveUserDocumentResponses[keyof UsersControllerRemoveUserDocumentResponses];

export type UsersControllerFindOneUserDocumentData = {
    body?: never;
    path: {
        documentId: string;
        id: string;
    };
    query?: never;
    url: '/v1/users/{id}/documents/{documentId}';
};

export type UsersControllerFindOneUserDocumentResponses = {
    /**
     * OK
     */
    200: UserDocumentDto;
};

export type UsersControllerFindOneUserDocumentResponse = UsersControllerFindOneUserDocumentResponses[keyof UsersControllerFindOneUserDocumentResponses];

export type UsersControllerUpdateUserDocumentData = {
    body: UpdateUserDocumentDto;
    path: {
        documentId: string;
        id: string;
    };
    query?: never;
    url: '/v1/users/{id}/documents/{documentId}';
};

export type UsersControllerUpdateUserDocumentResponses = {
    /**
     * OK
     */
    200: UserDocumentDto;
};

export type UsersControllerUpdateUserDocumentResponse = UsersControllerUpdateUserDocumentResponses[keyof UsersControllerUpdateUserDocumentResponses];

export type UsersControllerResendWelcomeMailData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/users/{id}/mails/welcome';
};

export type UsersControllerResendWelcomeMailResponses = {
    /**
     * No Content
     */
    204: void;
};

export type UsersControllerResendWelcomeMailResponse = UsersControllerResendWelcomeMailResponses[keyof UsersControllerResendWelcomeMailResponses];

export type UsersControllerRemovePermanentlyData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/users/{id}/permanently';
};

export type UsersControllerRemovePermanentlyResponses = {
    /**
     * No Content
     */
    204: void;
};

export type UsersControllerRemovePermanentlyResponse = UsersControllerRemovePermanentlyResponses[keyof UsersControllerRemovePermanentlyResponses];

export type VehicleExtrasControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        autoAssign?: boolean;
        autoAssignValue?: number | null;
        autoAssignValueType?: AutoAssignValueType | null;
        deprecated?: boolean;
        description?: string;
        keys?: Array<string>;
        types?: Array<VehicleExtraType>;
    };
    url: '/v1/vehicle-extras';
};

export type VehicleExtrasControllerFindAllResponses = {
    /**
     * OK
     */
    200: Array<VehicleExtra>;
};

export type VehicleExtrasControllerFindAllResponse = VehicleExtrasControllerFindAllResponses[keyof VehicleExtrasControllerFindAllResponses];

export type VehicleExtrasControllerCreateData = {
    body: CreateVehicleExtraDto;
    path?: never;
    query?: never;
    url: '/v1/vehicle-extras';
};

export type VehicleExtrasControllerCreateResponses = {
    /**
     * Created
     */
    201: VehicleExtra | null;
};

export type VehicleExtrasControllerCreateResponse = VehicleExtrasControllerCreateResponses[keyof VehicleExtrasControllerCreateResponses];

export type VehicleExtrasControllerEditAutoAssignVehicleExtraData = {
    body: EditAutoAssignVehicleExtraDto;
    path?: never;
    query?: never;
    url: '/v1/vehicle-extras/edit-auto-assign-extra';
};

export type VehicleExtrasControllerEditAutoAssignVehicleExtraResponses = {
    /**
     * Created
     */
    201: Array<VehicleExtra>;
};

export type VehicleExtrasControllerEditAutoAssignVehicleExtraResponse = VehicleExtrasControllerEditAutoAssignVehicleExtraResponses[keyof VehicleExtrasControllerEditAutoAssignVehicleExtraResponses];

export type VehicleExtrasControllerRemoveVehicleExtraData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/vehicle-extras/{id}';
};

export type VehicleExtrasControllerRemoveVehicleExtraResponses = {
    /**
     * OK
     */
    200: DeleteResult;
};

export type VehicleExtrasControllerRemoveVehicleExtraResponse = VehicleExtrasControllerRemoveVehicleExtraResponses[keyof VehicleExtrasControllerRemoveVehicleExtraResponses];

export type VehicleExtrasControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/vehicle-extras/{id}';
};

export type VehicleExtrasControllerFindOneResponses = {
    /**
     * OK
     */
    200: VehicleExtra | null;
};

export type VehicleExtrasControllerFindOneResponse = VehicleExtrasControllerFindOneResponses[keyof VehicleExtrasControllerFindOneResponses];

export type VehicleExtrasControllerUpdateVehicleExtraData = {
    body: UpdateVehicleExtraDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/vehicle-extras/{id}';
};

export type VehicleExtrasControllerUpdateVehicleExtraResponses = {
    /**
     * OK
     */
    200: VehicleExtra | null;
};

export type VehicleExtrasControllerUpdateVehicleExtraResponse = VehicleExtrasControllerUpdateVehicleExtraResponses[keyof VehicleExtrasControllerUpdateVehicleExtraResponses];

export type VehicleTypesControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        sort?: Array<FindAllVehicleTypesSort>;
        categories?: Array<VehicleCategory>;
        decommissioned?: DecommissionedFilter;
        includeNumCars?: boolean;
        isGhostCar?: boolean;
        makeIds?: Array<string>;
        query?: string;
        stationIds?: Array<string>;
        vehicleTypeIds?: Array<string>;
        order?: Order;
    };
    url: '/v1/vehicle-types';
};

export type VehicleTypesControllerFindAllResponses = {
    /**
     * OK
     */
    200: Array<VehicleType>;
};

export type VehicleTypesControllerFindAllResponse = VehicleTypesControllerFindAllResponses[keyof VehicleTypesControllerFindAllResponses];

export type VehicleTypesControllerCreateData = {
    body: CreateVehicleTypeDto;
    path?: never;
    query?: never;
    url: '/v1/vehicle-types';
};

export type VehicleTypesControllerCreateResponses = {
    /**
     * Created
     */
    201: VehicleType;
};

export type VehicleTypesControllerCreateResponse = VehicleTypesControllerCreateResponses[keyof VehicleTypesControllerCreateResponses];

export type VehicleTypesControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/vehicle-types/{id}';
};

export type VehicleTypesControllerRemoveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type VehicleTypesControllerRemoveResponse = VehicleTypesControllerRemoveResponses[keyof VehicleTypesControllerRemoveResponses];

export type VehicleTypesControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/vehicle-types/{id}';
};

export type VehicleTypesControllerFindOneResponses = {
    /**
     * OK
     */
    200: VehicleType;
};

export type VehicleTypesControllerFindOneResponse = VehicleTypesControllerFindOneResponses[keyof VehicleTypesControllerFindOneResponses];

export type VehicleTypesControllerUpdateData = {
    body: UpdateVehicleTypeDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/vehicle-types/{id}';
};

export type VehicleTypesControllerUpdateResponses = {
    /**
     * OK
     */
    200: VehicleType;
};

export type VehicleTypesControllerUpdateResponse = VehicleTypesControllerUpdateResponses[keyof VehicleTypesControllerUpdateResponses];

export type AppControllerGetVersionData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/version';
};

export type AppControllerGetVersionResponses = {
    /**
     * OK
     */
    200: string;
};

export type AppControllerGetVersionResponse = AppControllerGetVersionResponses[keyof AppControllerGetVersionResponses];

export type VideosControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        order?: Order;
        sort?: Array<FindAllVideosSort>;
        limit?: number;
        page?: number;
    };
    url: '/v1/videos';
};

export type VideosControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationVideoPaginationMeta;
};

export type VideosControllerFindAllResponse = VideosControllerFindAllResponses[keyof VideosControllerFindAllResponses];

export type VideosControllerCreateData = {
    body: CreateVideoDto;
    path?: never;
    query?: never;
    url: '/v1/videos';
};

export type VideosControllerCreateResponses = {
    /**
     * Created
     */
    201: Video | null;
};

export type VideosControllerCreateResponse = VideosControllerCreateResponses[keyof VideosControllerCreateResponses];

export type VideosControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/videos/{id}';
};

export type VideosControllerRemoveResponses = {
    /**
     * No Content
     */
    204: DeleteResult;
};

export type VideosControllerRemoveResponse = VideosControllerRemoveResponses[keyof VideosControllerRemoveResponses];

export type VideosControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/videos/{id}';
};

export type VideosControllerFindOneResponses = {
    /**
     * OK
     */
    200: Video;
};

export type VideosControllerFindOneResponse = VideosControllerFindOneResponses[keyof VideosControllerFindOneResponses];

export type VideosControllerUpdateData = {
    body: UpdateVideoDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/videos/{id}';
};

export type VideosControllerUpdateResponses = {
    /**
     * OK
     */
    200: Video | null;
};

export type VideosControllerUpdateResponse = VideosControllerUpdateResponses[keyof VideosControllerUpdateResponses];

export type WorkshopAppointmentsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        allocationStatuses?: Array<AllocationStatus>;
        appointmentTypes?: Array<WorkshopAppointmentType>;
        carId?: string;
        dateAfter?: Date;
        dateBefore?: Date;
        licencePlateOrFin?: string;
        type?: WorkshopAppointmentListType;
        order?: Order;
        sort?: Array<WorkshopAppointmentListType>;
        limit?: number;
        page?: number;
    };
    url: '/v1/workshop-appointments';
};

export type WorkshopAppointmentsControllerFindAllResponses = {
    /**
     * OK
     */
    200: PaginationWorkshopAppointmentPaginationMeta;
};

export type WorkshopAppointmentsControllerFindAllResponse = WorkshopAppointmentsControllerFindAllResponses[keyof WorkshopAppointmentsControllerFindAllResponses];

export type WorkshopAppointmentsControllerCreateData = {
    body: CreateWorkshopAppointmentDto;
    path?: never;
    query?: never;
    url: '/v1/workshop-appointments';
};

export type WorkshopAppointmentsControllerCreateResponses = {
    /**
     * Created
     */
    201: WorkshopAppointment;
};

export type WorkshopAppointmentsControllerCreateResponse = WorkshopAppointmentsControllerCreateResponses[keyof WorkshopAppointmentsControllerCreateResponses];

export type WorkshopAppointmentsControllerGetTotalCostsByCarIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/workshop-appointments/cars/{id}/total-costs';
};

export type WorkshopAppointmentsControllerGetTotalCostsByCarIdResponses = {
    /**
     * OK
     */
    200: WorkshopAppointmentTotalCostsDto;
};

export type WorkshopAppointmentsControllerGetTotalCostsByCarIdResponse = WorkshopAppointmentsControllerGetTotalCostsByCarIdResponses[keyof WorkshopAppointmentsControllerGetTotalCostsByCarIdResponses];

export type WorkshopAppointmentsControllerMigrateFromBlockerData = {
    body: MigrateBlockerToWorkshopAppointmentDto;
    path: {
        allocationId: string;
    };
    query?: never;
    url: '/v1/workshop-appointments/from-blocker/{allocationId}';
};

export type WorkshopAppointmentsControllerMigrateFromBlockerResponses = {
    /**
     * OK
     */
    200: WorkshopAppointment;
};

export type WorkshopAppointmentsControllerMigrateFromBlockerResponse = WorkshopAppointmentsControllerMigrateFromBlockerResponses[keyof WorkshopAppointmentsControllerMigrateFromBlockerResponses];

export type WorkshopAppointmentsControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        withForce?: boolean;
    };
    url: '/v1/workshop-appointments/{id}';
};

export type WorkshopAppointmentsControllerRemoveResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type WorkshopAppointmentsControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/workshop-appointments/{id}';
};

export type WorkshopAppointmentsControllerFindOneResponses = {
    /**
     * OK
     */
    200: WorkshopAppointment;
};

export type WorkshopAppointmentsControllerFindOneResponse = WorkshopAppointmentsControllerFindOneResponses[keyof WorkshopAppointmentsControllerFindOneResponses];

export type WorkshopAppointmentsControllerUpdateData = {
    body: UpdateWorkshopAppointmentDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/workshop-appointments/{id}';
};

export type WorkshopAppointmentsControllerUpdateResponses = {
    /**
     * OK
     */
    200: WorkshopAppointment;
};

export type WorkshopAppointmentsControllerUpdateResponse = WorkshopAppointmentsControllerUpdateResponses[keyof WorkshopAppointmentsControllerUpdateResponses];

export type WorkshopAppointmentsControllerFindAllWorkshopAppointmentDocumentsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        query?: string;
        type?: Array<WorkshopAppointmentDocumentType>;
        order?: Order;
        sort?: Array<'name'>;
        limit?: number;
        page?: number;
    };
    url: '/v1/workshop-appointments/{id}/documents';
};

export type WorkshopAppointmentsControllerFindAllWorkshopAppointmentDocumentsResponses = {
    /**
     * OK
     */
    200: PaginationWorkshopAppointmentDocumentDtoPaginationMeta;
};

export type WorkshopAppointmentsControllerFindAllWorkshopAppointmentDocumentsResponse = WorkshopAppointmentsControllerFindAllWorkshopAppointmentDocumentsResponses[keyof WorkshopAppointmentsControllerFindAllWorkshopAppointmentDocumentsResponses];

export type WorkshopAppointmentsControllerCreateWorkshopAppointmentDocumentData = {
    body: CreateWorkshopAppointmentDocumentDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/v1/workshop-appointments/{id}/documents';
};

export type WorkshopAppointmentsControllerCreateWorkshopAppointmentDocumentResponses = {
    /**
     * Created
     */
    201: WorkshopAppointmentDocumentDto;
};

export type WorkshopAppointmentsControllerCreateWorkshopAppointmentDocumentResponse = WorkshopAppointmentsControllerCreateWorkshopAppointmentDocumentResponses[keyof WorkshopAppointmentsControllerCreateWorkshopAppointmentDocumentResponses];

export type WorkshopAppointmentsControllerRemoveWorkshopAppointmentDocumentData = {
    body?: never;
    path: {
        documentId: string;
        id: string;
    };
    query?: never;
    url: '/v1/workshop-appointments/{id}/documents/{documentId}';
};

export type WorkshopAppointmentsControllerRemoveWorkshopAppointmentDocumentResponses = {
    /**
     * No Content
     */
    204: void;
};

export type WorkshopAppointmentsControllerRemoveWorkshopAppointmentDocumentResponse = WorkshopAppointmentsControllerRemoveWorkshopAppointmentDocumentResponses[keyof WorkshopAppointmentsControllerRemoveWorkshopAppointmentDocumentResponses];

export type WorkshopAppointmentsControllerFindOneWorkshopAppointmentDocumentData = {
    body?: never;
    path: {
        documentId: string;
        id: string;
    };
    query?: never;
    url: '/v1/workshop-appointments/{id}/documents/{documentId}';
};

export type WorkshopAppointmentsControllerFindOneWorkshopAppointmentDocumentResponses = {
    /**
     * OK
     */
    200: WorkshopAppointmentDocumentDto;
};

export type WorkshopAppointmentsControllerFindOneWorkshopAppointmentDocumentResponse = WorkshopAppointmentsControllerFindOneWorkshopAppointmentDocumentResponses[keyof WorkshopAppointmentsControllerFindOneWorkshopAppointmentDocumentResponses];

export type WorkshopAppointmentsControllerUpdateWorkshopAppointmentDocumentData = {
    body: UpdateWorkshopAppointmentDocumentDto;
    path: {
        documentId: string;
        id: string;
    };
    query?: never;
    url: '/v1/workshop-appointments/{id}/documents/{documentId}';
};

export type WorkshopAppointmentsControllerUpdateWorkshopAppointmentDocumentResponses = {
    /**
     * OK
     */
    200: WorkshopAppointmentDocumentDto;
};

export type WorkshopAppointmentsControllerUpdateWorkshopAppointmentDocumentResponse = WorkshopAppointmentsControllerUpdateWorkshopAppointmentDocumentResponses[keyof WorkshopAppointmentsControllerUpdateWorkshopAppointmentDocumentResponses];

export type YieldManagementSettingsControllerGetSettingsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/yield-management-settings';
};

export type YieldManagementSettingsControllerGetSettingsResponses = {
    /**
     * OK
     */
    200: YieldManagementSettings;
};

export type YieldManagementSettingsControllerGetSettingsResponse = YieldManagementSettingsControllerGetSettingsResponses[keyof YieldManagementSettingsControllerGetSettingsResponses];

export type YieldManagementSettingsControllerUpdateSettingsData = {
    body: UpdateYieldManagementSettingsDto;
    path?: never;
    query?: never;
    url: '/v1/yield-management-settings';
};

export type YieldManagementSettingsControllerUpdateSettingsResponses = {
    /**
     * OK
     */
    200: YieldManagementSettings | null;
};

export type YieldManagementSettingsControllerUpdateSettingsResponse = YieldManagementSettingsControllerUpdateSettingsResponses[keyof YieldManagementSettingsControllerUpdateSettingsResponses];

export type YieldManagementSettingsControllerCalculatePricePerExtraKmData = {
    body?: never;
    path?: never;
    query: {
        category: VehicleCategory;
        netPurchasePrice: number;
    };
    url: '/v1/yield-management-settings/calculate-price-per-extra-km';
};

export type YieldManagementSettingsControllerCalculatePricePerExtraKmResponses = {
    /**
     * OK
     */
    200: CalculatePricePerExtraKmResponseDto;
};

export type YieldManagementSettingsControllerCalculatePricePerExtraKmResponse = YieldManagementSettingsControllerCalculatePricePerExtraKmResponses[keyof YieldManagementSettingsControllerCalculatePricePerExtraKmResponses];

export type YieldManagementSettingsControllerGetDepositData = {
    body?: never;
    path?: never;
    query: {
        netPurchasePrice: number;
    };
    url: '/v1/yield-management-settings/get-deposit';
};

export type YieldManagementSettingsControllerGetDepositResponses = {
    /**
     * OK
     */
    200: GetDepositResponseDto;
};

export type YieldManagementSettingsControllerGetDepositResponse = YieldManagementSettingsControllerGetDepositResponses[keyof YieldManagementSettingsControllerGetDepositResponses];

export type YieldManagementSettingsControllerGetMinAgeData = {
    body?: never;
    path?: never;
    query: {
        netPurchasePrice: number;
    };
    url: '/v1/yield-management-settings/get-min-age';
};

export type YieldManagementSettingsControllerGetMinAgeResponses = {
    /**
     * OK
     */
    200: GetMinAgeResponseDto;
};

export type YieldManagementSettingsControllerGetMinAgeResponse = YieldManagementSettingsControllerGetMinAgeResponses[keyof YieldManagementSettingsControllerGetMinAgeResponses];

export type AppControllerGetHelloV2Data = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v2/';
};

export type AppControllerGetHelloV2Responses = {
    /**
     * OK
     */
    200: string;
};

export type AppControllerGetHelloV2Response = AppControllerGetHelloV2Responses[keyof AppControllerGetHelloV2Responses];
